import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  ExpectedErrorType: { input: any; output: any; }
  GenericScalar: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AcceptTermsMutation = {
  __typename?: 'AcceptTermsMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum AcceptationTermTermType {
  /** Política de Privacidade */
  PrivacyPolicy = 'PRIVACY_POLICY',
  /** Termo de Uso */
  TermsOfUse = 'TERMS_OF_USE'
}

export type AcceptationTermType = Node & {
  __typename?: 'AcceptationTermType';
  content: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  termType: AcceptationTermTermType;
  useracceptationSet: Array<UserAcceptationType>;
};

export type ActiveOrInactiveCampaignInput = {
  campaignId: Scalars['ID']['input'];
  deleteNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type ActiveOrInactiveCampaignMutation = {
  __typename?: 'ActiveOrInactiveCampaignMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTagsToAudienceSelection = {
  __typename?: 'AddTagsToAudienceSelection';
  updatedCount: Scalars['Int']['output'];
};

export type AddTagsToAudienceSelectionInput = {
  selectionId: Scalars['ID']['input'];
  tagIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type AddTagsToCustomers = {
  __typename?: 'AddTagsToCustomers';
  updatedCount: Scalars['Int']['output'];
};

export type AddTagsToCustomersInput = {
  customerIds: Array<InputMaybe<Scalars['ID']['input']>>;
  tagIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type AdminCreateShopifyGiftbackAutomaticInput = {
  encerraEm: Scalars['String']['input'];
  iniciaEm: Scalars['String']['input'];
  lojaId: Scalars['ID']['input'];
  valor: Scalars['Float']['input'];
  valorMinimoParaResgate: Scalars['Float']['input'];
};

export type AdminCreateShopifyGiftbackAutomaticMutation = {
  __typename?: 'AdminCreateShopifyGiftbackAutomaticMutation';
  couponId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminCreateTrayGiftbackInput = {
  acumulativo: Scalars['Boolean']['input'];
  codigo: Scalars['String']['input'];
  descricao: Scalars['String']['input'];
  encerraEm: Scalars['String']['input'];
  limiteCuponsGerados: Scalars['Int']['input'];
  lojaId: Scalars['ID']['input'];
  tipoDeDesconto: Scalars['String']['input'];
  valor: Scalars['Float']['input'];
  valorLimite: Scalars['Float']['input'];
  valorMinimoDoProduto: Scalars['Float']['input'];
};

export type AdminCreateTrayGiftbackMutation = {
  __typename?: 'AdminCreateTrayGiftbackMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  trayCouponId?: Maybe<Scalars['Int']['output']>;
};

export type AdminDeleteTrayGiftbackInput = {
  lojaId: Scalars['ID']['input'];
  trayGiftbackId: Scalars['ID']['input'];
};

export type AdminDeleteTrayGiftbackMutation = {
  __typename?: 'AdminDeleteTrayGiftbackMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminRelateGiftbackInput = {
  giftbackId: Scalars['ID']['input'];
  pedidoId: Scalars['ID']['input'];
};

export type AdminRelateGiftbackMutation = {
  __typename?: 'AdminRelateGiftbackMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminRelateTrayGiftbackInput = {
  lojaId: Scalars['ID']['input'];
  trayGiftbackId: Scalars['ID']['input'];
  trayProductId?: InputMaybe<Scalars['ID']['input']>;
  zekiClientesIds: Scalars['String']['input'];
};

export type AdminRelateTrayGiftbackMutation = {
  __typename?: 'AdminRelateTrayGiftbackMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AgeColumnChartReturn = {
  __typename?: 'AgeColumnChartReturn';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<AgeColumnChartSeries>>>;
};

export type AgeColumnChartSeries = {
  __typename?: 'AgeColumnChartSeries';
  data?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplyLoyaltyManualRuleMutation = {
  __typename?: 'ApplyLoyaltyManualRuleMutation';
  member?: Maybe<LoyaltyMemberType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AppointmentActionResultType = {
  __typename?: 'AppointmentActionResultType';
  alternativeSlots?: Maybe<Array<Maybe<AvailableSlotType>>>;
  appointment?: Maybe<PublicAppointmentType>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AppointmentBookingResultType = {
  __typename?: 'AppointmentBookingResultType';
  alternativeSlots?: Maybe<Array<Maybe<AvailableSlotType>>>;
  appointment?: Maybe<PublicAppointmentType>;
  code?: Maybe<Scalars['String']['output']>;
  googleCalendarUrl?: Maybe<Scalars['String']['output']>;
  icsUrl?: Maybe<Scalars['String']['output']>;
  idempotentReplay: Scalars['Boolean']['output'];
  managementToken?: Maybe<Scalars['String']['output']>;
  managementUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  outlookCalendarUrl?: Maybe<Scalars['String']['output']>;
};

export type AppointmentDashboardType = {
  __typename?: 'AppointmentDashboardType';
  attendanceRate?: Maybe<Scalars['Float']['output']>;
  cancellationRate?: Maybe<Scalars['Float']['output']>;
  confirmationRate?: Maybe<Scalars['Float']['output']>;
  estimatedValue?: Maybe<Scalars['Decimal']['output']>;
  noShowRate?: Maybe<Scalars['Float']['output']>;
  occupancyRate?: Maybe<Scalars['Float']['output']>;
  realizedRevenue?: Maybe<Scalars['Decimal']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum AppointmentOrigin {
  /** Campanha */
  Campaign = 'CAMPAIGN',
  /** Interno */
  Internal = 'INTERNAL',
  /** PDV */
  Pdv = 'PDV',
  /** Página pública */
  Public = 'PUBLIC'
}

/** An enumeration. */
export enum AppointmentStatus {
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Cliente chegou */
  CheckedIn = 'CHECKED_IN',
  /** Concluído */
  Completed = 'COMPLETED',
  /** Confirmado */
  Confirmed = 'CONFIRMED',
  /** Em atendimento */
  InService = 'IN_SERVICE',
  /** Não compareceu */
  NoShow = 'NO_SHOW',
  /** Agendado */
  Scheduled = 'SCHEDULED'
}

export type AppointmentType = {
  __typename?: 'AppointmentType';
  attribution: Scalars['JSONString']['output'];
  bufferAfterMinutes: Scalars['Int']['output'];
  bufferBeforeMinutes: Scalars['Int']['output'];
  cancellationReason: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<CustomUserNode>;
  consentEvidence: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CustomUserNode>;
  customer: CustomerTypeRelay;
  customerActivities: CustomerActivitiesTypeRelayConnection;
  durationMinutes: Scalars['Int']['output'];
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  occupiedEndsAt: Scalars['DateTime']['output'];
  occupiedStartsAt: Scalars['DateTime']['output'];
  origin: AppointmentOrigin;
  pk: Scalars['Int']['output'];
  professional: ProfessionalType;
  publicId: Scalars['UUID']['output'];
  purchaseServices: Array<PurchaseServiceType>;
  service: ServiceRelayType;
  serviceName: Scalars['String']['output'];
  serviceValue: Scalars['Float']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: AppointmentStatus;
  store: StoreType;
  timezone: Scalars['String']['output'];
  unit: SchedulingUnitType;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};


export type AppointmentTypeCustomerActivitiesArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};

export type AppointmentWorkspaceType = {
  __typename?: 'AppointmentWorkspaceType';
  adjustments?: Maybe<Array<Maybe<ScheduleAdjustmentType>>>;
  bookingPage?: Maybe<BookingPageType>;
  professionals?: Maybe<Array<Maybe<ProfessionalType>>>;
  storefront?: Maybe<BookingStorefrontProfileType>;
  unit?: Maybe<SchedulingUnitType>;
  workingHours?: Maybe<Array<Maybe<WorkingHoursType>>>;
};

export type ArchiveAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/**
 * Archive account and revoke refresh tokens.
 *
 * User must be verified and confirm password.
 */
export type ArchiveAccountPayload = {
  __typename?: 'ArchiveAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AvailableSlotType = {
  __typename?: 'AvailableSlotType';
  endsAt: Scalars['DateTime']['output'];
  professionalId: Scalars['ID']['output'];
  professionalName: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type BlingStoreIntegrationType = {
  __typename?: 'BlingStoreIntegrationType';
  acceptedStatusToImport: Scalars['String']['output'];
  accessToken: Scalars['String']['output'];
  activated: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresIn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  lastProcessingAt?: Maybe<Scalars['DateTime']['output']>;
  pk: Scalars['Int']['output'];
  processingLock: Scalars['Boolean']['output'];
  refreshToken: Scalars['String']['output'];
  /** Palavras separadas por vírgula, exemplo: 'brinde, presente, etc.' */
  shouldImportInDescriptionWords: Scalars['String']['output'];
  /** Palavras separadas por vírgula, exemplo: 'Loja Virtual, etc.' */
  shouldNotImportBySellers: Scalars['String']['output'];
  /** Palavras separadas por vírgula, exemplo: 'brinde, presente, etc.' */
  shouldNotImportInDescriptionWords: Scalars['String']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type BoardInput = {
  colaborators: Array<InputMaybe<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type BoardNode = Node & {
  __typename?: 'BoardNode';
  colaborators: CustomUserNodeConnection;
  columnstatusSet: ColumnStatusNodeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: CustomUserNode;
  pk: Scalars['Int']['output'];
};


export type BoardNodeColaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status_Archived?: InputMaybe<Scalars['Boolean']['input']>;
  status_SecondaryEmail?: InputMaybe<Scalars['String']['input']>;
  status_Verified?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_Icontains?: InputMaybe<Scalars['String']['input']>;
  username_Istartswith?: InputMaybe<Scalars['String']['input']>;
};


export type BoardNodeColumnstatusSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  board?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type BoardNodeConnection = {
  __typename?: 'BoardNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BoardNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BoardNode` and its cursor. */
export type BoardNodeEdge = {
  __typename?: 'BoardNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BoardNode>;
};

export type BoardType = {
  __typename?: 'BoardType';
  colaborators: CustomUserNodeConnection;
  columnstatusSet: ColumnStatusNodeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: CustomUserNode;
  pk: Scalars['Int']['output'];
};


export type BoardTypeColaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status_Archived?: InputMaybe<Scalars['Boolean']['input']>;
  status_SecondaryEmail?: InputMaybe<Scalars['String']['input']>;
  status_Verified?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_Icontains?: InputMaybe<Scalars['String']['input']>;
  username_Istartswith?: InputMaybe<Scalars['String']['input']>;
};


export type BoardTypeColumnstatusSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  board?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingPageType = {
  __typename?: 'BookingPageType';
  allowProfessionalPreference: Scalars['Boolean']['output'];
  bookingHorizonDays: Scalars['Int']['output'];
  cancellationLeadMinutes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  minimumLeadMinutes: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  privacyUrl: Scalars['String']['output'];
  reminderOffsetMinutes: Scalars['Int']['output'];
  reminderViaEmail: Scalars['Boolean']['output'];
  reminderViaWhatsapp: Scalars['Boolean']['output'];
  slotIntervalMinutes: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  storefront?: Maybe<BookingStorefrontProfileType>;
  termsUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit: SchedulingUnitType;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum BookingStorefrontProfilePreset {
  /** Editorial */
  Editorial = 'EDITORIAL',
  /** Elegante */
  Elegant = 'ELEGANT',
  /** Natural */
  Natural = 'NATURAL',
  /** Vibrante */
  Vibrant = 'VIBRANT'
}

export type BookingStorefrontProfileType = {
  __typename?: 'BookingStorefrontProfileType';
  aboutText: Scalars['String']['output'];
  aboutTitle: Scalars['String']['output'];
  accentColor: Scalars['String']['output'];
  bookingPage: BookingPageType;
  coverImageAlt: Scalars['String']['output'];
  coverImageUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  facebookUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instagramUrl: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  logoAlt: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  mapsUrl: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  preset: BookingStorefrontProfilePreset;
  primaryColor: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedData: Scalars['JSONString']['output'];
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  surfaceColor: Scalars['String']['output'];
  tiktokUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl: Scalars['String']['output'];
};

export type BulkNotificationAttachmentType = {
  __typename?: 'BulkNotificationAttachmentType';
  bulkNotification: BulkNotificationRelayType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BulkNotificationCancellInput = {
  id: Scalars['ID']['input'];
};

export type BulkNotificationCancellMutation = {
  __typename?: 'BulkNotificationCancellMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationCreateInput = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  audienceSelectionId?: InputMaybe<Scalars['ID']['input']>;
  coupon?: InputMaybe<CouponCreateInput>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dailyMessageLimit?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  messageTimeInterval?: InputMaybe<Scalars['Int']['input']>;
  messages?: InputMaybe<Array<InputMaybe<BulkNotificationMessageCreateInput>>>;
  startRunningDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateId?: InputMaybe<Scalars['String']['input']>;
  whatsappTemplateTitle?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelId?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelNumber?: InputMaybe<Scalars['String']['input']>;
  zekiCrmTemplateVariableMapping?: InputMaybe<Array<InputMaybe<BulkNotificationZekiCrmTemplateVariableMappingInput>>>;
};

/** An enumeration. */
export enum BulkNotificationCustomerMessageStatus {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Clicado */
  Clicked = 'CLICKED',
  /** Entregue */
  Delivered = 'DELIVERED',
  /** Falha */
  Failed = 'FAILED',
  /** Pendente */
  Pending = 'PENDING',
  /** Lido */
  Read = 'READ',
  /** Recebido */
  Received = 'RECEIVED',
  /** Enviado */
  Sent = 'SENT'
}

export type BulkNotificationCustomerMessageStatusCountsType = {
  __typename?: 'BulkNotificationCustomerMessageStatusCountsType';
  canceled: Scalars['Int']['output'];
  clicked: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  read: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulkNotificationCustomerRelayType = Node & {
  __typename?: 'BulkNotificationCustomerRelayType';
  bulkNotification: BulkNotificationRelayType;
  bulknotificationcustomersalesSet: Array<BulkNotificationCustomerSalesType>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  celeryId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Colunas extras do arquivo Excel usadas como variáveis dinâmicas da campanha */
  customVariables: Scalars['JSONString']['output'];
  customer?: Maybe<CustomerTypeRelay>;
  dispatchToken: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailMessage: Scalars['String']['output'];
  emailTitle: Scalars['String']['output'];
  failureReason: Scalars['String']['output'];
  /** Para mostrar o nome do cliente, escreva {client_name} na mensagem. */
  htmlMessage: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  messageStatus?: Maybe<BulkNotificationCustomerMessageStatus>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  /** JSON contendo os dados do template de email para edição no frontend */
  reactEmailData: Scalars['JSONString']['output'];
  reservedUntil?: Maybe<Scalars['DateTime']['output']>;
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BulkNotificationCustomerStatus>;
  store?: Maybe<StoreType>;
  /** Variáveis usadas para substituir placeholders em templates do WhatsApp Official */
  templateVariables?: Maybe<Scalars['JSONString']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type BulkNotificationCustomerRelayTypeConnection = {
  __typename?: 'BulkNotificationCustomerRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BulkNotificationCustomerRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BulkNotificationCustomerRelayType` and its cursor. */
export type BulkNotificationCustomerRelayTypeEdge = {
  __typename?: 'BulkNotificationCustomerRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BulkNotificationCustomerRelayType>;
};

export type BulkNotificationCustomerSalesType = {
  __typename?: 'BulkNotificationCustomerSalesType';
  bulkNotificationCustomer: BulkNotificationCustomerRelayType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  purchase: PurchaseRelayType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['Float']['output'];
};

/** An enumeration. */
export enum BulkNotificationCustomerStatus {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Falha */
  Failed = 'FAILED',
  /** Finalizado */
  Finished = 'FINISHED',
  /** Pendente */
  Pending = 'PENDING',
  /** Processando */
  Processing = 'PROCESSING'
}

export type BulkNotificationDeleteInput = {
  id: Scalars['ID']['input'];
};

export type BulkNotificationDeleteMutation = {
  __typename?: 'BulkNotificationDeleteMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationMessageCreateInput = {
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  /** Lista de botões dinâmicos para template WhatsApp (máx 3, sem botão fixo obrigatório) */
  buttons?: InputMaybe<Array<InputMaybe<WhatsappButtonInput>>>;
  emailMessage?: InputMaybe<Scalars['String']['input']>;
  emailTitle?: InputMaybe<Scalars['String']['input']>;
  /** Rodapé WhatsApp (máx 60 caracteres, opcional) */
  footer?: InputMaybe<Scalars['String']['input']>;
  htmlMessage?: InputMaybe<Scalars['String']['input']>;
  imageAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reactEmailData?: InputMaybe<Scalars['JSONString']['input']>;
  videoAttachmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkNotificationMessageType = {
  __typename?: 'BulkNotificationMessageType';
  active: Scalars['Boolean']['output'];
  bulkNotification: BulkNotificationRelayType;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  /** Lista de botões dinâmicos para template WhatsApp [{'type': 'URL', 'text': '...', 'url': '...'}, ...] */
  buttons: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Para mostrar o nome do cliente, escreva {client_name} na mensagem. */
  emailMessage: Scalars['String']['output'];
  emailTitle: Scalars['String']['output'];
  /** Texto opcional para rodapé do template WhatsApp (máx 60 caracteres) */
  footer?: Maybe<Scalars['String']['output']>;
  /** Para mostrar o nome do cliente, escreva {client_name} na mensagem. Com esse campo, você pode enviar templates HTML customizados para o corpo do email. */
  htmlMessage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ao colar a url de uma imagem, ela será enviada junto com a mensagem de whatsapp. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Para mostrar o nome do cliente, escreva {client_name} na mensagem. Assim como, para deixar a palavra em negrito, escreva a palavra entre * *. */
  message: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  /** JSON contendo os dados do template de email para edição no frontend */
  reactEmailData: Scalars['JSONString']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Ao enviar um vídeo, ele será enviado junto com a mensagem de whatsapp. Tipos permitidos: mp4 e 3gp. Tamanho permitido: até 16MB. */
  video?: Maybe<Scalars['String']['output']>;
  /** Ao colar a url de um vídeo, ele será enviado junto com a mensagem de whatsapp. Tipos permitidos: mp4 e 3gp. Tamanho permitido: até 16MB. */
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type BulkNotificationMessageUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  /** Lista de botões dinâmicos para template WhatsApp (máx 3, sem botão fixo obrigatório) */
  buttons?: InputMaybe<Array<InputMaybe<WhatsappButtonInput>>>;
  emailMessage?: InputMaybe<Scalars['String']['input']>;
  emailTitle?: InputMaybe<Scalars['String']['input']>;
  /** Rodapé WhatsApp (máx 60 caracteres, opcional) */
  footer?: InputMaybe<Scalars['String']['input']>;
  htmlMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reactEmailData?: InputMaybe<Scalars['JSONString']['input']>;
  videoAttachmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkNotificationPauseInput = {
  id: Scalars['ID']['input'];
};

export type BulkNotificationPauseMutation = {
  __typename?: 'BulkNotificationPauseMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationRelayType = Node & {
  __typename?: 'BulkNotificationRelayType';
  bulknotificationattachmentSet: Array<BulkNotificationAttachmentType>;
  bulknotificationcustomerSet: BulkNotificationCustomerRelayTypeConnection;
  bulknotificationmessageSet: Array<BulkNotificationMessageType>;
  coupon?: Maybe<CouponRelayType>;
  createdAt: Scalars['DateTime']['output'];
  creditWeight: Scalars['Int']['output'];
  dailyMessageLimit: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  errorPayload: Scalars['JSONString']['output'];
  /** Por favor, anexe um arquivo xlsx. Assim como, a planilha deve conter como primeira coluna o nome do cliente e a segunda coluna com o telefone ou com o email. */
  fileAttachment?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  messageTimeInterval: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  progressCount: Scalars['String']['output'];
  progressPercentage: Scalars['Float']['output'];
  purchaseQuantity: Scalars['Int']['output'];
  purchaseTotalValue: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  startRunningDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<BulkNotificationStatus>;
  store: StoreType;
  taskId: Scalars['String']['output'];
  /** Adicione os contatos (Nome:Contato) separados por vírgula, por ex: Teste1:11999999998, Teste2:11999999999, no caso de selecionar whatsapp ou sms. Já para email, adicione por ex: Teste1:email@email, Teste2:email2@email */
  testContacts: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viaDiscord: Scalars['Boolean']['output'];
  viaEmail: Scalars['Boolean']['output'];
  viaSms: Scalars['Boolean']['output'];
  viaTest: Scalars['Boolean']['output'];
  viaWhatsapp: Scalars['Boolean']['output'];
  viaWhatsappOfficial: Scalars['Boolean']['output'];
  viaZekiCrm: Scalars['Boolean']['output'];
  whatsappTemplate?: Maybe<WhatsappTemplateRelayType>;
  zekiCrmChannelId?: Maybe<Scalars['String']['output']>;
  zekiCrmChannelNumber?: Maybe<Scalars['String']['output']>;
  zekiCrmTemplateVariableMapping?: Maybe<Array<Maybe<BulkNotificationZekiCrmTemplateVariableMappingType>>>;
};


export type BulkNotificationRelayTypeBulknotificationcustomerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BulkNotificationRelayTypeConnection = {
  __typename?: 'BulkNotificationRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BulkNotificationRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `BulkNotificationRelayType` and its cursor. */
export type BulkNotificationRelayTypeEdge = {
  __typename?: 'BulkNotificationRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BulkNotificationRelayType>;
};

export type BulkNotificationRescheduleCampaignInput = {
  id: Scalars['ID']['input'];
};

export type BulkNotificationRescheduleCampaignMutation = {
  __typename?: 'BulkNotificationRescheduleCampaignMutation';
  bulkNotification?: Maybe<BulkNotificationType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationResumeInput = {
  id: Scalars['ID']['input'];
};

export type BulkNotificationResumeMutation = {
  __typename?: 'BulkNotificationResumeMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationSendCampaignInput = {
  id: Scalars['ID']['input'];
};

export type BulkNotificationSendCampaignMutation = {
  __typename?: 'BulkNotificationSendCampaignMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum BulkNotificationStatus {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Falha */
  Failed = 'FAILED',
  /** Finalizado */
  Finished = 'FINISHED',
  /** Pausado */
  Paused = 'PAUSED',
  /** Pausado pelo Limite Diário de Mensagens */
  PausedByDailyLimit = 'PAUSED_BY_DAILY_LIMIT',
  /** Pausado pelo Limite de Tempo */
  PausedByTimeLimit = 'PAUSED_BY_TIME_LIMIT',
  /** Pendente */
  Pending = 'PENDING',
  /** Processando */
  Processing = 'PROCESSING'
}

export type BulkNotificationTestSendInput = {
  /** ID da campanha, quando já salva */
  bulkNotificationId?: InputMaybe<Scalars['ID']['input']>;
  /** EMAIL, WHATSAPP, WHATSAPP_OFFICIAL ou ZEKI_CRM */
  channel: Scalars['String']['input'];
  /** Identificador do rascunho gerado pelo front */
  draftKey: Scalars['UUID']['input'];
  messages?: InputMaybe<Array<InputMaybe<BulkNotificationMessageCreateInput>>>;
  /** E-mail ou telefone que receberá o teste */
  recipient: Scalars['String']['input'];
  whatsappTemplateId?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelId?: InputMaybe<Scalars['String']['input']>;
  zekiCrmTemplateVariableMapping?: InputMaybe<Array<InputMaybe<BulkNotificationZekiCrmTemplateVariableMappingInput>>>;
};

export type BulkNotificationTestSendsResultType = {
  __typename?: 'BulkNotificationTestSendsResultType';
  limit: Scalars['Int']['output'];
  remainingTests: Scalars['Int']['output'];
};

export type BulkNotificationType = {
  __typename?: 'BulkNotificationType';
  audienceMaterializationStatus: Scalars['String']['output'];
  bulknotificationattachmentSet: Array<BulkNotificationAttachmentType>;
  bulknotificationcustomerSet: BulkNotificationCustomerRelayTypeConnection;
  bulknotificationmessageSet: Array<BulkNotificationMessageType>;
  coupon?: Maybe<CouponRelayType>;
  createdAt: Scalars['DateTime']['output'];
  creditWeight: Scalars['Int']['output'];
  customerMessageStatusCounts: BulkNotificationCustomerMessageStatusCountsType;
  dailyMessageLimit: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  errorPayload: Scalars['JSONString']['output'];
  /** Por favor, anexe um arquivo xlsx. Assim como, a planilha deve conter como primeira coluna o nome do cliente e a segunda coluna com o telefone ou com o email. */
  fileAttachment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageTimeInterval: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  progressCount: Scalars['String']['output'];
  progressPercentage: Scalars['Float']['output'];
  purchaseQuantity: Scalars['Int']['output'];
  purchaseTotalValue: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  startRunningDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  status?: Maybe<BulkNotificationStatus>;
  store: StoreType;
  taskId: Scalars['String']['output'];
  /** Adicione os contatos (Nome:Contato) separados por vírgula, por ex: Teste1:11999999998, Teste2:11999999999, no caso de selecionar whatsapp ou sms. Já para email, adicione por ex: Teste1:email@email, Teste2:email2@email */
  testContacts: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viaDiscord: Scalars['Boolean']['output'];
  viaEmail: Scalars['Boolean']['output'];
  viaSms: Scalars['Boolean']['output'];
  viaTest: Scalars['Boolean']['output'];
  viaWhatsapp: Scalars['Boolean']['output'];
  viaWhatsappOfficial: Scalars['Boolean']['output'];
  viaZekiCrm: Scalars['Boolean']['output'];
  whatsappTemplate?: Maybe<WhatsappTemplateRelayType>;
  zekiCrmChannelId?: Maybe<Scalars['String']['output']>;
  zekiCrmChannelNumber?: Maybe<Scalars['String']['output']>;
  zekiCrmTemplateVariableMapping?: Maybe<Array<Maybe<BulkNotificationZekiCrmTemplateVariableMappingType>>>;
};


export type BulkNotificationTypeBulknotificationcustomerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BulkNotificationUpdateCustomerDataInput = {
  customerIds: Array<InputMaybe<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};

export type BulkNotificationUpdateCustomerDataMutation = {
  __typename?: 'BulkNotificationUpdateCustomerDataMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationUpdateInput = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dailyMessageLimit?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  messageTimeInterval?: InputMaybe<Scalars['Int']['input']>;
  messages?: InputMaybe<Array<InputMaybe<BulkNotificationMessageUpdateInput>>>;
  startRunningDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateId?: InputMaybe<Scalars['String']['input']>;
  whatsappTemplateTitle?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelId?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelNumber?: InputMaybe<Scalars['String']['input']>;
  zekiCrmTemplateVariableMapping?: InputMaybe<Array<InputMaybe<BulkNotificationZekiCrmTemplateVariableMappingInput>>>;
};

export type BulkNotificationUpdateMutation = {
  __typename?: 'BulkNotificationUpdateMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkNotificationZekiCrmTemplateVariableMappingInput = {
  templateVariable: Scalars['String']['input'];
  zekiVariable: Scalars['String']['input'];
};

export type BulkNotificationZekiCrmTemplateVariableMappingType = {
  __typename?: 'BulkNotificationZekiCrmTemplateVariableMappingType';
  templateVariable?: Maybe<Scalars['String']['output']>;
  zekiVariable?: Maybe<Scalars['String']['output']>;
};

export type CalculateGiftbackValueResponse = {
  __typename?: 'CalculateGiftbackValueResponse';
  dueDate?: Maybe<Scalars['Date']['output']>;
  giftbackValue?: Maybe<Scalars['Decimal']['output']>;
  minValueToRedeem?: Maybe<Scalars['Decimal']['output']>;
  purchaseValue?: Maybe<Scalars['Decimal']['output']>;
};

export type CampaignRelayType = Node & {
  __typename?: 'CampaignRelayType';
  /** Texto do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonLabelEmail?: Maybe<Scalars['String']['output']>;
  /** URL do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonUrlEmail?: Maybe<Scalars['String']['output']>;
  /** Lista de botões dinâmicos para o template do WhatsApp oficial [{'type': 'URL', 'text': '...', 'url': '...'}, ...] (até 3). Usado apenas para o canal WhatsApp oficial (via_whatsapp_official). */
  buttons: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  date: Scalars['Date']['output'];
  daysToTrigger: Scalars['Int']['output'];
  /** Rodapé do template WhatsApp oficial (máx 60 caracteres, limite da Meta). Usado apenas para via_whatsapp_official. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Texto de rodapé exibido no e-mail. Usado apenas para via_email. */
  footerEmail?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  messageEmail: Scalars['String']['output'];
  messageSms?: Maybe<Scalars['String']['output']>;
  onlyDiscord: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  slug?: Maybe<Scalars['String']['output']>;
  store?: Maybe<StoreType>;
  subject: Scalars['String']['output'];
  tag: CampaignTag;
  title: Scalars['String']['output'];
  triggerCustomerTag?: Maybe<CustomerTagsRelayType>;
  updatedAt: Scalars['DateTime']['output'];
  viaEmail: Scalars['Boolean']['output'];
  viaSms: Scalars['Boolean']['output'];
  viaWhatsapp: Scalars['Boolean']['output'];
  viaWhatsappOfficial: Scalars['Boolean']['output'];
  viaZekiCrm: Scalars['Boolean']['output'];
  whatsappTemplate?: Maybe<WhatsappTemplateType>;
  zekiCrmChannelId?: Maybe<Scalars['String']['output']>;
  zekiCrmChannelNumber?: Maybe<Scalars['String']['output']>;
  zekiCrmTemplate?: Maybe<WhatsappTemplateType>;
  zekiCrmTemplateVariableMapping?: Maybe<Array<Maybe<ZekiCrmTemplateVariableMappingType>>>;
};


export type CampaignRelayTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};

export type CampaignRelayTypeConnection = {
  __typename?: 'CampaignRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CampaignRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CampaignRelayType` and its cursor. */
export type CampaignRelayTypeEdge = {
  __typename?: 'CampaignRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CampaignRelayType>;
};

/** An enumeration. */
export enum CampaignTag {
  /** Carrinho abandonado */
  AbandonedCart = 'ABANDONED_CART',
  /** Tag adicionada ao cliente */
  CustomerTagAdded = 'CUSTOMER_TAG_ADDED',
  /** Dias após uma venda */
  DaysAfterPurchase = 'DAYS_AFTER_PURCHASE',
  /** Dias após uma venda importada */
  DaysAfterPurchaseImported = 'DAYS_AFTER_PURCHASE_IMPORTED',
  /** Giftback cancelado */
  GiftbackCancelled = 'GIFTBACK_CANCELLED',
  /** Giftback gerado */
  GiftbackCreated = 'GIFTBACK_CREATED',
  /** Giftback expirará logo */
  GiftbackExpireSoon = 'GIFTBACK_EXPIRE_SOON',
  /** Giftback expira hoje */
  GiftbackExpireToday = 'GIFTBACK_EXPIRE_TODAY',
  /** Parabéns */
  HappyBirthday = 'HAPPY_BIRTHDAY',
  /** Fidelidade: código de retirada */
  LoyaltyPickupCode = 'LOYALTY_PICKUP_CODE',
  /** Fidelidade: pontos concedidos */
  LoyaltyPointsGranted = 'LOYALTY_POINTS_GRANTED',
  /** Fidelidade: resgate concluído */
  LoyaltyRedemptionCompleted = 'LOYALTY_REDEMPTION_COMPLETED',
  /** Fidelidade: resgate expirado */
  LoyaltyRedemptionExpired = 'LOYALTY_REDEMPTION_EXPIRED',
  /** Fidelidade: resgate iniciado */
  LoyaltyRedemptionStarted = 'LOYALTY_REDEMPTION_STARTED',
  /** Cliente ausente */
  MissingCustomer = 'MISSING_CUSTOMER',
  /** Bem-vindo */
  Welcome = 'WELCOME'
}

export type CampaignType = {
  __typename?: 'CampaignType';
  /** Texto do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonLabelEmail?: Maybe<Scalars['String']['output']>;
  /** URL do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonUrlEmail?: Maybe<Scalars['String']['output']>;
  /** Lista de botões dinâmicos para o template do WhatsApp oficial [{'type': 'URL', 'text': '...', 'url': '...'}, ...] (até 3). Usado apenas para o canal WhatsApp oficial (via_whatsapp_official). */
  buttons: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  date: Scalars['Date']['output'];
  daysToTrigger: Scalars['Int']['output'];
  /** Rodapé do template WhatsApp oficial (máx 60 caracteres, limite da Meta). Usado apenas para via_whatsapp_official. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Texto de rodapé exibido no e-mail. Usado apenas para via_email. */
  footerEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  messageEmail: Scalars['String']['output'];
  messageSms?: Maybe<Scalars['String']['output']>;
  onlyDiscord: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  slug?: Maybe<Scalars['String']['output']>;
  store?: Maybe<StoreType>;
  subject: Scalars['String']['output'];
  tag: CampaignTag;
  title: Scalars['String']['output'];
  triggerCustomerTag?: Maybe<CustomerTagsRelayType>;
  updatedAt: Scalars['DateTime']['output'];
  viaEmail: Scalars['Boolean']['output'];
  viaSms: Scalars['Boolean']['output'];
  viaWhatsapp: Scalars['Boolean']['output'];
  viaWhatsappOfficial: Scalars['Boolean']['output'];
  viaZekiCrm: Scalars['Boolean']['output'];
  whatsappTemplate?: Maybe<WhatsappTemplateType>;
  zekiCrmChannelId?: Maybe<Scalars['String']['output']>;
  zekiCrmChannelNumber?: Maybe<Scalars['String']['output']>;
  zekiCrmTemplate?: Maybe<WhatsappTemplateType>;
  zekiCrmTemplateVariableMapping?: Maybe<Array<Maybe<ZekiCrmTemplateVariableMappingType>>>;
};


export type CampaignTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};

export type CancelCommunityScheduledMessage = {
  __typename?: 'CancelCommunityScheduledMessage';
  message: CommunityScheduledMessage;
};

export type CancelLoyaltyRedemptionMutation = {
  __typename?: 'CancelLoyaltyRedemptionMutation';
  redemption?: Maybe<LoyaltyRedemptionType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelPurchaseInput = {
  crossRegistrationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  purchaseId?: InputMaybe<Scalars['ID']['input']>;
};

export type CancelPurchaseMutation = {
  __typename?: 'CancelPurchaseMutation';
  purchase?: Maybe<PurchaseType>;
};

export type CashRegisterClosingDeclaredAmountInput = {
  amount: Scalars['Decimal']['input'];
  paymentMethodName: Scalars['String']['input'];
};

export type CashRegisterClosingPaymentMethodSummaryType = {
  __typename?: 'CashRegisterClosingPaymentMethodSummaryType';
  calculatedAmount?: Maybe<Scalars['Decimal']['output']>;
  declaredAmount?: Maybe<Scalars['Decimal']['output']>;
  differenceAmount?: Maybe<Scalars['Decimal']['output']>;
  paymentMethodName?: Maybe<Scalars['String']['output']>;
};

export type CashRegisterClosingPaymentMethodType = {
  __typename?: 'CashRegisterClosingPaymentMethodType';
  calculatedAmount: Scalars['Float']['output'];
  closing: CashRegisterClosingType;
  createdAt: Scalars['DateTime']['output'];
  declaredAmount: Scalars['Float']['output'];
  differenceAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  paymentMethodName: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CashRegisterClosingSaveMutation = {
  __typename?: 'CashRegisterClosingSaveMutation';
  cashRegisterClosing?: Maybe<CashRegisterClosingSummaryType>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CashRegisterClosingSummaryType = {
  __typename?: 'CashRegisterClosingSummaryType';
  additionalTotal?: Maybe<Scalars['Decimal']['output']>;
  businessDate?: Maybe<Scalars['Date']['output']>;
  canceledTotal?: Maybe<Scalars['Decimal']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedByEmail?: Maybe<Scalars['String']['output']>;
  closedByName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discountTotal?: Maybe<Scalars['Decimal']['output']>;
  finalTotal?: Maybe<Scalars['Decimal']['output']>;
  paymentMethods?: Maybe<Array<Maybe<CashRegisterClosingPaymentMethodSummaryType>>>;
  periodStartedAt?: Maybe<Scalars['DateTime']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  receivedTotal?: Maybe<Scalars['Decimal']['output']>;
  sangriaTotal?: Maybe<Scalars['Decimal']['output']>;
  totalSales?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CashRegisterClosingType = {
  __typename?: 'CashRegisterClosingType';
  additionalTotal: Scalars['Float']['output'];
  businessDate: Scalars['Date']['output'];
  canceledTotal: Scalars['Float']['output'];
  closedAt: Scalars['DateTime']['output'];
  closedByEmail: Scalars['String']['output'];
  closedByName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  discountTotal: Scalars['Float']['output'];
  finalTotal: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  paymentMethods: Array<CashRegisterClosingPaymentMethodType>;
  periodStartedAt: Scalars['DateTime']['output'];
  pk: Scalars['Int']['output'];
  receivedTotal: Scalars['Float']['output'];
  sangriaTotal: Scalars['Float']['output'];
  store: StoreType;
  totalSales: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
};

/** An enumeration. */
export enum CashRegisterMovementMovementType {
  /** Sangria */
  Sangria = 'SANGRIA'
}

export type CashRegisterMovementType = {
  __typename?: 'CashRegisterMovementType';
  amount: Scalars['Float']['output'];
  businessDate: Scalars['Date']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  movementType: CashRegisterMovementMovementType;
  notes: Scalars['String']['output'];
  operatorName?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
};

export type CashRegisterSangriaCreateMutation = {
  __typename?: 'CashRegisterSangriaCreateMutation';
  cashAvailable?: Maybe<Scalars['Decimal']['output']>;
  cashRegisterMovement?: Maybe<CashRegisterMovementType>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum CategoryImportedFrom {
  /** Bling */
  Bling = 'BLING',
  /** Giftback criado separadamente */
  CreateOnlyGiftback = 'CREATE_ONLY_GIFTBACK',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** PDV */
  Pdv = 'PDV',
  /** Quick ERP */
  QuickErp = 'QUICK_ERP',
  /** SGI */
  Sgi = 'SGI',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Totem */
  Totem = 'TOTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type CategoryRelayType = Node & {
  __typename?: 'CategoryRelayType';
  coupons: CouponRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  customertagsSet: CustomerTagsRelayTypeConnection;
  date: Scalars['Date']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  giftbackCouponConfigs: Array<GiftbackConfigType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedFrom: CategoryImportedFrom;
  integrationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  productSet: ProductRelayTypeConnection;
  store: StoreType;
  subcategories: CategoryRelayTypeConnection;
  subcategory?: Maybe<CategoryRelayType>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CategoryRelayTypeCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryRelayTypeCustomertagsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryRelayTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type CategoryRelayTypeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryRelayTypeConnection = {
  __typename?: 'CategoryRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CategoryRelayType` and its cursor. */
export type CategoryRelayTypeEdge = {
  __typename?: 'CategoryRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoryRelayType>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  coupons: CouponRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  customertagsSet: CustomerTagsRelayTypeConnection;
  date: Scalars['Date']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  giftbackCouponConfigs: Array<GiftbackConfigType>;
  id: Scalars['ID']['output'];
  importedFrom: CategoryImportedFrom;
  integrationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  productSet: ProductRelayTypeConnection;
  store: StoreType;
  subcategories: CategoryRelayTypeConnection;
  subcategory?: Maybe<CategoryRelayType>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CategoryTypeCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryTypeCustomertagsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type CategoryTypeSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeAppointmentStatusMutation = {
  __typename?: 'ChangeAppointmentStatusMutation';
  appointment?: Maybe<AppointmentType>;
};

export type ChartsConfigType = {
  __typename?: 'ChartsConfigType';
  city: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  gender: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  state: Scalars['Boolean']['output'];
  store: StoreType;
  tags: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  yearRange: Scalars['Boolean']['output'];
};

export type CityType = {
  __typename?: 'CityType';
  id?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

export type ColumnStatusInput = {
  boardId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type ColumnStatusNode = Node & {
  __typename?: 'ColumnStatusNode';
  board: BoardNode;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  taskSet: TaskNodeConnection;
};


export type ColumnStatusNodeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columnStatus?: InputMaybe<Scalars['ID']['input']>;
  columnStatus_IntegrationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['ID']['input']>;
};

export type ColumnStatusNodeConnection = {
  __typename?: 'ColumnStatusNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ColumnStatusNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ColumnStatusNode` and its cursor. */
export type ColumnStatusNodeEdge = {
  __typename?: 'ColumnStatusNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ColumnStatusNode>;
};

export type ColumnStatusType = {
  __typename?: 'ColumnStatusType';
  board: BoardNode;
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  taskSet: TaskNodeConnection;
};


export type ColumnStatusTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columnStatus?: InputMaybe<Scalars['ID']['input']>;
  columnStatus_IntegrationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['ID']['input']>;
};

export type Community = {
  __typename?: 'Community';
  addedCount: Scalars['Int']['output'];
  adminsOnly: Scalars['Boolean']['output'];
  audienceSelectionId?: Maybe<Scalars['ID']['output']>;
  canRetry: Scalars['Boolean']['output'];
  connectionPhone: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  duplicateCount: Scalars['Int']['output'];
  eligibleCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  groupJid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instanceName: Scalars['String']['output'];
  invalidCount: Scalars['Int']['output'];
  lastError: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pendingCount: Scalars['Int']['output'];
  sourceLabel: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityCapability = {
  __typename?: 'CommunityCapability';
  connectionPhone: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  instanceName: Scalars['String']['output'];
  maxMembers: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type CommunityMember = {
  __typename?: 'CommunityMember';
  customerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CommunityMemberPage = {
  __typename?: 'CommunityMemberPage';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<CommunityMember>;
  total: Scalars['Int']['output'];
};

export type CommunityPage = {
  __typename?: 'CommunityPage';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<Community>;
  total: Scalars['Int']['output'];
};

export type CommunityScheduledMessage = {
  __typename?: 'CommunityScheduledMessage';
  canCancel: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  communityId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastError: Scalars['String']['output'];
  revision: Scalars['Int']['output'];
  scheduledAt: Scalars['DateTime']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunityScheduledMessagePage = {
  __typename?: 'CommunityScheduledMessagePage';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<CommunityScheduledMessage>;
  total: Scalars['Int']['output'];
};

export type ConfirmCommunity = {
  __typename?: 'ConfirmCommunity';
  community: Community;
};

export type ConfirmCommunityInput = {
  adminsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  communityId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ConnectOrDisconnectEvolutionApiIntegrationInput = {
  connected: Scalars['Boolean']['input'];
};

export type ConnectOrDisconnectEvolutionApiIntegrationMutation = {
  __typename?: 'ConnectOrDisconnectEvolutionApiIntegrationMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type ConnectedStoreIntegrationType = {
  __typename?: 'ConnectedStoreIntegrationType';
  integration?: Maybe<Scalars['String']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
};

export type CouponCreateInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Vazio significa uso ilimitado */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  /** FIXED ou PERCENTAGE */
  valueType?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum CouponImportedFrom {
  /** Bling */
  Bling = 'BLING',
  /** Giftback criado separadamente */
  CreateOnlyGiftback = 'CREATE_ONLY_GIFTBACK',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** PDV */
  Pdv = 'PDV',
  /** Quick ERP */
  QuickErp = 'QUICK_ERP',
  /** SGI */
  Sgi = 'SGI',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Totem */
  Totem = 'TOTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type CouponInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Vazio significa uso ilimitado */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['Decimal']['input'];
  /** FIXED ou PERCENTAGE */
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type CouponRelayType = Node & {
  __typename?: 'CouponRelayType';
  bulknotificationSet: BulkNotificationRelayTypeConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  eligibleCategories: CategoryRelayTypeConnection;
  eligibleProducts: ProductRelayTypeConnection;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedFrom: CouponImportedFrom;
  /** Vazio significa que o cupom não foi sincronizado com a plataforma. */
  integrationId: Scalars['String']['output'];
  isCumulative: Scalars['Boolean']['output'];
  isFreeShipping: Scalars['Boolean']['output'];
  loyaltyRedemption?: Maybe<LoyaltyRedemptionType>;
  pk: Scalars['Int']['output'];
  purchases: PurchaseRelayTypeConnection;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  /** Vazio significa uso ilimitado. */
  usageLimit?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Float']['output'];
  valueType: CouponValueType;
};


export type CouponRelayTypeBulknotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  endTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  startTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateStatus?: InputMaybe<Scalars['String']['input']>;
};


export type CouponRelayTypeEligibleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type CouponRelayTypeEligibleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type CouponRelayTypePurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

export type CouponRelayTypeConnection = {
  __typename?: 'CouponRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CouponRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CouponRelayType` and its cursor. */
export type CouponRelayTypeEdge = {
  __typename?: 'CouponRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CouponRelayType>;
};

export type CouponType = {
  __typename?: 'CouponType';
  bulknotificationSet: BulkNotificationRelayTypeConnection;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  eligibleCategories: CategoryRelayTypeConnection;
  eligibleProducts: ProductRelayTypeConnection;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  importedFrom: CouponImportedFrom;
  /** Vazio significa que o cupom não foi sincronizado com a plataforma. */
  integrationId: Scalars['String']['output'];
  isCumulative: Scalars['Boolean']['output'];
  isFreeShipping: Scalars['Boolean']['output'];
  loyaltyRedemption?: Maybe<LoyaltyRedemptionType>;
  pk: Scalars['Int']['output'];
  purchases: PurchaseRelayTypeConnection;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  /** Vazio significa uso ilimitado. */
  usageLimit?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Float']['output'];
  valueType: CouponValueType;
};


export type CouponTypeBulknotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  endTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  startTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateStatus?: InputMaybe<Scalars['String']['input']>;
};


export type CouponTypeEligibleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type CouponTypeEligibleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type CouponTypePurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

/** An enumeration. */
export enum CouponValueType {
  /** Fixo */
  Fixed = 'FIXED',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type CreateBoard = {
  __typename?: 'CreateBoard';
  board?: Maybe<BoardType>;
};

export type CreateBulkNotificationMutation = {
  __typename?: 'CreateBulkNotificationMutation';
  bulkNotification?: Maybe<BulkNotificationType>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCampaignInput = {
  /** Texto do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonLabelEmail?: InputMaybe<Scalars['String']['input']>;
  /** URL do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonUrlEmail?: InputMaybe<Scalars['String']['input']>;
  /** Botões do template WhatsApp oficial (máx 3, tipos URL/QUICK_REPLY/PHONE_NUMBER). Usado apenas quando via_whatsapp_official=true. */
  buttons?: InputMaybe<Array<InputMaybe<WhatsappButtonInput>>>;
  daysToTrigger?: InputMaybe<Scalars['Int']['input']>;
  /** Rodapé do template WhatsApp oficial (máx 60 caracteres). Usado apenas para via_whatsapp_official. */
  footer?: InputMaybe<Scalars['String']['input']>;
  /** Rodapé exibido no e-mail. Usado apenas para via_email. */
  footerEmail?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageEmail?: InputMaybe<Scalars['String']['input']>;
  messageSms?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  triggerCustomerTagId?: InputMaybe<Scalars['ID']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  zekiCrmChannelId?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelNumber?: InputMaybe<Scalars['String']['input']>;
  zekiCrmTemplateId?: InputMaybe<Scalars['ID']['input']>;
  zekiCrmTemplateVariableMapping?: InputMaybe<Array<InputMaybe<ZekiCrmTemplateVariableMappingInput>>>;
};

export type CreateCampaignMutation = {
  __typename?: 'CreateCampaignMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCashRegisterSangriaInput = {
  amount: Scalars['Decimal']['input'];
  businessDate: Scalars['Date']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCategoryInput = {
  categories: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateCategoryMutation = {
  __typename?: 'CreateCategoryMutation';
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateColumnStatus = {
  __typename?: 'CreateColumnStatus';
  columnStatus?: Maybe<ColumnStatusType>;
};

export type CreateCouponMutation = {
  __typename?: 'CreateCouponMutation';
  coupon?: Maybe<CouponType>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCustomUserMutation = {
  __typename?: 'CreateCustomUserMutation';
  customUser?: Maybe<CustomUserType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCustomer = {
  __typename?: 'CreateCustomer';
  customer?: Maybe<CustomerType>;
};

export type CreateCustomerInput = {
  acquisitionChannelId?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<CustomerGender>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  tagsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerTagsInput = {
  tags: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateCustomerTagsMutation = {
  __typename?: 'CreateCustomerTagsMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  tagsList?: Maybe<Array<Maybe<CustomerTagsType>>>;
};

export type CreateEmailTemplateMutation = {
  __typename?: 'CreateEmailTemplateMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<EmailTemplateType>;
};

export type CreateGiftbackInput = {
  crossRegistrationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  dueInDays?: InputMaybe<Scalars['Decimal']['input']>;
  minValueToRedeem?: InputMaybe<Scalars['Decimal']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateGiftbackMutation = {
  __typename?: 'CreateGiftbackMutation';
  giftback?: Maybe<GiftbackType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateInstance = {
  __typename?: 'CreateInstance';
  instance?: Maybe<InstanceType>;
};

export type CreateIntegration = {
  __typename?: 'CreateIntegration';
  integration?: Maybe<IntegrationType>;
};

export type CreateInternalAppointmentMutation = {
  __typename?: 'CreateInternalAppointmentMutation';
  appointment?: Maybe<AppointmentType>;
};

export type CreateLead = {
  __typename?: 'CreateLead';
  lead?: Maybe<LeadType>;
};

export type CreateLoyaltyRedemptionMutation = {
  __typename?: 'CreateLoyaltyRedemptionMutation';
  redemption?: Maybe<LoyaltyRedemptionType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProductBulkInput = {
  categoriesId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  costValue?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  wholesaleValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateProductBulkMutation = {
  __typename?: 'CreateProductBulkMutation';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductType>;
};

export type CreateProductInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  costValue?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  wholesaleValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateProductMutation = {
  __typename?: 'CreateProductMutation';
  error?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductType>;
};

export type CreatePublicAppointmentMutation = {
  __typename?: 'CreatePublicAppointmentMutation';
  result?: Maybe<AppointmentBookingResultType>;
};

export type CreatePurchaseInput = {
  canRegisterGiftback?: InputMaybe<Scalars['Boolean']['input']>;
  crossRegistrationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Decimal']['input']>;
  giftbackCode?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethodInput>>>;
  products?: InputMaybe<Array<InputMaybe<PurchaseProductInput>>>;
  services?: InputMaybe<Array<InputMaybe<PurchaseServiceInput>>>;
  taxes?: InputMaybe<Scalars['Decimal']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreatePurchaseMutation = {
  __typename?: 'CreatePurchaseMutation';
  error?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<PurchaseType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreatePurchaseTotemInput = {
  canRegisterGiftback?: InputMaybe<Scalars['Boolean']['input']>;
  creditHouseInstallments?: InputMaybe<Scalars['Int']['input']>;
  creditHouseTax?: InputMaybe<Scalars['Decimal']['input']>;
  crossRegistrationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['ID']['input'];
  giftbackCode?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export type CreatePurchaseTotemMutation = {
  __typename?: 'CreatePurchaseTotemMutation';
  error?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<PurchaseType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateStoreInput = {
  cnpj?: InputMaybe<Scalars['String']['input']>;
  currencyType?: InputMaybe<StoreCurrencyType>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<StorePlan>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStoreMutation = {
  __typename?: 'CreateStoreMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  store?: Maybe<StoreType>;
};

export type CreateTask = {
  __typename?: 'CreateTask';
  task?: Maybe<TaskType>;
};

export type CreateTrayStoreIntegration = {
  __typename?: 'CreateTrayStoreIntegration';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateTrayStoreIntegrationInput = {
  apiKey: Scalars['String']['input'];
  code: Scalars['String']['input'];
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId: Scalars['String']['input'];
};

export type CreateUserInput = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  cpf: Scalars['String']['input'];
  email: Scalars['String']['input'];
  gender?: InputMaybe<CustomerGender>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<PermissionUserType>;
};

export type CreateWhatsappTemplateByCampaignInput = {
  campaignId: Scalars['ID']['input'];
};

export type CreateWhatsappTemplateByCampaignMutation = {
  __typename?: 'CreateWhatsappTemplateByCampaignMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditHouseConfigType = {
  __typename?: 'CreditHouseConfigType';
  credithousegiftbackconfigSet: Array<CreditHouseGiftbackConfigType>;
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
};

/** An enumeration. */
export enum CreditHouseGiftbackConfigGiftbackTypeValue {
  /** R$ */
  Fixed = 'FIXED',
  /** % */
  Percentage = 'PERCENTAGE'
}

export type CreditHouseGiftbackConfigType = {
  __typename?: 'CreditHouseGiftbackConfigType';
  createdAt: Scalars['DateTime']['output'];
  creditHouseConfig: CreditHouseConfigType;
  giftbackTypeValue: CreditHouseGiftbackConfigGiftbackTypeValue;
  giftbackValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  loanMaxValue: Scalars['Float']['output'];
  loanMinValue: Scalars['Float']['output'];
  pk: Scalars['Int']['output'];
  taxMaxValue: Scalars['Float']['output'];
  taxMinValue: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreditHousePurchaseType = {
  __typename?: 'CreditHousePurchaseType';
  id: Scalars['ID']['output'];
  installments: Scalars['Int']['output'];
  pk: Scalars['Int']['output'];
  purchase: PurchaseRelayType;
  tax: Scalars['Float']['output'];
};

export type CreditLoyaltyPointsMutation = {
  __typename?: 'CreditLoyaltyPointsMutation';
  member?: Maybe<LoyaltyMemberType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum CustomUserGender {
  /** Feminino */
  Female = 'FEMALE',
  /** Masculino */
  Male = 'MALE',
  /** Indefinido */
  NotInformed = 'NOT_INFORMED'
}

export type CustomUserNode = Node & {
  __typename?: 'CustomUserNode';
  acceptedTerm?: Maybe<Scalars['Boolean']['output']>;
  appointmentProfessionals: Array<ProfessionalType>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  boardSet: BoardNodeConnection;
  cancelledAppointments: Array<AppointmentType>;
  cashregisterclosingSet: Array<CashRegisterClosingType>;
  cashregistermovementSet: Array<CashRegisterMovementType>;
  colaborators: BoardNodeConnection;
  connectedStore?: Maybe<StoreType>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAppointments: Array<AppointmentType>;
  createdAt: Scalars['DateTime']['output'];
  createdJourneyDrafts: Array<JourneyDraftType>;
  createdJourneys: Array<JourneyType>;
  createdLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dateJoined: Scalars['DateTime']['output'];
  deliveredLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<CustomUserGender>;
  giftbackSet: GiftbackRelayTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instanceSet: InstanceNodeConnection;
  integrationSet: IntegrationNodeConnection;
  /** Indica que o usuário será tratado como ativo. Ao invés de excluir contas de usuário, desmarque isso. */
  isActive: Scalars['Boolean']['output'];
  /** Indica que usuário consegue acessar este site de administração. */
  isStaff: Scalars['Boolean']['output'];
  journeyOwnershipChanges: Array<JourneyOwnershipType>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  loyaltyredemptiontransitionSet: Array<LoyaltyRedemptionTransitionType>;
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<PermissionType>;
  phone?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  profile: CustomUserProfile;
  publishedJourneyVersions: Array<JourneyVersionType>;
  purchaseSet: PurchaseRelayTypeConnection;
  redeemedGiftbacks: GiftbackRelayTypeConnection;
  scheduleadjustmentSet: Array<ScheduleAdjustmentType>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  taskSet: TaskNodeConnection;
  updatedAt: Scalars['DateTime']['output'];
  updatedJourneyDrafts: Array<JourneyDraftType>;
  updatedJourneys: Array<JourneyType>;
  useracceptationSet: Array<UserAcceptationType>;
  /** Obrigatório. 150 caracteres ou menos. Letras, números e @/./+/-/_ apenas. */
  username: Scalars['String']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};


export type CustomUserNodeBoardSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserNodeColaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserNodeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type CustomUserNodeGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserNodeInstanceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserNodeIntegrationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserNodePurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserNodeRedeemedGiftbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserNodeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columnStatus?: InputMaybe<Scalars['ID']['input']>;
  columnStatus_IntegrationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomUserNodeConnection = {
  __typename?: 'CustomUserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomUserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomUserNode` and its cursor. */
export type CustomUserNodeEdge = {
  __typename?: 'CustomUserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomUserNode>;
};

/** An enumeration. */
export enum CustomUserProfile {
  /** Admin */
  Admin = 'ADMIN',
  /** Funcionário */
  Employee = 'EMPLOYEE',
  /** Vendedor */
  Seller = 'SELLER'
}

export type CustomUserRelayType = Node & {
  __typename?: 'CustomUserRelayType';
  appointmentProfessionals: Array<ProfessionalType>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  boardSet: BoardNodeConnection;
  cancelledAppointments: Array<AppointmentType>;
  cashregisterclosingSet: Array<CashRegisterClosingType>;
  cashregistermovementSet: Array<CashRegisterMovementType>;
  colaborators: BoardNodeConnection;
  connectedStore?: Maybe<StoreType>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAppointments: Array<AppointmentType>;
  createdAt: Scalars['DateTime']['output'];
  createdJourneyDrafts: Array<JourneyDraftType>;
  createdJourneys: Array<JourneyType>;
  createdLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dateJoined: Scalars['DateTime']['output'];
  deliveredLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<CustomUserGender>;
  giftbackSet: GiftbackRelayTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instanceSet: InstanceNodeConnection;
  integrationSet: IntegrationNodeConnection;
  /** Indica que o usuário será tratado como ativo. Ao invés de excluir contas de usuário, desmarque isso. */
  isActive: Scalars['Boolean']['output'];
  /** Indica que usuário consegue acessar este site de administração. */
  isStaff: Scalars['Boolean']['output'];
  /** Indica que este usuário tem todas as permissões sem atribuí-las explicitamente. */
  isSuperuser: Scalars['Boolean']['output'];
  journeyOwnershipChanges: Array<JourneyOwnershipType>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  loyaltyredemptiontransitionSet: Array<LoyaltyRedemptionTransitionType>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  permissionInStore?: Maybe<PermissionType>;
  permissions: Array<PermissionType>;
  phone?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  profile: CustomUserProfile;
  publishedJourneyVersions: Array<JourneyVersionType>;
  purchaseSet: PurchaseRelayTypeConnection;
  redeemedGiftbacks: GiftbackRelayTypeConnection;
  scheduleadjustmentSet: Array<ScheduleAdjustmentType>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  taskSet: TaskNodeConnection;
  updatedAt: Scalars['DateTime']['output'];
  updatedJourneyDrafts: Array<JourneyDraftType>;
  updatedJourneys: Array<JourneyType>;
  useracceptationSet: Array<UserAcceptationType>;
  /** Obrigatório. 150 caracteres ou menos. Letras, números e @/./+/-/_ apenas. */
  username: Scalars['String']['output'];
};


export type CustomUserRelayTypeBoardSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserRelayTypeColaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserRelayTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type CustomUserRelayTypeGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserRelayTypeInstanceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserRelayTypeIntegrationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserRelayTypePurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserRelayTypeRedeemedGiftbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserRelayTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columnStatus?: InputMaybe<Scalars['ID']['input']>;
  columnStatus_IntegrationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomUserRelayTypeConnection = {
  __typename?: 'CustomUserRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomUserRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomUserRelayType` and its cursor. */
export type CustomUserRelayTypeEdge = {
  __typename?: 'CustomUserRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomUserRelayType>;
};

export type CustomUserType = {
  __typename?: 'CustomUserType';
  appointmentProfessionals: Array<ProfessionalType>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  boardSet: BoardNodeConnection;
  cancelledAppointments: Array<AppointmentType>;
  cashregisterclosingSet: Array<CashRegisterClosingType>;
  cashregistermovementSet: Array<CashRegisterMovementType>;
  colaborators: BoardNodeConnection;
  connectedStore?: Maybe<StoreType>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAppointments: Array<AppointmentType>;
  createdAt: Scalars['DateTime']['output'];
  createdJourneyDrafts: Array<JourneyDraftType>;
  createdJourneys: Array<JourneyType>;
  createdLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dateJoined: Scalars['DateTime']['output'];
  deliveredLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<CustomUserGender>;
  giftbackSet: GiftbackRelayTypeConnection;
  id: Scalars['ID']['output'];
  instanceSet: InstanceNodeConnection;
  integrationSet: IntegrationNodeConnection;
  /** Indica que o usuário será tratado como ativo. Ao invés de excluir contas de usuário, desmarque isso. */
  isActive: Scalars['Boolean']['output'];
  /** Indica que usuário consegue acessar este site de administração. */
  isStaff: Scalars['Boolean']['output'];
  /** Indica que este usuário tem todas as permissões sem atribuí-las explicitamente. */
  isSuperuser: Scalars['Boolean']['output'];
  journeyOwnershipChanges: Array<JourneyOwnershipType>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  loyaltyredemptiontransitionSet: Array<LoyaltyRedemptionTransitionType>;
  name?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  permissions: Array<PermissionType>;
  phone?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  profile: CustomUserProfile;
  publishedJourneyVersions: Array<JourneyVersionType>;
  purchaseSet: PurchaseRelayTypeConnection;
  redeemedGiftbacks: GiftbackRelayTypeConnection;
  scheduleadjustmentSet: Array<ScheduleAdjustmentType>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  taskSet: TaskNodeConnection;
  updatedAt: Scalars['DateTime']['output'];
  updatedJourneyDrafts: Array<JourneyDraftType>;
  updatedJourneys: Array<JourneyType>;
  useracceptationSet: Array<UserAcceptationType>;
  /** Obrigatório. 150 caracteres ou menos. Letras, números e @/./+/-/_ apenas. */
  username: Scalars['String']['output'];
};


export type CustomUserTypeBoardSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserTypeColaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type CustomUserTypeGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserTypeInstanceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserTypeIntegrationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type CustomUserTypePurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserTypeRedeemedGiftbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomUserTypeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columnStatus?: InputMaybe<Scalars['ID']['input']>;
  columnStatus_IntegrationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomerAcquisitionChannelRelayType = Node & {
  __typename?: 'CustomerAcquisitionChannelRelayType';
  createdAt: Scalars['DateTime']['output'];
  customers: CustomerTypeRelayConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerAcquisitionChannelRelayTypeCustomersArgs = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerAcquisitionChannelRelayTypeConnection = {
  __typename?: 'CustomerAcquisitionChannelRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerAcquisitionChannelRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerAcquisitionChannelRelayType` and its cursor. */
export type CustomerAcquisitionChannelRelayTypeEdge = {
  __typename?: 'CustomerAcquisitionChannelRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerAcquisitionChannelRelayType>;
};

export type CustomerAcquisitionChannelType = {
  __typename?: 'CustomerAcquisitionChannelType';
  createdAt: Scalars['DateTime']['output'];
  customers: CustomerTypeRelayConnection;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerAcquisitionChannelTypeCustomersArgs = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerActivitiesTypeRelay = Node & {
  __typename?: 'CustomerActivitiesTypeRelay';
  activity?: Maybe<CustomerActivityActivity>;
  appointment?: Maybe<AppointmentType>;
  campaign?: Maybe<CampaignRelayType>;
  channelEmail: Scalars['Boolean']['output'];
  channelSms: Scalars['Boolean']['output'];
  channelWhatsapp: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerTypeRelay;
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  giftback?: Maybe<GiftbackRelayType>;
  hour: Scalars['Time']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  messageBody?: Maybe<Scalars['String']['output']>;
  /** Status de entrega/leitura da mensagem */
  messageStatus?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  source: CustomerActivitySource;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
};

export type CustomerActivitiesTypeRelayConnection = {
  __typename?: 'CustomerActivitiesTypeRelayConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerActivitiesTypeRelayEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerActivitiesTypeRelay` and its cursor. */
export type CustomerActivitiesTypeRelayEdge = {
  __typename?: 'CustomerActivitiesTypeRelayEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerActivitiesTypeRelay>;
};

/** An enumeration. */
export enum CustomerActivityActivity {
  /** Appointment */
  Appointment = 'APPOINTMENT',
  /** Customer */
  Customer = 'CUSTOMER',
  /** Giftback */
  Giftback = 'GIFTBACK',
  /** Purchases */
  Purchase = 'PURCHASE',
  /** User */
  User = 'USER'
}

/** An enumeration. */
export enum CustomerActivitySource {
  /** Bling */
  Bling = 'BLING',
  /** Giftback criado separadamente */
  CreateOnlyGiftback = 'CREATE_ONLY_GIFTBACK',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** PDV */
  Pdv = 'PDV',
  /** Quick ERP */
  QuickErp = 'QUICK_ERP',
  /** SGI */
  Sgi = 'SGI',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Totem */
  Totem = 'TOTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type CustomerAppointmentInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum CustomerAudienceFilterContext {
  Dashboard = 'DASHBOARD',
  List = 'LIST'
}

export type CustomerCustomFieldOptionsType = {
  __typename?: 'CustomerCustomFieldOptionsType';
  hasMore: Scalars['Boolean']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CustomerCustomFieldType = {
  __typename?: 'CustomerCustomFieldType';
  fieldType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  metadataPath: Array<Scalars['GenericScalar']['output']>;
  pk: Scalars['Int']['output'];
};

export type CustomerCustomFieldValueType = {
  __typename?: 'CustomerCustomFieldValueType';
  field: CustomerCustomFieldType;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['GenericScalar']['output']>;
};

export type CustomerDashboardCardsReturn = {
  __typename?: 'CustomerDashboardCardsReturn';
  averagePurchaseCountPerCustomer?: Maybe<Scalars['Float']['output']>;
  averageValuePerCustomer?: Maybe<Scalars['Float']['output']>;
  totalCustomers?: Maybe<Scalars['Int']['output']>;
};

export type CustomerExcelReportInput = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  /** Birthdates by Month and Day (MM-DD) */
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  /** Maximum Days Without Purchase */
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum Days Without Purchase */
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Name (OR) Email */
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name (Or) Email (Or) Phone */
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  /** Ordenando */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Phone (Or) Tax document */
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  /** Purchase Coupon Code */
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  /** Purchase Date Gte */
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  /** Purchase Date Lte */
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  /** RFM Classification  */
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['Float']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerExcelReportType = {
  __typename?: 'CustomerExcelReportType';
  background?: Maybe<Scalars['Boolean']['output']>;
  relatorio?: Maybe<Scalars['String']['output']>;
};

export type CustomerFilterSetInput = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  /** Birthdates by Month and Day (MM-DD) */
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  /** Maximum Days Without Purchase */
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum Days Without Purchase */
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Name (OR) Email */
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name (Or) Email (Or) Phone */
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  /** Ordenando */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Phone (Or) Tax document */
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  /** Purchase Coupon Code */
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  /** Purchase Date Gte */
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  /** Purchase Date Lte */
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  /** RFM Classification  */
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['Float']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** An enumeration. */
export enum CustomerGender {
  /** Feminino */
  Female = 'FEMALE',
  /** Masculino */
  Male = 'MALE',
  /** Indefinido */
  NotInformed = 'NOT_INFORMED'
}

/** An enumeration. */
export enum CustomerHasWhatsapp {
  /** Não */
  No = 'NO',
  /** Desconhecido */
  Unknown = 'UNKNOWN',
  /** Sim */
  Yes = 'YES'
}

/** An enumeration. */
export enum CustomerImportedFrom {
  /** Bling */
  Bling = 'BLING',
  /** Giftback criado separadamente */
  CreateOnlyGiftback = 'CREATE_ONLY_GIFTBACK',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** PDV */
  Pdv = 'PDV',
  /** Quick ERP */
  QuickErp = 'QUICK_ERP',
  /** SGI */
  Sgi = 'SGI',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Totem */
  Totem = 'TOTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type CustomerMetadataOptionType = {
  __typename?: 'CustomerMetadataOptionType';
  path: Array<Scalars['GenericScalar']['output']>;
  preview: Scalars['String']['output'];
  previewTruncated: Scalars['Boolean']['output'];
  suggestedType: Scalars['String']['output'];
};

export type CustomerMetadataSampleType = {
  __typename?: 'CustomerMetadataSampleType';
  customerId: Scalars['ID']['output'];
  fields: Array<CustomerMetadataOptionType>;
  truncated: Scalars['Boolean']['output'];
  unsupportedCount: Scalars['Int']['output'];
};

export type CustomerRecencyPerPeriodInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CustomerRecencyPerPeriodListType = {
  __typename?: 'CustomerRecencyPerPeriodListType';
  data?: Maybe<Array<Maybe<CustomerRecencyPerPeriodType>>>;
  kindOfDate?: Maybe<Scalars['String']['output']>;
};

export type CustomerRecencyPerPeriodType = {
  __typename?: 'CustomerRecencyPerPeriodType';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CustomerTagsDonutChartReturn = {
  __typename?: 'CustomerTagsDonutChartReturn';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type CustomerTagsRelayType = Node & {
  __typename?: 'CustomerTagsRelayType';
  categories: CategoryRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  customerSet: CustomerTypeRelayConnection;
  date: Scalars['Date']['output'];
  giftbackConfigs: Array<MultipleGiftbackConfigType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  keywords: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  products: ProductRelayTypeConnection;
  store?: Maybe<StoreType>;
  tagType?: Maybe<CustomerTagsTagType>;
  triggeredCampaigns: CampaignRelayTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerTagsRelayTypeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerTagsRelayTypeCustomerSetArgs = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type CustomerTagsRelayTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type CustomerTagsRelayTypeTriggeredCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tag_Icontains?: InputMaybe<Scalars['String']['input']>;
  titleOrMessage?: InputMaybe<Scalars['String']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerTagsRelayTypeConnection = {
  __typename?: 'CustomerTagsRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerTagsRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerTagsRelayType` and its cursor. */
export type CustomerTagsRelayTypeEdge = {
  __typename?: 'CustomerTagsRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerTagsRelayType>;
};

/** An enumeration. */
export enum CustomerTagsTagType {
  /** Vazio */
  A = 'A_',
  /** Categoria */
  Category = 'CATEGORY',
  /** Palavra-chave */
  Keyword = 'KEYWORD',
  /** Produto */
  Product = 'PRODUCT'
}

export type CustomerTagsType = {
  __typename?: 'CustomerTagsType';
  categories: CategoryRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  customerSet: CustomerTypeRelayConnection;
  date: Scalars['Date']['output'];
  giftbackConfigs: Array<MultipleGiftbackConfigType>;
  id: Scalars['ID']['output'];
  keywords: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  products: ProductRelayTypeConnection;
  store?: Maybe<StoreType>;
  tagType?: Maybe<CustomerTagsTagType>;
  triggeredCampaigns: CampaignRelayTypeConnection;
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerTagsTypeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type CustomerTagsTypeCustomerSetArgs = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type CustomerTagsTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type CustomerTagsTypeTriggeredCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tag_Icontains?: InputMaybe<Scalars['String']['input']>;
  titleOrMessage?: InputMaybe<Scalars['String']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerType = {
  __typename?: 'CustomerType';
  acquisitionChannel?: Maybe<CustomerAcquisitionChannelRelayType>;
  address?: Maybe<Scalars['String']['output']>;
  appointments: Array<AppointmentType>;
  averageTicket: Scalars['Float']['output'];
  avgDaysBetweenPurchases: Scalars['Float']['output'];
  bulknotificationcustomerSet: BulkNotificationCustomerRelayTypeConnection;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<CustomerCustomFieldValueType>;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  frequencyClass?: Maybe<Scalars['Int']['output']>;
  frequencyValueAverage?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<CustomerGender>;
  giftbackSet: GiftbackRelayTypeConnection;
  hasWhatsapp: CustomerHasWhatsapp;
  id: Scalars['ID']['output'];
  importedFrom: CustomerImportedFrom;
  integrationId?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  journeyActionIntents: Array<JourneyActionIntentType>;
  journeyExecutions: Array<JourneyExecutionType>;
  lastPurchaseDate?: Maybe<Scalars['Date']['output']>;
  loyaltyMemberships: Array<LoyaltyMemberType>;
  monetaryValueClass?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  penultimatePurchaseDate?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  purchaseSet: PurchaseRelayTypeConnection;
  recency?: Maybe<Scalars['Int']['output']>;
  recencyClass?: Maybe<Scalars['Int']['output']>;
  rfmAverage?: Maybe<Scalars['Float']['output']>;
  rfmClassification?: Maybe<Scalars['String']['output']>;
  rfmCode?: Maybe<Scalars['String']['output']>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  state?: Maybe<Scalars['String']['output']>;
  store: StoreType;
  tags: CustomerTagsRelayTypeConnection;
  taxDocument?: Maybe<Scalars['String']['output']>;
  totalMonetaryValue: Scalars['Float']['output'];
  totalPurchasesCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerTypeBulknotificationcustomerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type CustomerTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type CustomerTypeGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerTypePurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerTypeRelay = Node & {
  __typename?: 'CustomerTypeRelay';
  acquisitionChannel?: Maybe<CustomerAcquisitionChannelRelayType>;
  address?: Maybe<Scalars['String']['output']>;
  appointments: Array<AppointmentType>;
  averageTicket: Scalars['Float']['output'];
  avgDaysBetweenPurchases: Scalars['Float']['output'];
  bulknotificationcustomerSet: BulkNotificationCustomerRelayTypeConnection;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  frequencyClass?: Maybe<Scalars['Int']['output']>;
  frequencyValueAverage?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<CustomerGender>;
  giftbackSet: GiftbackRelayTypeConnection;
  hasWhatsapp: CustomerHasWhatsapp;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedFrom: CustomerImportedFrom;
  integrationId?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  journeyActionIntents: Array<JourneyActionIntentType>;
  journeyExecutions: Array<JourneyExecutionType>;
  lastPurchaseDate?: Maybe<Scalars['Date']['output']>;
  loyaltyMemberships: Array<LoyaltyMemberType>;
  monetaryValueClass?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  penultimatePurchaseDate?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  purchaseSet: PurchaseRelayTypeConnection;
  recencyClass?: Maybe<Scalars['Int']['output']>;
  rfmAverage?: Maybe<Scalars['Float']['output']>;
  rfmClassification?: Maybe<Scalars['String']['output']>;
  rfmCode?: Maybe<Scalars['String']['output']>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  state?: Maybe<Scalars['String']['output']>;
  store: StoreType;
  tags: CustomerTagsRelayTypeConnection;
  taxDocument?: Maybe<Scalars['String']['output']>;
  totalMonetaryValue: Scalars['Float']['output'];
  totalPurchasesCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerTypeRelayBulknotificationcustomerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type CustomerTypeRelayCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type CustomerTypeRelayGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerTypeRelayPurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type CustomerTypeRelayTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerTypeRelayConnection = {
  __typename?: 'CustomerTypeRelayConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerTypeRelayEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerTypeRelay` and its cursor. */
export type CustomerTypeRelayEdge = {
  __typename?: 'CustomerTypeRelayEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerTypeRelay>;
};

export type DashboardCustomersByCityResponse = {
  __typename?: 'DashboardCustomersByCityResponse';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DeleteAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/**
 * Delete account permanently or make `user.is_active=False`.
 *
 * The behavior is defined on settings.
 * Anyway user refresh tokens are revoked.
 *
 * User must be verified and confirm password.
 */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBoard = {
  __typename?: 'DeleteBoard';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCampaignInput = {
  campaignId: Scalars['ID']['input'];
};

export type DeleteCampaignMutation = {
  __typename?: 'DeleteCampaignMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCategoryInput = {
  categoryId: Scalars['ID']['input'];
};

export type DeleteCategoryMutation = {
  __typename?: 'DeleteCategoryMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteColumnStatus = {
  __typename?: 'DeleteColumnStatus';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCouponInput = {
  couponId: Scalars['ID']['input'];
};

export type DeleteCouponMutation = {
  __typename?: 'DeleteCouponMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomer = {
  __typename?: 'DeleteCustomer';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomerCustomField = {
  __typename?: 'DeleteCustomerCustomField';
  success: Scalars['Boolean']['output'];
};

export type DeleteCustomerTagsMutation = {
  __typename?: 'DeleteCustomerTagsMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteEmailTemplateMutation = {
  __typename?: 'DeleteEmailTemplateMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteInstance = {
  __typename?: 'DeleteInstance';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteIntegration = {
  __typename?: 'DeleteIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLead = {
  __typename?: 'DeleteLead';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLoyaltyConfigurationMutation = {
  __typename?: 'DeleteLoyaltyConfigurationMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProductInput = {
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteProductMutation = {
  __typename?: 'DeleteProductMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTask = {
  __typename?: 'DeleteTask';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliverLoyaltyRewardMutation = {
  __typename?: 'DeliverLoyaltyRewardMutation';
  redemption?: Maybe<LoyaltyRedemptionType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailProviderStoreIntegrationInput = {
  emailToSend?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enumeration. */
export enum EmailProviderStoreIntegrationProvider {
  /** Mailgun */
  Mailgun = 'MAILGUN',
  /** Resend */
  Resend = 'RESEND'
}

export type EmailProviderStoreIntegrationType = {
  __typename?: 'EmailProviderStoreIntegrationType';
  createdAt: Scalars['DateTime']['output'];
  emailToSend: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  provider: EmailProviderStoreIntegrationProvider;
  store: StoreType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateCreateInput = {
  json: Scalars['JSONString']['input'];
  name: Scalars['String']['input'];
};

export type EmailTemplateType = {
  __typename?: 'EmailTemplateType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  json: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  stores: Array<StoreType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateUpdateInput = {
  id: Scalars['ID']['input'];
  json?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EvolutionApiIntegrationInput = {
  phoneNumber: Scalars['String']['input'];
};

export type EvolutionApiIntegrationType = {
  __typename?: 'EvolutionApiIntegrationType';
  apiKey?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  instance?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  serverUrl: Scalars['String']['output'];
  store: StoreType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FrequencyRfmInput = {
  zoneFiveMax?: InputMaybe<Scalars['Int']['input']>;
  zoneFiveMin?: InputMaybe<Scalars['Int']['input']>;
  zoneFourMax?: InputMaybe<Scalars['Int']['input']>;
  zoneFourMin?: InputMaybe<Scalars['Int']['input']>;
  zoneOneMax?: InputMaybe<Scalars['Int']['input']>;
  zoneOneMin?: InputMaybe<Scalars['Int']['input']>;
  zoneThreeMax?: InputMaybe<Scalars['Int']['input']>;
  zoneThreeMin?: InputMaybe<Scalars['Int']['input']>;
  zoneTwoMax?: InputMaybe<Scalars['Int']['input']>;
  zoneTwoMin?: InputMaybe<Scalars['Int']['input']>;
};

export type FrequencyRfmType = {
  __typename?: 'FrequencyRFMType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  zoneFiveMax: Scalars['Int']['output'];
  zoneFiveMin: Scalars['Int']['output'];
  zoneFourMax: Scalars['Int']['output'];
  zoneFourMin: Scalars['Int']['output'];
  zoneOneMax: Scalars['Int']['output'];
  zoneOneMin: Scalars['Int']['output'];
  zoneThreeMax: Scalars['Int']['output'];
  zoneThreeMin: Scalars['Int']['output'];
  zoneTwoMax: Scalars['Int']['output'];
  zoneTwoMin: Scalars['Int']['output'];
};

export type GenderPieChartReturn = {
  __typename?: 'GenderPieChartReturn';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GetEvolutionConnectionStatusReturnType = {
  __typename?: 'GetEvolutionConnectionStatusReturnType';
  equalStatus?: Maybe<Scalars['Boolean']['output']>;
};

export type GiftbackAreaChartReturn = {
  __typename?: 'GiftbackAreaChartReturn';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  kindOfDate?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Array<Maybe<GiftbackAreaChartSeries>>>;
};

export type GiftbackAreaChartSeries = {
  __typename?: 'GiftbackAreaChartSeries';
  data?: Maybe<Array<Maybe<GiftbackAreaChartSeriesData>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GiftbackAreaChartSeriesData = {
  __typename?: 'GiftbackAreaChartSeriesData';
  date?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type GiftbackAverageTickets = {
  __typename?: 'GiftbackAverageTickets';
  activeGiftbackAverageTicket?: Maybe<Scalars['Float']['output']>;
  cancelledGiftbackAverageTicket?: Maybe<Scalars['Float']['output']>;
  expiredGiftbackAverageTicket?: Maybe<Scalars['Float']['output']>;
  overdueGiftbackAverageTicket?: Maybe<Scalars['Float']['output']>;
  redeemedGiftbackAverageTicket?: Maybe<Scalars['Float']['output']>;
};

export type GiftbackCardsValues = {
  __typename?: 'GiftbackCardsValues';
  activeGiftbacks?: Maybe<Scalars['Int']['output']>;
  cancelledGiftbacks?: Maybe<Scalars['Int']['output']>;
  expiredGiftbacks?: Maybe<Scalars['Int']['output']>;
  giftbackGains?: Maybe<Scalars['Float']['output']>;
  overdueGiftbacks?: Maybe<Scalars['Int']['output']>;
  redeemedGiftbacks?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum GiftbackConfigCouponProductScope {
  /** Todos os produtos */
  AllProducts = 'ALL_PRODUCTS',
  /** Categorias específicas */
  Categories = 'CATEGORIES',
  /** Produtos específicos */
  Products = 'PRODUCTS'
}

/** An enumeration. */
export enum GiftbackConfigCouponScopeMode {
  /** Excluir selecionados */
  Exclude = 'EXCLUDE',
  /** Incluir selecionados */
  Include = 'INCLUDE'
}

export type GiftbackConfigInput = {
  allowGiftbackCreation?: InputMaybe<Scalars['Boolean']['input']>;
  allowGiftbackCreationWithoutContact?: InputMaybe<Scalars['Boolean']['input']>;
  availableAfterDays?: InputMaybe<Scalars['Int']['input']>;
  couponProductScope?: InputMaybe<GiftbackConfigCouponProductScope>;
  couponScopeCategoriesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  couponScopeMode?: InputMaybe<GiftbackConfigCouponScopeMode>;
  couponScopeProductsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['Int']['input']>;
  multipleConfigs?: InputMaybe<Array<InputMaybe<MultipleGiftbackConfigInput>>>;
};

/** An enumeration. */
export enum GiftbackConfigMinimumValueType {
  /** Valor Fixo */
  FixedValue = 'FIXED_VALUE',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type GiftbackConfigType = {
  __typename?: 'GiftbackConfigType';
  allowGiftbackCreation: Scalars['Boolean']['output'];
  allowGiftbackCreationWithoutContact: Scalars['Boolean']['output'];
  availableAfterDays: Scalars['Int']['output'];
  codePrefix: Scalars['String']['output'];
  couponProductScope: GiftbackConfigCouponProductScope;
  couponScopeCategories?: Maybe<Array<Maybe<CategoryType>>>;
  couponScopeMode: GiftbackConfigCouponScopeMode;
  couponScopeProducts?: Maybe<Array<Maybe<ProductType>>>;
  createdAt: Scalars['DateTime']['output'];
  cumulative?: Maybe<Scalars['Boolean']['output']>;
  /** Giftback nao pode ser mior que R$ 200,00 */
  discountLimit: Scalars['Float']['output'];
  discountLimitEnabled: Scalars['Boolean']['output'];
  dueDate: Scalars['Int']['output'];
  generateGenericGiftbacks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** O valor máximo que o cupom pode representar de desconto na próxima compra */
  maximumDiscountPercentage: Scalars['Float']['output'];
  minPurchaseValueForCreate: Scalars['Float']['output'];
  minPurchaseValueForRedeem: Scalars['Float']['output'];
  minimumValueType: GiftbackConfigMinimumValueType;
  multiplegiftbackconfigSet: Array<MultipleGiftbackConfigType>;
  pk: Scalars['Int']['output'];
  store?: Maybe<StoreType>;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  valueType: GiftbackConfigValueType;
};

/** An enumeration. */
export enum GiftbackConfigValueType {
  /** Valor Fixo */
  FixedValue = 'FIXED_VALUE',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type GiftbackExcelReportType = {
  __typename?: 'GiftbackExcelReportType';
  background?: Maybe<Scalars['Boolean']['output']>;
  relatorio?: Maybe<Scalars['String']['output']>;
};

export type GiftbackFilterSetInput = {
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  /** Name (OR) Email */
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  /** Ordenando */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

/** An enumeration. */
export enum GiftbackImportedFrom {
  /** Bling */
  Bling = 'BLING',
  /** Giftback criado separadamente */
  CreateOnlyGiftback = 'CREATE_ONLY_GIFTBACK',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** PDV */
  Pdv = 'PDV',
  /** Quick ERP */
  QuickErp = 'QUICK_ERP',
  /** SGI */
  Sgi = 'SGI',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Totem */
  Totem = 'TOTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type GiftbackRadialBarCharReturn = {
  __typename?: 'GiftbackRadialBarCharReturn';
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type GiftbackRelayType = Node & {
  __typename?: 'GiftbackRelayType';
  availableFrom?: Maybe<Scalars['Date']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerTypeRelay;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dueDate: Scalars['Date']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedFrom: GiftbackImportedFrom;
  integrationId: Scalars['String']['output'];
  journeyActionIntents: Array<JourneyActionIntentType>;
  justification: Scalars['String']['output'];
  minValueToRedeem: Scalars['Float']['output'];
  pk: Scalars['Int']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  purchaseUsed?: Maybe<PurchaseRelayType>;
  redeemedAt?: Maybe<Scalars['Date']['output']>;
  redeemedBy?: Maybe<CustomUserNode>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  status: GiftbackStatus;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
  value: Scalars['Float']['output'];
};


export type GiftbackRelayTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};

export type GiftbackRelayTypeConnection = {
  __typename?: 'GiftbackRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GiftbackRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `GiftbackRelayType` and its cursor. */
export type GiftbackRelayTypeEdge = {
  __typename?: 'GiftbackRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GiftbackRelayType>;
};

/** An enumeration. */
export enum GiftbackStatus {
  /** Ativo */
  Active = 'ACTIVE',
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Expirado */
  Expired = 'EXPIRED',
  /** Vencido */
  Overdue = 'OVERDUE',
  /** Resgatado */
  Redeemed = 'REDEEMED'
}

export type GiftbackType = {
  __typename?: 'GiftbackType';
  availableFrom?: Maybe<Scalars['Date']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerTypeRelay;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dueDate: Scalars['Date']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importedFrom: GiftbackImportedFrom;
  integrationId: Scalars['String']['output'];
  journeyActionIntents: Array<JourneyActionIntentType>;
  justification: Scalars['String']['output'];
  minValueToRedeem: Scalars['Float']['output'];
  pk: Scalars['Int']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  purchaseUsed?: Maybe<PurchaseRelayType>;
  redeemedAt?: Maybe<Scalars['Date']['output']>;
  redeemedBy?: Maybe<CustomUserNode>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  status: GiftbackStatus;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
  value: Scalars['Float']['output'];
};


export type GiftbackTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};

export type HelenaChannelType = {
  __typename?: 'HelenaChannelType';
  active?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  identity?: Maybe<Scalars['JSONString']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  numberFormatted?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HelenaStoreIntegrationInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  connected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HelenaStoreIntegrationType = {
  __typename?: 'HelenaStoreIntegrationType';
  activated: Scalars['Boolean']['output'];
  apiTokenPreview?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
};

export type HomePageCards = {
  __typename?: 'HomePageCards';
  purchaseAverageTicket?: Maybe<Scalars['Float']['output']>;
  totalActiveGiftbacks?: Maybe<Scalars['Int']['output']>;
  totalCustomers?: Maybe<Scalars['Int']['output']>;
  totalGiftbackGains?: Maybe<Scalars['Float']['output']>;
  totalPurchase?: Maybe<Scalars['Int']['output']>;
  totalRecurrentCustomers?: Maybe<Scalars['Int']['output']>;
  totalUniqueCustomers?: Maybe<Scalars['Int']['output']>;
  totalValuePurchase?: Maybe<Scalars['Float']['output']>;
  totalValueRedeemedGiftbacks?: Maybe<Scalars['Float']['output']>;
};

export type HomePageConfigType = {
  __typename?: 'HomePageConfigType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  redeemedGiftbackTicketAverage: Scalars['Boolean']['output'];
  repurchaseRate: Scalars['Boolean']['output'];
  roi: Scalars['Boolean']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  welcomeAndUpdates: Scalars['Boolean']['output'];
};

export type HostgatorStoreIntegrationType = {
  __typename?: 'HostgatorStoreIntegrationType';
  /** Status disponíveis: Criado, Pago, Pagamento Confirmado, Entregue, Cancelado, Enviado. Caso o campo esteja vazio, todos os status serão importados */
  acceptedStatusToImport: Scalars['String']['output'];
  appKey: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  storeIntegrationId: Scalars['String']['output'];
  /** Caso queira digitar o domínio sem o protocolo (exemplo: 123456.hostgator), ao ser salvo irá se transformar em https://123456.hostgator.com.br */
  storeUrl: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InstanceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isActived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  saveContact?: InputMaybe<Scalars['Boolean']['input']>;
  webhookAfterDisconnect?: InputMaybe<Scalars['String']['input']>;
  webhookAfterReceive?: InputMaybe<Scalars['String']['input']>;
  webhookAfterSend?: InputMaybe<Scalars['String']['input']>;
  zApiId?: InputMaybe<Scalars['String']['input']>;
  zApiToken?: InputMaybe<Scalars['String']['input']>;
};

export type InstanceNode = Node & {
  __typename?: 'InstanceNode';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationSet: IntegrationNodeConnection;
  isActived: Scalars['Boolean']['output'];
  leadSet: LeadNodeConnection;
  name: Scalars['String']['output'];
  owner?: Maybe<CustomUserNode>;
  pk: Scalars['Int']['output'];
  saveContact: Scalars['Boolean']['output'];
  webhookAfterDisconnect: Scalars['String']['output'];
  webhookAfterReceive: Scalars['String']['output'];
  webhookAfterSend: Scalars['String']['output'];
  zApiId: Scalars['String']['output'];
  zApiToken: Scalars['String']['output'];
};


export type InstanceNodeIntegrationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceNodeLeadSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InstanceNodeConnection = {
  __typename?: 'InstanceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InstanceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InstanceNode` and its cursor. */
export type InstanceNodeEdge = {
  __typename?: 'InstanceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InstanceNode>;
};

export type InstanceType = {
  __typename?: 'InstanceType';
  id: Scalars['ID']['output'];
  integrationSet: IntegrationNodeConnection;
  isActived: Scalars['Boolean']['output'];
  leadSet: LeadNodeConnection;
  name: Scalars['String']['output'];
  owner?: Maybe<CustomUserNode>;
  pk: Scalars['Int']['output'];
  saveContact: Scalars['Boolean']['output'];
  webhookAfterDisconnect: Scalars['String']['output'];
  webhookAfterReceive: Scalars['String']['output'];
  webhookAfterSend: Scalars['String']['output'];
  zApiId: Scalars['String']['output'];
  zApiToken: Scalars['String']['output'];
};


export type InstanceTypeIntegrationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type InstanceTypeLeadSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  integrationType?: InputMaybe<Scalars['String']['input']>;
  isActived?: InputMaybe<Scalars['Boolean']['input']>;
  methodType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pipefyToken?: InputMaybe<Scalars['String']['input']>;
  triggers?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationNode = Node & {
  __typename?: 'IntegrationNode';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instance?: Maybe<InstanceNode>;
  integrationType: Scalars['String']['output'];
  isActived: Scalars['Boolean']['output'];
  methodType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<CustomUserNode>;
  pipefyToken: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  triggers: Scalars['JSONString']['output'];
};

export type IntegrationNodeConnection = {
  __typename?: 'IntegrationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IntegrationNode` and its cursor. */
export type IntegrationNodeEdge = {
  __typename?: 'IntegrationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationNode>;
};

export type IntegrationType = {
  __typename?: 'IntegrationType';
  id: Scalars['ID']['output'];
  instance?: Maybe<InstanceNode>;
  integrationType: Scalars['String']['output'];
  isActived: Scalars['Boolean']['output'];
  methodType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<CustomUserNode>;
  pipefyToken: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  triggers: Scalars['JSONString']['output'];
};

export type InternalAppointmentInput = {
  customerId: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  serviceId: Scalars['ID']['input'];
  startsAt: Scalars['DateTime']['input'];
};

/** An enumeration. */
export enum JourneyActionIntentActionType {
  /** Adicionar tag ao cliente */
  AddCustomerTag = 'ADD_CUSTOMER_TAG',
  /** Criar Giftback */
  CreateGiftback = 'CREATE_GIFTBACK'
}

/** An enumeration. */
export enum JourneyActionIntentStatus {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Concluído */
  Completed = 'COMPLETED',
  /** Erro */
  Error = 'ERROR',
  /** Pendente */
  Pending = 'PENDING',
  /** Processando */
  Processing = 'PROCESSING',
  /** Benefício criado */
  Ready = 'READY',
  /** Ignorado */
  Skipped = 'SKIPPED',
  /** Resultado externo desconhecido */
  Unknown = 'UNKNOWN'
}

export type JourneyActionIntentType = {
  __typename?: 'JourneyActionIntentType';
  actionType: JourneyActionIntentActionType;
  attemptCount: Scalars['Int']['output'];
  cancelReason: Scalars['String']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  configSnapshot: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdGiftback?: Maybe<GiftbackType>;
  id: Scalars['ID']['output'];
  lastError: Scalars['String']['output'];
  maxAttempts: Scalars['Int']['output'];
  nextEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  nodeKey: Scalars['String']['output'];
  providerOutcome: Scalars['JSONString']['output'];
  scheduledAt: Scalars['DateTime']['output'];
  sequence: Scalars['Int']['output'];
  status: JourneyActionIntentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type JourneyAnalyticsType = {
  __typename?: 'JourneyAnalyticsType';
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  definitions: Scalars['GenericScalar']['output'];
  nodes: Array<Maybe<JourneyNodeMetricType>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type JourneyDeliveryType = {
  __typename?: 'JourneyDeliveryType';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  attempts: Scalars['Int']['output'];
  channel: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryKey: Scalars['String']['output'];
  execution?: Maybe<JourneyExecutionType>;
  externalMessageId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nodeKey: Scalars['String']['output'];
  notificationIntentId?: Maybe<Scalars['Int']['output']>;
  provider: Scalars['String']['output'];
  sanitizedError: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: NotificationDeliveryLedgerStatus;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type JourneyDraftType = {
  __typename?: 'JourneyDraftType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CustomUserNode>;
  definition: Scalars['JSONString']['output'];
  id: Scalars['ID']['output'];
  journey: JourneyType;
  lastValidation: Scalars['JSONString']['output'];
  revision: Scalars['Int']['output'];
  schemaVersion: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<CustomUserNode>;
};

/** An enumeration. */
export enum JourneyExecutionStatus {
  /** Cancelado */
  Canceled = 'CANCELED',
  /** Concluído */
  Completed = 'COMPLETED',
  /** Falho */
  Failed = 'FAILED',
  /** Em andamento */
  InProgress = 'IN_PROGRESS',
  /** Parcialmente falho */
  PartiallyFailed = 'PARTIALLY_FAILED',
  /** Planejado */
  Planned = 'PLANNED'
}

export type JourneyExecutionType = {
  __typename?: 'JourneyExecutionType';
  actionIntents?: Maybe<Array<Maybe<JourneyActionIntentType>>>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customer?: Maybe<CustomerTypeRelay>;
  deliveries?: Maybe<Array<Maybe<JourneyDeliveryType>>>;
  enrollmentContext: Scalars['JSONString']['output'];
  goalEvents?: Maybe<Array<Maybe<JourneyGoalEventType>>>;
  id: Scalars['ID']['output'];
  isShadow: Scalars['Boolean']['output'];
  journey: JourneyType;
  journeyVersion: JourneyVersionType;
  notificationIntents?: Maybe<Array<Maybe<JourneyScheduledIntentType>>>;
  outcomeReason: Scalars['String']['output'];
  planningTrace: Scalars['JSONString']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  purchaseProduct?: Maybe<PurchaseProductRelayType>;
  startedAt: Scalars['DateTime']['output'];
  status: JourneyExecutionStatus;
  store: StoreType;
  subjectId: Scalars['String']['output'];
  subjectType: Scalars['String']['output'];
  summary: Scalars['JSONString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type JourneyFunnelStageType = {
  __typename?: 'JourneyFunnelStageType';
  canceledBefore: Scalars['Int']['output'];
  convertedCustomers: Scalars['Int']['output'];
  convertedExecutions: Scalars['Int']['output'];
  nodeKey: Scalars['String']['output'];
  reachedCustomers: Scalars['Int']['output'];
  reachedExecutions: Scalars['Int']['output'];
  sentMessages: Scalars['Int']['output'];
};

export type JourneyFunnelType = {
  __typename?: 'JourneyFunnelType';
  enrolledCustomers: Scalars['Int']['output'];
  enrolledExecutions: Scalars['Int']['output'];
  stages: Array<Maybe<JourneyFunnelStageType>>;
};

export type JourneyGoalEventType = {
  __typename?: 'JourneyGoalEventType';
  attributedNodeKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  execution: JourneyExecutionType;
  exitRuleKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchedContext: Scalars['JSONString']['output'];
  occurredAt: Scalars['DateTime']['output'];
  preventedIntentCount: Scalars['Int']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  reversalReason: Scalars['String']['output'];
  reversed: Scalars['Boolean']['output'];
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JourneyMutationResult = {
  __typename?: 'JourneyMutationResult';
  draft?: Maybe<JourneyDraftType>;
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['GenericScalar']['output']>;
  execution?: Maybe<JourneyExecutionType>;
  intent?: Maybe<JourneyScheduledIntentType>;
  journey?: Maybe<JourneyType>;
  ok: Scalars['Boolean']['output'];
  ownership?: Maybe<JourneyOwnershipType>;
  simulation?: Maybe<Scalars['GenericScalar']['output']>;
  validation?: Maybe<Scalars['GenericScalar']['output']>;
  version?: Maybe<JourneyVersionType>;
};

export type JourneyNodeMetricType = {
  __typename?: 'JourneyNodeMetricType';
  canceledActions: Scalars['Int']['output'];
  canceledMessages: Scalars['Int']['output'];
  completedActions: Scalars['Int']['output'];
  conversionRate: Scalars['Float']['output'];
  convertedCustomers: Scalars['Int']['output'];
  convertedExecutions: Scalars['Int']['output'];
  createdGiftbacks: Scalars['Int']['output'];
  deliveryAttempts: Scalars['Int']['output'];
  dueActions: Scalars['Int']['output'];
  dueMessages: Scalars['Int']['output'];
  engagement?: Maybe<Scalars['GenericScalar']['output']>;
  failedActions: Scalars['Int']['output'];
  failedMessages: Scalars['Int']['output'];
  nodeKey: Scalars['String']['output'];
  nodeType: Scalars['String']['output'];
  preventedMessages: Scalars['Int']['output'];
  reachedCustomers: Scalars['Int']['output'];
  reachedExecutions: Scalars['Int']['output'];
  scheduledActions: Scalars['Int']['output'];
  scheduledMessages: Scalars['Int']['output'];
  sentCustomers: Scalars['Int']['output'];
  sentMessages: Scalars['Int']['output'];
  skippedActions: Scalars['Int']['output'];
  skippedMessages: Scalars['Int']['output'];
  stoppedExecutions: Scalars['Int']['output'];
};

export type JourneyOwnershipType = {
  __typename?: 'JourneyOwnershipType';
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<CustomUserNode>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mode: JourneyTriggerOwnershipMode;
  rollbackPolicy: Scalars['String']['output'];
  store: StoreType;
  triggerFamily: Scalars['String']['output'];
};

export type JourneyScheduledIntentType = {
  __typename?: 'JourneyScheduledIntentType';
  attemptCount?: Maybe<Scalars['Int']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enrollmentContext?: Maybe<Scalars['JSONString']['output']>;
  giftback?: Maybe<GiftbackRelayType>;
  id: Scalars['ID']['output'];
  journeyNodeKey?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  matchedCategoryIds?: Maybe<Scalars['JSONString']['output']>;
  maxAttempts?: Maybe<Scalars['Int']['output']>;
  messageSnapshot?: Maybe<Scalars['JSONString']['output']>;
  nextEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  purchase?: Maybe<PurchaseRelayType>;
  purchaseProduct?: Maybe<PurchaseProductRelayType>;
  requiredJourneyAction?: Maybe<JourneyActionIntentType>;
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  scheduledTime?: Maybe<Scalars['Time']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceEngine?: Maybe<ScheduledNotificationIntentSourceEngine>;
  status: ScheduledNotificationIntentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum JourneyStatus {
  /** Ativo */
  Active = 'ACTIVE',
  /** Arquivado */
  Archived = 'ARCHIVED',
  /** Rascunho */
  Draft = 'DRAFT',
  /** Pausado */
  Paused = 'PAUSED'
}

export type JourneyTargetType = {
  __typename?: 'JourneyTargetType';
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

/** An enumeration. */
export enum JourneyTriggerOwnershipMode {
  /** Jornadas */
  Journey = 'JOURNEY',
  /** Legado */
  Legacy = 'LEGACY',
  /** Shadow */
  Shadow = 'SHADOW'
}

export type JourneyType = {
  __typename?: 'JourneyType';
  activeVersion?: Maybe<JourneyVersionType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CustomUserNode>;
  description: Scalars['String']['output'];
  draft?: Maybe<JourneyDraftType>;
  executions: Array<JourneyExecutionType>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  status: JourneyStatus;
  store: StoreType;
  triggerFamily: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<CustomUserNode>;
  versions: Array<JourneyVersionType>;
};

export type JourneyVersionType = {
  __typename?: 'JourneyVersionType';
  actionIntents: Array<JourneyActionIntentType>;
  activeForJourneys: Array<JourneyType>;
  checksum: Scalars['String']['output'];
  compiledPlan: Scalars['JSONString']['output'];
  definition: Scalars['JSONString']['output'];
  executions: Array<JourneyExecutionType>;
  id: Scalars['ID']['output'];
  journey: JourneyType;
  notificationIntents: Array<JourneyScheduledIntentType>;
  number: Scalars['Int']['output'];
  publishedAt: Scalars['DateTime']['output'];
  publishedBy?: Maybe<CustomUserNode>;
  schemaVersion: Scalars['Int']['output'];
};

export type LeadInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type LeadNode = Node & {
  __typename?: 'LeadNode';
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instance?: Maybe<InstanceNode>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  task?: Maybe<TaskNode>;
};

export type LeadNodeConnection = {
  __typename?: 'LeadNodeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LeadNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `LeadNode` and its cursor. */
export type LeadNodeEdge = {
  __typename?: 'LeadNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LeadNode>;
};

export type LeadType = {
  __typename?: 'LeadType';
  id: Scalars['ID']['output'];
  instance?: Maybe<InstanceNode>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  task?: Maybe<TaskNode>;
};

export type LojaIntegradaStoreIntegrationType = {
  __typename?: 'LojaIntegradaStoreIntegrationType';
  /** Escreva aqui os status dos pedidos que devem ser importados para o sistema, separados por vírgula e em maiúsculo. Por exemplo: Aguardando Pagamento, Cancelamento solicitado, Em produção, Faturado, Pagamento devolvido, Pagamento em análise, Pagamento em chargeback, Pagamento em disputa, Pedido Cancelado, Pedido Efetuado, Pedido em separação, Pedido Entregue, Pedido Enviado, Pedido Pago, Pedido pronto para retirada */
  acceptedStatusToImport: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  appKey: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastProcessingAt?: Maybe<Scalars['DateTime']['output']>;
  pk: Scalars['Int']['output'];
  processingLock: Scalars['Boolean']['output'];
  store: StoreType;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webhookToken: Scalars['String']['output'];
};

export type LoyaltyBenefitType = {
  __typename?: 'LoyaltyBenefitType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  member: LoyaltyMemberType;
  name: Scalars['String']['output'];
  reward?: Maybe<LoyaltyRewardType>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  tier?: Maybe<LoyaltyTierType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltyMemberType = {
  __typename?: 'LoyaltyMemberType';
  availablePoints: Scalars['Int']['output'];
  benefits: Array<LoyaltyBenefitType>;
  createdAt: Scalars['DateTime']['output'];
  currentTier?: Maybe<LoyaltyTierType>;
  customer: CustomerTypeRelay;
  eligiblePdvRewards?: Maybe<Array<Maybe<LoyaltyRewardType>>>;
  eligiblePublicRewards?: Maybe<Array<Maybe<LoyaltyRewardType>>>;
  entries: Array<LoyaltyPointEntryType>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  normalizedTaxDocument: Scalars['String']['output'];
  program: LoyaltyProgramType;
  redemptions: Array<LoyaltyRedemptionType>;
  reservedPoints: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum LoyaltyPointEntryEntryType {
  /** Ajuste */
  Adjust = 'ADJUST',
  /** Crédito */
  Credit = 'CREDIT',
  /** Débito */
  Debit = 'DEBIT',
  /** Expiração */
  Expire = 'EXPIRE',
  /** Liberação */
  Release = 'RELEASE',
  /** Reserva */
  Reserve = 'RESERVE',
  /** Estorno */
  Reverse = 'REVERSE'
}

export type LoyaltyPointEntryType = {
  __typename?: 'LoyaltyPointEntryType';
  availableDelta: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  entryType: LoyaltyPointEntryEntryType;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  member: LoyaltyMemberType;
  metadata: Scalars['JSONString']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  redemption?: Maybe<LoyaltyRedemptionType>;
  reservedDelta: Scalars['Int']['output'];
  rule?: Maybe<LoyaltyRuleType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltyProgramInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointsExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  redemptionExpirationHours?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltyProgramType = {
  __typename?: 'LoyaltyProgramType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  members: Array<LoyaltyMemberType>;
  name: Scalars['String']['output'];
  pointsExpirationDays?: Maybe<Scalars['Int']['output']>;
  primaryColor: Scalars['String']['output'];
  redemptionExpirationHours: Scalars['Int']['output'];
  rewards: Array<LoyaltyRewardType>;
  rules: Array<LoyaltyRuleType>;
  store: StoreType;
  tiers: Array<LoyaltyTierType>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum LoyaltyRedemptionChannel {
  /** PDV */
  Pdv = 'PDV',
  /** Página pública */
  Public = 'PUBLIC'
}

/** An enumeration. */
export enum LoyaltyRedemptionFulfillmentMethod {
  /** Digital */
  Digital = 'DIGITAL',
  /** Retirada */
  Pickup = 'PICKUP',
  /** Envio */
  Shipping = 'SHIPPING'
}

export type LoyaltyRedemptionInput = {
  fulfillmentMethod: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
  requestKey: Scalars['String']['input'];
  rewardId: Scalars['ID']['input'];
};

export type LoyaltyRedemptionItemType = {
  __typename?: 'LoyaltyRedemptionItemType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  product: ProductRelayType;
  quantity: Scalars['Int']['output'];
  redemption: LoyaltyRedemptionType;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum LoyaltyRedemptionStatus {
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Checkout pago */
  CheckoutPaid = 'CHECKOUT_PAID',
  /** Cupom emitido */
  CouponIssued = 'COUPON_ISSUED',
  /** Entregue */
  Delivered = 'DELIVERED',
  /** Expirado */
  Expired = 'EXPIRED',
  /** Concluído */
  Fulfilled = 'FULFILLED',
  /** Pendente */
  Pending = 'PENDING',
  /** Pronto para retirada */
  ReadyForPickup = 'READY_FOR_PICKUP',
  /** Revertido */
  Reversed = 'REVERSED'
}

/** An enumeration. */
export enum LoyaltyRedemptionTransitionToStatus {
  /** Cancelado */
  Cancelled = 'CANCELLED',
  /** Checkout pago */
  CheckoutPaid = 'CHECKOUT_PAID',
  /** Cupom emitido */
  CouponIssued = 'COUPON_ISSUED',
  /** Entregue */
  Delivered = 'DELIVERED',
  /** Expirado */
  Expired = 'EXPIRED',
  /** Concluído */
  Fulfilled = 'FULFILLED',
  /** Pendente */
  Pending = 'PENDING',
  /** Pronto para retirada */
  ReadyForPickup = 'READY_FOR_PICKUP',
  /** Revertido */
  Reversed = 'REVERSED'
}

export type LoyaltyRedemptionTransitionType = {
  __typename?: 'LoyaltyRedemptionTransitionType';
  actor?: Maybe<CustomUserNode>;
  createdAt: Scalars['DateTime']['output'];
  fromStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONString']['output'];
  reason: Scalars['String']['output'];
  redemption: LoyaltyRedemptionType;
  toStatus: LoyaltyRedemptionTransitionToStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type LoyaltyRedemptionType = {
  __typename?: 'LoyaltyRedemptionType';
  cancellationReason: Scalars['String']['output'];
  channel: LoyaltyRedemptionChannel;
  code: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  coupon?: Maybe<CouponRelayType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CustomUserNode>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredBy?: Maybe<CustomUserNode>;
  expiresAt: Scalars['DateTime']['output'];
  fulfillmentMethod: LoyaltyRedemptionFulfillmentMethod;
  id: Scalars['ID']['output'];
  items: Array<LoyaltyRedemptionItemType>;
  member: LoyaltyMemberType;
  pointEntries: Array<LoyaltyPointEntryType>;
  pointsCost: Scalars['Int']['output'];
  purchase?: Maybe<PurchaseRelayType>;
  requestKey: Scalars['String']['output'];
  reward: LoyaltyRewardType;
  status: LoyaltyRedemptionStatus;
  transitions: Array<LoyaltyRedemptionTransitionType>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum LoyaltyRewardDiscountType {
  /** Fixo */
  Fixed = 'FIXED',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type LoyaltyRewardInput = {
  allowCustomerPaidShipping?: InputMaybe<Scalars['Boolean']['input']>;
  allowPickup?: InputMaybe<Scalars['Boolean']['input']>;
  availableInPdv?: InputMaybe<Scalars['Boolean']['input']>;
  availableInPublicPage?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Decimal']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumTierId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  perMemberLimit?: InputMaybe<Scalars['Int']['input']>;
  pointsCost: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  rewardType: Scalars['String']['input'];
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum LoyaltyRewardRewardType {
  /** Desconto */
  Discount = 'DISCOUNT',
  /** Acesso antecipado */
  EarlyAccess = 'EARLY_ACCESS',
  /** Frete grátis */
  FreeShipping = 'FREE_SHIPPING',
  /** Brinde */
  Gift = 'GIFT',
  /** Benefício não monetário */
  NonMonetary = 'NON_MONETARY',
  /** Produto */
  Product = 'PRODUCT'
}

export type LoyaltyRewardType = {
  __typename?: 'LoyaltyRewardType';
  allowCustomerPaidShipping: Scalars['Boolean']['output'];
  allowPickup: Scalars['Boolean']['output'];
  availableInPdv: Scalars['Boolean']['output'];
  availableInPublicPage: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  discountType: LoyaltyRewardDiscountType;
  discountValue?: Maybe<Scalars['Float']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loyaltybenefitSet: Array<LoyaltyBenefitType>;
  minimumTier?: Maybe<LoyaltyTierType>;
  name: Scalars['String']['output'];
  perMemberLimit?: Maybe<Scalars['Int']['output']>;
  pointsCost: Scalars['Int']['output'];
  product?: Maybe<ProductRelayType>;
  program: LoyaltyProgramType;
  redemptions: Array<LoyaltyRedemptionType>;
  rewardType: LoyaltyRewardRewardType;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  totalLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum LoyaltyRuleEvent {
  /** Aniversário */
  Birthday = 'BIRTHDAY',
  /** Ação manual */
  Manual = 'MANUAL',
  /** Compra aprovada */
  Purchase = 'PURCHASE',
  /** Cadastro */
  Signup = 'SIGNUP'
}

export type LoyaltyRuleInput = {
  conditions?: InputMaybe<Scalars['GenericScalar']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  event: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maximumPoints?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  occurrenceLimit?: InputMaybe<Scalars['Int']['input']>;
  pointsMode: Scalars['String']['input'];
  pointsValue: Scalars['Decimal']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  validityDays?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum LoyaltyRulePointsMode {
  /** Valor fixo */
  Fixed = 'FIXED',
  /** Por unidade monetária */
  PerCurrency = 'PER_CURRENCY'
}

export type LoyaltyRuleType = {
  __typename?: 'LoyaltyRuleType';
  conditions: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  event: LoyaltyRuleEvent;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loyaltypointentrySet: Array<LoyaltyPointEntryType>;
  maximumPoints?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  occurrenceLimit?: Maybe<Scalars['Int']['output']>;
  pointsMode: LoyaltyRulePointsMode;
  pointsValue: Scalars['Float']['output'];
  priority: Scalars['Int']['output'];
  program: LoyaltyProgramType;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  validityDays?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyTierInput = {
  benefits?: InputMaybe<Scalars['GenericScalar']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPoints: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type LoyaltyTierType = {
  __typename?: 'LoyaltyTierType';
  benefits: Scalars['JSONString']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loyaltybenefitSet: Array<LoyaltyBenefitType>;
  members: Array<LoyaltyMemberType>;
  minimumPoints: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  program: LoyaltyProgramType;
  rewards: Array<LoyaltyRewardType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MultipleGiftbackConfigInput = {
  discountLimit?: InputMaybe<Scalars['Decimal']['input']>;
  discountLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maximumDiscountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  minPurchaseValueForCreate?: InputMaybe<Scalars['Decimal']['input']>;
  minPurchaseValueForRedeem?: InputMaybe<Scalars['Decimal']['input']>;
  minimumValueType?: InputMaybe<MultipleGiftbackConfigValueType>;
  tagsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  valueType?: InputMaybe<MultipleGiftbackConfigValueType>;
};

/** An enumeration. */
export enum MultipleGiftbackConfigMinimumValueType {
  /** Valor Fixo */
  FixedValue = 'FIXED_VALUE',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type MultipleGiftbackConfigType = {
  __typename?: 'MultipleGiftbackConfigType';
  createdAt: Scalars['DateTime']['output'];
  defaultConfig?: Maybe<GiftbackConfigType>;
  /** Giftback nao pode ser mior que R$ 200,00 */
  discountLimit: Scalars['Float']['output'];
  discountLimitEnabled: Scalars['Boolean']['output'];
  generateGenericGiftbacks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** O valor máximo que o cupom pode representar de desconto na próxima compra */
  maximumDiscountPercentage: Scalars['Float']['output'];
  minPurchaseValueForCreate: Scalars['Float']['output'];
  minPurchaseValueForRedeem: Scalars['Float']['output'];
  minimumValueType: MultipleGiftbackConfigMinimumValueType;
  pk: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<CustomerTagsType>>>;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  valueType: MultipleGiftbackConfigValueType;
};

/** An enumeration. */
export enum MultipleGiftbackConfigValueType {
  /** Valor Fixo */
  FixedValue = 'FIXED_VALUE',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<AcceptTermsMutation>;
  activateJourney?: Maybe<JourneyMutationResult>;
  activeOrInactiveCampaign?: Maybe<ActiveOrInactiveCampaignMutation>;
  addTagsToAudienceSelection?: Maybe<AddTagsToAudienceSelection>;
  addTagsToCustomers?: Maybe<AddTagsToCustomers>;
  adminGiftbackShopifyAutomaticoCriar?: Maybe<AdminCreateShopifyGiftbackAutomaticMutation>;
  adminGiftbackTrayCriar?: Maybe<AdminCreateTrayGiftbackMutation>;
  adminGiftbackTrayDeletar?: Maybe<AdminDeleteTrayGiftbackMutation>;
  adminGiftbackTrayVincular?: Maybe<AdminRelateTrayGiftbackMutation>;
  adminGiftbackVincular?: Maybe<AdminRelateGiftbackMutation>;
  /**
   * Archive account and revoke refresh tokens.
   *
   * User must be verified and confirm password.
   */
  archiveAccount?: Maybe<ArchiveAccountPayload>;
  archiveJourney?: Maybe<JourneyMutationResult>;
  cancelBulkNotification?: Maybe<BulkNotificationCancellMutation>;
  cancelCommunityScheduledMessage?: Maybe<CancelCommunityScheduledMessage>;
  cancelJourneyExecution?: Maybe<JourneyMutationResult>;
  cancelPurchase?: Maybe<CancelPurchaseMutation>;
  cashRegisterClosingSave?: Maybe<CashRegisterClosingSaveMutation>;
  cashRegisterSangriaCreate?: Maybe<CashRegisterSangriaCreateMutation>;
  categoryCreate?: Maybe<CreateCategoryMutation>;
  categoryDelete?: Maybe<DeleteCategoryMutation>;
  categoryUpdate?: Maybe<UpdateCategoryMutation>;
  changeAppointmentStatus?: Maybe<ChangeAppointmentStatusMutation>;
  changeJourneyTriggerOwnership?: Maybe<JourneyMutationResult>;
  confirmCommunity?: Maybe<ConfirmCommunity>;
  connectOrDisconnectEvolutionApiIntegration?: Maybe<ConnectOrDisconnectEvolutionApiIntegrationMutation>;
  couponCreate?: Maybe<CreateCouponMutation>;
  couponDelete?: Maybe<DeleteCouponMutation>;
  couponUpdate?: Maybe<UpdateCouponMutation>;
  createBoard?: Maybe<CreateBoard>;
  createBulkNotification?: Maybe<CreateBulkNotificationMutation>;
  createCampaign?: Maybe<CreateCampaignMutation>;
  createColumnStatus?: Maybe<CreateColumnStatus>;
  createCustomer?: Maybe<CreateCustomer>;
  createCustomerAudienceSelection?: Maybe<RetentionAudienceSelectionReturn>;
  createEmailTemplate?: Maybe<CreateEmailTemplateMutation>;
  createInstance?: Maybe<CreateInstance>;
  createIntegration?: Maybe<CreateIntegration>;
  createInternalAppointment?: Maybe<CreateInternalAppointmentMutation>;
  createJourney?: Maybe<JourneyMutationResult>;
  createLead?: Maybe<CreateLead>;
  createPublicAppointment?: Maybe<CreatePublicAppointmentMutation>;
  createPurchaseProgressionAudienceSelection?: Maybe<RetentionAudienceSelectionReturn>;
  createRetentionAudienceSelection?: Maybe<RetentionAudienceSelectionReturn>;
  createTask?: Maybe<CreateTask>;
  createTemplateByCampaign?: Maybe<CreateWhatsappTemplateByCampaignMutation>;
  createTrayStoreIntegration?: Maybe<CreateTrayStoreIntegration>;
  createUserCustom?: Maybe<CreateCustomUserMutation>;
  /**
   * Delete account permanently or make `user.is_active=False`.
   *
   * The behavior is defined on settings.
   * Anyway user refresh tokens are revoked.
   *
   * User must be verified and confirm password.
   */
  deleteAccount?: Maybe<DeleteAccountPayload>;
  deleteBoard?: Maybe<DeleteBoard>;
  deleteBulkNotification?: Maybe<BulkNotificationDeleteMutation>;
  deleteCampaign?: Maybe<DeleteCampaignMutation>;
  deleteColumnStatus?: Maybe<DeleteColumnStatus>;
  deleteCustomer?: Maybe<DeleteCustomer>;
  deleteCustomerCustomField?: Maybe<DeleteCustomerCustomField>;
  deleteEmailTemplate?: Maybe<DeleteEmailTemplateMutation>;
  deleteInstance?: Maybe<DeleteInstance>;
  deleteIntegration?: Maybe<DeleteIntegration>;
  deleteLead?: Maybe<DeleteLead>;
  deleteTask?: Maybe<DeleteTask>;
  duplicateJourney?: Maybe<JourneyMutationResult>;
  giftbackCancel?: Maybe<UpdateCancelGiftbackMutation>;
  giftbackCreate?: Maybe<CreateGiftbackMutation>;
  giftbackReactivate?: Maybe<ReactivateGiftbackMutation>;
  giftbackRedeem?: Maybe<UpdateRedeemGiftbackMutation>;
  loyaltyConfigurationDelete?: Maybe<DeleteLoyaltyConfigurationMutation>;
  loyaltyManualRuleApply?: Maybe<ApplyLoyaltyManualRuleMutation>;
  loyaltyPointsCredit?: Maybe<CreditLoyaltyPointsMutation>;
  loyaltyProgramUpdate?: Maybe<UpdateLoyaltyProgramMutation>;
  loyaltyRedemptionCancel?: Maybe<CancelLoyaltyRedemptionMutation>;
  loyaltyRedemptionCreate?: Maybe<CreateLoyaltyRedemptionMutation>;
  loyaltyRewardDeliver?: Maybe<DeliverLoyaltyRewardMutation>;
  loyaltyRewardSave?: Maybe<SaveLoyaltyRewardMutation>;
  loyaltyRuleSave?: Maybe<SaveLoyaltyRuleMutation>;
  loyaltyTierSave?: Maybe<SaveLoyaltyTierMutation>;
  nuvemshopAuthenticationRequest?: Maybe<NuvemshopAuthenticationRequest>;
  /**
   * Change account password when user knows the old password.
   *
   * A new token and refresh token are sent. User must be verified.
   */
  passwordChange?: Maybe<PasswordChangePayload>;
  /**
   * Change user password without old password.
   *
   * Receive the token that was sent by email.
   *
   * If token and new passwords are valid, update
   * user password and in case of using refresh
   * tokens, revoke all of them.
   *
   * Also, if user has not been verified yet, verify it.
   */
  passwordReset?: Maybe<PasswordResetPayload>;
  pauseBulkNotification?: Maybe<BulkNotificationPauseMutation>;
  pauseJourney?: Maybe<JourneyMutationResult>;
  prepareCommunity?: Maybe<PrepareCommunity>;
  productBulkCreate?: Maybe<CreateProductBulkMutation>;
  productCreate?: Maybe<CreateProductMutation>;
  productDelete?: Maybe<DeleteProductMutation>;
  productUpdate?: Maybe<UpdateProductMutation>;
  publicCancelAppointment?: Maybe<PublicCancelAppointmentMutation>;
  publicRescheduleAppointment?: Maybe<PublicRescheduleAppointmentMutation>;
  publishBookingStorefront?: Maybe<PublishBookingStorefrontMutation>;
  publishJourney?: Maybe<JourneyMutationResult>;
  purchaseCreate?: Maybe<CreatePurchaseMutation>;
  purchaseNotesUpdate?: Maybe<UpdatePurchaseNotesMutation>;
  purchaseTotemCreate?: Maybe<CreatePurchaseTotemMutation>;
  redefinePassword?: Maybe<RedefinePasswordMutation>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  refreshToken?: Maybe<RefreshTokenPayload>;
  /**
   * Register user with fields defined in the settings.
   *
   * If the email field of the user model is part of the
   * registration fields (default), check if there is
   * no user with that email or as a secondary email.
   *
   * If it exists, it does not register the user,
   * even if the email field is not defined as unique
   * (default of the default django user model).
   *
   * When creating the user, it also creates a `UserStatus`
   * related to that user, making it possible to track
   * if the user is archived, verified and has a secondary
   * email.
   *
   * Send account verification email.
   *
   * If allowed to not verified users login, return token.
   */
  register?: Maybe<RegisterPayload>;
  reorderCustomerAcquisitionChannels?: Maybe<ReorderCustomerAcquisitionChannels>;
  replaceAppointmentWorkingHours?: Maybe<ReplaceWorkingHoursMutation>;
  rescheduleAppointment?: Maybe<RescheduleAppointmentMutation>;
  rescheduleBulkNotificationCampaign?: Maybe<BulkNotificationRescheduleCampaignMutation>;
  /**
   * Sends activation email.
   *
   * It is called resend because theoretically
   * the first activation email was sent when
   * the user registered.
   *
   * If there is no user with the requested email,
   * a successful response is returned.
   */
  resendActivationEmail?: Maybe<ResendActivationEmailPayload>;
  restoreJourneyVersionToDraft?: Maybe<JourneyMutationResult>;
  resumeBulkNotification?: Maybe<BulkNotificationResumeMutation>;
  retryCommunity?: Maybe<RetryCommunity>;
  retryJourneyIntent?: Maybe<JourneyMutationResult>;
  saveAppointmentProfessional?: Maybe<SaveProfessionalMutation>;
  saveBookingSettings?: Maybe<SaveBookingSettingsMutation>;
  saveCustomerAcquisitionChannel?: Maybe<SaveCustomerAcquisitionChannel>;
  saveCustomerCustomField?: Maybe<SaveCustomerCustomField>;
  saveCustomerTagsConfig?: Maybe<SaveCustomerTagsConfigMutation>;
  saveEmailProvider?: Maybe<SaveEmailProviderStoreIntegrationMutation>;
  saveEvolutionApiIntegration?: Maybe<SaveEvolutionApiIntegrationMutation>;
  saveGiftbackConfig?: Maybe<SaveGiftbackConfigMutation>;
  saveHelenaStoreIntegration?: Maybe<SaveHelenaStoreIntegrationMutation>;
  saveHostgatorStoreIntegration?: Maybe<SaveHostgatorStoreIntegrationMutation>;
  saveJourneyDraft?: Maybe<JourneyMutationResult>;
  saveLojaIntegradaStoreIntegration?: Maybe<SaveLojaIntegradaStoreIntegrationMutation>;
  saveNuvemshopStoreIntegration?: Maybe<SaveNuvemShopStoreIntegrationMutation>;
  saveRfmAutomation?: Maybe<SaveRfmAutomationMutation>;
  saveRfmConfig?: Maybe<SaveRfmMutation>;
  saveScheduleAdjustment?: Maybe<SaveScheduleAdjustmentMutation>;
  saveService?: Maybe<SaveServiceMutation>;
  saveServiceCategory?: Maybe<SaveServiceCategoryMutation>;
  saveWebpicStoreIntegration?: Maybe<SaveWebpicStoreIntegrationMutation>;
  saveWhatsapp?: Maybe<SaveWhatsappConfigMutation>;
  saveZApi?: Maybe<SaveZApiIntegrationMutation>;
  scheduleCommunityMessage?: Maybe<ScheduleCommunityMessage>;
  sendBulkNotificationCampaign?: Maybe<BulkNotificationSendCampaignMutation>;
  sendBulkNotificationTest?: Maybe<SendBulkNotificationTestMutation>;
  /**
   * Send password reset email.
   *
   * For non verified users, send an activation
   * email instead.
   *
   * Accepts both primary and secondary email.
   *
   * If there is no user with the requested email,
   * a successful response is returned.
   */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  setActiveCustomer?: Maybe<SetActiveCustomer>;
  setBlingStoreIntegration?: Maybe<SetBlingStoreIntegration>;
  setOmieStoreIntegration?: Maybe<SetOmieStoreIntegration>;
  setPaymentMethod?: Maybe<SetPaymentMethod>;
  setShopifyStoreIntegration?: Maybe<SetShopifyStoreIntegration>;
  setSmsBaratoIntegration?: Maybe<SetSmsBaratoIntegration>;
  setSmsInfoBipIntegration?: Maybe<SetSmsInfoBipIntegration>;
  setTrinksStoreIntegration?: Maybe<SetTrinksStoreIntegration>;
  setYampiStoreIntegration?: Maybe<SetYampiStoreIntegration>;
  simulateJourney?: Maybe<JourneyMutationResult>;
  storeCreate?: Maybe<CreateStoreMutation>;
  storeUpdate?: Maybe<UpdateStoreMutation>;
  tagDelete?: Maybe<DeleteCustomerTagsMutation>;
  tagUpdate?: Maybe<UpdateCustomerTagsMutation>;
  tagsCreate?: Maybe<CreateCustomerTagsMutation>;
  testWhatsappConnection?: Maybe<TestWhatsappConnectionMutation>;
  /**
   * Obtain JSON web token for given user.
   *
   * Allow to perform login with different fields,
   * and secondary email if set. The fields are
   * defined on settings.
   *
   * Not verified users can login by default. This
   * can be changes on settings.
   *
   * If user is archived, make it unarchive and
   * return `unarchiving=True` on output.
   */
  tokenAuth?: Maybe<ObtainJsonWebTokenPayload>;
  trackBookingFunnelEvent?: Maybe<TrackBookingFunnelEventMutation>;
  /**
   * Update user model fields, defined on settings.
   *
   * User must be verified.
   */
  updateAccount?: Maybe<UpdateAccountPayload>;
  updateBoard?: Maybe<UpdateBoard>;
  updateBulkNotification?: Maybe<BulkNotificationUpdateMutation>;
  updateBulkNotificationCustomerData?: Maybe<BulkNotificationUpdateCustomerDataMutation>;
  updateCampaign?: Maybe<UpdateCampaignMutation>;
  updateColumnStatus?: Maybe<UpdateColumnStatus>;
  updateCommunityScheduledMessage?: Maybe<UpdateCommunityScheduledMessage>;
  updateCustomer?: Maybe<UpdateCustomer>;
  updateEmailTemplate?: Maybe<UpdateEmailTemplateMutation>;
  updateInstance?: Maybe<UpdateInstance>;
  updateIntegration?: Maybe<UpdateIntegration>;
  updateJourney?: Maybe<JourneyMutationResult>;
  updateLead?: Maybe<UpdateLead>;
  updateTask?: Maybe<UpdateTask>;
  updateTemplateStatus?: Maybe<UpdateTemplateStatusMutation>;
  updateUserConnectedStore?: Maybe<UpdateUserConnectedStoreMutation>;
  updateUserCustom?: Maybe<UpdateCustomUserMutation>;
  validateJourneyDraft?: Maybe<JourneyMutationResult>;
  /**
   * Verify user account.
   *
   * Receive the token that was sent by email.
   * If the token is valid, make the user verified
   * by making the `user.status.verified` field true.
   */
  verifyAccount?: Maybe<VerifyAccountPayload>;
  /** Same as `grapgql_jwt` implementation, with standard output. */
  verifyToken?: Maybe<VerifyTokenPayload>;
};


export type MutationAcceptTermsArgs = {
  termsId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationActivateJourneyArgs = {
  journeyId: Scalars['ID']['input'];
};


export type MutationActiveOrInactiveCampaignArgs = {
  input: ActiveOrInactiveCampaignInput;
};


export type MutationAddTagsToAudienceSelectionArgs = {
  input: AddTagsToAudienceSelectionInput;
};


export type MutationAddTagsToCustomersArgs = {
  input: AddTagsToCustomersInput;
};


export type MutationAdminGiftbackShopifyAutomaticoCriarArgs = {
  input?: InputMaybe<AdminCreateShopifyGiftbackAutomaticInput>;
};


export type MutationAdminGiftbackTrayCriarArgs = {
  input?: InputMaybe<AdminCreateTrayGiftbackInput>;
};


export type MutationAdminGiftbackTrayDeletarArgs = {
  input?: InputMaybe<AdminDeleteTrayGiftbackInput>;
};


export type MutationAdminGiftbackTrayVincularArgs = {
  input?: InputMaybe<AdminRelateTrayGiftbackInput>;
};


export type MutationAdminGiftbackVincularArgs = {
  input?: InputMaybe<AdminRelateGiftbackInput>;
};


export type MutationArchiveAccountArgs = {
  input: ArchiveAccountInput;
};


export type MutationArchiveJourneyArgs = {
  journeyId: Scalars['ID']['input'];
};


export type MutationCancelBulkNotificationArgs = {
  input: BulkNotificationCancellInput;
};


export type MutationCancelCommunityScheduledMessageArgs = {
  expectedRevision: Scalars['Int']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationCancelJourneyExecutionArgs = {
  executionId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelPurchaseArgs = {
  purchaseInput?: InputMaybe<CancelPurchaseInput>;
};


export type MutationCashRegisterClosingSaveArgs = {
  input: SaveCashRegisterClosingInput;
};


export type MutationCashRegisterSangriaCreateArgs = {
  input: CreateCashRegisterSangriaInput;
};


export type MutationCategoryCreateArgs = {
  categoryInput: CreateCategoryInput;
};


export type MutationCategoryDeleteArgs = {
  categoryInput: DeleteCategoryInput;
};


export type MutationCategoryUpdateArgs = {
  categoryInput: UpdateCategoryInput;
};


export type MutationChangeAppointmentStatusArgs = {
  appointmentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationChangeJourneyTriggerOwnershipArgs = {
  confirmNoDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  mode: Scalars['String']['input'];
  rollbackPolicy?: InputMaybe<Scalars['String']['input']>;
  triggerFamily: Scalars['String']['input'];
};


export type MutationConfirmCommunityArgs = {
  input: ConfirmCommunityInput;
};


export type MutationConnectOrDisconnectEvolutionApiIntegrationArgs = {
  input: ConnectOrDisconnectEvolutionApiIntegrationInput;
};


export type MutationCouponCreateArgs = {
  couponInput: CouponInput;
};


export type MutationCouponDeleteArgs = {
  couponInput: DeleteCouponInput;
};


export type MutationCouponUpdateArgs = {
  couponInput: UpdateCouponInput;
};


export type MutationCreateBoardArgs = {
  boardInput?: InputMaybe<BoardInput>;
};


export type MutationCreateBulkNotificationArgs = {
  input: BulkNotificationCreateInput;
};


export type MutationCreateCampaignArgs = {
  campaignInput: CreateCampaignInput;
};


export type MutationCreateColumnStatusArgs = {
  columnStatusInput?: InputMaybe<ColumnStatusInput>;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CreateCustomerInput>;
};


export type MutationCreateCustomerAudienceSelectionArgs = {
  filterContext?: InputMaybe<CustomerAudienceFilterContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackInput?: InputMaybe<GiftbackFilterSetInput>;
  input: CustomerFilterSetInput;
  purchaseInput?: InputMaybe<PurchaseProductFilterSetInput>;
  salesInput?: InputMaybe<PurchaseFilterSetInput>;
};


export type MutationCreateEmailTemplateArgs = {
  input: EmailTemplateCreateInput;
};


export type MutationCreateInstanceArgs = {
  instanceInput?: InputMaybe<InstanceInput>;
};


export type MutationCreateIntegrationArgs = {
  integrationInput?: InputMaybe<IntegrationInput>;
};


export type MutationCreateInternalAppointmentArgs = {
  input: InternalAppointmentInput;
};


export type MutationCreateJourneyArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  triggerType: Scalars['String']['input'];
};


export type MutationCreateLeadArgs = {
  leadInput?: InputMaybe<LeadInput>;
};


export type MutationCreatePublicAppointmentArgs = {
  input: PublicAppointmentInput;
};


export type MutationCreatePurchaseProgressionAudienceSelectionArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PurchaseProgressionInput;
  pendingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseNumber: Scalars['Int']['input'];
};


export type MutationCreateRetentionAudienceSelectionArgs = {
  cohortStart: Scalars['Date']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetentionCohortInput;
  offset: Scalars['Int']['input'];
};


export type MutationCreateTaskArgs = {
  taskInput?: InputMaybe<TaskInput>;
};


export type MutationCreateTemplateByCampaignArgs = {
  input: CreateWhatsappTemplateByCampaignInput;
};


export type MutationCreateTrayStoreIntegrationArgs = {
  trayInput: CreateTrayStoreIntegrationInput;
};


export type MutationCreateUserCustomArgs = {
  userInput: CreateUserInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteBoardArgs = {
  boardId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteBulkNotificationArgs = {
  input: BulkNotificationDeleteInput;
};


export type MutationDeleteCampaignArgs = {
  campaignInput: DeleteCampaignInput;
};


export type MutationDeleteColumnStatusArgs = {
  integrationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ID']['input'];
};


export type MutationDeleteCustomerCustomFieldArgs = {
  fieldId: Scalars['ID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInstanceArgs = {
  instanceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteIntegrationArgs = {
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteLeadArgs = {
  leadId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteTaskArgs = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDuplicateJourneyArgs = {
  journeyId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGiftbackCancelArgs = {
  giftbackInput: UpdateCancelGiftbackInput;
};


export type MutationGiftbackCreateArgs = {
  giftbackInput: CreateGiftbackInput;
};


export type MutationGiftbackReactivateArgs = {
  input: ReactivateGiftbackInput;
};


export type MutationGiftbackRedeemArgs = {
  giftbackInput: UpdateRedeemGiftbackInput;
};


export type MutationLoyaltyConfigurationDeleteArgs = {
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
};


export type MutationLoyaltyManualRuleApplyArgs = {
  memberId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
  ruleId: Scalars['ID']['input'];
};


export type MutationLoyaltyPointsCreditArgs = {
  memberId: Scalars['ID']['input'];
  points: Scalars['Int']['input'];
  reference: Scalars['String']['input'];
};


export type MutationLoyaltyProgramUpdateArgs = {
  input: LoyaltyProgramInput;
};


export type MutationLoyaltyRedemptionCancelArgs = {
  reason: Scalars['String']['input'];
  redemptionId: Scalars['ID']['input'];
};


export type MutationLoyaltyRedemptionCreateArgs = {
  input: LoyaltyRedemptionInput;
};


export type MutationLoyaltyRewardDeliverArgs = {
  code: Scalars['String']['input'];
};


export type MutationLoyaltyRewardSaveArgs = {
  input: LoyaltyRewardInput;
};


export type MutationLoyaltyRuleSaveArgs = {
  input: LoyaltyRuleInput;
};


export type MutationLoyaltyTierSaveArgs = {
  input: LoyaltyTierInput;
};


export type MutationNuvemshopAuthenticationRequestArgs = {
  input: NuvemshopAuthenticationRequestInput;
};


export type MutationPasswordChangeArgs = {
  input: PasswordChangeInput;
};


export type MutationPasswordResetArgs = {
  input: PasswordResetInput;
};


export type MutationPauseBulkNotificationArgs = {
  input: BulkNotificationPauseInput;
};


export type MutationPauseJourneyArgs = {
  journeyId: Scalars['ID']['input'];
};


export type MutationPrepareCommunityArgs = {
  input: PrepareCommunityInput;
};


export type MutationProductBulkCreateArgs = {
  productsInput?: InputMaybe<Array<InputMaybe<CreateProductBulkInput>>>;
};


export type MutationProductCreateArgs = {
  productInput: CreateProductInput;
};


export type MutationProductDeleteArgs = {
  productInput: DeleteProductInput;
};


export type MutationProductUpdateArgs = {
  productInput: UpdateProductInput;
};


export type MutationPublicCancelAppointmentArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationPublicRescheduleAppointmentArgs = {
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  startsAt: Scalars['DateTime']['input'];
  token: Scalars['String']['input'];
};


export type MutationPublishJourneyArgs = {
  expectedRevision: Scalars['Int']['input'];
  journeyId: Scalars['ID']['input'];
};


export type MutationPurchaseCreateArgs = {
  purchaseInput: CreatePurchaseInput;
};


export type MutationPurchaseNotesUpdateArgs = {
  purchaseInput?: InputMaybe<UpdatePurchaseNotesInput>;
};


export type MutationPurchaseTotemCreateArgs = {
  purchaseInput: CreatePurchaseTotemInput;
};


export type MutationRedefinePasswordArgs = {
  input?: InputMaybe<RedefinePasswordInput>;
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationReorderCustomerAcquisitionChannelsArgs = {
  input: ReorderCustomerAcquisitionChannelsInput;
};


export type MutationReplaceAppointmentWorkingHoursArgs = {
  hours: Array<InputMaybe<WorkingHoursInput>>;
};


export type MutationRescheduleAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  startsAt: Scalars['DateTime']['input'];
};


export type MutationRescheduleBulkNotificationCampaignArgs = {
  input: BulkNotificationRescheduleCampaignInput;
};


export type MutationResendActivationEmailArgs = {
  input: ResendActivationEmailInput;
};


export type MutationRestoreJourneyVersionToDraftArgs = {
  expectedRevision: Scalars['Int']['input'];
  journeyId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationResumeBulkNotificationArgs = {
  input: BulkNotificationResumeInput;
};


export type MutationRetryCommunityArgs = {
  communityId: Scalars['ID']['input'];
};


export type MutationRetryJourneyIntentArgs = {
  intentId: Scalars['ID']['input'];
};


export type MutationSaveAppointmentProfessionalArgs = {
  input: SaveProfessionalInput;
};


export type MutationSaveBookingSettingsArgs = {
  input: SaveBookingSettingsInput;
};


export type MutationSaveCustomerAcquisitionChannelArgs = {
  input: SaveCustomerAcquisitionChannelInput;
};


export type MutationSaveCustomerCustomFieldArgs = {
  input: SaveCustomerCustomFieldInput;
};


export type MutationSaveCustomerTagsConfigArgs = {
  tagInput: SaveCustomerTagsConfigInput;
};


export type MutationSaveEmailProviderArgs = {
  input?: InputMaybe<EmailProviderStoreIntegrationInput>;
};


export type MutationSaveEvolutionApiIntegrationArgs = {
  input: EvolutionApiIntegrationInput;
};


export type MutationSaveGiftbackConfigArgs = {
  input?: InputMaybe<GiftbackConfigInput>;
};


export type MutationSaveHelenaStoreIntegrationArgs = {
  input: HelenaStoreIntegrationInput;
};


export type MutationSaveHostgatorStoreIntegrationArgs = {
  input: SaveHostgatorStoreIntegrationInput;
};


export type MutationSaveJourneyDraftArgs = {
  definition: Scalars['GenericScalar']['input'];
  expectedRevision: Scalars['Int']['input'];
  journeyId: Scalars['ID']['input'];
};


export type MutationSaveLojaIntegradaStoreIntegrationArgs = {
  input: SaveLojaIntegradaStoreIntegrationInput;
};


export type MutationSaveNuvemshopStoreIntegrationArgs = {
  input: SaveNuvemshopStoreIntegrationInput;
};


export type MutationSaveRfmAutomationArgs = {
  dailyRefreshEnabled: Scalars['Boolean']['input'];
};


export type MutationSaveRfmConfigArgs = {
  frequencyInput?: InputMaybe<FrequencyRfmInput>;
  recencyInput?: InputMaybe<RecencyRfmInput>;
  valueInput?: InputMaybe<ValueRfmInput>;
};


export type MutationSaveScheduleAdjustmentArgs = {
  input: SaveScheduleAdjustmentInput;
};


export type MutationSaveServiceArgs = {
  input: SaveServiceInput;
};


export type MutationSaveServiceCategoryArgs = {
  input: SaveServiceCategoryInput;
};


export type MutationSaveWebpicStoreIntegrationArgs = {
  input: SaveWebpicStoreIntegrationInput;
};


export type MutationSaveWhatsappArgs = {
  input?: InputMaybe<WhatsappConfigInput>;
};


export type MutationSaveZApiArgs = {
  input?: InputMaybe<ZApiIntegrationInput>;
};


export type MutationScheduleCommunityMessageArgs = {
  input: ScheduleCommunityMessageInput;
};


export type MutationSendBulkNotificationCampaignArgs = {
  input: BulkNotificationSendCampaignInput;
};


export type MutationSendBulkNotificationTestArgs = {
  input: BulkNotificationTestSendInput;
};


export type MutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type MutationSetActiveCustomerArgs = {
  input: SetActiveCustomerInput;
};


export type MutationSetBlingStoreIntegrationArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetOmieStoreIntegrationArgs = {
  input: SetOmieStoreIntegrationInput;
};


export type MutationSetPaymentMethodArgs = {
  inputs?: InputMaybe<Array<InputMaybe<SetPaymentMethodInput>>>;
};


export type MutationSetShopifyStoreIntegrationArgs = {
  input: SetShopifyStoreIntegrationInput;
};


export type MutationSetSmsBaratoIntegrationArgs = {
  input: SetSmsBaratoIntegrationInput;
};


export type MutationSetSmsInfoBipIntegrationArgs = {
  input: SetSmsInfoBipIntegrationInput;
};


export type MutationSetTrinksStoreIntegrationArgs = {
  input: SetTrinksStoreIntegrationInput;
};


export type MutationSetYampiStoreIntegrationArgs = {
  input: SetYampiStoreIntegrationInput;
};


export type MutationSimulateJourneyArgs = {
  definition?: InputMaybe<Scalars['GenericScalar']['input']>;
  eventContext: Scalars['GenericScalar']['input'];
  journeyId: Scalars['ID']['input'];
};


export type MutationStoreCreateArgs = {
  input: CreateStoreInput;
};


export type MutationStoreUpdateArgs = {
  input?: InputMaybe<UpdateStoreInput>;
};


export type MutationTagDeleteArgs = {
  tagId: Scalars['ID']['input'];
};


export type MutationTagUpdateArgs = {
  tagInput: UpdateCustomerTagsInput;
};


export type MutationTagsCreateArgs = {
  tagInput: CreateCustomerTagsInput;
};


export type MutationTokenAuthArgs = {
  input: ObtainJsonWebTokenInput;
};


export type MutationTrackBookingFunnelEventArgs = {
  attribution?: InputMaybe<Scalars['GenericScalar']['input']>;
  eventType: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateBoardArgs = {
  boardId?: InputMaybe<Scalars['ID']['input']>;
  boardInput?: InputMaybe<BoardInput>;
};


export type MutationUpdateBulkNotificationArgs = {
  input: BulkNotificationUpdateInput;
};


export type MutationUpdateBulkNotificationCustomerDataArgs = {
  input: BulkNotificationUpdateCustomerDataInput;
};


export type MutationUpdateCampaignArgs = {
  campaignInput: UpdateCampaignInput;
};


export type MutationUpdateColumnStatusArgs = {
  columnStatusId?: InputMaybe<Scalars['ID']['input']>;
  columnStatusInput?: InputMaybe<ColumnStatusInput>;
};


export type MutationUpdateCommunityScheduledMessageArgs = {
  input: UpdateCommunityScheduledMessageInput;
};


export type MutationUpdateCustomerArgs = {
  input?: InputMaybe<UpdateCustomerInput>;
};


export type MutationUpdateEmailTemplateArgs = {
  input: EmailTemplateUpdateInput;
};


export type MutationUpdateInstanceArgs = {
  instanceInput?: InputMaybe<InstanceInput>;
};


export type MutationUpdateIntegrationArgs = {
  integrationInput?: InputMaybe<IntegrationInput>;
};


export type MutationUpdateJourneyArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  journeyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateLeadArgs = {
  leadId?: InputMaybe<Scalars['ID']['input']>;
  leadInput?: InputMaybe<LeadInput>;
};


export type MutationUpdateTaskArgs = {
  taskInput?: InputMaybe<TaskInput>;
};


export type MutationUpdateTemplateStatusArgs = {
  input: UpdateTemplateStatusInput;
};


export type MutationUpdateUserConnectedStoreArgs = {
  storeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateUserCustomArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationValidateJourneyDraftArgs = {
  definition?: InputMaybe<Scalars['GenericScalar']['input']>;
  journeyId: Scalars['ID']['input'];
};


export type MutationVerifyAccountArgs = {
  input: VerifyAccountInput;
};


export type MutationVerifyTokenArgs = {
  input: VerifyTokenInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum NotificationDeliveryLedgerStatus {
  /** Aceito */
  Accepted = 'ACCEPTED',
  /** Falha recuperável */
  FailedRetryable = 'FAILED_RETRYABLE',
  /** Falha terminal */
  FailedTerminal = 'FAILED_TERMINAL',
  /** Reservado */
  Reserved = 'RESERVED',
  /** Redirecionado ao sandbox */
  Sandboxed = 'SANDBOXED',
  /** Enviado */
  Sent = 'SENT',
  /** Desconhecido */
  Unknown = 'UNKNOWN'
}

export type NuvemshopAuthenticationRequest = {
  __typename?: 'NuvemshopAuthenticationRequest';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type NuvemshopAuthenticationRequestInput = {
  code: Scalars['String']['input'];
  connected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NuvemshopStoreIntegrationType = {
  __typename?: 'NuvemshopStoreIntegrationType';
  /** Status disponíveis: pending, authorized, paid, voided, refunded, abandoned, open, closed, cancelled. Caso o campo esteja vazio, todos os status serão importados */
  acceptedStatusToImport: Scalars['String']['output'];
  accessToken: Scalars['String']['output'];
  appEmail: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type ObtainJsonWebTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/**
 * Obtain JSON web token for given user.
 *
 * Allow to perform login with different fields,
 * and secondary email if set. The fields are
 * defined on settings.
 *
 * Not verified users can login by default. This
 * can be changes on settings.
 *
 * If user is archived, make it unarchive and
 * return `unarchiving=True` on output.
 */
export type ObtainJsonWebTokenPayload = {
  __typename?: 'ObtainJSONWebTokenPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  unarchiving?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserNode>;
};

export type OmieStoreIntegrationType = {
  __typename?: 'OmieStoreIntegrationType';
  activated: Scalars['Boolean']['output'];
  appKey: Scalars['String']['output'];
  appSecret: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nfce: Scalars['Boolean']['output'];
  nfe: Scalars['Boolean']['output'];
  nfse: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordChangeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

/**
 * Change account password when user knows the old password.
 *
 * A new token and refresh token are sent. User must be verified.
 */
export type PasswordChangePayload = {
  __typename?: 'PasswordChangePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/**
 * Change user password without old password.
 *
 * Receive the token that was sent by email.
 *
 * If token and new passwords are valid, update
 * user password and in case of using refresh
 * tokens, revoke all of them.
 *
 * Also, if user has not been verified yet, verify it.
 */
export type PasswordResetPayload = {
  __typename?: 'PasswordResetPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum PaymentMethodAdjustmentType {
  /** Decréscimo */
  Decrease = 'DECREASE',
  /** Acréscimo */
  Increase = 'INCREASE'
}

export type PaymentMethodInput = {
  installments?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  adjustmentType: PaymentMethodAdjustmentType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  valueType: PaymentMethodValueType;
};

/** An enumeration. */
export enum PaymentMethodValueType {
  /** Fixo */
  Fixed = 'FIXED',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type PermissionType = {
  __typename?: 'PermissionType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  user: CustomUserNode;
  userType?: Maybe<PermissionUserType>;
};

/** An enumeration. */
export enum PermissionUserType {
  /** Admin */
  Admin = 'ADMIN',
  /** Funcionário */
  Employee = 'EMPLOYEE',
  /** Vendedor */
  Seller = 'SELLER'
}

export enum PlanningDateBasis {
  Actual = 'ACTUAL',
  Planned = 'PLANNED'
}

export type PlanningEvent = {
  __typename?: 'PlanningEvent';
  allDay: Scalars['Boolean']['output'];
  channels: Array<Scalars['String']['output']>;
  communityId?: Maybe<Scalars['ID']['output']>;
  date: Scalars['Date']['output'];
  dateBasis: PlanningDateBasis;
  destination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rawStatus: Scalars['String']['output'];
  source: PlanningEventSource;
  sourceId: Scalars['ID']['output'];
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: PlanningEventStatus;
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PlanningEventPage = {
  __typename?: 'PlanningEventPage';
  availableSources: Array<PlanningEventSource>;
  campaignTimeZone: Scalars['String']['output'];
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<PlanningEvent>;
  total: Scalars['Int']['output'];
  undatedCampaignCount: Scalars['Int']['output'];
};

export enum PlanningEventSource {
  Campaign = 'CAMPAIGN',
  Community = 'COMMUNITY'
}

export enum PlanningEventStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN'
}

export type PrepareCommunity = {
  __typename?: 'PrepareCommunity';
  community: Community;
};

export type PrepareCommunityInput = {
  audienceSelectionId: Scalars['ID']['input'];
  requestId: Scalars['UUID']['input'];
  sourceLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ProductExcelReportType = {
  __typename?: 'ProductExcelReportType';
  background?: Maybe<Scalars['Boolean']['output']>;
  relatorio?: Maybe<Scalars['String']['output']>;
};

export type ProductFilterSetInput = {
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};

/** An enumeration. */
export enum ProductImportedFrom {
  /** Bling */
  Bling = 'BLING',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type ProductListItemsType = {
  __typename?: 'ProductListItemsType';
  productAbcClassification?: Maybe<Scalars['String']['output']>;
  productAccumulatedPercentage?: Maybe<Scalars['Float']['output']>;
  productIndividualPercentage?: Maybe<Scalars['Float']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productPk?: Maybe<Scalars['ID']['output']>;
  productQuantity?: Maybe<Scalars['Float']['output']>;
  productRank?: Maybe<Scalars['Int']['output']>;
  productTotalValue?: Maybe<Scalars['Float']['output']>;
};

export type ProductListTableType = {
  __typename?: 'ProductListTableType';
  aThreshold?: Maybe<Scalars['Float']['output']>;
  bThreshold?: Maybe<Scalars['Float']['output']>;
  curvePoints?: Maybe<Array<Maybe<SalesAbcCurvePoint>>>;
  filteredProductsCount?: Maybe<Scalars['Int']['output']>;
  groups?: Maybe<Array<Maybe<ProductsCurveAbcColumnGroupsData>>>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  productsList?: Maybe<Array<Maybe<ProductListItemsType>>>;
  summary?: Maybe<Array<Maybe<SalesAbcSummary>>>;
  total?: Maybe<Scalars['Float']['output']>;
  totalProducts?: Maybe<Scalars['Int']['output']>;
};

export type ProductRelayType = Node & {
  __typename?: 'ProductRelayType';
  categories: CategoryRelayTypeConnection;
  costValue: Scalars['Float']['output'];
  coupons: CouponRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  customertagsSet: CustomerTagsRelayTypeConnection;
  date: Scalars['Date']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  giftbackCouponConfigs: Array<GiftbackConfigType>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedFrom: ProductImportedFrom;
  integrationId?: Maybe<Scalars['String']['output']>;
  isActivated: Scalars['Boolean']['output'];
  loyaltyRedemptionItems: Array<LoyaltyRedemptionItemType>;
  loyaltyRewards: Array<LoyaltyRewardType>;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  promotionalValue: Scalars['Float']['output'];
  purchaseproductSet: PurchaseProductRelayTypeConnection;
  stock?: Maybe<Scalars['Int']['output']>;
  store: StoreType;
  unit: ProductUnit;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  wholesaleValue: Scalars['Float']['output'];
};


export type ProductRelayTypeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type ProductRelayTypeCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};


export type ProductRelayTypeCustomertagsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};


export type ProductRelayTypePurchaseproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product_Id?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductRelayTypeConnection = {
  __typename?: 'ProductRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProductRelayType` and its cursor. */
export type ProductRelayTypeEdge = {
  __typename?: 'ProductRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProductRelayType>;
};

export type ProductType = {
  __typename?: 'ProductType';
  categories: CategoryRelayTypeConnection;
  costValue: Scalars['Float']['output'];
  coupons: CouponRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  customertagsSet: CustomerTagsRelayTypeConnection;
  date: Scalars['Date']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  giftbackCouponConfigs: Array<GiftbackConfigType>;
  id: Scalars['ID']['output'];
  importedFrom: ProductImportedFrom;
  integrationId?: Maybe<Scalars['String']['output']>;
  isActivated: Scalars['Boolean']['output'];
  loyaltyRedemptionItems: Array<LoyaltyRedemptionItemType>;
  loyaltyRewards: Array<LoyaltyRewardType>;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  promotionalValue: Scalars['Float']['output'];
  purchaseproductSet: PurchaseProductRelayTypeConnection;
  stock?: Maybe<Scalars['Int']['output']>;
  store: StoreType;
  unit: ProductUnit;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  wholesaleValue: Scalars['Float']['output'];
};


export type ProductTypeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTypeCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTypeCustomertagsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTypePurchaseproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product_Id?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

/** An enumeration. */
export enum ProductUnit {
  /** Quilograma */
  Kg = 'KG',
  /** Unidade */
  Un = 'UN'
}

export type ProductsCurveAbcColumnGroupsData = {
  __typename?: 'ProductsCurveAbcColumnGroupsData';
  cols?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductsTopSellingProductsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  rfmClassificationList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProductsTopSellingProductsType = {
  __typename?: 'ProductsTopSellingProductsType';
  productName?: Maybe<Scalars['String']['output']>;
  rankPosition?: Maybe<Scalars['Int']['output']>;
  totalSold?: Maybe<Scalars['Float']['output']>;
};

export type ProfessionalServiceType = {
  __typename?: 'ProfessionalServiceType';
  createdAt: Scalars['DateTime']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  effectiveDurationMinutes?: Maybe<Scalars['Int']['output']>;
  effectiveValue?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  professional: ProfessionalType;
  service: ServiceRelayType;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ProfessionalType = {
  __typename?: 'ProfessionalType';
  appointments: Array<AppointmentType>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  photoUrl: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  professionalServices: Array<ProfessionalServiceType>;
  publicName: Scalars['String']['output'];
  scheduleAdjustments: Array<ScheduleAdjustmentType>;
  services?: Maybe<Array<Maybe<ServiceType>>>;
  store: StoreType;
  unit: SchedulingUnitType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
  workingHours: Array<WorkingHoursType>;
};

export type PublicAppointmentInput = {
  attribution?: InputMaybe<Scalars['GenericScalar']['input']>;
  consentEvidence?: InputMaybe<Scalars['GenericScalar']['input']>;
  customer: CustomerAppointmentInput;
  idempotencyKey: Scalars['String']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  serviceId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['UUID']['input']>;
  slug: Scalars['String']['input'];
  startsAt: Scalars['DateTime']['input'];
};

export type PublicAppointmentType = {
  __typename?: 'PublicAppointmentType';
  bookingSlug: Scalars['String']['output'];
  canCancel: Scalars['Boolean']['output'];
  canReschedule: Scalars['Boolean']['output'];
  endsAt: Scalars['DateTime']['output'];
  professionalName: Scalars['String']['output'];
  publicId: Scalars['UUID']['output'];
  serviceId: Scalars['ID']['output'];
  serviceName: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
  storefront?: Maybe<PublicStorefrontProfileType>;
  timezone: Scalars['String']['output'];
};

export type PublicBookingPageType = {
  __typename?: 'PublicBookingPageType';
  address?: Maybe<Scalars['String']['output']>;
  allowProfessionalPreference: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  privacyUrl?: Maybe<Scalars['String']['output']>;
  professionals?: Maybe<Array<Maybe<PublicProfessionalType>>>;
  services?: Maybe<Array<Maybe<PublicServiceType>>>;
  slug: Scalars['String']['output'];
  storeName: Scalars['String']['output'];
  storefront?: Maybe<PublicStorefrontProfileType>;
  termsUrl?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  workingHours?: Maybe<Array<Maybe<WorkingHoursType>>>;
};

export type PublicCancelAppointmentMutation = {
  __typename?: 'PublicCancelAppointmentMutation';
  appointment?: Maybe<PublicAppointmentType>;
};

export type PublicProfessionalType = {
  __typename?: 'PublicProfessionalType';
  bio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  serviceIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type PublicRescheduleAppointmentMutation = {
  __typename?: 'PublicRescheduleAppointmentMutation';
  result?: Maybe<AppointmentActionResultType>;
};

export type PublicServiceType = {
  __typename?: 'PublicServiceType';
  categoryId: Scalars['ID']['output'];
  categoryName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type PublicStorefrontProfileType = {
  __typename?: 'PublicStorefrontProfileType';
  aboutText?: Maybe<Scalars['String']['output']>;
  aboutTitle?: Maybe<Scalars['String']['output']>;
  accentColor: Scalars['String']['output'];
  coverImageAlt?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  logoAlt?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  mapsUrl?: Maybe<Scalars['String']['output']>;
  preset: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  surfaceColor: Scalars['String']['output'];
  tiktokUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type PublishBookingStorefrontMutation = {
  __typename?: 'PublishBookingStorefrontMutation';
  workspace?: Maybe<AppointmentWorkspaceType>;
};

export type PurchaseCardsValues = {
  __typename?: 'PurchaseCardsValues';
  purchaseAverageTicket?: Maybe<Scalars['Float']['output']>;
  purchasesCount?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseColumnChartReturn = {
  __typename?: 'PurchaseColumnChartReturn';
  kindOfDate?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<PurchaseColumnChartSeries>>>;
};

export type PurchaseColumnChartSeries = {
  __typename?: 'PurchaseColumnChartSeries';
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum PurchaseDiscountType {
  /** Fixo */
  Fixed = 'FIXED',
  /** Porcentagem */
  Percentage = 'PERCENTAGE'
}

export type PurchaseExcelReportType = {
  __typename?: 'PurchaseExcelReportType';
  background?: Maybe<Scalars['Boolean']['output']>;
  relatorio?: Maybe<Scalars['String']['output']>;
};

export type PurchaseFilterSetInput = {
  /** Approved or Canceled Sales */
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Created and/or Redeemed Giftbacks in Purchases */
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  /** Name (OR) Email */
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  /** Ordenando */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Product IDs */
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['Float']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['Float']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Username (OR) Email */
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

/** An enumeration. */
export enum PurchaseImportedFrom {
  /** Bling */
  Bling = 'BLING',
  /** Giftback criado separadamente */
  CreateOnlyGiftback = 'CREATE_ONLY_GIFTBACK',
  /** Dapic */
  Dapic = 'DAPIC',
  /** Gesfood */
  Gesfood = 'GESFOOD',
  /** HostGator */
  Hostgator = 'HOSTGATOR',
  /** Loja Integrada */
  LojaIntegrada = 'LOJA_INTEGRADA',
  /** Moego */
  Moego = 'MOEGO',
  /** Nuvemshop */
  Nuvemshop = 'NUVEMSHOP',
  /** Omie */
  Omie = 'OMIE',
  /** PDV */
  Pdv = 'PDV',
  /** Quick ERP */
  QuickErp = 'QUICK_ERP',
  /** SGI */
  Sgi = 'SGI',
  /** Shopify */
  Shopify = 'SHOPIFY',
  /** SOST */
  Sost = 'SOST',
  /** Planilha */
  Spreadsheet = 'SPREADSHEET',
  /** Sistema Zeki */
  System = 'SYSTEM',
  /** Totem */
  Totem = 'TOTEM',
  /** Tray */
  Tray = 'TRAY',
  /** Trinks */
  Trinks = 'TRINKS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Yampi */
  Yampi = 'YAMPI'
}

export type PurchasePaymentMethodType = {
  __typename?: 'PurchasePaymentMethodType';
  id: Scalars['ID']['output'];
  installments?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  purchase: PurchaseRelayType;
  value: Scalars['Float']['output'];
};

export type PurchaseProductFilterSetInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  /** Ordenando */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product_Id?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseProductInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  value: Scalars['Decimal']['input'];
};

export type PurchaseProductRelayType = Node & {
  __typename?: 'PurchaseProductRelayType';
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  journeyExecutions: Array<JourneyExecutionType>;
  pk: Scalars['Int']['output'];
  product: ProductRelayType;
  purchase: PurchaseRelayType;
  quantity?: Maybe<Scalars['Float']['output']>;
  scheduledNotificationIntents: Array<JourneyScheduledIntentType>;
  subtotal: Scalars['Float']['output'];
  unitCostValue: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type PurchaseProductRelayTypeConnection = {
  __typename?: 'PurchaseProductRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseProductRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PurchaseProductRelayType` and its cursor. */
export type PurchaseProductRelayTypeEdge = {
  __typename?: 'PurchaseProductRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseProductRelayType>;
};

export type PurchaseProgressionInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type PurchaseProgressionReturn = {
  __typename?: 'PurchaseProgressionReturn';
  rows: Array<PurchaseProgressionRowReturn>;
};

export type PurchaseProgressionRowReturn = {
  __typename?: 'PurchaseProgressionRowReturn';
  averageTicket?: Maybe<Scalars['Float']['output']>;
  customerCount: Scalars['Int']['output'];
  medianDaysToNextPurchase?: Maybe<Scalars['Float']['output']>;
  nextPurchaseCount: Scalars['Int']['output'];
  pendingNextPurchaseCount: Scalars['Int']['output'];
  purchaseNumber: Scalars['Int']['output'];
};

export type PurchaseRelayType = Node & {
  __typename?: 'PurchaseRelayType';
  additionalValues: Scalars['Float']['output'];
  bulknotificationcustomersalesSet: Array<BulkNotificationCustomerSalesType>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<CouponRelayType>;
  createdAt: Scalars['DateTime']['output'];
  credithousepurchase?: Maybe<CreditHousePurchaseType>;
  customer: CustomerTypeRelay;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  discountType: PurchaseDiscountType;
  discountValue: Scalars['Float']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  extraData?: Maybe<Scalars['GenericScalar']['output']>;
  giftback?: Maybe<GiftbackRelayType>;
  giftbackRedeemed?: Maybe<GiftbackRelayType>;
  giftbackRedeemedValue: Scalars['Float']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  importedFrom: PurchaseImportedFrom;
  integrationId?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  journeyExecutions: Array<JourneyExecutionType>;
  journeyGoalEvents: Array<JourneyGoalEventType>;
  justification: Scalars['String']['output'];
  loyaltyRedemption?: Maybe<LoyaltyRedemptionType>;
  loyaltypointentrySet: Array<LoyaltyPointEntryType>;
  nfeKey?: Maybe<Scalars['String']['output']>;
  nfeLink?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  purchasepaymentmethodSet: Array<PurchasePaymentMethodType>;
  purchaseproductSet: PurchaseProductRelayTypeConnection;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  sellerName?: Maybe<Scalars['String']['output']>;
  serviceItems: Array<PurchaseServiceType>;
  shipmentValue: Scalars['Float']['output'];
  shipmentWeight?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  store: StoreType;
  trackingCode?: Maybe<Scalars['String']['output']>;
  trackingCodeUrl?: Maybe<Scalars['String']['output']>;
  transportCompany?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
  value: Scalars['Float']['output'];
  volumesQuantity?: Maybe<Scalars['Int']['output']>;
};


export type PurchaseRelayTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type PurchaseRelayTypePurchaseproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product_Id?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseRelayTypeConnection = {
  __typename?: 'PurchaseRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `PurchaseRelayType` and its cursor. */
export type PurchaseRelayTypeEdge = {
  __typename?: 'PurchaseRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseRelayType>;
};

export type PurchaseServiceInput = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  serviceId: Scalars['ID']['input'];
  value: Scalars['Decimal']['input'];
};

export type PurchaseServiceType = {
  __typename?: 'PurchaseServiceType';
  appointment?: Maybe<AppointmentType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  purchase: PurchaseRelayType;
  quantity: Scalars['Int']['output'];
  service?: Maybe<ServiceRelayType>;
  serviceName: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  unitCostValue: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type PurchaseType = {
  __typename?: 'PurchaseType';
  additionalValues: Scalars['Float']['output'];
  bulknotificationcustomersalesSet: Array<BulkNotificationCustomerSalesType>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<CouponRelayType>;
  createdAt: Scalars['DateTime']['output'];
  credithousepurchase?: Maybe<CreditHousePurchaseType>;
  customer: CustomerTypeRelay;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  date?: Maybe<Scalars['Date']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  discountType: PurchaseDiscountType;
  discountValue: Scalars['Float']['output'];
  erpIntegrationId?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['Date']['output']>;
  extraData?: Maybe<Scalars['GenericScalar']['output']>;
  giftback?: Maybe<GiftbackRelayType>;
  giftbackRedeemed?: Maybe<GiftbackRelayType>;
  giftbackRedeemedValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  importedFrom: PurchaseImportedFrom;
  integrationId?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  journeyExecutions: Array<JourneyExecutionType>;
  journeyGoalEvents: Array<JourneyGoalEventType>;
  justification: Scalars['String']['output'];
  loyaltyRedemption?: Maybe<LoyaltyRedemptionType>;
  loyaltypointentrySet: Array<LoyaltyPointEntryType>;
  nfeKey?: Maybe<Scalars['String']['output']>;
  nfeLink?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  purchasepaymentmethodSet: Array<PurchasePaymentMethodType>;
  purchaseproductSet: PurchaseProductRelayTypeConnection;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  sellerName?: Maybe<Scalars['String']['output']>;
  serviceItems: Array<PurchaseServiceType>;
  shipmentValue: Scalars['Float']['output'];
  shipmentWeight?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  store: StoreType;
  storeProfileImageBase64?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  trackingCodeUrl?: Maybe<Scalars['String']['output']>;
  transportCompany?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<CustomUserNode>;
  value: Scalars['Float']['output'];
  volumesQuantity?: Maybe<Scalars['Int']['output']>;
};


export type PurchaseTypeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type PurchaseTypePurchaseproductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product_Id?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  allBulkNotificationCustomersRelay?: Maybe<BulkNotificationCustomerRelayTypeConnection>;
  allBulkNotificationsRelay?: Maybe<BulkNotificationRelayTypeConnection>;
  allCustomerActivitiesRelay?: Maybe<CustomerActivitiesTypeRelayConnection>;
  allCustomersRelay?: Maybe<CustomerTypeRelayConnection>;
  allGiftbacksRelay?: Maybe<GiftbackRelayTypeConnection>;
  allProductsRelay?: Maybe<ProductRelayTypeConnection>;
  allPurchasesProductsRelay?: Maybe<PurchaseProductRelayTypeConnection>;
  allPurchasesRelay?: Maybe<PurchaseRelayTypeConnection>;
  allServicesRelay?: Maybe<ServiceRelayTypeConnection>;
  allStateCities?: Maybe<Array<Maybe<CityType>>>;
  allStates?: Maybe<Array<Maybe<StateType>>>;
  allTemplatesRelay?: Maybe<WhatsappTemplateRelayTypeConnection>;
  allTerms?: Maybe<Array<Maybe<AcceptationTermType>>>;
  allUsersRelay?: Maybe<CustomUserRelayTypeConnection>;
  appointmentAvailability?: Maybe<Array<Maybe<AvailableSlotType>>>;
  appointmentDashboard?: Maybe<AppointmentDashboardType>;
  appointmentStorefrontPreview?: Maybe<PublicBookingPageType>;
  appointmentWorkspace?: Maybe<AppointmentWorkspaceType>;
  appointments?: Maybe<Array<Maybe<AppointmentType>>>;
  boardDetail?: Maybe<BoardType>;
  boardsFilter?: Maybe<BoardNodeConnection>;
  bulkNotificationTestSends?: Maybe<BulkNotificationTestSendsResultType>;
  calculateGiftbackValue?: Maybe<CalculateGiftbackValueResponse>;
  cashRegisterCashAvailable?: Maybe<Scalars['Decimal']['output']>;
  cashRegisterClosing?: Maybe<CashRegisterClosingSummaryType>;
  cashRegisterClosingPreview?: Maybe<CashRegisterClosingSummaryType>;
  cashRegisterClosings?: Maybe<Array<Maybe<CashRegisterClosingSummaryType>>>;
  cashRegisterSangrias?: Maybe<Array<Maybe<CashRegisterMovementType>>>;
  categoryList?: Maybe<CategoryRelayTypeConnection>;
  columnStatusFilter?: Maybe<ColumnStatusNodeConnection>;
  communities?: Maybe<CommunityPage>;
  community?: Maybe<Community>;
  communityCapability?: Maybe<CommunityCapability>;
  communityMembers?: Maybe<CommunityMemberPage>;
  communityScheduledMessages?: Maybe<CommunityScheduledMessagePage>;
  communityWhatsappLink: Scalars['String']['output'];
  coupon?: Maybe<CouponRelayType>;
  couponList?: Maybe<CouponRelayTypeConnection>;
  customerAcquisitionChannels?: Maybe<CustomerAcquisitionChannelRelayTypeConnection>;
  customerAudiencePreview?: Maybe<RetentionCohortCustomersReturn>;
  customerAudienceSelection?: Maybe<RetentionAudienceSelectionReturn>;
  customerCustomFieldValueOptions?: Maybe<CustomerCustomFieldOptionsType>;
  customerCustomFields: Array<CustomerCustomFieldType>;
  customerExcelReport?: Maybe<CustomerExcelReportType>;
  customerMetadataSample?: Maybe<CustomerMetadataSampleType>;
  customerTagsList?: Maybe<CustomerTagsRelayTypeConnection>;
  dashboardAgeColumnChartValues?: Maybe<AgeColumnChartReturn>;
  dashboardCustomerCardsValues?: Maybe<CustomerDashboardCardsReturn>;
  dashboardCustomerRecencyPerPeriod?: Maybe<CustomerRecencyPerPeriodListType>;
  dashboardCustomerTagsValues?: Maybe<CustomerTagsDonutChartReturn>;
  dashboardCustomersByCity?: Maybe<DashboardCustomersByCityResponse>;
  dashboardGenderPieChartValues?: Maybe<GenderPieChartReturn>;
  dashboardGiftbackAreaChartValues?: Maybe<GiftbackAreaChartReturn>;
  dashboardGiftbackAverageTicket?: Maybe<GiftbackAverageTickets>;
  dashboardGiftbackCardsValues?: Maybe<GiftbackCardsValues>;
  dashboardGiftbacksRadialBarChartValues?: Maybe<GiftbackRadialBarCharReturn>;
  dashboardProductsListValues?: Maybe<ProductListTableType>;
  dashboardPurchaseProgressionValues?: Maybe<PurchaseProgressionReturn>;
  dashboardRetentionAudienceCustomers?: Maybe<RetentionAudienceSelectionReturn>;
  dashboardRetentionCohortCustomers?: Maybe<RetentionCohortCustomersReturn>;
  dashboardRetentionCohortValues?: Maybe<RetentionCohortReturn>;
  dashboardRfmChartValues?: Maybe<Array<Maybe<RfmChartReturn>>>;
  dashboardSalesCardsValues?: Maybe<PurchaseCardsValues>;
  dashboardSalesPeriodColumnChartValues?: Maybe<PurchaseColumnChartReturn>;
  dashboardSalesProductKpis?: Maybe<SalesProductKpisType>;
  dashboardSalesProductTrends?: Maybe<SalesProductTrendsType>;
  dashboardSalesRecencyPerPeriod?: Maybe<SalesRecencyPerPeriodListType>;
  dashboardTopSellingProducts?: Maybe<Array<Maybe<ProductsTopSellingProductsType>>>;
  dashboardUfBarChartValues?: Maybe<UfBarChartReturn>;
  getBulkNotification?: Maybe<BulkNotificationType>;
  getBulkNotificationCustomerIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  getCustomer?: Maybe<CustomerType>;
  getCustomerTag?: Maybe<CustomerTagsType>;
  getEmailProvider?: Maybe<EmailProviderStoreIntegrationType>;
  getEmailTemplates?: Maybe<Array<Maybe<EmailTemplateType>>>;
  getEvolutionApiConnectionStatus?: Maybe<GetEvolutionConnectionStatusReturnType>;
  getGiftback?: Maybe<GiftbackType>;
  getGiftbackByCode?: Maybe<GiftbackType>;
  getGiftbackByCodeCpfEmailPhone?: Maybe<GiftbackType>;
  getGiftbackConfig?: Maybe<GiftbackConfigType>;
  getHelenaChannels?: Maybe<Array<Maybe<HelenaChannelType>>>;
  getHelenaStoreIntegration?: Maybe<HelenaStoreIntegrationType>;
  getProduct?: Maybe<ProductType>;
  getPublicGiftbackDataByCpfPhone?: Maybe<ReturnPublicGiftbackData>;
  getPurchase?: Maybe<PurchaseType>;
  getRfmAutomation?: Maybe<RfmAutomationType>;
  getRfmFrequency?: Maybe<FrequencyRfmType>;
  getRfmRecency?: Maybe<RecencyRfmType>;
  getRfmStatus?: Maybe<RfmAutomationType>;
  getRfmValue?: Maybe<ValueRfmType>;
  getService?: Maybe<ServiceType>;
  getStore?: Maybe<StoreType>;
  getStoreBySlug?: Maybe<ReturnStorePublicData>;
  getStoreMetrics?: Maybe<StoreMetricsType>;
  getStoreModulePermissions?: Maybe<StoreModulePermissionsType>;
  getTemplateById?: Maybe<WhatsappTemplateType>;
  getUser?: Maybe<CustomUserType>;
  getWhatsappIntegration?: Maybe<WhatsappConfigType>;
  getYampiAuthorizationUrl?: Maybe<YampiAuthorizationUrlType>;
  getZApiIntegration?: Maybe<ZApiIntegrationType>;
  giftbackExcelReport?: Maybe<GiftbackExcelReportType>;
  homepageCardsValues?: Maybe<HomePageCards>;
  homepageTopCustomers?: Maybe<Array<Maybe<TopCustomersTypeField>>>;
  homepageTopProducts?: Maybe<Array<Maybe<TopProductsTypeField>>>;
  instanceDetail?: Maybe<InstanceType>;
  instancesFilter?: Maybe<InstanceNodeConnection>;
  integrationDetail?: Maybe<IntegrationType>;
  integrationsFilter?: Maybe<IntegrationNodeConnection>;
  journey?: Maybe<JourneyType>;
  journeyCatalog?: Maybe<Scalars['GenericScalar']['output']>;
  journeyExecution?: Maybe<JourneyExecutionType>;
  journeyExecutions?: Maybe<Array<Maybe<JourneyExecutionType>>>;
  journeyFunnel?: Maybe<JourneyFunnelType>;
  journeyGoalEvents?: Maybe<Array<Maybe<JourneyGoalEventType>>>;
  journeyNodeAnalytics?: Maybe<JourneyAnalyticsType>;
  journeyOwnerships?: Maybe<Array<Maybe<JourneyOwnershipType>>>;
  journeyTargetCategories?: Maybe<Array<Maybe<JourneyTargetType>>>;
  journeyTargetProducts?: Maybe<Array<Maybe<JourneyTargetType>>>;
  journeyVersions?: Maybe<Array<Maybe<JourneyVersionType>>>;
  journeys?: Maybe<Array<Maybe<JourneyType>>>;
  leadDetail?: Maybe<LeadType>;
  leadsFilter?: Maybe<LeadNodeConnection>;
  listCampaigns?: Maybe<CampaignRelayTypeConnection>;
  listHelenaWhatsappTemplates?: Maybe<Array<Maybe<WhatsappTemplateType>>>;
  listPaymentMethod?: Maybe<Array<Maybe<PaymentMethodType>>>;
  listStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  loyaltyMember?: Maybe<LoyaltyMemberType>;
  loyaltyMembers?: Maybe<Array<Maybe<LoyaltyMemberType>>>;
  loyaltyPointEntries?: Maybe<Array<Maybe<LoyaltyPointEntryType>>>;
  loyaltyProgram?: Maybe<LoyaltyProgramType>;
  loyaltyRedemptions?: Maybe<Array<Maybe<LoyaltyRedemptionType>>>;
  loyaltyRewards?: Maybe<Array<Maybe<LoyaltyRewardType>>>;
  loyaltyRules?: Maybe<Array<Maybe<LoyaltyRuleType>>>;
  loyaltyTiers?: Maybe<Array<Maybe<LoyaltyTierType>>>;
  me?: Maybe<CustomUserNode>;
  planningEvents: PlanningEventPage;
  productExcelReport?: Maybe<ProductExcelReportType>;
  publicAppointmentAvailability?: Maybe<Array<Maybe<AvailableSlotType>>>;
  publicAppointmentByToken?: Maybe<PublicAppointmentType>;
  publicAppointmentPage?: Maybe<PublicBookingPageType>;
  purchaseExcelReport?: Maybe<PurchaseExcelReportType>;
  readCampaign?: Maybe<CampaignType>;
  serviceCategories?: Maybe<Array<Maybe<ServiceCategoryType>>>;
  serviceDashboard?: Maybe<ServiceDashboardType>;
  shopifyOauthUrl?: Maybe<Scalars['String']['output']>;
  taskDetail?: Maybe<TaskType>;
  tasksFilter?: Maybe<TaskNodeConnection>;
  user?: Maybe<CustomUserNode>;
  users?: Maybe<CustomUserNodeConnection>;
  verifyIfStoreHasZapiOrEvolutionApiIntegration?: Maybe<ReturnVerifyIfStoreHasZapiOrEvolutionApiIntegration>;
  verifyWhatsappPhoneNumberAndConnectedIntegrations?: Maybe<ReturnWhatsappPhoneNumberVerification>;
};


export type QueryAllBulkNotificationCustomersRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  bulkNotificationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllBulkNotificationsRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  endTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  startTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateStatus?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllCustomerActivitiesRelayArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllCustomersRelayArgs = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllGiftbacksRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllProductsRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAllPurchasesProductsRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product_Id?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllPurchasesRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAllServicesRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableForBooking?: InputMaybe<Scalars['Boolean']['input']>;
  availableInPdv?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameIcontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStateCitiesArgs = {
  uf?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTemplatesRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_Gt?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  origin_In?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllUsersRelayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cpf_Icontains?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  permissions_UserType?: InputMaybe<Scalars['String']['input']>;
  permissions_UserType_Icontains?: InputMaybe<Scalars['String']['input']>;
  permissions_UserType_In?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppointmentAvailabilityArgs = {
  end: Scalars['Date']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  serviceId: Scalars['ID']['input'];
  start: Scalars['Date']['input'];
};


export type QueryAppointmentDashboardArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};


export type QueryAppointmentsArgs = {
  end: Scalars['DateTime']['input'];
  professionalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBoardDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBoardsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBulkNotificationTestSendsArgs = {
  draftKey: Scalars['UUID']['input'];
};


export type QueryCalculateGiftbackValueArgs = {
  purchaseValue?: InputMaybe<Scalars['Decimal']['input']>;
};


export type QueryCashRegisterCashAvailableArgs = {
  businessDate: Scalars['Date']['input'];
};


export type QueryCashRegisterClosingArgs = {
  businessDate: Scalars['Date']['input'];
};


export type QueryCashRegisterClosingPreviewArgs = {
  businessDate: Scalars['Date']['input'];
};


export type QueryCashRegisterClosingsArgs = {
  businessDate: Scalars['Date']['input'];
};


export type QueryCashRegisterSangriasArgs = {
  businessDate: Scalars['Date']['input'];
};


export type QueryCategoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type QueryColumnStatusFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommunitiesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  communityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommunityScheduledMessagesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  communityId: Scalars['ID']['input'];
  endsAt: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
};


export type QueryCommunityWhatsappLinkArgs = {
  communityId: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  couponId: Scalars['ID']['input'];
};


export type QueryCouponListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerAcquisitionChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerAudiencePreviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CustomerFilterSetInput;
  purchaseInput?: InputMaybe<PurchaseProductFilterSetInput>;
};


export type QueryCustomerAudienceSelectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  selectionId: Scalars['ID']['input'];
};


export type QueryCustomerCustomFieldValueOptionsArgs = {
  fieldId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerExcelReportArgs = {
  input?: InputMaybe<CustomerExcelReportInput>;
};


export type QueryCustomerMetadataSampleArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryCustomerTagsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDashboardAgeColumnChartValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryDashboardCustomerCardsValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryDashboardCustomerRecencyPerPeriodArgs = {
  input?: InputMaybe<CustomerRecencyPerPeriodInput>;
};


export type QueryDashboardCustomerTagsValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryDashboardCustomersByCityArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryDashboardGenderPieChartValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryDashboardGiftbackAreaChartValuesArgs = {
  input?: InputMaybe<GiftbackFilterSetInput>;
};


export type QueryDashboardGiftbackAverageTicketArgs = {
  input?: InputMaybe<GiftbackFilterSetInput>;
};


export type QueryDashboardGiftbackCardsValuesArgs = {
  input?: InputMaybe<GiftbackFilterSetInput>;
};


export type QueryDashboardGiftbacksRadialBarChartValuesArgs = {
  input?: InputMaybe<GiftbackFilterSetInput>;
};


export type QueryDashboardProductsListValuesArgs = {
  classification?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<PurchaseProductFilterSetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDashboardPurchaseProgressionValuesArgs = {
  input: PurchaseProgressionInput;
};


export type QueryDashboardRetentionAudienceCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  selectionId: Scalars['ID']['input'];
};


export type QueryDashboardRetentionCohortCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  cohortStart: Scalars['Date']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetentionCohortInput;
  offset: Scalars['Int']['input'];
};


export type QueryDashboardRetentionCohortValuesArgs = {
  input: RetentionCohortInput;
};


export type QueryDashboardRfmChartValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryDashboardSalesCardsValuesArgs = {
  input?: InputMaybe<PurchaseFilterSetInput>;
};


export type QueryDashboardSalesPeriodColumnChartValuesArgs = {
  input?: InputMaybe<PurchaseFilterSetInput>;
};


export type QueryDashboardSalesProductKpisArgs = {
  input?: InputMaybe<PurchaseProductFilterSetInput>;
  metric?: InputMaybe<SalesProductKpiMetric>;
};


export type QueryDashboardSalesProductTrendsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<SalesProductTrendMode>;
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
  productId: Scalars['ID']['input'];
};


export type QueryDashboardSalesRecencyPerPeriodArgs = {
  input?: InputMaybe<SalesRecencyPerPeriodInput>;
};


export type QueryDashboardTopSellingProductsArgs = {
  input?: InputMaybe<ProductsTopSellingProductsInput>;
};


export type QueryDashboardUfBarChartValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryGetBulkNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBulkNotificationCustomerIdsArgs = {
  bulkNotificationId: Scalars['ID']['input'];
};


export type QueryGetCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCustomerTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGiftbackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGiftbackByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetGiftbackByCodeCpfEmailPhoneArgs = {
  input: Scalars['String']['input'];
};


export type QueryGetProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPublicGiftbackDataByCpfPhoneArgs = {
  contactData: Scalars['String']['input'];
  storeId: Scalars['ID']['input'];
};


export type QueryGetPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStoreBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetTemplateByIdArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGiftbackExcelReportArgs = {
  input?: InputMaybe<GiftbackFilterSetInput>;
};


export type QueryHomepageCardsValuesArgs = {
  input?: InputMaybe<CustomerFilterSetInput>;
};


export type QueryInstanceDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstancesFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntegrationDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJourneyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJourneyExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJourneyExecutionsArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  journeyId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJourneyFunnelArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  journeyId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJourneyGoalEventsArgs = {
  journeyId: Scalars['ID']['input'];
  reversed?: InputMaybe<Scalars['Boolean']['input']>;
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJourneyNodeAnalyticsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  journeyId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryJourneyTargetCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJourneyTargetProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJourneyVersionsArgs = {
  journeyId: Scalars['ID']['input'];
};


export type QueryJourneysArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeadDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadsFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tag_Icontains?: InputMaybe<Scalars['String']['input']>;
  titleOrMessage?: InputMaybe<Scalars['String']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListHelenaWhatsappTemplatesArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLoyaltyMemberArgs = {
  customerId: Scalars['ID']['input'];
};


export type QueryLoyaltyMembersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLoyaltyPointEntriesArgs = {
  memberId: Scalars['ID']['input'];
};


export type QueryLoyaltyRedemptionsArgs = {
  memberId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlanningEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Scalars['ID']['input']>;
  endsAt: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<PlanningEventSource>>;
  startsAt: Scalars['DateTime']['input'];
  statuses?: InputMaybe<Array<PlanningEventStatus>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductExcelReportArgs = {
  input?: InputMaybe<ProductFilterSetInput>;
};


export type QueryPublicAppointmentAvailabilityArgs = {
  end: Scalars['Date']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  serviceId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  start: Scalars['Date']['input'];
};


export type QueryPublicAppointmentByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryPublicAppointmentPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPurchaseExcelReportArgs = {
  input?: InputMaybe<PurchaseFilterSetInput>;
};


export type QueryReadCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryServiceDashboardArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryShopifyOauthUrlArgs = {
  shop: Scalars['String']['input'];
};


export type QueryTaskDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTasksFilterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status_Archived?: InputMaybe<Scalars['Boolean']['input']>;
  status_SecondaryEmail?: InputMaybe<Scalars['String']['input']>;
  status_Verified?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_Icontains?: InputMaybe<Scalars['String']['input']>;
  username_Istartswith?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifyWhatsappPhoneNumberAndConnectedIntegrationsArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type ReactivateGiftbackInput = {
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  giftbackId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReactivateGiftbackMutation = {
  __typename?: 'ReactivateGiftbackMutation';
  giftback?: Maybe<GiftbackType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RecencyRfmInput = {
  zoneFiveMax?: InputMaybe<Scalars['Int']['input']>;
  zoneFiveMin?: InputMaybe<Scalars['Int']['input']>;
  zoneFourMax?: InputMaybe<Scalars['Int']['input']>;
  zoneFourMin?: InputMaybe<Scalars['Int']['input']>;
  zoneOneMax?: InputMaybe<Scalars['Int']['input']>;
  zoneOneMin?: InputMaybe<Scalars['Int']['input']>;
  zoneThreeMax?: InputMaybe<Scalars['Int']['input']>;
  zoneThreeMin?: InputMaybe<Scalars['Int']['input']>;
  zoneTwoMax?: InputMaybe<Scalars['Int']['input']>;
  zoneTwoMin?: InputMaybe<Scalars['Int']['input']>;
};

export type RecencyRfmType = {
  __typename?: 'RecencyRFMType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  zoneFiveMax: Scalars['Int']['output'];
  zoneFiveMin: Scalars['Int']['output'];
  zoneFourMax: Scalars['Int']['output'];
  zoneFourMin: Scalars['Int']['output'];
  zoneOneMax: Scalars['Int']['output'];
  zoneOneMin: Scalars['Int']['output'];
  zoneThreeMax: Scalars['Int']['output'];
  zoneThreeMin: Scalars['Int']['output'];
  zoneTwoMax: Scalars['Int']['output'];
  zoneTwoMin: Scalars['Int']['output'];
};

export type RedefinePasswordInput = {
  newPassword: Scalars['String']['input'];
  newPasswordConfirm: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type RedefinePasswordMutation = {
  __typename?: 'RedefinePasswordMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RefreshTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type RefreshTokenPayload = {
  __typename?: 'RefreshTokenPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  payload?: Maybe<Scalars['GenericScalar']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type RegisterInput = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  isStaff?: InputMaybe<Scalars['String']['input']>;
  isSuperuser?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/**
 * Register user with fields defined in the settings.
 *
 * If the email field of the user model is part of the
 * registration fields (default), check if there is
 * no user with that email or as a secondary email.
 *
 * If it exists, it does not register the user,
 * even if the email field is not defined as unique
 * (default of the default django user model).
 *
 * When creating the user, it also creates a `UserStatus`
 * related to that user, making it possible to track
 * if the user is archived, verified and has a secondary
 * email.
 *
 * Send account verification email.
 *
 * If allowed to not verified users login, return token.
 */
export type RegisterPayload = {
  __typename?: 'RegisterPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ReorderCustomerAcquisitionChannels = {
  __typename?: 'ReorderCustomerAcquisitionChannels';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ReorderCustomerAcquisitionChannelsInput = {
  channelIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type ReplaceWorkingHoursMutation = {
  __typename?: 'ReplaceWorkingHoursMutation';
  workingHours?: Maybe<Array<Maybe<WorkingHoursType>>>;
};

export type RescheduleAppointmentMutation = {
  __typename?: 'RescheduleAppointmentMutation';
  result?: Maybe<AppointmentActionResultType>;
};

export type ResendActivationEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/**
 * Sends activation email.
 *
 * It is called resend because theoretically
 * the first activation email was sent when
 * the user registered.
 *
 * If there is no user with the requested email,
 * a successful response is returned.
 */
export type ResendActivationEmailPayload = {
  __typename?: 'ResendActivationEmailPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetentionAudienceSelectionReturn = {
  __typename?: 'RetentionAudienceSelectionReturn';
  customers: Array<RetentionCohortCustomerReturn>;
  expiresAt: Scalars['DateTime']['output'];
  pageInfo: RetentionPageInfoReturn;
  selectionId: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};

export type RetentionCohortCustomerReturn = {
  __typename?: 'RetentionCohortCustomerReturn';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  purchaseCount: Scalars['Int']['output'];
  purchaseValue: Scalars['Float']['output'];
  rfmClassification?: Maybe<Scalars['String']['output']>;
};

export type RetentionCohortCustomersReturn = {
  __typename?: 'RetentionCohortCustomersReturn';
  customers: Array<RetentionCohortCustomerReturn>;
  pageInfo: RetentionPageInfoReturn;
  total?: Maybe<Scalars['Int']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
};

export type RetentionCohortInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate: Scalars['Date']['input'];
  groupBy: RetentionGroupBy;
  startDate: Scalars['Date']['input'];
};

export type RetentionCohortPeriodReturn = {
  __typename?: 'RetentionCohortPeriodReturn';
  customers: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type RetentionCohortReturn = {
  __typename?: 'RetentionCohortReturn';
  rows: Array<RetentionCohortRowReturn>;
  summary: RetentionCohortSummaryReturn;
};

export type RetentionCohortRowReturn = {
  __typename?: 'RetentionCohortRowReturn';
  cohortStart: Scalars['Date']['output'];
  periods: Array<RetentionCohortPeriodReturn>;
  totalCustomers: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type RetentionCohortSummaryReturn = {
  __typename?: 'RetentionCohortSummaryReturn';
  averageReturnRate: Scalars['Float']['output'];
  averageTimeToReturn: Scalars['Float']['output'];
  nonReturningCustomers: Scalars['Int']['output'];
  recurrentCustomers: Scalars['Int']['output'];
  retainedRevenue: Scalars['Float']['output'];
};

export enum RetentionGroupBy {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK'
}

export type RetentionPageInfoReturn = {
  __typename?: 'RetentionPageInfoReturn';
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type RetryCommunity = {
  __typename?: 'RetryCommunity';
  community: Community;
};

export type ReturnPublicGiftbackData = {
  __typename?: 'ReturnPublicGiftbackData';
  clientName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  minValueForRedeem?: Maybe<Scalars['Decimal']['output']>;
  publicToken?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type ReturnStorePublicData = {
  __typename?: 'ReturnStorePublicData';
  pk?: Maybe<Scalars['ID']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ReturnVerifyIfStoreHasZapiOrEvolutionApiIntegration = {
  __typename?: 'ReturnVerifyIfStoreHasZapiOrEvolutionApiIntegration';
  hasIntegration?: Maybe<Scalars['Boolean']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
};

export type ReturnWhatsappPhoneNumberVerification = {
  __typename?: 'ReturnWhatsappPhoneNumberVerification';
  hasWhatsapp?: Maybe<Scalars['String']['output']>;
};

export type RfmAutomationType = {
  __typename?: 'RfmAutomationType';
  dailyRefreshEnabled: Scalars['Boolean']['output'];
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RfmChartReturn = {
  __typename?: 'RfmChartReturn';
  /** Valor histórico total dividido pelo número de clientes. */
  averageMonetaryValue?: Maybe<Scalars['Float']['output']>;
  /** Valor histórico total dividido pelas compras; null sem compras. */
  averageTicket?: Maybe<Scalars['Float']['output']>;
  /** Soma do valor histórico de compras dos clientes da categoria. */
  monetaryValue?: Maybe<Scalars['Float']['output']>;
  /** Soma da quantidade histórica de compras dos clientes da categoria. */
  totalPurchases?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type SmsBaratoIntegrationType = {
  __typename?: 'SMSBaratoIntegrationType';
  activated: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SmsInfoBipIntegrationType = {
  __typename?: 'SMSInfoBipIntegrationType';
  activated: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type SalesAbcCurvePoint = {
  __typename?: 'SalesAbcCurvePoint';
  accumulatedPercentage?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type SalesAbcSummary = {
  __typename?: 'SalesAbcSummary';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
};

export type SalesProductKpiItemType = {
  __typename?: 'SalesProductKpiItemType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordersCount: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
  totalRevenue: Scalars['Decimal']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export enum SalesProductKpiMetric {
  Purchases = 'PURCHASES',
  Quantity = 'QUANTITY'
}

export type SalesProductKpisType = {
  __typename?: 'SalesProductKpisType';
  firstPurchaseCategories: Array<SalesProductKpiItemType>;
  firstPurchaseCategory?: Maybe<SalesProductKpiItemType>;
  firstPurchaseProduct?: Maybe<SalesProductKpiItemType>;
  firstPurchaseProducts: Array<SalesProductKpiItemType>;
  secondPurchaseCategories: Array<SalesProductKpiItemType>;
  secondPurchaseCategory?: Maybe<SalesProductKpiItemType>;
  secondPurchaseProduct?: Maybe<SalesProductKpiItemType>;
  secondPurchaseProducts: Array<SalesProductKpiItemType>;
  topCategories: Array<SalesProductKpiItemType>;
  topCategory?: Maybe<SalesProductKpiItemType>;
  topProduct?: Maybe<SalesProductKpiItemType>;
  topProducts: Array<SalesProductKpiItemType>;
};

export type SalesProductTrendItem = {
  __typename?: 'SalesProductTrendItem';
  integrationId?: Maybe<Scalars['String']['output']>;
  lastPurchaseDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  ordersCount: Scalars['Int']['output'];
  ordersPercentage: Scalars['Float']['output'];
  productId: Scalars['ID']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export enum SalesProductTrendMode {
  NextPurchase = 'NEXT_PURCHASE',
  Together = 'TOGETHER'
}

export type SalesProductTrendSelectedProduct = {
  __typename?: 'SalesProductTrendSelectedProduct';
  id: Scalars['ID']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SalesProductTrendsType = {
  __typename?: 'SalesProductTrendsType';
  analyzedOrdersCount: Scalars['Int']['output'];
  baseOrdersCount: Scalars['Int']['output'];
  items: Array<SalesProductTrendItem>;
  selectedProduct: SalesProductTrendSelectedProduct;
};

export type SalesRecencyPerPeriodInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SalesRecencyPerPeriodListType = {
  __typename?: 'SalesRecencyPerPeriodListType';
  data?: Maybe<Array<Maybe<SalesRecencyPerPeriodType>>>;
  kindOfDate?: Maybe<Scalars['String']['output']>;
};

export type SalesRecencyPerPeriodType = {
  __typename?: 'SalesRecencyPerPeriodType';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type SaveBookingSettingsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowProfessionalPreference?: InputMaybe<Scalars['Boolean']['input']>;
  bookingHorizonDays?: InputMaybe<Scalars['Int']['input']>;
  cancellationLeadMinutes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  minimumLeadMinutes?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  reminderOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  reminderViaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  reminderViaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  slotIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  storefrontAboutText?: InputMaybe<Scalars['String']['input']>;
  storefrontAboutTitle?: InputMaybe<Scalars['String']['input']>;
  storefrontAccentColor?: InputMaybe<Scalars['String']['input']>;
  storefrontCoverImageAlt?: InputMaybe<Scalars['String']['input']>;
  storefrontCoverImageUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontFacebookUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontInstagramUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontLatitude?: InputMaybe<Scalars['Decimal']['input']>;
  storefrontLogoAlt?: InputMaybe<Scalars['String']['input']>;
  storefrontLogoUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontLongitude?: InputMaybe<Scalars['Decimal']['input']>;
  storefrontMapsUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontPreset?: InputMaybe<Scalars['String']['input']>;
  storefrontPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  storefrontSeoDescription?: InputMaybe<Scalars['String']['input']>;
  storefrontSeoTitle?: InputMaybe<Scalars['String']['input']>;
  storefrontSurfaceColor?: InputMaybe<Scalars['String']['input']>;
  storefrontTiktokUrl?: InputMaybe<Scalars['String']['input']>;
  storefrontWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  termsUrl?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
  unitName: Scalars['String']['input'];
};

export type SaveBookingSettingsMutation = {
  __typename?: 'SaveBookingSettingsMutation';
  workspace?: Maybe<AppointmentWorkspaceType>;
};

export type SaveCashRegisterClosingInput = {
  businessDate: Scalars['Date']['input'];
  declaredAmounts: Array<CashRegisterClosingDeclaredAmountInput>;
  expectedPeriodStartedAt: Scalars['DateTime']['input'];
};

export type SaveCustomerAcquisitionChannel = {
  __typename?: 'SaveCustomerAcquisitionChannel';
  channel?: Maybe<CustomerAcquisitionChannelType>;
};

export type SaveCustomerAcquisitionChannelInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveCustomerCustomField = {
  __typename?: 'SaveCustomerCustomField';
  field?: Maybe<CustomerCustomFieldType>;
};

export type SaveCustomerCustomFieldInput = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  fieldType: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  metadataPath?: InputMaybe<Array<Scalars['GenericScalar']['input']>>;
  sampleCustomerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveCustomerTagsConfigInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  tagName: Scalars['String']['input'];
  tagType?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCustomerTagsConfigMutation = {
  __typename?: 'SaveCustomerTagsConfigMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveEmailProviderStoreIntegrationMutation = {
  __typename?: 'SaveEmailProviderStoreIntegrationMutation';
  emailProvider?: Maybe<EmailProviderStoreIntegrationType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveEvolutionApiIntegrationMutation = {
  __typename?: 'SaveEvolutionApiIntegrationMutation';
  isCreated?: Maybe<Scalars['Boolean']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveGiftbackConfigMutation = {
  __typename?: 'SaveGiftbackConfigMutation';
  giftback?: Maybe<GiftbackConfigType>;
};

export type SaveHelenaStoreIntegrationMutation = {
  __typename?: 'SaveHelenaStoreIntegrationMutation';
  helenaStoreIntegration?: Maybe<HelenaStoreIntegrationType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveHostgatorStoreIntegrationInput = {
  appKey: Scalars['String']['input'];
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  storeIntegrationId: Scalars['String']['input'];
  storeUrl: Scalars['String']['input'];
};

export type SaveHostgatorStoreIntegrationMutation = {
  __typename?: 'SaveHostgatorStoreIntegrationMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveLojaIntegradaStoreIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  connected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveLojaIntegradaStoreIntegrationMutation = {
  __typename?: 'SaveLojaIntegradaStoreIntegrationMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveLoyaltyRewardMutation = {
  __typename?: 'SaveLoyaltyRewardMutation';
  reward?: Maybe<LoyaltyRewardType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveLoyaltyRuleMutation = {
  __typename?: 'SaveLoyaltyRuleMutation';
  rule?: Maybe<LoyaltyRuleType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveLoyaltyTierMutation = {
  __typename?: 'SaveLoyaltyTierMutation';
  success?: Maybe<Scalars['Boolean']['output']>;
  tier?: Maybe<LoyaltyTierType>;
};

export type SaveNuvemShopStoreIntegrationMutation = {
  __typename?: 'SaveNuvemShopStoreIntegrationMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveNuvemshopStoreIntegrationInput = {
  accessToken: Scalars['String']['input'];
  appEmail: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type SaveProfessionalInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  publicName: Scalars['String']['input'];
  serviceIds: Array<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveProfessionalMutation = {
  __typename?: 'SaveProfessionalMutation';
  professional?: Maybe<ProfessionalType>;
};

export type SaveRfmAutomationMutation = {
  __typename?: 'SaveRFMAutomationMutation';
  dailyRefreshEnabled: Scalars['Boolean']['output'];
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveRfmMutation = {
  __typename?: 'SaveRFMMutation';
  frequency?: Maybe<FrequencyRfmType>;
  recency?: Maybe<RecencyRfmType>;
  value?: Maybe<ValueRfmType>;
};

export type SaveScheduleAdjustmentInput = {
  endsAt: Scalars['DateTime']['input'];
  kind: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  professionalId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  repeatsUntil?: InputMaybe<Scalars['Date']['input']>;
  repeatsWeekly?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTime']['input'];
};

export type SaveScheduleAdjustmentMutation = {
  __typename?: 'SaveScheduleAdjustmentMutation';
  adjustment?: Maybe<ScheduleAdjustmentType>;
};

export type SaveServiceCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type SaveServiceCategoryMutation = {
  __typename?: 'SaveServiceCategoryMutation';
  category?: Maybe<ServiceCategoryType>;
};

export type SaveServiceInput = {
  availableForBooking?: InputMaybe<Scalars['Boolean']['input']>;
  availableInPdv?: InputMaybe<Scalars['Boolean']['input']>;
  bufferAfterMinutes?: InputMaybe<Scalars['Int']['input']>;
  bufferBeforeMinutes?: InputMaybe<Scalars['Int']['input']>;
  categoryId: Scalars['ID']['input'];
  costValue?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  promotionalValue?: InputMaybe<Scalars['Decimal']['input']>;
  recommendedReturnDays?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['Decimal']['input'];
};

export type SaveServiceMutation = {
  __typename?: 'SaveServiceMutation';
  service?: Maybe<ServiceType>;
};

export type SaveWebpicStoreIntegrationInput = {
  companyId: Scalars['String']['input'];
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  haveInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  havePdv?: InputMaybe<Scalars['Boolean']['input']>;
  integrationToken: Scalars['String']['input'];
};

export type SaveWebpicStoreIntegrationMutation = {
  __typename?: 'SaveWebpicStoreIntegrationMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  webpicIntegration?: Maybe<WebpicStoreIntegrationType>;
};

export type SaveWhatsappConfigMutation = {
  __typename?: 'SaveWhatsappConfigMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  whatsappIntegration?: Maybe<WhatsappConfigType>;
};

export type SaveZApiIntegrationMutation = {
  __typename?: 'SaveZApiIntegrationMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  zApiIntegration?: Maybe<ZApiIntegrationType>;
};

/** An enumeration. */
export enum ScheduleAdjustmentKind {
  /** Bloqueio/ausência */
  Block = 'BLOCK',
  /** Liberação */
  Release = 'RELEASE'
}

export type ScheduleAdjustmentType = {
  __typename?: 'ScheduleAdjustmentType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<CustomUserNode>;
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  kind: ScheduleAdjustmentKind;
  notes: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  professional: ProfessionalType;
  reason: Scalars['String']['output'];
  repeatsUntil?: Maybe<Scalars['Date']['output']>;
  repeatsWeekly: Scalars['Boolean']['output'];
  startsAt: Scalars['DateTime']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ScheduleCommunityMessage = {
  __typename?: 'ScheduleCommunityMessage';
  message: CommunityScheduledMessage;
};

export type ScheduleCommunityMessageInput = {
  communityId: Scalars['ID']['input'];
  requestId: Scalars['UUID']['input'];
  scheduledAt: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

/** An enumeration. */
export enum ScheduledNotificationIntentSourceEngine {
  /** Comunidade */
  Community = 'COMMUNITY',
  /** Jornadas */
  Journey = 'JOURNEY',
  /** Legacy */
  Legacy = 'LEGACY'
}

/** An enumeration. */
export enum ScheduledNotificationIntentStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Error */
  Error = 'ERROR',
  /** Pending */
  Pending = 'PENDING',
  /** Processing */
  Processing = 'PROCESSING',
  /** Sent */
  Sent = 'SENT',
  /** Skipped */
  Skipped = 'SKIPPED',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export type SchedulingUnitType = {
  __typename?: 'SchedulingUnitType';
  address: Scalars['String']['output'];
  appointments: Array<AppointmentType>;
  bookingPage?: Maybe<BookingPageType>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  professionals: Array<ProfessionalType>;
  store: StoreType;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workingHours: Array<WorkingHoursType>;
};

export type SendBulkNotificationTestMutation = {
  __typename?: 'SendBulkNotificationTestMutation';
  message?: Maybe<Scalars['String']['output']>;
  remainingTests?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendPasswordResetEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/**
 * Send password reset email.
 *
 * For non verified users, send an activation
 * email instead.
 *
 * Accepts both primary and secondary email.
 *
 * If there is no user with the requested email,
 * a successful response is returned.
 */
export type SendPasswordResetEmailPayload = {
  __typename?: 'SendPasswordResetEmailPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceCategoryType = {
  __typename?: 'ServiceCategoryType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  services: ServiceRelayTypeConnection;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};


export type ServiceCategoryTypeServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableForBooking?: InputMaybe<Scalars['Boolean']['input']>;
  availableInPdv?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameIcontains?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDashboardType = {
  __typename?: 'ServiceDashboardType';
  activeServices?: Maybe<Scalars['Int']['output']>;
  averageServiceTicket?: Maybe<Scalars['Decimal']['output']>;
  bookingServices?: Maybe<Scalars['Int']['output']>;
  pdvServices?: Maybe<Scalars['Int']['output']>;
  serviceRevenue?: Maybe<Scalars['Decimal']['output']>;
  servicesSold?: Maybe<Scalars['Int']['output']>;
};

export type ServiceRelayType = Node & {
  __typename?: 'ServiceRelayType';
  appointments: Array<AppointmentType>;
  availableForBooking: Scalars['Boolean']['output'];
  availableInPdv: Scalars['Boolean']['output'];
  bufferAfterMinutes: Scalars['Int']['output'];
  bufferBeforeMinutes: Scalars['Int']['output'];
  category: ServiceCategoryType;
  costValue: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  professionalServices: Array<ProfessionalServiceType>;
  promotionalValue: Scalars['Float']['output'];
  purchaseItems: Array<PurchaseServiceType>;
  recommendedReturnDays?: Maybe<Scalars['Int']['output']>;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type ServiceRelayTypeConnection = {
  __typename?: 'ServiceRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ServiceRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ServiceRelayType` and its cursor. */
export type ServiceRelayTypeEdge = {
  __typename?: 'ServiceRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ServiceRelayType>;
};

export type ServiceType = {
  __typename?: 'ServiceType';
  appointments: Array<AppointmentType>;
  availableForBooking: Scalars['Boolean']['output'];
  availableInPdv: Scalars['Boolean']['output'];
  bufferAfterMinutes: Scalars['Int']['output'];
  bufferBeforeMinutes: Scalars['Int']['output'];
  category: ServiceCategoryType;
  costValue: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  professionalServices: Array<ProfessionalServiceType>;
  promotionalValue: Scalars['Float']['output'];
  purchaseItems: Array<PurchaseServiceType>;
  recommendedReturnDays?: Maybe<Scalars['Int']['output']>;
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type SetActiveCustomer = {
  __typename?: 'SetActiveCustomer';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetActiveCustomerInput = {
  customerId: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type SetBlingStoreIntegration = {
  __typename?: 'SetBlingStoreIntegration';
  blingIntegration?: Maybe<BlingStoreIntegrationType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetOmieStoreIntegration = {
  __typename?: 'SetOmieStoreIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
  omieIntegration?: Maybe<OmieStoreIntegrationType>;
};

export type SetOmieStoreIntegrationInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  appKey: Scalars['String']['input'];
  appSecret: Scalars['String']['input'];
  nfce?: InputMaybe<Scalars['Boolean']['input']>;
  nfe?: InputMaybe<Scalars['Boolean']['input']>;
  nfse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetPaymentMethod = {
  __typename?: 'SetPaymentMethod';
  ok?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<PaymentMethodType>;
};

export type SetPaymentMethodInput = {
  adjustmentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Decimal']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type SetSmsBaratoIntegration = {
  __typename?: 'SetSMSBaratoIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
  smsBaratoIntegration?: Maybe<SmsBaratoIntegrationType>;
};

export type SetSmsBaratoIntegrationInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetSmsInfoBipIntegration = {
  __typename?: 'SetSMSInfoBipIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
  smsInfoBipIntegration?: Maybe<SmsInfoBipIntegrationType>;
};

export type SetSmsInfoBipIntegrationInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetShopifyStoreIntegration = {
  __typename?: 'SetShopifyStoreIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
  shopifyIntegration?: Maybe<ShopifyStoreIntegrationType>;
};

export type SetShopifyStoreIntegrationInput = {
  activated: Scalars['Boolean']['input'];
  baseUrl: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type SetTrinksStoreIntegration = {
  __typename?: 'SetTrinksStoreIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
  trinksIntegration?: Maybe<TrinksStoreIntegrationType>;
};

export type SetTrinksStoreIntegrationInput = {
  activated: Scalars['Boolean']['input'];
  apiKey: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
};

export type SetYampiStoreIntegration = {
  __typename?: 'SetYampiStoreIntegration';
  ok?: Maybe<Scalars['Boolean']['output']>;
  yampiIntegration?: Maybe<YampiStoreIntegrationType>;
};

export type SetYampiStoreIntegrationInput = {
  activated: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  merchantAlias: Scalars['String']['input'];
};

export type ShopifyStoreIntegrationType = {
  __typename?: 'ShopifyStoreIntegrationType';
  acceptedStatusToImport: Scalars['String']['output'];
  accessToken: Scalars['String']['output'];
  activated: Scalars['Boolean']['output'];
  baseUrl: Scalars['String']['output'];
  combineDiscountWithOrder: Scalars['Boolean']['output'];
  combineDiscountWithProduct: Scalars['Boolean']['output'];
  combineDiscountWithShipping: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  hasHmac: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type StateType = {
  __typename?: 'StateType';
  id?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  sigla?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum StoreAvailableBulkNotificationChannels {
  /** Ambos */
  Both = 'BOTH',
  /** E-mail */
  Email = 'EMAIL',
  /** WhatsApp Oficial */
  WhatsappOfficial = 'WHATSAPP_OFFICIAL',
  /** ZekiMessage */
  Zekimessage = 'ZEKIMESSAGE'
}

/** An enumeration. */
export enum StoreCurrencyType {
  /** Dolar */
  Dolar = 'DOLAR',
  /** Real */
  Real = 'REAL'
}

export type StoreMetricsType = {
  __typename?: 'StoreMetricsType';
  id: Scalars['ID']['output'];
  investment: Scalars['Float']['output'];
  pk: Scalars['Int']['output'];
  profit: Scalars['Float']['output'];
  redeemedGiftbackTicketAverage: Scalars['Float']['output'];
  repurchaseQuantity: Scalars['Int']['output'];
  repurchaseRate: Scalars['Float']['output'];
  roiPercentage: Scalars['Float']['output'];
  roiValue: Scalars['Float']['output'];
  store: StoreType;
};

export type StoreModulePermissionsType = {
  __typename?: 'StoreModulePermissionsType';
  createdAt: Scalars['DateTime']['output'];
  hasAppointments: Scalars['Boolean']['output'];
  hasBulkNotification: Scalars['Boolean']['output'];
  hasCommunicationIntegrations: Scalars['Int']['output'];
  hasCoupons: Scalars['Boolean']['output'];
  hasDashboards: Scalars['Boolean']['output'];
  hasEcommerceIntegrations: Scalars['Int']['output'];
  hasErpIntegrations: Scalars['Int']['output'];
  hasJourneys: Scalars['Boolean']['output'];
  hasLoyalty: Scalars['Boolean']['output'];
  hasMessageTemplates: Scalars['Boolean']['output'];
  hasOrderDeliveryDataPermission: Scalars['Boolean']['output'];
  hasPdv: Scalars['Boolean']['output'];
  hasProducts: Scalars['Boolean']['output'];
  hasReports: Scalars['Boolean']['output'];
  hasRfm: Scalars['Boolean']['output'];
  hasServices: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum StorePlan {
  /** Avançado */
  Avancado = 'AVANCADO',
  /** Básico */
  Basico = 'BASICO',
  /** Free */
  Free = 'FREE',
  /** Impulso */
  Impulso = 'IMPULSO',
  /** Intermediário */
  Intermediario = 'INTERMEDIARIO',
  /** Pro */
  Pro = 'PRO'
}

export type StoreType = {
  __typename?: 'StoreType';
  address?: Maybe<Scalars['String']['output']>;
  appointmentProfessionals: Array<ProfessionalType>;
  appointmentWorkingHours: Array<WorkingHoursType>;
  appointments: Array<AppointmentType>;
  availableBulkNotificationChannels: StoreAvailableBulkNotificationChannels;
  /** Saldo real de ZCoins disponível para uso: max(0, total - usado) + extra. Nunca é negativo — é a única fonte confiável para exibir o saldo ao cliente, diferente de somar/subtrair total, usado e extra manualmente. */
  availableNotificationCredits?: Maybe<Scalars['Int']['output']>;
  blingstoreintegration?: Maybe<BlingStoreIntegrationType>;
  bulknotificationSet: BulkNotificationRelayTypeConnection;
  bulknotificationcustomerSet: BulkNotificationCustomerRelayTypeConnection;
  campaignSet: CampaignRelayTypeConnection;
  cashregisterclosingSet: Array<CashRegisterClosingType>;
  cashregistermovementSet: Array<CashRegisterMovementType>;
  categorySet: CategoryRelayTypeConnection;
  chartsconfig?: Maybe<ChartsConfigType>;
  cnpj: Scalars['String']['output'];
  connectedIntegration?: Maybe<ConnectedStoreIntegrationType>;
  couponSet: CouponRelayTypeConnection;
  createdAt: Scalars['DateTime']['output'];
  credithouseconfig?: Maybe<CreditHouseConfigType>;
  currencyType: StoreCurrencyType;
  customerAcquisitionChannels: CustomerAcquisitionChannelRelayTypeConnection;
  customerSet: CustomerTypeRelayConnection;
  customercustomfieldSet: Array<CustomerCustomFieldType>;
  customertagsSet: CustomerTagsRelayTypeConnection;
  customuserSet: CustomUserNodeConnection;
  email: Scalars['String']['output'];
  emailFooterImg?: Maybe<Scalars['String']['output']>;
  emailFooterPrimaryColor: Scalars['String']['output'];
  emailFooterSecondaryColor: Scalars['String']['output'];
  emailFooterTertiaryColor: Scalars['String']['output'];
  emailproviderstoreintegration?: Maybe<EmailProviderStoreIntegrationType>;
  /** Se ativado, as notificações só serão enviadas dentro do horário permitido */
  enableNotificationTimeRestriction: Scalars['Boolean']['output'];
  evolutionapiintegration?: Maybe<EvolutionApiIntegrationType>;
  /** Créditos adicionais. Decrementado quando usado após esgotar os totais. Não reseta mensalmente. */
  extraNotificationCredits: Scalars['Int']['output'];
  frequencyrfm?: Maybe<FrequencyRfmType>;
  friday: Scalars['Boolean']['output'];
  giftbackSet: GiftbackRelayTypeConnection;
  giftbackconfig?: Maybe<GiftbackConfigType>;
  hasBulkNotificationPermission: Scalars['Boolean']['output'];
  hasCompletePdv: Scalars['Boolean']['output'];
  helenastoreintegration?: Maybe<HelenaStoreIntegrationType>;
  homepageChartsConfig?: Maybe<HomePageConfigType>;
  homepageconfig?: Maybe<HomePageConfigType>;
  hostgatorstoreintegration?: Maybe<HostgatorStoreIntegrationType>;
  id: Scalars['ID']['output'];
  integrationToken?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  journeyActionIntents: Array<JourneyActionIntentType>;
  journeyDeliveryLedger: Array<JourneyDeliveryType>;
  journeyExecutions: Array<JourneyExecutionType>;
  journeyTriggerOwnerships: Array<JourneyOwnershipType>;
  journeys: Array<JourneyType>;
  lojaintegradastoreintegration?: Maybe<LojaIntegradaStoreIntegrationType>;
  loyaltyProgram?: Maybe<LoyaltyProgramType>;
  metrics?: Maybe<StoreMetricsType>;
  modulePermissions?: Maybe<StoreModulePermissionsType>;
  monday: Scalars['Boolean']['output'];
  monthlyInvestment: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** Data de início do ciclo cujo reset de créditos já foi aplicado (não é a data em que a rotina rodou). Vazio significa que a loja nunca teve o consumo resetado. */
  notificationCreditsResetAt?: Maybe<Scalars['Date']['output']>;
  /** Horário máximo para envio de notificações */
  notificationEndTime: Scalars['Time']['output'];
  /** Horário mínimo para envio de notificações */
  notificationStartTime: Scalars['Time']['output'];
  notificationTime: Scalars['Time']['output'];
  nuvemshopstoreintegration?: Maybe<NuvemshopStoreIntegrationType>;
  omiestoreintegration?: Maybe<OmieStoreIntegrationType>;
  onlyDiscordCampaigns: Scalars['Boolean']['output'];
  paymentMethods: Array<PaymentMethodType>;
  permissionSet: Array<PermissionType>;
  plan: StorePlan;
  productSet: ProductRelayTypeConnection;
  profileImage?: Maybe<Scalars['String']['output']>;
  profileImageEmail?: Maybe<Scalars['String']['output']>;
  purchaseSet: PurchaseRelayTypeConnection;
  recencyrfm?: Maybe<RecencyRfmType>;
  /** Recalibra as faixas pela base da loja e atualiza a classificação RFM diariamente. */
  rfmDailyRefreshEnabled: Scalars['Boolean']['output'];
  rfmLastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Quantidade de horas sem novas vendas para considerar a loja em alerta */
  salesInactivityAlertHours: Scalars['Int']['output'];
  saturday: Scalars['Boolean']['output'];
  scheduleAdjustments: Array<ScheduleAdjustmentType>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  schedulingUnits: Array<SchedulingUnitType>;
  serviceCategories: Array<ServiceCategoryType>;
  services: ServiceRelayTypeConnection;
  shopifystoreintegration?: Maybe<ShopifyStoreIntegrationType>;
  /** Digite um slug sem caracteres especiais e em caixa baixa */
  slug?: Maybe<Scalars['String']['output']>;
  smsbaratointegration?: Maybe<SmsBaratoIntegrationType>;
  smsinfobipintegration?: Maybe<SmsInfoBipIntegrationType>;
  startUseDate?: Maybe<Scalars['Date']['output']>;
  sunday: Scalars['Boolean']['output'];
  telephone: Scalars['String']['output'];
  templates: Array<EmailTemplateType>;
  thursday: Scalars['Boolean']['output'];
  /** Créditos mensais da loja. Resetado na data de início de cada mês. */
  totalNotificationCredits: Scalars['Int']['output'];
  traystoreintegration?: Maybe<TrayStoreIntegrationType>;
  trinksstoreintegration?: Maybe<TrinksStoreIntegrationType>;
  tuesday: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** Créditos consumidos dos totais (mensais). Nunca ultrapassa total_credits. Resetado mensalmente. */
  usedNotificationCredits: Scalars['Int']['output'];
  valuerfm?: Maybe<ValueRfmType>;
  webpicstoreintegration?: Maybe<WebpicStoreIntegrationType>;
  wednesday: Scalars['Boolean']['output'];
  whatsappconfig?: Maybe<WhatsappConfigType>;
  whatsapptemplateSet: WhatsappTemplateRelayTypeConnection;
  yampistoreintegration?: Maybe<YampiStoreIntegrationType>;
  zapiintegration?: Maybe<ZApiIntegrationType>;
  zekiMessage: StoreZekiMessage;
};


export type StoreTypeBulknotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  endTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  startTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateStatus?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeBulknotificationcustomerSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type StoreTypeCampaignSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tag_Icontains?: InputMaybe<Scalars['String']['input']>;
  titleOrMessage?: InputMaybe<Scalars['String']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StoreTypeCategorySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeCouponSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeCustomerAcquisitionChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeCustomerSetArgs = {
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannel?: InputMaybe<Scalars['ID']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  averageTicket?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Gte?: InputMaybe<Scalars['Float']['input']>;
  averageTicket_Lte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Gte?: InputMaybe<Scalars['Float']['input']>;
  avgDaysBetweenPurchases_Lte?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_Icontains?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Gte?: InputMaybe<Scalars['Date']['input']>;
  dateOfBirth_Lte?: InputMaybe<Scalars['Date']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Status_In?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp_In?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  id_In?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDateMonth?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDateYear?: InputMaybe<Scalars['Float']['input']>;
  lastPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  lastPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  newProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  rfmClassification?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_Icontains?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
};


export type StoreTypeCustomertagsSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories_Pk?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords_Icontains?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  products_Pk?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagType_In?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeCustomuserSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status_Archived?: InputMaybe<Scalars['Boolean']['input']>;
  status_SecondaryEmail?: InputMaybe<Scalars['String']['input']>;
  status_Verified?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_Icontains?: InputMaybe<Scalars['String']['input']>;
  username_Istartswith?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type StoreTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  name_In?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchaseproduct_Purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
};


export type StoreTypePurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type StoreTypeServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableForBooking?: InputMaybe<Scalars['Boolean']['input']>;
  availableInPdv?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameIcontains?: InputMaybe<Scalars['String']['input']>;
};


export type StoreTypeWhatsapptemplateSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_Gt?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  origin_In?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum StoreZekiMessage {
  /** Evolution API */
  Evolution = 'EVOLUTION',
  /** Z-API */
  Zapi = 'ZAPI'
}

export type TaskInput = {
  columnStatusIntegrationId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  responsibleId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskNode = Node & {
  __typename?: 'TaskNode';
  columnStatus: ColumnStatusNode;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  dueTime?: Maybe<Scalars['Time']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  leadSet: LeadNodeConnection;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  responsible?: Maybe<CustomUserNode>;
};


export type TaskNodeLeadSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TaskNodeConnection = {
  __typename?: 'TaskNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaskNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TaskNode` and its cursor. */
export type TaskNodeEdge = {
  __typename?: 'TaskNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TaskNode>;
};

export type TaskType = {
  __typename?: 'TaskType';
  columnStatus: ColumnStatusNode;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  dueTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  leadSet: LeadNodeConnection;
  name: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  responsible?: Maybe<CustomUserNode>;
};


export type TaskTypeLeadSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TestWhatsappConnectionMutation = {
  __typename?: 'TestWhatsappConnectionMutation';
  businessId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type TopCustomersTypeField = {
  __typename?: 'TopCustomersTypeField';
  customerGender?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPk?: Maybe<Scalars['ID']['output']>;
  purchaseTotalQuantity?: Maybe<Scalars['Int']['output']>;
  purchaseTotalValue?: Maybe<Scalars['Float']['output']>;
};

export type TopProductsTypeField = {
  __typename?: 'TopProductsTypeField';
  productName?: Maybe<Scalars['String']['output']>;
  productPk?: Maybe<Scalars['ID']['output']>;
  totalSold?: Maybe<Scalars['Float']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
};

export type TrackBookingFunnelEventMutation = {
  __typename?: 'TrackBookingFunnelEventMutation';
  ok: Scalars['Boolean']['output'];
};

export type TrayStoreIntegrationType = {
  __typename?: 'TrayStoreIntegrationType';
  acceptedStatusToImport: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  authResponse: Scalars['JSONString']['output'];
  code: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TrinksStoreIntegrationType = {
  __typename?: 'TrinksStoreIntegrationType';
  activated: Scalars['Boolean']['output'];
  apiKey: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  snsSubscriptionArn: Scalars['String']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type UfBarChartReturn = {
  __typename?: 'UfBarChartReturn';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  series?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UpdateAccountInput = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update user model fields, defined on settings.
 *
 * User must be verified.
 */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBoard = {
  __typename?: 'UpdateBoard';
  board?: Maybe<BoardType>;
};

export type UpdateCampaignInput = {
  /** Texto do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonLabelEmail?: InputMaybe<Scalars['String']['input']>;
  /** URL do botão de CTA do e-mail. Usado apenas para via_email. */
  buttonUrlEmail?: InputMaybe<Scalars['String']['input']>;
  /** Botões do template WhatsApp oficial (máx 3, tipos URL/QUICK_REPLY/PHONE_NUMBER). Usado apenas quando via_whatsapp_official=true. */
  buttons?: InputMaybe<Array<InputMaybe<WhatsappButtonInput>>>;
  campaignId: Scalars['ID']['input'];
  daysToTrigger?: InputMaybe<Scalars['Int']['input']>;
  /** Rodapé do template WhatsApp oficial (máx 60 caracteres). Usado apenas para via_whatsapp_official. */
  footer?: InputMaybe<Scalars['String']['input']>;
  /** Rodapé exibido no e-mail. Usado apenas para via_email. */
  footerEmail?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageEmail?: InputMaybe<Scalars['String']['input']>;
  messageSms?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerCustomerTagId?: InputMaybe<Scalars['ID']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  zekiCrmChannelId?: InputMaybe<Scalars['String']['input']>;
  zekiCrmChannelNumber?: InputMaybe<Scalars['String']['input']>;
  zekiCrmTemplateId?: InputMaybe<Scalars['ID']['input']>;
  zekiCrmTemplateVariableMapping?: InputMaybe<Array<InputMaybe<ZekiCrmTemplateVariableMappingInput>>>;
};

export type UpdateCampaignMutation = {
  __typename?: 'UpdateCampaignMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCancelGiftbackInput = {
  crossRegistrationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  giftbackId?: InputMaybe<Scalars['ID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCancelGiftbackMutation = {
  __typename?: 'UpdateCancelGiftbackMutation';
  giftback?: Maybe<GiftbackType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCategoryInput = {
  categoryId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryMutation = {
  __typename?: 'UpdateCategoryMutation';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateColumnStatus = {
  __typename?: 'UpdateColumnStatus';
  columnStatus?: Maybe<ColumnStatusType>;
};

export type UpdateCommunityScheduledMessage = {
  __typename?: 'UpdateCommunityScheduledMessage';
  message: CommunityScheduledMessage;
};

export type UpdateCommunityScheduledMessageInput = {
  expectedRevision: Scalars['Int']['input'];
  messageId: Scalars['ID']['input'];
  scheduledAt: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type UpdateCouponInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  couponId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCouponMutation = {
  __typename?: 'UpdateCouponMutation';
  coupon?: Maybe<CouponType>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomUserMutation = {
  __typename?: 'UpdateCustomUserMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomer = {
  __typename?: 'UpdateCustomer';
  customer?: Maybe<CustomerType>;
};

export type UpdateCustomerInput = {
  acquisitionChannelId?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<CustomerGender>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tagsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerTagsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tagId: Scalars['ID']['input'];
};

export type UpdateCustomerTagsMutation = {
  __typename?: 'UpdateCustomerTagsMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  tag?: Maybe<CustomerTagsType>;
};

export type UpdateEmailTemplateMutation = {
  __typename?: 'UpdateEmailTemplateMutation';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<EmailTemplateType>;
};

export type UpdateInstance = {
  __typename?: 'UpdateInstance';
  instance?: Maybe<InstanceType>;
};

export type UpdateIntegration = {
  __typename?: 'UpdateIntegration';
  integration?: Maybe<IntegrationType>;
};

export type UpdateLead = {
  __typename?: 'UpdateLead';
  lead?: Maybe<LeadType>;
};

export type UpdateLoyaltyProgramMutation = {
  __typename?: 'UpdateLoyaltyProgramMutation';
  program?: Maybe<LoyaltyProgramType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProductInput = {
  categoriesId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  costValue?: InputMaybe<Scalars['Decimal']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
  wholesaleValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateProductMutation = {
  __typename?: 'UpdateProductMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductType>;
};

export type UpdatePurchaseNotesInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePurchaseNotesMutation = {
  __typename?: 'UpdatePurchaseNotesMutation';
  purchase?: Maybe<PurchaseType>;
};

export type UpdateRedeemGiftbackInput = {
  crossRegistrationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  giftbackId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateRedeemGiftbackMutation = {
  __typename?: 'UpdateRedeemGiftbackMutation';
  giftback?: Maybe<GiftbackType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateStoreInput = {
  currencyType?: InputMaybe<StoreCurrencyType>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailFooterImg?: InputMaybe<Scalars['String']['input']>;
  emailFooterPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterTertiaryColor?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<StorePlan>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  profileImageEmail?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStoreMutation = {
  __typename?: 'UpdateStoreMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
  store?: Maybe<StoreType>;
};

export type UpdateTask = {
  __typename?: 'UpdateTask';
  task?: Maybe<TaskType>;
};

export type UpdateTemplateStatusInput = {
  name: Scalars['String']['input'];
};

export type UpdateTemplateStatusMutation = {
  __typename?: 'UpdateTemplateStatusMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserConnectedStoreMutation = {
  __typename?: 'UpdateUserConnectedStoreMutation';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserInput = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<CustomerGender>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  userType?: InputMaybe<PermissionUserType>;
};

export type UserAcceptationType = {
  __typename?: 'UserAcceptationType';
  acceptationTerm: AcceptationTermType;
  acceptedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  user: CustomUserNode;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  appointmentProfessionals: Array<ProfessionalType>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  boardSet: BoardNodeConnection;
  cancelledAppointments: Array<AppointmentType>;
  cashregisterclosingSet: Array<CashRegisterClosingType>;
  cashregistermovementSet: Array<CashRegisterMovementType>;
  colaborators: BoardNodeConnection;
  connectedStore?: Maybe<StoreType>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAppointments: Array<AppointmentType>;
  createdAt: Scalars['DateTime']['output'];
  createdJourneyDrafts: Array<JourneyDraftType>;
  createdJourneys: Array<JourneyType>;
  createdLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  customeractivitySet: CustomerActivitiesTypeRelayConnection;
  dateJoined: Scalars['DateTime']['output'];
  deliveredLoyaltyRedemptions: Array<LoyaltyRedemptionType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<CustomUserGender>;
  giftbackSet: GiftbackRelayTypeConnection;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  instanceSet: InstanceNodeConnection;
  integrationSet: IntegrationNodeConnection;
  /** Indica que o usuário será tratado como ativo. Ao invés de excluir contas de usuário, desmarque isso. */
  isActive: Scalars['Boolean']['output'];
  /** Indica que usuário consegue acessar este site de administração. */
  isStaff: Scalars['Boolean']['output'];
  journeyOwnershipChanges: Array<JourneyOwnershipType>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  loyaltyredemptiontransitionSet: Array<LoyaltyRedemptionTransitionType>;
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<PermissionType>;
  phone?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  profile: CustomUserProfile;
  publishedJourneyVersions: Array<JourneyVersionType>;
  purchaseSet: PurchaseRelayTypeConnection;
  redeemedGiftbacks: GiftbackRelayTypeConnection;
  scheduleadjustmentSet: Array<ScheduleAdjustmentType>;
  schedulednotificationintentSet: Array<JourneyScheduledIntentType>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  taskSet: TaskNodeConnection;
  updatedAt: Scalars['DateTime']['output'];
  updatedJourneyDrafts: Array<JourneyDraftType>;
  updatedJourneys: Array<JourneyType>;
  useracceptationSet: Array<UserAcceptationType>;
  /** Obrigatório. 150 caracteres ou menos. Letras, números e @/./+/-/_ apenas. */
  username: Scalars['String']['output'];
  verified?: Maybe<Scalars['Boolean']['output']>;
};


export type UserNodeBoardSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type UserNodeColaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type UserNodeCustomeractivitySetArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  activity_In?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftback_Id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  includesCampaignMessage?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  messageStatus_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase_Id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  user_Email?: InputMaybe<Scalars['String']['input']>;
  user_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  user_Id?: InputMaybe<Scalars['ID']['input']>;
};


export type UserNodeGiftbackSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type UserNodeInstanceSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type UserNodeIntegrationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type UserNodePurchaseSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coupon_Code?: InputMaybe<Scalars['String']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Phone?: InputMaybe<Scalars['String']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  date_Month?: InputMaybe<Scalars['Float']['input']>;
  date_Year?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  giftbackRedeemedValue?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  giftbackRedeemedValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  issueDate_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  issueDate_Month?: InputMaybe<Scalars['Float']['input']>;
  issueDate_Year?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  purchaseproduct_Product_Id?: InputMaybe<Scalars['ID']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  store_Id?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type UserNodeRedeemedGiftbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Gte?: InputMaybe<Scalars['Date']['input']>;
  availableFrom_Lte?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  customer_Email?: InputMaybe<Scalars['String']['input']>;
  customer_Email_Icontains?: InputMaybe<Scalars['String']['input']>;
  customer_Name?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  purchase_Date?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  purchase_In?: InputMaybe<Scalars['ID']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['ID']['input']>;
  store_Name?: InputMaybe<Scalars['String']['input']>;
  store_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
};


export type UserNodeTaskSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columnStatus?: InputMaybe<Scalars['ID']['input']>;
  columnStatus_IntegrationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lt?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  dueTime?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lt?: InputMaybe<Scalars['Time']['input']>;
  dueTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['ID']['input']>;
};

export type ValueRfmInput = {
  zoneFiveMax?: InputMaybe<Scalars['Decimal']['input']>;
  zoneFiveMin?: InputMaybe<Scalars['Decimal']['input']>;
  zoneFourMax?: InputMaybe<Scalars['Decimal']['input']>;
  zoneFourMin?: InputMaybe<Scalars['Decimal']['input']>;
  zoneOneMax?: InputMaybe<Scalars['Decimal']['input']>;
  zoneOneMin?: InputMaybe<Scalars['Decimal']['input']>;
  zoneThreeMax?: InputMaybe<Scalars['Decimal']['input']>;
  zoneThreeMin?: InputMaybe<Scalars['Decimal']['input']>;
  zoneTwoMax?: InputMaybe<Scalars['Decimal']['input']>;
  zoneTwoMin?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ValueRfmType = {
  __typename?: 'ValueRFMType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  zoneFiveMax: Scalars['Float']['output'];
  zoneFiveMin: Scalars['Float']['output'];
  zoneFourMax: Scalars['Float']['output'];
  zoneFourMin: Scalars['Float']['output'];
  zoneOneMax: Scalars['Float']['output'];
  zoneOneMin: Scalars['Float']['output'];
  zoneThreeMax: Scalars['Float']['output'];
  zoneThreeMin: Scalars['Float']['output'];
  zoneTwoMax: Scalars['Float']['output'];
  zoneTwoMin: Scalars['Float']['output'];
};

export type VerifyAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/**
 * Verify user account.
 *
 * Receive the token that was sent by email.
 * If the token is valid, make the user verified
 * by making the `user.status.verified` field true.
 */
export type VerifyAccountPayload = {
  __typename?: 'VerifyAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Same as `grapgql_jwt` implementation, with standard output. */
export type VerifyTokenPayload = {
  __typename?: 'VerifyTokenPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['ExpectedErrorType']['output']>;
  payload?: Maybe<Scalars['GenericScalar']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WebpicStoreIntegrationType = {
  __typename?: 'WebpicStoreIntegrationType';
  accessToken: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresIn?: Maybe<Scalars['Date']['output']>;
  haveInvoice: Scalars['Boolean']['output'];
  havePdv: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationToken: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Input type para botões dinâmicos em templates WhatsApp */
export type WhatsappButtonInput = {
  /** Número de telefone em formato E.164 (obrigatório se type=PHONE_NUMBER) */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Texto do botão (máx 20 caracteres) */
  text: Scalars['String']['input'];
  /** Tipo de botão: URL, QUICK_REPLY ou PHONE_NUMBER */
  type: Scalars['String']['input'];
  /** URL do botão (obrigatório se type=URL, máx 255 caracteres) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WhatsappConfigInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  facebookAuthorizationCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId?: InputMaybe<Scalars['String']['input']>;
  whatsappAccessToken?: InputMaybe<Scalars['String']['input']>;
  whatsappBusinessAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type WhatsappConfigType = {
  __typename?: 'WhatsappConfigType';
  activated: Scalars['Boolean']['output'];
  automaticResponseEnabled: Scalars['Boolean']['output'];
  automaticResponseMessage: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  pk: Scalars['Int']['output'];
  store?: Maybe<StoreType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webhookCallbackUrl?: Maybe<Scalars['String']['output']>;
  webhookVerificationToken?: Maybe<Scalars['String']['output']>;
  whatsappAccessToken?: Maybe<Scalars['String']['output']>;
  whatsappAppBusinessId: Scalars['String']['output'];
  whatsappBusinessAccountId: Scalars['String']['output'];
  whatsappPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum WhatsappTemplateCategory {
  /** Autenticação */
  Authentication = 'AUTHENTICATION',
  /** Marketing */
  Marketing = 'MARKETING',
  /** Utilidade */
  Utility = 'UTILITY'
}

/** An enumeration. */
export enum WhatsappTemplateOrigin {
  /** Notificação em Massa */
  BulkNotification = 'BULK_NOTIFICATION',
  /** Campanha */
  Campaign = 'CAMPAIGN'
}

export type WhatsappTemplateRelayType = Node & {
  __typename?: 'WhatsappTemplateRelayType';
  allowCategoryChange: Scalars['Boolean']['output'];
  bulknotificationSet: BulkNotificationRelayTypeConnection;
  campaign?: Maybe<CampaignRelayType>;
  category?: Maybe<WhatsappTemplateCategory>;
  components?: Maybe<Scalars['JSONString']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Ao colar a url de uma imagem, ela será enviada junto com a mensagem de whatsapp. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  isCurrentlySending: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newQualityScore?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<WhatsappTemplateOrigin>;
  pk: Scalars['Int']['output'];
  previousQualityScore?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WhatsappTemplateStatus>;
  store?: Maybe<StoreType>;
  templateId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Ao colar a url de um vídeo, ele será enviado junto com a mensagem de whatsapp. Tipos permitidos: mp4 e 3gp. Tamanho permitido: até 16MB. */
  videoUrl?: Maybe<Scalars['String']['output']>;
  zekiCrmParameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type WhatsappTemplateRelayTypeBulknotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  endTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  startTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateStatus?: InputMaybe<Scalars['String']['input']>;
};

export type WhatsappTemplateRelayTypeConnection = {
  __typename?: 'WhatsappTemplateRelayTypeConnection';
  edgeCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WhatsappTemplateRelayTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `WhatsappTemplateRelayType` and its cursor. */
export type WhatsappTemplateRelayTypeEdge = {
  __typename?: 'WhatsappTemplateRelayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WhatsappTemplateRelayType>;
};

/** An enumeration. */
export enum WhatsappTemplateStatus {
  /** Aprovado */
  Approved = 'APPROVED',
  /** Em Análise */
  Pending = 'PENDING',
  /** Rejeitado */
  Rejected = 'REJECTED'
}

export type WhatsappTemplateType = {
  __typename?: 'WhatsappTemplateType';
  allowCategoryChange: Scalars['Boolean']['output'];
  bulknotificationSet: BulkNotificationRelayTypeConnection;
  campaign?: Maybe<CampaignRelayType>;
  category?: Maybe<WhatsappTemplateCategory>;
  components?: Maybe<Scalars['JSONString']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Ao colar a url de uma imagem, ela será enviada junto com a mensagem de whatsapp. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  isCurrentlySending: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newQualityScore?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<WhatsappTemplateOrigin>;
  pk: Scalars['Int']['output'];
  previousQualityScore?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WhatsappTemplateStatus>;
  store?: Maybe<StoreType>;
  templateId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Ao colar a url de um vídeo, ele será enviado junto com a mensagem de whatsapp. Tipos permitidos: mp4 e 3gp. Tamanho permitido: até 16MB. */
  videoUrl?: Maybe<Scalars['String']['output']>;
  zekiCrmParameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type WhatsappTemplateTypeBulknotificationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Date?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  endTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTime_Gte?: InputMaybe<Scalars['Time']['input']>;
  startTime_Lte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  updatedAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  updatedAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaDiscord?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  whatsappTemplateStatus?: InputMaybe<Scalars['String']['input']>;
};

export type WorkingHoursInput = {
  endTime: Scalars['Time']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
  scope: Scalars['String']['input'];
  startTime: Scalars['Time']['input'];
  weekday: Scalars['Int']['input'];
};

/** An enumeration. */
export enum WorkingHoursScope {
  /** Profissional */
  Professional = 'PROFESSIONAL',
  /** Unidade */
  Unit = 'UNIT'
}

export type WorkingHoursType = {
  __typename?: 'WorkingHoursType';
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pk: Scalars['Int']['output'];
  professional?: Maybe<ProfessionalType>;
  scope: WorkingHoursScope;
  startTime: Scalars['Time']['output'];
  store: StoreType;
  unit?: Maybe<SchedulingUnitType>;
  updatedAt: Scalars['DateTime']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
  weekday: Scalars['Int']['output'];
};

export type YampiAuthorizationUrlType = {
  __typename?: 'YampiAuthorizationUrlType';
  codeVerifier: Scalars['String']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type YampiStoreIntegrationType = {
  __typename?: 'YampiStoreIntegrationType';
  accessToken: Scalars['String']['output'];
  activated: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  merchantAlias: Scalars['String']['output'];
  pk: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  /** Aguardando Pagamento, Pedido Autorizado, Pagamento Aprovado, Produtos em Separação, Faturado, Pronto para Envio, Em Transporte, Entregue e Cancelado */
  statusesToGenerateGiftback: Scalars['String']['output'];
  store: StoreType;
  updatedAt: Scalars['DateTime']['output'];
  webhookId?: Maybe<Scalars['Int']['output']>;
  webhookSecret: Scalars['String']['output'];
};

export type ZApiIntegrationInput = {
  token?: InputMaybe<Scalars['String']['input']>;
  zApiId?: InputMaybe<Scalars['String']['input']>;
  zApiToken?: InputMaybe<Scalars['String']['input']>;
};

export type ZApiIntegrationType = {
  __typename?: 'ZApiIntegrationType';
  connected: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  pk: Scalars['Int']['output'];
  store: StoreType;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zApiId: Scalars['String']['output'];
  zApiToken: Scalars['String']['output'];
};

export type ZekiCrmTemplateVariableMappingInput = {
  templateVariable: Scalars['String']['input'];
  zekiVariable: Scalars['String']['input'];
};

export type ZekiCrmTemplateVariableMappingType = {
  __typename?: 'ZekiCrmTemplateVariableMappingType';
  templateVariable?: Maybe<Scalars['String']['output']>;
  zekiVariable?: Maybe<Scalars['String']['output']>;
};

export type SaveBookingSettingsFrontendMutationVariables = Exact<{
  input: SaveBookingSettingsInput;
}>;


export type SaveBookingSettingsFrontendMutation = { __typename?: 'Mutation', saveBookingSettings?: { __typename?: 'SaveBookingSettingsMutation', workspace?: { __typename?: 'AppointmentWorkspaceType', unit?: { __typename?: 'SchedulingUnitType', id: string, pk: number, name: string, timezone: string, address: string, phone: string } | null, bookingPage?: { __typename?: 'BookingPageType', id: string, pk: number, slug: string, title: string, description: string, isPublished: boolean, minimumLeadMinutes: number, bookingHorizonDays: number, cancellationLeadMinutes: number, slotIntervalMinutes: number, allowProfessionalPreference: boolean, reminderOffsetMinutes: number, reminderViaWhatsapp: boolean, reminderViaEmail: boolean, termsUrl: string, privacyUrl: string } | null, storefront?: { __typename?: 'BookingStorefrontProfileType', id: string, pk: number, preset: BookingStorefrontProfilePreset, primaryColor: string, accentColor: string, surfaceColor: string, logoUrl: string, logoAlt: string, coverImageUrl: string, coverImageAlt: string, aboutTitle: string, aboutText: string, instagramUrl: string, facebookUrl: string, tiktokUrl: string, websiteUrl: string, mapsUrl: string, latitude?: number | null, longitude?: number | null, seoTitle: string, seoDescription: string, publishedAt?: any | null } | null } | null } | null };

export type PublishBookingStorefrontFrontendMutationVariables = Exact<{ [key: string]: never; }>;


export type PublishBookingStorefrontFrontendMutation = { __typename?: 'Mutation', publishBookingStorefront?: { __typename?: 'PublishBookingStorefrontMutation', workspace?: { __typename?: 'AppointmentWorkspaceType', bookingPage?: { __typename?: 'BookingPageType', id: string, pk: number, slug: string, title: string, description: string, isPublished: boolean } | null, storefront?: { __typename?: 'BookingStorefrontProfileType', id: string, pk: number, preset: BookingStorefrontProfilePreset, primaryColor: string, accentColor: string, surfaceColor: string, logoUrl: string, coverImageUrl: string, aboutTitle: string, aboutText: string, publishedAt?: any | null } | null } | null } | null };

export type SaveProfessionalFrontendMutationVariables = Exact<{
  input: SaveProfessionalInput;
}>;


export type SaveProfessionalFrontendMutation = { __typename?: 'Mutation', saveAppointmentProfessional?: { __typename?: 'SaveProfessionalMutation', professional?: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string, bio: string, photoUrl: string, isActive: boolean, isPublic: boolean, services?: Array<{ __typename?: 'ServiceType', id: string, pk: number, name: string } | null> | null } | null } | null };

export type ReplaceWorkingHoursFrontendMutationVariables = Exact<{
  hours: Array<InputMaybe<WorkingHoursInput>> | InputMaybe<WorkingHoursInput>;
}>;


export type ReplaceWorkingHoursFrontendMutation = { __typename?: 'Mutation', replaceAppointmentWorkingHours?: { __typename?: 'ReplaceWorkingHoursMutation', workingHours?: Array<{ __typename?: 'WorkingHoursType', id: string, pk: number, scope: WorkingHoursScope, weekday: number, startTime: any, endTime: any, professional?: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string } | null } | null> | null } | null };

export type SaveScheduleAdjustmentFrontendMutationVariables = Exact<{
  input: SaveScheduleAdjustmentInput;
}>;


export type SaveScheduleAdjustmentFrontendMutation = { __typename?: 'Mutation', saveScheduleAdjustment?: { __typename?: 'SaveScheduleAdjustmentMutation', adjustment?: { __typename?: 'ScheduleAdjustmentType', id: string, pk: number, kind: ScheduleAdjustmentKind, startsAt: any, endsAt: any, reason: string, repeatsWeekly: boolean, professional: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string } } | null } | null };

export type CreateInternalAppointmentFrontendMutationVariables = Exact<{
  input: InternalAppointmentInput;
}>;


export type CreateInternalAppointmentFrontendMutation = { __typename?: 'Mutation', createInternalAppointment?: { __typename?: 'CreateInternalAppointmentMutation', appointment?: { __typename?: 'AppointmentType', id: string, pk: number, publicId: any, startsAt: any, endsAt: any, serviceName: string, status: AppointmentStatus, customer: { __typename?: 'CustomerTypeRelay', id: string, pk: number, name?: string | null }, professional: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string } } | null } | null };

export type ChangeAppointmentStatusFrontendMutationVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeAppointmentStatusFrontendMutation = { __typename?: 'Mutation', changeAppointmentStatus?: { __typename?: 'ChangeAppointmentStatusMutation', appointment?: { __typename?: 'AppointmentType', id: string, pk: number, publicId: any, startsAt: any, endsAt: any, serviceName: string, status: AppointmentStatus, customer: { __typename?: 'CustomerTypeRelay', id: string, pk: number, name?: string | null }, professional: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string } } | null } | null };

export type RescheduleAppointmentFrontendMutationVariables = Exact<{
  appointmentId: Scalars['ID']['input'];
  startsAt: Scalars['DateTime']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RescheduleAppointmentFrontendMutation = { __typename?: 'Mutation', rescheduleAppointment?: { __typename?: 'RescheduleAppointmentMutation', result?: { __typename?: 'AppointmentActionResultType', code?: string | null, message?: string | null, alternativeSlots?: Array<{ __typename?: 'AvailableSlotType', startsAt: any, endsAt: any, professionalId: string, professionalName: string } | null> | null, appointment?: { __typename?: 'PublicAppointmentType', publicId: any, startsAt: any, endsAt: any, status: string } | null } | null } | null };

export type AppointmentWorkspaceQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentWorkspaceQuery = { __typename?: 'Query', appointmentWorkspace?: { __typename?: 'AppointmentWorkspaceType', unit?: { __typename?: 'SchedulingUnitType', id: string, pk: number, name: string, timezone: string, address: string, phone: string, isPrimary: boolean, isActive: boolean } | null, bookingPage?: { __typename?: 'BookingPageType', id: string, pk: number, slug: string, title: string, description: string, isPublished: boolean, minimumLeadMinutes: number, bookingHorizonDays: number, cancellationLeadMinutes: number, slotIntervalMinutes: number, allowProfessionalPreference: boolean, reminderOffsetMinutes: number, reminderViaWhatsapp: boolean, reminderViaEmail: boolean, termsUrl: string, privacyUrl: string } | null, storefront?: { __typename?: 'BookingStorefrontProfileType', id: string, pk: number, preset: BookingStorefrontProfilePreset, primaryColor: string, accentColor: string, surfaceColor: string, logoUrl: string, logoAlt: string, coverImageUrl: string, coverImageAlt: string, aboutTitle: string, aboutText: string, instagramUrl: string, facebookUrl: string, tiktokUrl: string, websiteUrl: string, mapsUrl: string, latitude?: number | null, longitude?: number | null, seoTitle: string, seoDescription: string, publishedAt?: any | null } | null, professionals?: Array<{ __typename?: 'ProfessionalType', id: string, pk: number, publicName: string, bio: string, photoUrl: string, isActive: boolean, isPublic: boolean, user?: { __typename?: 'CustomUserNode', id: string, pk?: number | null, name?: string | null, email: string } | null, services?: Array<{ __typename?: 'ServiceType', id: string, pk: number, name: string, durationMinutes?: number | null, value: number } | null> | null } | null> | null, workingHours?: Array<{ __typename?: 'WorkingHoursType', id: string, pk: number, scope: WorkingHoursScope, weekday: number, startTime: any, endTime: any, professional?: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string } | null } | null> | null, adjustments?: Array<{ __typename?: 'ScheduleAdjustmentType', id: string, pk: number, kind: ScheduleAdjustmentKind, startsAt: any, endsAt: any, reason: string, notes: string, repeatsWeekly: boolean, repeatsUntil?: any | null, professional: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string } } | null> | null } | null };

export type AppointmentStorefrontPreviewQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentStorefrontPreviewQuery = { __typename?: 'Query', appointmentStorefrontPreview?: { __typename?: 'PublicBookingPageType', slug: string, storeName: string, logo?: string | null, title: string, description?: string | null, timezone: string, address?: string | null, phone?: string | null, allowProfessionalPreference: boolean, termsUrl?: string | null, privacyUrl?: string | null, storefront?: { __typename?: 'PublicStorefrontProfileType', preset: string, primaryColor: string, accentColor: string, surfaceColor: string, logoUrl?: string | null, logoAlt?: string | null, coverImageUrl?: string | null, coverImageAlt?: string | null, aboutTitle?: string | null, aboutText?: string | null, instagramUrl?: string | null, facebookUrl?: string | null, tiktokUrl?: string | null, websiteUrl?: string | null, mapsUrl?: string | null, latitude?: any | null, longitude?: any | null, seoTitle?: string | null, seoDescription?: string | null } | null, workingHours?: Array<{ __typename?: 'WorkingHoursType', id: string, pk: number, scope: WorkingHoursScope, weekday: number, startTime: any, endTime: any } | null> | null, services?: Array<{ __typename?: 'PublicServiceType', id: string, categoryId: string, categoryName: string, name: string, description?: string | null, value: any, durationMinutes: number } | null> | null, professionals?: Array<{ __typename?: 'PublicProfessionalType', id: string, name: string, bio?: string | null, photoUrl?: string | null, serviceIds?: Array<string> | null } | null> | null } | null };

export type AppointmentsQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  professionalIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AppointmentsQuery = { __typename?: 'Query', appointments?: Array<{ __typename?: 'AppointmentType', id: string, pk: number, publicId: any, startsAt: any, endsAt: any, occupiedStartsAt: any, occupiedEndsAt: any, serviceName: string, serviceValue: number, durationMinutes: number, status: AppointmentStatus, origin: AppointmentOrigin, notes: string, cancellationReason: string, version: number, customer: { __typename?: 'CustomerTypeRelay', id: string, pk: number, name?: string | null, phone?: string | null, email?: string | null }, professional: { __typename?: 'ProfessionalType', id: string, pk: number, publicName: string }, service: { __typename?: 'ServiceRelayType', id: string, pk: number, name: string, category: { __typename?: 'ServiceCategoryType', id: string, pk: number, name: string } } } | null> | null };

export type AppointmentAvailabilityQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  start: Scalars['Date']['input'];
  end: Scalars['Date']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AppointmentAvailabilityQuery = { __typename?: 'Query', appointmentAvailability?: Array<{ __typename?: 'AvailableSlotType', startsAt: any, endsAt: any, professionalId: string, professionalName: string } | null> | null };

export type AppointmentDashboardQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type AppointmentDashboardQuery = { __typename?: 'Query', appointmentDashboard?: { __typename?: 'AppointmentDashboardType', total?: number | null, occupancyRate?: number | null, confirmationRate?: number | null, attendanceRate?: number | null, cancellationRate?: number | null, noShowRate?: number | null, estimatedValue?: any | null, realizedRevenue?: any | null } | null };

export type AppointmentCustomersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AppointmentCustomersQuery = { __typename?: 'Query', allCustomersRelay?: { __typename?: 'CustomerTypeRelayConnection', edges: Array<{ __typename?: 'CustomerTypeRelayEdge', node?: { __typename?: 'CustomerTypeRelay', id: string, pk: number, name?: string | null, phone?: string | null, email?: string | null } | null } | null> } | null };

export type PublicAppointmentPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PublicAppointmentPageQuery = { __typename?: 'Query', publicAppointmentPage?: { __typename?: 'PublicBookingPageType', slug: string, storeName: string, logo?: string | null, title: string, description?: string | null, timezone: string, address?: string | null, phone?: string | null, allowProfessionalPreference: boolean, termsUrl?: string | null, privacyUrl?: string | null, storefront?: { __typename?: 'PublicStorefrontProfileType', preset: string, primaryColor: string, accentColor: string, surfaceColor: string, logoUrl?: string | null, logoAlt?: string | null, coverImageUrl?: string | null, coverImageAlt?: string | null, aboutTitle?: string | null, aboutText?: string | null, instagramUrl?: string | null, facebookUrl?: string | null, tiktokUrl?: string | null, websiteUrl?: string | null, mapsUrl?: string | null, latitude?: any | null, longitude?: any | null, seoTitle?: string | null, seoDescription?: string | null } | null, workingHours?: Array<{ __typename?: 'WorkingHoursType', id: string, pk: number, scope: WorkingHoursScope, weekday: number, startTime: any, endTime: any } | null> | null, services?: Array<{ __typename?: 'PublicServiceType', id: string, categoryId: string, categoryName: string, name: string, description?: string | null, value: any, durationMinutes: number } | null> | null, professionals?: Array<{ __typename?: 'PublicProfessionalType', id: string, name: string, bio?: string | null, photoUrl?: string | null, serviceIds?: Array<string> | null } | null> | null } | null };

export type PublicAppointmentAvailabilityQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
  start: Scalars['Date']['input'];
  end: Scalars['Date']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicAppointmentAvailabilityQuery = { __typename?: 'Query', publicAppointmentAvailability?: Array<{ __typename?: 'AvailableSlotType', startsAt: any, endsAt: any, professionalId: string, professionalName: string } | null> | null };

export type PublicAppointmentByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type PublicAppointmentByTokenQuery = { __typename?: 'Query', publicAppointmentByToken?: { __typename?: 'PublicAppointmentType', publicId: any, bookingSlug: string, storeName: string, serviceId: string, serviceName: string, professionalName: string, startsAt: any, endsAt: any, timezone: string, status: string, canCancel: boolean, canReschedule: boolean, storefront?: { __typename?: 'PublicStorefrontProfileType', primaryColor: string, accentColor: string, surfaceColor: string } | null } | null };

export type CreatePublicAppointmentFrontendMutationVariables = Exact<{
  input: PublicAppointmentInput;
}>;


export type CreatePublicAppointmentFrontendMutation = { __typename?: 'Mutation', createPublicAppointment?: { __typename?: 'CreatePublicAppointmentMutation', result?: { __typename?: 'AppointmentBookingResultType', code?: string | null, message?: string | null, idempotentReplay: boolean, managementToken?: string | null, managementUrl?: string | null, googleCalendarUrl?: string | null, outlookCalendarUrl?: string | null, icsUrl?: string | null, alternativeSlots?: Array<{ __typename?: 'AvailableSlotType', startsAt: any, endsAt: any, professionalId: string, professionalName: string } | null> | null, appointment?: { __typename?: 'PublicAppointmentType', publicId: any, serviceId: string, serviceName: string, professionalName: string, startsAt: any, endsAt: any, timezone: string, status: string, canCancel: boolean, canReschedule: boolean } | null } | null } | null };

export type PublicCancelAppointmentFrontendMutationVariables = Exact<{
  token: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicCancelAppointmentFrontendMutation = { __typename?: 'Mutation', publicCancelAppointment?: { __typename?: 'PublicCancelAppointmentMutation', appointment?: { __typename?: 'PublicAppointmentType', publicId: any, serviceId: string, serviceName: string, professionalName: string, startsAt: any, endsAt: any, timezone: string, status: string, canCancel: boolean, canReschedule: boolean } | null } | null };

export type PublicRescheduleAppointmentFrontendMutationVariables = Exact<{
  token: Scalars['String']['input'];
  startsAt: Scalars['DateTime']['input'];
  professionalId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicRescheduleAppointmentFrontendMutation = { __typename?: 'Mutation', publicRescheduleAppointment?: { __typename?: 'PublicRescheduleAppointmentMutation', result?: { __typename?: 'AppointmentActionResultType', code?: string | null, message?: string | null, alternativeSlots?: Array<{ __typename?: 'AvailableSlotType', startsAt: any, endsAt: any, professionalId: string, professionalName: string } | null> | null, appointment?: { __typename?: 'PublicAppointmentType', publicId: any, serviceId: string, serviceName: string, professionalName: string, startsAt: any, endsAt: any, timezone: string, status: string, canCancel: boolean, canReschedule: boolean } | null } | null } | null };

export type TrackBookingFunnelEventFrontendMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  sessionId: Scalars['UUID']['input'];
  eventType: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['GenericScalar']['input']>;
}>;


export type TrackBookingFunnelEventFrontendMutation = { __typename?: 'Mutation', trackBookingFunnelEvent?: { __typename?: 'TrackBookingFunnelEventMutation', ok: boolean } | null };

export type ActiveOrInactiveTemplateMutationVariables = Exact<{
  input: ActiveOrInactiveCampaignInput;
}>;


export type ActiveOrInactiveTemplateMutation = { __typename?: 'Mutation', activeOrInactiveCampaign?: { __typename?: 'ActiveOrInactiveCampaignMutation', success?: boolean | null } | null };

export type CreateNewCampaignMutationVariables = Exact<{
  campaignInput: CreateCampaignInput;
}>;


export type CreateNewCampaignMutation = { __typename?: 'Mutation', createCampaign?: { __typename?: 'CreateCampaignMutation', success?: boolean | null, error?: string | null } | null };

export type CreateTemplateMutationVariables = Exact<{
  input: CreateWhatsappTemplateByCampaignInput;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplateByCampaign?: { __typename?: 'CreateWhatsappTemplateByCampaignMutation', success?: boolean | null } | null };

export type GetCampaignDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCampaignDetailsQuery = { __typename?: 'Query', readCampaign?: { __typename?: 'CampaignType', pk: number, title: string, subject: string, messageSms?: string | null, message: string, messageEmail: string, daysToTrigger: number, tag: CampaignTag, buttonLabelEmail?: string | null, buttonUrlEmail?: string | null, footerEmail?: string | null, createdAt: any, updatedAt: any, footer?: string | null, buttons: any, viaWhatsapp: boolean, viaWhatsappOfficial: boolean, viaZekiCrm: boolean, zekiCrmChannelId?: string | null, zekiCrmChannelNumber?: string | null, viaSms: boolean, viaEmail: boolean, isActive: boolean, triggerCustomerTag?: { __typename?: 'CustomerTagsRelayType', pk: number, name: string } | null, zekiCrmTemplateVariableMapping?: Array<{ __typename?: 'ZekiCrmTemplateVariableMappingType', templateVariable?: string | null, zekiVariable?: string | null } | null> | null, whatsappTemplate?: { __typename?: 'WhatsappTemplateType', pk: number, name: string, category?: WhatsappTemplateCategory | null, status?: WhatsappTemplateStatus | null } | null, zekiCrmTemplate?: { __typename?: 'WhatsappTemplateType', pk: number, templateId?: string | null, name: string, message: string, status?: WhatsappTemplateStatus | null, provider?: string | null, zekiCrmParameters?: Array<string | null> | null } | null } | null };

export type ListCampaignsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  titleOrMessage?: InputMaybe<Scalars['String']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  viaSms?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  tag_Icontains?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListCampaignsQuery = { __typename?: 'Query', listCampaigns?: { __typename?: 'CampaignRelayTypeConnection', totalCount?: number | null, edgeCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CampaignRelayTypeEdge', node?: { __typename?: 'CampaignRelayType', pk: number, id: string, tag: CampaignTag, title: string, messageEmail: string, messageSms?: string | null, message: string, buttonLabelEmail?: string | null, buttonUrlEmail?: string | null, createdAt: any, updatedAt: any, viaWhatsapp: boolean, viaWhatsappOfficial: boolean, viaZekiCrm: boolean, viaSms: boolean, viaEmail: boolean, isActive: boolean, whatsappTemplate?: { __typename?: 'WhatsappTemplateType', pk: number, category?: WhatsappTemplateCategory | null, status?: WhatsappTemplateStatus | null } | null } | null } | null> } | null };

export type ListZekiCrmChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListZekiCrmChannelsQuery = { __typename?: 'Query', getHelenaChannels?: Array<{ __typename?: 'HelenaChannelType', id?: string | null, number?: string | null, numberFormatted?: string | null, active?: boolean | null } | null> | null };

export type ListZekiCrmWhatsappTemplatesQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListZekiCrmWhatsappTemplatesQuery = { __typename?: 'Query', listHelenaWhatsappTemplates?: Array<{ __typename?: 'WhatsappTemplateType', pk: number, templateId?: string | null, name: string, message: string, status?: WhatsappTemplateStatus | null, provider?: string | null, zekiCrmParameters?: Array<string | null> | null } | null> | null };

export type EditCampaignMutationVariables = Exact<{
  campaignInput: UpdateCampaignInput;
}>;


export type EditCampaignMutation = { __typename?: 'Mutation', updateCampaign?: { __typename?: 'UpdateCampaignMutation', success?: boolean | null, error?: string | null } | null };

export type CategoryCreateMutationVariables = Exact<{
  categoryInput: CreateCategoryInput;
}>;


export type CategoryCreateMutation = { __typename?: 'Mutation', categoryCreate?: { __typename?: 'CreateCategoryMutation', success?: boolean | null, error?: string | null, categories?: Array<{ __typename?: 'CategoryType', id: string, pk: number, name: string } | null> | null } | null };

export type CategoryDeleteMutationVariables = Exact<{
  categoryInput: DeleteCategoryInput;
}>;


export type CategoryDeleteMutation = { __typename?: 'Mutation', categoryDelete?: { __typename?: 'DeleteCategoryMutation', success?: boolean | null, error?: string | null } | null };

export type CategoryUpdateMutationVariables = Exact<{
  categoryInput: UpdateCategoryInput;
}>;


export type CategoryUpdateMutation = { __typename?: 'Mutation', categoryUpdate?: { __typename?: 'UpdateCategoryMutation', success?: boolean | null, error?: string | null } | null };

export type CommunityFieldsFragment = { __typename?: 'Community', id: string, name: string, description: string, adminsOnly: boolean, status: string, groupJid: string, audienceSelectionId?: string | null, sourceLabel: string, connectionPhone: string, instanceName: string, totalCount: number, eligibleCount: number, addedCount: number, failedCount: number, invalidCount: number, duplicateCount: number, pendingCount: number, lastError: string, canRetry: boolean, createdAt: any, updatedAt: any };

export type CommunityCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityCapabilityQuery = { __typename?: 'Query', communityCapability?: { __typename?: 'CommunityCapability', enabled: boolean, reason: string, maxMembers: number, connectionPhone: string, instanceName: string } | null };

export type CommunitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommunitiesQuery = { __typename?: 'Query', communities?: { __typename?: 'CommunityPage', total: number, hasNextPage: boolean, endCursor?: string | null, items: Array<{ __typename?: 'Community', id: string, name: string, description: string, adminsOnly: boolean, status: string, groupJid: string, audienceSelectionId?: string | null, sourceLabel: string, connectionPhone: string, instanceName: string, totalCount: number, eligibleCount: number, addedCount: number, failedCount: number, invalidCount: number, duplicateCount: number, pendingCount: number, lastError: string, canRetry: boolean, createdAt: any, updatedAt: any }> } | null };

export type CommunityDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CommunityDetailQuery = { __typename?: 'Query', community?: { __typename?: 'Community', id: string, name: string, description: string, adminsOnly: boolean, status: string, groupJid: string, audienceSelectionId?: string | null, sourceLabel: string, connectionPhone: string, instanceName: string, totalCount: number, eligibleCount: number, addedCount: number, failedCount: number, invalidCount: number, duplicateCount: number, pendingCount: number, lastError: string, canRetry: boolean, createdAt: any, updatedAt: any } | null };

export type CommunityMembersQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityMembersQuery = { __typename?: 'Query', communityMembers?: { __typename?: 'CommunityMemberPage', total: number, hasNextPage: boolean, endCursor?: string | null, items: Array<{ __typename?: 'CommunityMember', id: string, customerId?: string | null, name: string, phone: string, status: string, reason: string }> } | null };

export type PrepareCommunityMutationVariables = Exact<{
  input: PrepareCommunityInput;
}>;


export type PrepareCommunityMutation = { __typename?: 'Mutation', prepareCommunity?: { __typename?: 'PrepareCommunity', community: { __typename?: 'Community', id: string, name: string, description: string, adminsOnly: boolean, status: string, groupJid: string, audienceSelectionId?: string | null, sourceLabel: string, connectionPhone: string, instanceName: string, totalCount: number, eligibleCount: number, addedCount: number, failedCount: number, invalidCount: number, duplicateCount: number, pendingCount: number, lastError: string, canRetry: boolean, createdAt: any, updatedAt: any } } | null };

export type ConfirmCommunityMutationVariables = Exact<{
  input: ConfirmCommunityInput;
}>;


export type ConfirmCommunityMutation = { __typename?: 'Mutation', confirmCommunity?: { __typename?: 'ConfirmCommunity', community: { __typename?: 'Community', id: string, name: string, description: string, adminsOnly: boolean, status: string, groupJid: string, audienceSelectionId?: string | null, sourceLabel: string, connectionPhone: string, instanceName: string, totalCount: number, eligibleCount: number, addedCount: number, failedCount: number, invalidCount: number, duplicateCount: number, pendingCount: number, lastError: string, canRetry: boolean, createdAt: any, updatedAt: any } } | null };

export type RetryCommunityMutationVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type RetryCommunityMutation = { __typename?: 'Mutation', retryCommunity?: { __typename?: 'RetryCommunity', community: { __typename?: 'Community', id: string, name: string, description: string, adminsOnly: boolean, status: string, groupJid: string, audienceSelectionId?: string | null, sourceLabel: string, connectionPhone: string, instanceName: string, totalCount: number, eligibleCount: number, addedCount: number, failedCount: number, invalidCount: number, duplicateCount: number, pendingCount: number, lastError: string, canRetry: boolean, createdAt: any, updatedAt: any } } | null };

export type CommunityMessageFieldsFragment = { __typename?: 'CommunityScheduledMessage', id: string, communityId: string, text: string, scheduledAt: any, timeZone: string, status: string, revision: number, canEdit: boolean, canCancel: boolean, lastError: string, sentAt?: any | null, createdAt: any, updatedAt: any };

export type CommunityScheduledMessagesQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
  startsAt: Scalars['DateTime']['input'];
  endsAt: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommunityScheduledMessagesQuery = { __typename?: 'Query', communityScheduledMessages?: { __typename?: 'CommunityScheduledMessagePage', total: number, hasNextPage: boolean, endCursor?: string | null, items: Array<{ __typename?: 'CommunityScheduledMessage', id: string, communityId: string, text: string, scheduledAt: any, timeZone: string, status: string, revision: number, canEdit: boolean, canCancel: boolean, lastError: string, sentAt?: any | null, createdAt: any, updatedAt: any }> } | null };

export type CommunityWhatsappLinkQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type CommunityWhatsappLinkQuery = { __typename?: 'Query', communityWhatsappLink: string };

export type ScheduleCommunityMessageMutationVariables = Exact<{
  input: ScheduleCommunityMessageInput;
}>;


export type ScheduleCommunityMessageMutation = { __typename?: 'Mutation', scheduleCommunityMessage?: { __typename?: 'ScheduleCommunityMessage', message: { __typename?: 'CommunityScheduledMessage', id: string, communityId: string, text: string, scheduledAt: any, timeZone: string, status: string, revision: number, canEdit: boolean, canCancel: boolean, lastError: string, sentAt?: any | null, createdAt: any, updatedAt: any } } | null };

export type UpdateCommunityScheduledMessageMutationVariables = Exact<{
  input: UpdateCommunityScheduledMessageInput;
}>;


export type UpdateCommunityScheduledMessageMutation = { __typename?: 'Mutation', updateCommunityScheduledMessage?: { __typename?: 'UpdateCommunityScheduledMessage', message: { __typename?: 'CommunityScheduledMessage', id: string, communityId: string, text: string, scheduledAt: any, timeZone: string, status: string, revision: number, canEdit: boolean, canCancel: boolean, lastError: string, sentAt?: any | null, createdAt: any, updatedAt: any } } | null };

export type CancelCommunityScheduledMessageMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
  expectedRevision: Scalars['Int']['input'];
}>;


export type CancelCommunityScheduledMessageMutation = { __typename?: 'Mutation', cancelCommunityScheduledMessage?: { __typename?: 'CancelCommunityScheduledMessage', message: { __typename?: 'CommunityScheduledMessage', id: string, communityId: string, text: string, scheduledAt: any, timeZone: string, status: string, revision: number, canEdit: boolean, canCancel: boolean, lastError: string, sentAt?: any | null, createdAt: any, updatedAt: any } } | null };

export type ConnectOrDisconnectEvolutionApiMutationVariables = Exact<{
  input: ConnectOrDisconnectEvolutionApiIntegrationInput;
}>;


export type ConnectOrDisconnectEvolutionApiMutation = { __typename?: 'Mutation', connectOrDisconnectEvolutionApiIntegration?: { __typename?: 'ConnectOrDisconnectEvolutionApiIntegrationMutation', ok?: boolean | null, response?: string | null } | null };

export type GetAllRfmQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRfmQuery = { __typename?: 'Query', frequency?: { __typename?: 'FrequencyRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null, recency?: { __typename?: 'RecencyRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null, value?: { __typename?: 'ValueRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null };

export type GetAllStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStatesQuery = { __typename?: 'Query', allStates?: Array<{ __typename?: 'StateType', id?: number | null, sigla?: string | null, nome?: string | null } | null> | null };

export type GetGiftbackConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGiftbackConfigQuery = { __typename?: 'Query', getGiftbackConfig?: { __typename?: 'GiftbackConfigType', id: string, dueDate: number, cumulative?: boolean | null, couponProductScope: GiftbackConfigCouponProductScope, couponScopeMode: GiftbackConfigCouponScopeMode, pk: number, couponScopeProducts?: Array<{ __typename?: 'ProductType', id: string, pk: number, name: string, integrationId?: string | null } | null> | null, couponScopeCategories?: Array<{ __typename?: 'CategoryType', id: string, pk: number, name: string, integrationId: string } | null> | null, multiplegiftbackconfigSet: Array<{ __typename?: 'MultipleGiftbackConfigType', id: string, value: number, valueType: MultipleGiftbackConfigValueType, minPurchaseValueForCreate: number, minimumValueType: MultipleGiftbackConfigMinimumValueType, maximumDiscountPercentage: number, discountLimitEnabled: boolean, discountLimit: number, minPurchaseValueForRedeem: number, pk: number, tags?: Array<{ __typename?: 'CustomerTagsType', id: string, name: string } | null> | null }> } | null };

export type GetWhatsappIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhatsappIntegrationQuery = { __typename?: 'Query', getWhatsappIntegration?: { __typename?: 'WhatsappConfigType', id: string, whatsappBusinessAccountId: string, whatsappAccessToken?: string | null, phoneNumberId?: string | null, activated: boolean, connected: boolean } | null };

export type GetEvolutionApiInstanceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEvolutionApiInstanceStatusQuery = { __typename?: 'Query', getEvolutionApiConnectionStatus?: { __typename?: 'GetEvolutionConnectionStatusReturnType', equalStatus?: boolean | null } | null };

export type GetRfmAutomationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRfmAutomationQuery = { __typename?: 'Query', getRfmAutomation?: { __typename?: 'RfmAutomationType', dailyRefreshEnabled: boolean, lastCompletedAt?: any | null } | null };

export type GetRfmFrequencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRfmFrequencyQuery = { __typename?: 'Query', getRfmFrequency?: { __typename?: 'FrequencyRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null };

export type GetRfmRecencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRfmRecencyQuery = { __typename?: 'Query', getRfmRecency?: { __typename?: 'RecencyRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null };

export type GetRfmValueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRfmValueQuery = { __typename?: 'Query', getRfmValue?: { __typename?: 'ValueRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null };

export type GetShopifyOauthUrlQueryVariables = Exact<{
  shop: Scalars['String']['input'];
}>;


export type GetShopifyOauthUrlQuery = { __typename?: 'Query', shopifyOauthUrl?: string | null };

export type GetStoreIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoreIntegrationsQuery = { __typename?: 'Query', infoIntegration?: { __typename?: 'StoreType', zekiMessage: StoreZekiMessage, traystoreintegration?: { __typename?: 'TrayStoreIntegrationType', integrationId: string, code: string, apiKey: string, connected: boolean } | null, whatsappconfig?: { __typename?: 'WhatsappConfigType', id: string, connected: boolean, activated: boolean, whatsappAccessToken?: string | null, whatsappPhoneNumber?: string | null, phoneNumberId?: string | null, whatsappBusinessAccountId: string } | null, omiestoreintegration?: { __typename?: 'OmieStoreIntegrationType', id: string, appKey: string, appSecret: string, connected: boolean, activated: boolean, nfce: boolean, nfe: boolean, nfse: boolean } | null, smsinfobipintegration?: { __typename?: 'SMSInfoBipIntegrationType', id: string, connected: boolean, activated: boolean } | null, blingstoreintegration?: { __typename?: 'BlingStoreIntegrationType', id: string, connected: boolean, activated: boolean } | null, webpicstoreintegration?: { __typename?: 'WebpicStoreIntegrationType', id: string, integrationToken: string, companyId: string, havePdv: boolean, haveInvoice: boolean, connected: boolean } | null, emailproviderstoreintegration?: { __typename?: 'EmailProviderStoreIntegrationType', emailToSend: string, provider: EmailProviderStoreIntegrationProvider, isActive: boolean } | null, hostgatorstoreintegration?: { __typename?: 'HostgatorStoreIntegrationType', id: string, storeUrl: string, storeIntegrationId: string, appKey: string, connected: boolean } | null, evolutionapiintegration?: { __typename?: 'EvolutionApiIntegrationType', id: string, apiKey?: string | null, instance?: string | null, phoneNumber: string, connected: boolean } | null, nuvemshopstoreintegration?: { __typename?: 'NuvemshopStoreIntegrationType', id: string, appName: string, appEmail: string, userId: string, accessToken: string, connected: boolean } | null, shopifystoreintegration?: { __typename?: 'ShopifyStoreIntegrationType', id: string, baseUrl: string, accessToken: string, activated: boolean } | null, zapiintegration?: { __typename?: 'ZApiIntegrationType', zApiId: string, zApiToken: string, token?: string | null, pk: number, connected: boolean } | null, lojaintegradastoreintegration?: { __typename?: 'LojaIntegradaStoreIntegrationType', id: string, connected: boolean, apiKey: string } | null, yampistoreintegration?: { __typename?: 'YampiStoreIntegrationType', id: string, connected: boolean, merchantAlias: string } | null, trinksstoreintegration?: { __typename?: 'TrinksStoreIntegrationType', id: string, integrationId: string, apiKey: string, activated: boolean, connected: boolean } | null } | null };

export type GetYampiAuthorizationUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYampiAuthorizationUrlQuery = { __typename?: 'Query', getYampiAuthorizationUrl?: { __typename?: 'YampiAuthorizationUrlType', url: string, codeVerifier: string, state: string } | null };

export type GetZapiIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetZapiIntegrationQuery = { __typename?: 'Query', getZApiIntegration?: { __typename?: 'ZApiIntegrationType', zApiId: string, zApiToken: string, token?: string | null, pk: number, connected: boolean } | null };

export type UpdateRfmAutomationMutationVariables = Exact<{
  dailyRefreshEnabled: Scalars['Boolean']['input'];
}>;


export type UpdateRfmAutomationMutation = { __typename?: 'Mutation', saveRfmAutomation?: { __typename?: 'SaveRFMAutomationMutation', dailyRefreshEnabled: boolean, lastCompletedAt?: any | null } | null };

export type SetTrinksStoreIntegrationMutationVariables = Exact<{
  input: SetTrinksStoreIntegrationInput;
}>;


export type SetTrinksStoreIntegrationMutation = { __typename?: 'Mutation', setTrinksStoreIntegration?: { __typename?: 'SetTrinksStoreIntegration', ok?: boolean | null, trinksIntegration?: { __typename?: 'TrinksStoreIntegrationType', id: string, integrationId: string, apiKey: string, activated: boolean, connected: boolean } | null } | null };

export type SetYampiStoreIntegrationMutationVariables = Exact<{
  input: SetYampiStoreIntegrationInput;
}>;


export type SetYampiStoreIntegrationMutation = { __typename?: 'Mutation', setYampiStoreIntegration?: { __typename?: 'SetYampiStoreIntegration', ok?: boolean | null, yampiIntegration?: { __typename?: 'YampiStoreIntegrationType', pk: number, connected: boolean, merchantAlias: string } | null } | null };

export type TestWhatsappConnectionRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type TestWhatsappConnectionRequestMutation = { __typename?: 'Mutation', testWhatsappConnection?: { __typename?: 'TestWhatsappConnectionMutation', ok?: boolean | null, message?: string | null, businessId?: string | null, businessName?: string | null, currency?: string | null } | null };

export type BlingIntegrationMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlingIntegrationMutation = { __typename?: 'Mutation', setBlingStoreIntegration?: { __typename?: 'SetBlingStoreIntegration', ok?: boolean | null, blingIntegration?: { __typename?: 'BlingStoreIntegrationType', pk: number } | null } | null };

export type SaveEvolutionApiConfigMutationVariables = Exact<{
  input: EvolutionApiIntegrationInput;
}>;


export type SaveEvolutionApiConfigMutation = { __typename?: 'Mutation', saveEvolutionApiIntegration?: { __typename?: 'SaveEvolutionApiIntegrationMutation', ok?: boolean | null, isCreated?: boolean | null } | null };

export type UpdateGiftbackConfigMutationVariables = Exact<{
  input?: InputMaybe<GiftbackConfigInput>;
}>;


export type UpdateGiftbackConfigMutation = { __typename?: 'Mutation', saveGiftbackConfig?: { __typename?: 'SaveGiftbackConfigMutation', giftback?: { __typename?: 'GiftbackConfigType', id: string, dueDate: number, cumulative?: boolean | null, couponProductScope: GiftbackConfigCouponProductScope, couponScopeMode: GiftbackConfigCouponScopeMode, pk: number, couponScopeProducts?: Array<{ __typename?: 'ProductType', id: string, pk: number, name: string, integrationId?: string | null } | null> | null, couponScopeCategories?: Array<{ __typename?: 'CategoryType', id: string, pk: number, name: string, integrationId: string } | null> | null, multiplegiftbackconfigSet: Array<{ __typename?: 'MultipleGiftbackConfigType', value: number, valueType: MultipleGiftbackConfigValueType, minPurchaseValueForCreate: number, minimumValueType: MultipleGiftbackConfigMinimumValueType, maximumDiscountPercentage: number, discountLimitEnabled: boolean, discountLimit: number, minPurchaseValueForRedeem: number, pk: number, tags?: Array<{ __typename?: 'CustomerTagsType', id: string, name: string } | null> | null }> } | null } | null };

export type SaveHostgatorConfigMutationVariables = Exact<{
  input: SaveHostgatorStoreIntegrationInput;
}>;


export type SaveHostgatorConfigMutation = { __typename?: 'Mutation', saveHostgatorStoreIntegration?: { __typename?: 'SaveHostgatorStoreIntegrationMutation', ok?: boolean | null } | null };

export type UpdateLojaIntegradaConfigMutationVariables = Exact<{
  input: SaveLojaIntegradaStoreIntegrationInput;
}>;


export type UpdateLojaIntegradaConfigMutation = { __typename?: 'Mutation', saveLojaIntegradaStoreIntegration?: { __typename?: 'SaveLojaIntegradaStoreIntegrationMutation', ok?: boolean | null } | null };

export type UpdateNuvemshopStoreIntegrationMutationMutationVariables = Exact<{
  input: SaveNuvemshopStoreIntegrationInput;
}>;


export type UpdateNuvemshopStoreIntegrationMutationMutation = { __typename?: 'Mutation', saveNuvemshopStoreIntegration?: { __typename?: 'SaveNuvemShopStoreIntegrationMutation', ok?: boolean | null } | null };

export type NuvemshopAuthenticationMutationVariables = Exact<{
  input: NuvemshopAuthenticationRequestInput;
}>;


export type NuvemshopAuthenticationMutation = { __typename?: 'Mutation', nuvemshopAuthenticationRequest?: { __typename?: 'NuvemshopAuthenticationRequest', ok?: boolean | null } | null };

export type OmieIntegrationMutationVariables = Exact<{
  input: SetOmieStoreIntegrationInput;
}>;


export type OmieIntegrationMutation = { __typename?: 'Mutation', setOmieStoreIntegration?: { __typename?: 'SetOmieStoreIntegration', ok?: boolean | null, omieIntegration?: { __typename?: 'OmieStoreIntegrationType', appKey: string, appSecret: string, connected: boolean, activated: boolean, nfce: boolean, nfe: boolean, nfse: boolean } | null } | null };

export type SetShopifyIntegrationMutationVariables = Exact<{
  input: SetShopifyStoreIntegrationInput;
}>;


export type SetShopifyIntegrationMutation = { __typename?: 'Mutation', setShopifyStoreIntegration?: { __typename?: 'SetShopifyStoreIntegration', ok?: boolean | null, shopifyIntegration?: { __typename?: 'ShopifyStoreIntegrationType', pk: number, baseUrl: string, accessToken: string, connected: boolean, activated: boolean } | null } | null };

export type SmsInfobipIntegrationMutationVariables = Exact<{
  input: SetSmsInfoBipIntegrationInput;
}>;


export type SmsInfobipIntegrationMutation = { __typename?: 'Mutation', setSmsInfoBipIntegration?: { __typename?: 'SetSMSInfoBipIntegration', ok?: boolean | null, smsInfoBipIntegration?: { __typename?: 'SMSInfoBipIntegrationType', id: string, connected: boolean, activated: boolean, store: { __typename?: 'StoreType', name: string } } | null } | null };

export type CreateTrayStoreIntegrationMutationVariables = Exact<{
  trayInput: CreateTrayStoreIntegrationInput;
}>;


export type CreateTrayStoreIntegrationMutation = { __typename?: 'Mutation', createTrayStoreIntegration?: { __typename?: 'CreateTrayStoreIntegration', success?: boolean | null, error?: string | null } | null };

export type CreateWebPicIntegrationMutationVariables = Exact<{
  input: SaveWebpicStoreIntegrationInput;
}>;


export type CreateWebPicIntegrationMutation = { __typename?: 'Mutation', saveWebpicStoreIntegration?: { __typename?: 'SaveWebpicStoreIntegrationMutation', ok?: boolean | null } | null };

export type SaveWhatsappIntegrationMutationVariables = Exact<{
  input?: InputMaybe<WhatsappConfigInput>;
}>;


export type SaveWhatsappIntegrationMutation = { __typename?: 'Mutation', saveWhatsapp?: { __typename?: 'SaveWhatsappConfigMutation', ok?: boolean | null, whatsappIntegration?: { __typename?: 'WhatsappConfigType', id: string, whatsappAccessToken?: string | null, phoneNumberId?: string | null, whatsappBusinessAccountId: string, connected: boolean, activated: boolean, pk: number } | null } | null };

export type SetEmailProviderMutationVariables = Exact<{
  input?: InputMaybe<EmailProviderStoreIntegrationInput>;
}>;


export type SetEmailProviderMutation = { __typename?: 'Mutation', saveEmailProvider?: { __typename?: 'SaveEmailProviderStoreIntegrationMutation', ok?: boolean | null, emailProvider?: { __typename?: 'EmailProviderStoreIntegrationType', emailToSend: string, provider: EmailProviderStoreIntegrationProvider, isActive: boolean } | null } | null };

export type UpdateRfmConfigMutationVariables = Exact<{
  recency: RecencyRfmInput;
  frequency: FrequencyRfmInput;
  value: ValueRfmInput;
}>;


export type UpdateRfmConfigMutation = { __typename?: 'Mutation', saveRfmConfig?: { __typename?: 'SaveRFMMutation', recency?: { __typename?: 'RecencyRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null, frequency?: { __typename?: 'FrequencyRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null, value?: { __typename?: 'ValueRFMType', id: string, zoneOneMin: number, zoneOneMax: number, zoneTwoMin: number, zoneTwoMax: number, zoneThreeMin: number, zoneThreeMax: number, zoneFourMin: number, zoneFourMax: number, zoneFiveMin: number, zoneFiveMax: number } | null } | null };

export type SaveZapiIntegrationMutationVariables = Exact<{
  input: ZApiIntegrationInput;
}>;


export type SaveZapiIntegrationMutation = { __typename?: 'Mutation', saveZApi?: { __typename?: 'SaveZApiIntegrationMutation', ok?: boolean | null, zApiIntegration?: { __typename?: 'ZApiIntegrationType', zApiId: string, zApiToken: string, token?: string | null, connected: boolean, pk: number } | null } | null };

export type CouponCreateMutationVariables = Exact<{
  couponInput: CouponInput;
}>;


export type CouponCreateMutation = { __typename?: 'Mutation', couponCreate?: { __typename?: 'CreateCouponMutation', success?: boolean | null, error?: string | null, coupon?: { __typename?: 'CouponType', id: string, pk: number, code: string, description: string, value: number, valueType: CouponValueType, startsAt?: any | null, expiresAt?: any | null, usageLimit?: number | null, isCumulative: boolean, isFreeShipping: boolean, integrationId: string } | null } | null };

export type CouponDeleteMutationVariables = Exact<{
  couponInput: DeleteCouponInput;
}>;


export type CouponDeleteMutation = { __typename?: 'Mutation', couponDelete?: { __typename?: 'DeleteCouponMutation', success?: boolean | null, error?: string | null } | null };

export type GetCouponQueryVariables = Exact<{
  couponId: Scalars['ID']['input'];
}>;


export type GetCouponQuery = { __typename?: 'Query', coupon?: { __typename?: 'CouponRelayType', id: string, pk: number, code: string, description: string, value: number, valueType: CouponValueType, startsAt?: any | null, expiresAt?: any | null, usageLimit?: number | null, isCumulative: boolean, isFreeShipping: boolean, importedFrom: CouponImportedFrom, integrationId: string, eligibleProducts: { __typename?: 'ProductRelayTypeConnection', edges: Array<{ __typename?: 'ProductRelayTypeEdge', node?: { __typename?: 'ProductRelayType', id: string, pk: number, name: string } | null } | null> }, eligibleCategories: { __typename?: 'CategoryRelayTypeConnection', edges: Array<{ __typename?: 'CategoryRelayTypeEdge', node?: { __typename?: 'CategoryRelayType', id: string, pk: number, name: string } | null } | null> } } | null };

export type ListCouponsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  code_Icontains?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  isCumulative?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListCouponsQuery = { __typename?: 'Query', couponList?: { __typename?: 'CouponRelayTypeConnection', edgeCount?: number | null, totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CouponRelayTypeEdge', node?: { __typename?: 'CouponRelayType', id: string, pk: number, code: string, description: string, value: number, valueType: CouponValueType, startsAt?: any | null, expiresAt?: any | null, usageLimit?: number | null, isCumulative: boolean, isFreeShipping: boolean, importedFrom: CouponImportedFrom, integrationId: string, createdAt: any } | null } | null> } | null };

export type CouponUpdateMutationVariables = Exact<{
  couponInput: UpdateCouponInput;
}>;


export type CouponUpdateMutation = { __typename?: 'Mutation', couponUpdate?: { __typename?: 'UpdateCouponMutation', success?: boolean | null, error?: string | null, coupon?: { __typename?: 'CouponType', id: string, pk: number, code: string, description: string, value: number, valueType: CouponValueType, startsAt?: any | null, expiresAt?: any | null, usageLimit?: number | null, isCumulative: boolean, isFreeShipping: boolean } | null } | null };

export type CustomerAcquisitionChannelsQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CustomerAcquisitionChannelsQuery = { __typename?: 'Query', customerAcquisitionChannels?: { __typename?: 'CustomerAcquisitionChannelRelayTypeConnection', edges: Array<{ __typename?: 'CustomerAcquisitionChannelRelayTypeEdge', node?: { __typename?: 'CustomerAcquisitionChannelRelayType', id: string, pk: number, name: string, isActive: boolean, position: number } | null } | null> } | null };

export type SaveCustomerAcquisitionChannelMutationVariables = Exact<{
  input: SaveCustomerAcquisitionChannelInput;
}>;


export type SaveCustomerAcquisitionChannelMutation = { __typename?: 'Mutation', saveCustomerAcquisitionChannel?: { __typename?: 'SaveCustomerAcquisitionChannel', channel?: { __typename?: 'CustomerAcquisitionChannelType', id: string, pk: number, name: string, isActive: boolean, position: number } | null } | null };

export type ReorderCustomerAcquisitionChannelsMutationVariables = Exact<{
  input: ReorderCustomerAcquisitionChannelsInput;
}>;


export type ReorderCustomerAcquisitionChannelsMutation = { __typename?: 'Mutation', reorderCustomerAcquisitionChannels?: { __typename?: 'ReorderCustomerAcquisitionChannels', ok?: boolean | null } | null };

export type CreateCustomerAudienceSelectionMutationVariables = Exact<{
  input: CustomerFilterSetInput;
  purchaseInput?: InputMaybe<PurchaseProductFilterSetInput>;
  salesInput?: InputMaybe<PurchaseFilterSetInput>;
  giftbackInput?: InputMaybe<GiftbackFilterSetInput>;
  first: Scalars['Int']['input'];
}>;


export type CreateCustomerAudienceSelectionMutation = { __typename?: 'Mutation', createCustomerAudienceSelection?: { __typename?: 'RetentionAudienceSelectionReturn', selectionId: string, total: number, expiresAt: any } | null };

export type CampaignAudienceCustomersQueryVariables = Exact<{
  selectionId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignAudienceCustomersQuery = { __typename?: 'Query', customerAudienceSelection?: { __typename?: 'RetentionAudienceSelectionReturn', selectionId: string, total: number, expiresAt: any, customers: Array<{ __typename?: 'RetentionCohortCustomerReturn', id: string, name: string, email?: string | null, phone?: string | null, rfmClassification?: string | null, purchaseCount: number, purchaseValue: number }>, pageInfo: { __typename?: 'RetentionPageInfoReturn', hasNextPage: boolean, nextCursor?: string | null } } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'CreateCustomer', customer?: { __typename?: 'CustomerType', id: string, name?: string | null, taxDocument?: string | null, acquisitionChannel?: { __typename?: 'CustomerAcquisitionChannelRelayType', pk: number, name: string } | null } | null } | null };

export type CustomerCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCustomFieldsQuery = { __typename?: 'Query', customerCustomFields: Array<{ __typename?: 'CustomerCustomFieldType', id: string, pk: number, key: string, label: string, fieldType: string, isActive: boolean, metadataPath: Array<any> }> };

export type CustomerMetadataSampleCustomersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerMetadataSampleCustomersQuery = { __typename?: 'Query', allCustomersRelay?: { __typename?: 'CustomerTypeRelayConnection', edges: Array<{ __typename?: 'CustomerTypeRelayEdge', node?: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null, email?: string | null } | null } | null> } | null };

export type CustomerMetadataSampleQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type CustomerMetadataSampleQuery = { __typename?: 'Query', customerMetadataSample?: { __typename?: 'CustomerMetadataSampleType', customerId: string, truncated: boolean, unsupportedCount: number, fields: Array<{ __typename?: 'CustomerMetadataOptionType', path: Array<any>, preview: string, previewTruncated: boolean, suggestedType: string }> } | null };

export type SaveCustomerCustomFieldMutationVariables = Exact<{
  input: SaveCustomerCustomFieldInput;
}>;


export type SaveCustomerCustomFieldMutation = { __typename?: 'Mutation', saveCustomerCustomField?: { __typename?: 'SaveCustomerCustomField', field?: { __typename?: 'CustomerCustomFieldType', id: string, pk: number, key: string, label: string, fieldType: string, isActive: boolean, metadataPath: Array<any> } | null } | null };

export type DeleteCustomerCustomFieldMutationVariables = Exact<{
  fieldId: Scalars['ID']['input'];
}>;


export type DeleteCustomerCustomFieldMutation = { __typename?: 'Mutation', deleteCustomerCustomField?: { __typename?: 'DeleteCustomerCustomField', success: boolean } | null };

export type PrepareCustomerAudienceMutationVariables = Exact<{
  input: CustomerFilterSetInput;
  purchaseInput?: InputMaybe<PurchaseProductFilterSetInput>;
  salesInput?: InputMaybe<PurchaseFilterSetInput>;
  giftbackInput?: InputMaybe<GiftbackFilterSetInput>;
  filterContext?: InputMaybe<CustomerAudienceFilterContext>;
  first: Scalars['Int']['input'];
}>;


export type PrepareCustomerAudienceMutation = { __typename?: 'Mutation', createCustomerAudienceSelection?: { __typename?: 'RetentionAudienceSelectionReturn', selectionId: string, total: number, expiresAt: any, customers: Array<{ __typename?: 'RetentionCohortCustomerReturn', id: string, name: string, email?: string | null, phone?: string | null, rfmClassification?: string | null, purchaseCount: number, purchaseValue: number }>, pageInfo: { __typename?: 'RetentionPageInfoReturn', hasNextPage: boolean, nextCursor?: string | null } } | null };

export type CustomerCustomFieldValueOptionsQueryVariables = Exact<{
  fieldId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerCustomFieldValueOptionsQuery = { __typename?: 'Query', customerCustomFieldValueOptions?: { __typename?: 'CustomerCustomFieldOptionsType', values: Array<string>, hasMore: boolean } | null };

export type CustomerExcelReportQueryVariables = Exact<{
  input?: InputMaybe<CustomerExcelReportInput>;
}>;


export type CustomerExcelReportQuery = { __typename?: 'Query', customerExcelReport?: { __typename?: 'CustomerExcelReportType', relatorio?: string | null } | null };

export type GetAllStateCitiesQueryVariables = Exact<{
  uf: Scalars['String']['input'];
}>;


export type GetAllStateCitiesQuery = { __typename?: 'Query', allStateCities?: Array<{ __typename?: 'CityType', id?: number | null, nome?: string | null } | null> | null };

export type GetCustomerDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerDetailsQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'CustomerType', id: string, name?: string | null, email?: string | null, phone?: string | null, taxDocument?: string | null, importedFrom: CustomerImportedFrom, gender?: CustomerGender | null, state?: string | null, city?: string | null, address?: string | null, rfmClassification?: string | null, averageTicket: number, integrationId?: string | null, dateOfBirth?: any | null, isActive: boolean, notes?: string | null, customFields: Array<{ __typename?: 'CustomerCustomFieldValueType', status: string, value?: any | null, field: { __typename?: 'CustomerCustomFieldType', id: string, label: string, fieldType: string } }>, acquisitionChannel?: { __typename?: 'CustomerAcquisitionChannelRelayType', pk: number, name: string, isActive: boolean } | null, tags: { __typename?: 'CustomerTagsRelayTypeConnection', edges: Array<{ __typename?: 'CustomerTagsRelayTypeEdge', node?: { __typename?: 'CustomerTagsRelayType', name: string, pk: number } | null } | null> }, giftbackSet: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'GiftbackRelayTypeEdge', node?: { __typename?: 'GiftbackRelayType', value: number, dueDate: any, code: string, pk: number, importedFrom: GiftbackImportedFrom } | null } | null> } } | null };

export type GetAllCustomerGiftbackStatusCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCustomerGiftbackStatusCountQuery = { __typename?: 'Query', giftbackAll?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null, giftbackActive?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null, giftbackExpired?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null, giftbackRedeemed?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null, giftbackCancelled?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null, giftbackOverdue?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null };

export type ListCustomerGiftbacksQueryVariables = Exact<{
  customer?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListCustomerGiftbacksQuery = { __typename?: 'Query', allGiftbacksRelay?: { __typename?: 'GiftbackRelayTypeConnection', edges: Array<{ __typename?: 'GiftbackRelayTypeEdge', node?: { __typename?: 'GiftbackRelayType', pk: number, code: string, value: number, dueDate: any, status: GiftbackStatus, createdAt: any, updatedAt: any, customeractivitySet: { __typename?: 'CustomerActivitiesTypeRelayConnection', edges: Array<{ __typename?: 'CustomerActivitiesTypeRelayEdge', node?: { __typename?: 'CustomerActivitiesTypeRelay', activity?: CustomerActivityActivity | null, title?: string | null, description: string, pk: number, createdAt: any, updatedAt: any } | null } | null> } } | null } | null> } | null };

export type ListCustomerActivitiesQueryVariables = Exact<{
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListCustomerActivitiesQuery = { __typename?: 'Query', allCustomerActivitiesRelay?: { __typename?: 'CustomerActivitiesTypeRelayConnection', edges: Array<{ __typename?: 'CustomerActivitiesTypeRelayEdge', node?: { __typename?: 'CustomerActivitiesTypeRelay', activity?: CustomerActivityActivity | null, pk: number, title?: string | null, description: string, updatedAt: any, messageStatus?: string | null, user?: { __typename?: 'CustomUserNode', pk?: number | null, email: string } | null, giftback?: { __typename?: 'GiftbackRelayType', value: number, dueDate: any, pk: number, status: GiftbackStatus, createdAt: any, updatedAt: any, customeractivitySet: { __typename?: 'CustomerActivitiesTypeRelayConnection', edges: Array<{ __typename?: 'CustomerActivitiesTypeRelayEdge', node?: { __typename?: 'CustomerActivitiesTypeRelay', title?: string | null, description: string, createdAt: any } | null } | null> } } | null, purchase?: { __typename?: 'PurchaseRelayType', pk: number, value: number, date?: any | null, status: string, canceledBy?: string | null, canceledAt?: any | null, createdAt: any, updatedAt: any } | null, appointment?: { __typename?: 'AppointmentType', pk: number, publicId: any, serviceName: string, startsAt: any, status: AppointmentStatus, professional: { __typename?: 'ProfessionalType', publicName: string } } | null } | null } | null> } | null };

export type ListCustomerCampaignQueryVariables = Exact<{
  customFields?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ListCustomerCampaignQuery = { __typename?: 'Query', allCustomersRelay?: { __typename?: 'CustomerTypeRelayConnection', edges: Array<{ __typename?: 'CustomerTypeRelayEdge', node?: { __typename?: 'CustomerTypeRelay', pk: number } | null } | null> } | null };

export type ListCustomerQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  rfmClassification_In?: InputMaybe<Scalars['String']['input']>;
  purchase_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  giftback_Status?: InputMaybe<Scalars['String']['input']>;
  giftback_Active?: InputMaybe<Scalars['String']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  containsTag?: InputMaybe<Scalars['String']['input']>;
  doesNotContainTag?: InputMaybe<Scalars['String']['input']>;
  productsBought?: InputMaybe<Scalars['String']['input']>;
  productsNotBought?: InputMaybe<Scalars['String']['input']>;
  byCategory?: InputMaybe<Scalars['String']['input']>;
  byCategoryExclude?: InputMaybe<Scalars['String']['input']>;
  gender_In?: InputMaybe<Scalars['String']['input']>;
  notes_Icontains?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  totalPurchasesCount_Lte?: InputMaybe<Scalars['Int']['input']>;
  totalPurchasesCount_Gte?: InputMaybe<Scalars['Int']['input']>;
  birthdatesByMonthAndDate?: InputMaybe<Scalars['String']['input']>;
  daysWithoutPurchaseMin?: InputMaybe<Scalars['Float']['input']>;
  daysWithoutPurchaseMax?: InputMaybe<Scalars['Float']['input']>;
  havePhone?: InputMaybe<Scalars['String']['input']>;
  haveEmail?: InputMaybe<Scalars['String']['input']>;
  hasWhatsapp?: InputMaybe<Scalars['String']['input']>;
  includedInCampaign?: InputMaybe<Scalars['String']['input']>;
  notIncludedInCampaign?: InputMaybe<Scalars['String']['input']>;
  totalMonetaryValue_Gte?: InputMaybe<Scalars['Float']['input']>;
  totalMonetaryValue_Lte?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  purchase_Coupon_Code?: InputMaybe<Scalars['String']['input']>;
  acquisitionChannelId?: InputMaybe<Scalars['Float']['input']>;
  acquisitionChannelUninformed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListCustomerQuery = { __typename?: 'Query', allCustomersRelay?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null, edgeCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CustomerTypeRelayEdge', node?: { __typename?: 'CustomerTypeRelay', pk: number, rfmClassification?: string | null, name?: string | null, email?: string | null, phone?: string | null, totalPurchasesCount: number, averageTicket: number, giftbackSet: { __typename?: 'GiftbackRelayTypeConnection', edges: Array<{ __typename?: 'GiftbackRelayTypeEdge', node?: { __typename?: 'GiftbackRelayType', pk: number, status: GiftbackStatus } | null } | null> }, acquisitionChannel?: { __typename?: 'CustomerAcquisitionChannelRelayType', pk: number, name: string } | null } | null } | null> } | null };

export type GetAllProductsForCustomerFiltersQueryVariables = Exact<{
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllProductsForCustomerFiltersQuery = { __typename?: 'Query', allProductsRelay?: { __typename?: 'ProductRelayTypeConnection', edges: Array<{ __typename?: 'ProductRelayTypeEdge', node?: { __typename?: 'ProductRelayType', pk: number, name: string, value: number, stock?: number | null } | null } | null> } | null };

export type SalesAudienceCountQueryVariables = Exact<{
  abcCurveBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveNotBought?: InputMaybe<Scalars['String']['input']>;
  abcCurveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  abcCurveScope?: InputMaybe<Scalars['String']['input']>;
  salesProductsBought?: InputMaybe<Scalars['String']['input']>;
  salesProductsNotBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesBought?: InputMaybe<Scalars['String']['input']>;
  salesCategoriesNotBought?: InputMaybe<Scalars['String']['input']>;
  salesPurchaseDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  salesPurchaseDate_Lte?: InputMaybe<Scalars['Date']['input']>;
}>;


export type SalesAudienceCountQuery = { __typename?: 'Query', allCustomersRelay?: { __typename?: 'CustomerTypeRelayConnection', totalCount?: number | null } | null };

export type SetActiveCustomerMutationVariables = Exact<{
  input: SetActiveCustomerInput;
}>;


export type SetActiveCustomerMutation = { __typename?: 'Mutation', setActiveCustomer?: { __typename?: 'SetActiveCustomer', ok?: boolean | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'UpdateCustomer', customer?: { __typename?: 'CustomerType', id: string, name?: string | null, email?: string | null, phone?: string | null, taxDocument?: string | null, gender?: CustomerGender | null, state?: string | null, city?: string | null, address?: string | null, dateOfBirth?: any | null, acquisitionChannel?: { __typename?: 'CustomerAcquisitionChannelRelayType', pk: number, name: string, isActive: boolean } | null } | null } | null };

export type CreateCustomerNewTagsMutationVariables = Exact<{
  tagInput: CreateCustomerTagsInput;
}>;


export type CreateCustomerNewTagsMutation = { __typename?: 'Mutation', tagsCreate?: { __typename?: 'CreateCustomerTagsMutation', ok?: boolean | null } | null };

export type GetAllCustomerTagsQueryVariables = Exact<{
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllCustomerTagsQuery = { __typename?: 'Query', customerTagsList?: { __typename?: 'CustomerTagsRelayTypeConnection', edges: Array<{ __typename?: 'CustomerTagsRelayTypeEdge', node?: { __typename?: 'CustomerTagsRelayType', name: string, pk: number } | null } | null> } | null };

export type AddTagsToRetentionAudienceMutationVariables = Exact<{
  selectionId: Scalars['ID']['input'];
  tagIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type AddTagsToRetentionAudienceMutation = { __typename?: 'Mutation', addTagsToAudienceSelection?: { __typename?: 'AddTagsToAudienceSelection', updatedCount: number } | null };

export type CreateRetentionAudienceSelectionMutationVariables = Exact<{
  input: RetentionCohortInput;
  cohortStart: Scalars['Date']['input'];
  offset: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
}>;


export type CreateRetentionAudienceSelectionMutation = { __typename?: 'Mutation', createRetentionAudienceSelection?: { __typename?: 'RetentionAudienceSelectionReturn', selectionId: string, total: number, totalRevenue?: number | null, expiresAt: any, customers: Array<{ __typename?: 'RetentionCohortCustomerReturn', id: string, name: string, phone?: string | null, rfmClassification?: string | null, purchaseCount: number, purchaseValue: number }>, pageInfo: { __typename?: 'RetentionPageInfoReturn', hasNextPage: boolean, nextCursor?: string | null } } | null };

export type DashboardAgeRangeQueriesQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type DashboardAgeRangeQueriesQuery = { __typename?: 'Query', dashboardAgeColumnChartValues?: { __typename?: 'AgeColumnChartReturn', categories?: Array<string | null> | null, series?: Array<{ __typename?: 'AgeColumnChartSeries', name?: string | null, data?: Array<number | null> | null } | null> | null } | null };

export type DashboardCustomerGenderDataQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type DashboardCustomerGenderDataQuery = { __typename?: 'Query', dashboardGenderPieChartValues?: { __typename?: 'GenderPieChartReturn', total?: number | null, labels?: Array<string | null> | null, series?: Array<number | null> | null } | null };

export type DashboardCustomerQueriesQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type DashboardCustomerQueriesQuery = { __typename?: 'Query', cardsData?: { __typename?: 'CustomerDashboardCardsReturn', totalCustomers?: number | null, averageValuePerCustomer?: number | null, averagePurchaseCountPerCustomer?: number | null } | null, homepageCardsValues?: { __typename?: 'HomePageCards', totalUniqueCustomers?: number | null, totalRecurrentCustomers?: number | null } | null };

export type DashboardCustomerTagsQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type DashboardCustomerTagsQuery = { __typename?: 'Query', dashboardCustomerTagsValues?: { __typename?: 'CustomerTagsDonutChartReturn', series?: Array<number | null> | null, labels?: Array<string | null> | null } | null };

export type DashboardCustomersByCityChartsQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type DashboardCustomersByCityChartsQuery = { __typename?: 'Query', dashboardCustomersByCity?: { __typename?: 'DashboardCustomersByCityResponse', total?: number | null, categories?: Array<string | null> | null, series?: Array<number | null> | null } | null };

export type DashboardCustomersByUfChartsQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type DashboardCustomersByUfChartsQuery = { __typename?: 'Query', dashboardUfBarChartValues?: { __typename?: 'UfBarChartReturn', total?: number | null, categories?: Array<string | null> | null, series?: Array<number | null> | null } | null };

export type DashboardGiftbackQueriesQueryVariables = Exact<{
  input?: InputMaybe<GiftbackFilterSetInput>;
}>;


export type DashboardGiftbackQueriesQuery = { __typename?: 'Query', cardsData?: { __typename?: 'GiftbackCardsValues', activeGiftbacks?: number | null, redeemedGiftbacks?: number | null, expiredGiftbacks?: number | null, giftbackGains?: number | null, cancelledGiftbacks?: number | null, overdueGiftbacks?: number | null } | null, averageTicketData?: { __typename?: 'GiftbackAverageTickets', activeGiftbackAverageTicket?: number | null, redeemedGiftbackAverageTicket?: number | null, expiredGiftbackAverageTicket?: number | null, cancelledGiftbackAverageTicket?: number | null, overdueGiftbackAverageTicket?: number | null } | null, radialChartData?: { __typename?: 'GiftbackRadialBarCharReturn', series?: Array<number | null> | null, labels?: Array<string | null> | null, total?: number | null } | null, areaChartData?: { __typename?: 'GiftbackAreaChartReturn', kindOfDate?: string | null, categories?: Array<string | null> | null, series?: Array<{ __typename?: 'GiftbackAreaChartSeries', name?: string | null, data?: Array<{ __typename?: 'GiftbackAreaChartSeriesData', value?: number | null, date?: string | null } | null> | null } | null> | null } | null };

export type DashboardGiftbackResumeQueryVariables = Exact<{
  input?: InputMaybe<GiftbackFilterSetInput>;
}>;


export type DashboardGiftbackResumeQuery = { __typename?: 'Query', dashboardGiftbacksRadialBarChartValues?: { __typename?: 'GiftbackRadialBarCharReturn', series?: Array<number | null> | null, labels?: Array<string | null> | null, total?: number | null } | null };

export type DashboardSalesAbcOverviewQueryVariables = Exact<{
  input?: InputMaybe<PurchaseProductFilterSetInput>;
}>;


export type DashboardSalesAbcOverviewQuery = { __typename?: 'Query', abcData?: { __typename?: 'ProductListTableType', total?: number | null, totalProducts?: number | null, aThreshold?: number | null, bThreshold?: number | null, summary?: Array<{ __typename?: 'SalesAbcSummary', title?: string | null, count?: number | null, totalValue?: number | null, percentage?: number | null } | null> | null } | null };

export type DashboardSalesAbcProductsQueryVariables = Exact<{
  input?: InputMaybe<PurchaseProductFilterSetInput>;
  classification?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardSalesAbcProductsQuery = { __typename?: 'Query', abcData?: { __typename?: 'ProductListTableType', filteredProductsCount?: number | null, page?: number | null, pageSize?: number | null, productsList?: Array<{ __typename?: 'ProductListItemsType', productName?: string | null, productTotalValue?: number | null, productIndividualPercentage?: number | null, productAccumulatedPercentage?: number | null, productAbcClassification?: string | null, productPk?: string | null, productRank?: number | null } | null> | null } | null };

export type DashboardSalesProductKpisQueryVariables = Exact<{
  input?: InputMaybe<PurchaseProductFilterSetInput>;
  metric?: InputMaybe<SalesProductKpiMetric>;
}>;


export type DashboardSalesProductKpisQuery = { __typename?: 'Query', productKpis?: { __typename?: 'SalesProductKpisType', topProducts: Array<{ __typename?: 'SalesProductKpiItemType', id: string, name: string, quantity: number, ordersCount: number, totalRevenue: any, unit?: string | null }>, firstPurchaseProducts: Array<{ __typename?: 'SalesProductKpiItemType', id: string, name: string, quantity: number, ordersCount: number, totalRevenue: any, unit?: string | null }>, secondPurchaseProducts: Array<{ __typename?: 'SalesProductKpiItemType', id: string, name: string, quantity: number, ordersCount: number, totalRevenue: any, unit?: string | null }>, topCategories: Array<{ __typename?: 'SalesProductKpiItemType', id: string, name: string, quantity: number, ordersCount: number, totalRevenue: any, unit?: string | null }>, firstPurchaseCategories: Array<{ __typename?: 'SalesProductKpiItemType', id: string, name: string, quantity: number, ordersCount: number, totalRevenue: any, unit?: string | null }>, secondPurchaseCategories: Array<{ __typename?: 'SalesProductKpiItemType', id: string, name: string, quantity: number, ordersCount: number, totalRevenue: any, unit?: string | null }> } | null };

export type DashboardSalesProductTrendsQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  mode?: InputMaybe<SalesProductTrendMode>;
  periodStart?: InputMaybe<Scalars['Date']['input']>;
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardSalesProductTrendsQuery = { __typename?: 'Query', productTrends?: { __typename?: 'SalesProductTrendsType', baseOrdersCount: number, analyzedOrdersCount: number, items: Array<{ __typename?: 'SalesProductTrendItem', productId: string, name: string, integrationId?: string | null, ordersCount: number, ordersPercentage: number, totalRevenue: number, lastPurchaseDate: any }> } | null };

export type DashboardSalesQueriesQueryVariables = Exact<{
  input?: InputMaybe<PurchaseFilterSetInput>;
}>;


export type DashboardSalesQueriesQuery = { __typename?: 'Query', cardsData?: { __typename?: 'PurchaseCardsValues', purchasesCount?: number | null, totalValue?: number | null, purchaseAverageTicket?: number | null } | null, periodData?: { __typename?: 'PurchaseColumnChartReturn', kindOfDate?: string | null, labels?: Array<string | null> | null, series?: Array<{ __typename?: 'PurchaseColumnChartSeries', name?: string | null, type?: string | null, data?: Array<number | null> | null } | null> | null } | null };

export type PurchaseProgressionValuesQueryVariables = Exact<{
  input: PurchaseProgressionInput;
}>;


export type PurchaseProgressionValuesQuery = { __typename?: 'Query', dashboardPurchaseProgressionValues?: { __typename?: 'PurchaseProgressionReturn', rows: Array<{ __typename?: 'PurchaseProgressionRowReturn', purchaseNumber: number, customerCount: number, averageTicket?: number | null, medianDaysToNextPurchase?: number | null, nextPurchaseCount: number, pendingNextPurchaseCount: number }> } | null };

export type CreatePurchaseProgressionAudienceSelectionMutationVariables = Exact<{
  input: PurchaseProgressionInput;
  purchaseNumber: Scalars['Int']['input'];
  pendingOnly: Scalars['Boolean']['input'];
  first: Scalars['Int']['input'];
}>;


export type CreatePurchaseProgressionAudienceSelectionMutation = { __typename?: 'Mutation', createPurchaseProgressionAudienceSelection?: { __typename?: 'RetentionAudienceSelectionReturn', selectionId: string, total: number, totalRevenue?: number | null, expiresAt: any, customers: Array<{ __typename?: 'RetentionCohortCustomerReturn', id: string, name: string, phone?: string | null, rfmClassification?: string | null, purchaseCount: number, purchaseValue: number }>, pageInfo: { __typename?: 'RetentionPageInfoReturn', hasNextPage: boolean, nextCursor?: string | null } } | null };

export type RetentionAudienceCustomersQueryVariables = Exact<{
  selectionId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RetentionAudienceCustomersQuery = { __typename?: 'Query', dashboardRetentionAudienceCustomers?: { __typename?: 'RetentionAudienceSelectionReturn', selectionId: string, total: number, expiresAt: any, customers: Array<{ __typename?: 'RetentionCohortCustomerReturn', id: string, name: string, email?: string | null, phone?: string | null, rfmClassification?: string | null, purchaseCount: number, purchaseValue: number }>, pageInfo: { __typename?: 'RetentionPageInfoReturn', hasNextPage: boolean, nextCursor?: string | null } } | null };

export type RetentionCohortValuesQueryVariables = Exact<{
  input: RetentionCohortInput;
}>;


export type RetentionCohortValuesQuery = { __typename?: 'Query', dashboardRetentionCohortValues?: { __typename?: 'RetentionCohortReturn', summary: { __typename?: 'RetentionCohortSummaryReturn', averageReturnRate: number, averageTimeToReturn: number, retainedRevenue: number, recurrentCustomers: number, nonReturningCustomers: number }, rows: Array<{ __typename?: 'RetentionCohortRowReturn', cohortStart: any, totalCustomers: number, totalRevenue: number, periods: Array<{ __typename?: 'RetentionCohortPeriodReturn', offset: number, customers: number, revenue: number }> }> } | null };

export type RetentionCohortCustomersQueryVariables = Exact<{
  input: RetentionCohortInput;
  cohortStart: Scalars['Date']['input'];
  offset: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RetentionCohortCustomersQuery = { __typename?: 'Query', dashboardRetentionCohortCustomers?: { __typename?: 'RetentionCohortCustomersReturn', total?: number | null, totalRevenue?: number | null, customers: Array<{ __typename?: 'RetentionCohortCustomerReturn', id: string, name: string, phone?: string | null, rfmClassification?: string | null, purchaseCount: number, purchaseValue: number }>, pageInfo: { __typename?: 'RetentionPageInfoReturn', hasNextPage: boolean, nextCursor?: string | null } } | null };

export type CalculateGiftbackValueQueryVariables = Exact<{
  purchaseValue: Scalars['Decimal']['input'];
}>;


export type CalculateGiftbackValueQuery = { __typename?: 'Query', calculateGiftbackValue?: { __typename?: 'CalculateGiftbackValueResponse', purchaseValue?: any | null, giftbackValue?: any | null, minValueToRedeem?: any | null, dueDate?: any | null } | null };

export type CancelGiftbackMutationVariables = Exact<{
  giftbackInput: UpdateCancelGiftbackInput;
}>;


export type CancelGiftbackMutation = { __typename?: 'Mutation', giftbackCancel?: { __typename?: 'UpdateCancelGiftbackMutation', ok?: boolean | null } | null };

export type CreateGiftbackManualMutationVariables = Exact<{
  giftbackInput: CreateGiftbackInput;
}>;


export type CreateGiftbackManualMutation = { __typename?: 'Mutation', giftbackCreate?: { __typename?: 'CreateGiftbackMutation', ok?: boolean | null, giftback?: { __typename?: 'GiftbackType', pk: number } | null } | null };

export type GiftbackExcelReportQueryVariables = Exact<{
  input?: InputMaybe<GiftbackFilterSetInput>;
}>;


export type GiftbackExcelReportQuery = { __typename?: 'Query', giftbackExcelReport?: { __typename?: 'GiftbackExcelReportType', relatorio?: string | null } | null };

export type GetGiftbackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGiftbackQuery = { __typename?: 'Query', giftback?: { __typename?: 'GiftbackType', code: string, value: number, minValueToRedeem: number, dueDate: any, id: string, pk: number, status: GiftbackStatus, redeemedAt?: any | null, importedFrom: GiftbackImportedFrom, justification: string, createdAt: any, updatedAt: any, redeemedBy?: { __typename?: 'CustomUserNode', pk?: number | null, name?: string | null, email: string } | null, customer: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null, email?: string | null, phone?: string | null }, purchaseUsed?: { __typename?: 'PurchaseRelayType', pk: number, date?: any | null, value: number } | null, purchase?: { __typename?: 'PurchaseRelayType', pk: number, date?: any | null, value: number } | null } | null, historic?: { __typename?: 'CustomerActivitiesTypeRelayConnection', edges: Array<{ __typename?: 'CustomerActivitiesTypeRelayEdge', node?: { __typename?: 'CustomerActivitiesTypeRelay', title?: string | null, description: string, updatedAt: any, pk: number } | null } | null> } | null };

export type GetGiftbackPublicDataQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
  contactData: Scalars['String']['input'];
}>;


export type GetGiftbackPublicDataQuery = { __typename?: 'Query', getPublicGiftbackDataByCpfPhone?: { __typename?: 'ReturnPublicGiftbackData', value?: any | null, code?: string | null, minValueForRedeem?: any | null, dueDate?: any | null, errorMessage?: string | null, clientName?: string | null, publicToken?: string | null } | null };

export type ListGiftbacksQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
  dueDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  dueDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Lte?: InputMaybe<Scalars['Date']['input']>;
  redeemedAt_Gte?: InputMaybe<Scalars['Date']['input']>;
  purchase?: InputMaybe<Scalars['ID']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  customer_Name_Icontains?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ListGiftbacksQuery = { __typename?: 'Query', giftbackAll?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null } | null, giftbackActive?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null } | null, giftbackExpired?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null } | null, giftbackRedeemed?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null } | null, giftbackCancelled?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null } | null, giftbackOverdue?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null } | null, allGiftbacksRelay?: { __typename?: 'GiftbackRelayTypeConnection', totalCount?: number | null, edgeCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'GiftbackRelayTypeEdge', node?: { __typename?: 'GiftbackRelayType', id: string, pk: number, code: string, status: GiftbackStatus, value: number, dueDate: any, minValueToRedeem: number, importedFrom: GiftbackImportedFrom, customer: { __typename?: 'CustomerTypeRelay', name?: string | null, email?: string | null }, purchase?: { __typename?: 'PurchaseRelayType', pk: number } | null, customeractivitySet: { __typename?: 'CustomerActivitiesTypeRelayConnection', edges: Array<{ __typename?: 'CustomerActivitiesTypeRelayEdge', node?: { __typename?: 'CustomerActivitiesTypeRelay', activity?: CustomerActivityActivity | null, title?: string | null, description: string, pk: number } | null } | null> } } | null } | null> } | null };

export type RedeemGiftbackMutationVariables = Exact<{
  giftbackInput: UpdateRedeemGiftbackInput;
}>;


export type RedeemGiftbackMutation = { __typename?: 'Mutation', giftbackRedeem?: { __typename?: 'UpdateRedeemGiftbackMutation', ok?: boolean | null, giftback?: { __typename?: 'GiftbackType', redeemedAt?: any | null } | null } | null };

export type GetHomeCardsValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeCardsValuesQuery = { __typename?: 'Query', homepageCardsValues?: { __typename?: 'HomePageCards', totalCustomers?: number | null, totalPurchase?: number | null, totalActiveGiftbacks?: number | null, totalUniqueCustomers?: number | null, totalRecurrentCustomers?: number | null, purchaseAverageTicket?: number | null, totalValuePurchase?: number | null, totalValueRedeemedGiftbacks?: number | null, totalGiftbackGains?: number | null } | null };

export type HomepageTopCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageTopCustomersQuery = { __typename?: 'Query', homepageTopCustomers?: Array<{ __typename?: 'TopCustomersTypeField', customerName?: string | null, customerGender?: string | null, purchaseTotalQuantity?: number | null, purchaseTotalValue?: number | null, customerPk?: string | null } | null> | null };

export type HomepageTopProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageTopProductsQuery = { __typename?: 'Query', homepageTopProducts?: Array<{ __typename?: 'TopProductsTypeField', productName?: string | null, totalValue?: number | null, totalSold?: number | null, productPk?: string | null } | null> | null };

export type VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyStoreZapiEvolutionIntegrationConnectedQuery = { __typename?: 'Query', verifyIfStoreHasZapiOrEvolutionApiIntegration?: { __typename?: 'ReturnVerifyIfStoreHasZapiOrEvolutionApiIntegration', hasIntegration?: boolean | null, isConnected?: boolean | null } | null };

export type GetRfmChartValuesQueryVariables = Exact<{
  input?: InputMaybe<CustomerFilterSetInput>;
}>;


export type GetRfmChartValuesQuery = { __typename?: 'Query', rfmStatus?: { __typename?: 'RfmAutomationType', dailyRefreshEnabled: boolean, lastCompletedAt?: any | null } | null, rfmData?: Array<{ __typename?: 'RfmChartReturn', x?: string | null, y?: number | null, monetaryValue?: number | null, totalPurchases?: number | null, averageMonetaryValue?: number | null, averageTicket?: number | null } | null> | null };

export type CreateJourneyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  triggerType: Scalars['String']['input'];
}>;


export type CreateJourneyMutation = { __typename?: 'Mutation', createJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, journey?: { __typename?: 'JourneyType', id: string, name: string, description: string, triggerFamily: string, status: JourneyStatus, draft?: { __typename?: 'JourneyDraftType', id: string, revision: number, definition: any } | null } | null } | null };

export type UpdateJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateJourneyMutation = { __typename?: 'Mutation', updateJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, journey?: { __typename?: 'JourneyType', id: string, name: string, description: string, updatedAt: any } | null } | null };

export type SaveJourneyDraftMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  definition: Scalars['GenericScalar']['input'];
  expectedRevision: Scalars['Int']['input'];
}>;


export type SaveJourneyDraftMutation = { __typename?: 'Mutation', saveJourneyDraft?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, draft?: { __typename?: 'JourneyDraftType', id: string, revision: number, definition: any, lastValidation: any, updatedAt: any } | null } | null };

export type ValidateJourneyDraftMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  definition?: InputMaybe<Scalars['GenericScalar']['input']>;
}>;


export type ValidateJourneyDraftMutation = { __typename?: 'Mutation', validateJourneyDraft?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, validation?: any | null } | null };

export type PublishJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  expectedRevision: Scalars['Int']['input'];
}>;


export type PublishJourneyMutation = { __typename?: 'Mutation', publishJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, validation?: any | null, journey?: { __typename?: 'JourneyType', id: string, status: JourneyStatus, activeVersion?: { __typename?: 'JourneyVersionType', id: string, number: number, publishedAt: any } | null } | null, version?: { __typename?: 'JourneyVersionType', id: string, number: number, checksum: string, publishedAt: any } | null } | null };

export type RestoreJourneyVersionToDraftMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
  expectedRevision: Scalars['Int']['input'];
}>;


export type RestoreJourneyVersionToDraftMutation = { __typename?: 'Mutation', restoreJourneyVersionToDraft?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, draft?: { __typename?: 'JourneyDraftType', id: string, revision: number, schemaVersion: number, definition: any, lastValidation: any, updatedAt: any } | null, version?: { __typename?: 'JourneyVersionType', id: string, number: number, publishedAt: any } | null, journey?: { __typename?: 'JourneyType', id: string, activeVersion?: { __typename?: 'JourneyVersionType', id: string, number: number, publishedAt: any } | null } | null } | null };

export type PauseJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
}>;


export type PauseJourneyMutation = { __typename?: 'Mutation', pauseJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, journey?: { __typename?: 'JourneyType', id: string, status: JourneyStatus } | null } | null };

export type ActivateJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
}>;


export type ActivateJourneyMutation = { __typename?: 'Mutation', activateJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, journey?: { __typename?: 'JourneyType', id: string, status: JourneyStatus } | null } | null };

export type ArchiveJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
}>;


export type ArchiveJourneyMutation = { __typename?: 'Mutation', archiveJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, journey?: { __typename?: 'JourneyType', id: string, status: JourneyStatus } | null } | null };

export type DuplicateJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type DuplicateJourneyMutation = { __typename?: 'Mutation', duplicateJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, journey?: { __typename?: 'JourneyType', id: string, name: string, status: JourneyStatus } | null } | null };

export type SimulateJourneyMutationVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  definition?: InputMaybe<Scalars['GenericScalar']['input']>;
  eventContext: Scalars['GenericScalar']['input'];
}>;


export type SimulateJourneyMutation = { __typename?: 'Mutation', simulateJourney?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, simulation?: any | null } | null };

export type CancelJourneyExecutionMutationVariables = Exact<{
  executionId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelJourneyExecutionMutation = { __typename?: 'Mutation', cancelJourneyExecution?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, execution?: { __typename?: 'JourneyExecutionType', id: string, status: JourneyExecutionStatus, outcomeReason: string, completedAt?: any | null } | null } | null };

export type RetryJourneyIntentMutationVariables = Exact<{
  intentId: Scalars['ID']['input'];
}>;


export type RetryJourneyIntentMutation = { __typename?: 'Mutation', retryJourneyIntent?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, intent?: { __typename?: 'JourneyScheduledIntentType', id: string, status: ScheduledNotificationIntentStatus, nextEligibleAt?: any | null, attemptCount?: number | null } | null } | null };

export type ChangeJourneyTriggerOwnershipMutationVariables = Exact<{
  triggerFamily: Scalars['String']['input'];
  mode: Scalars['String']['input'];
  rollbackPolicy: Scalars['String']['input'];
}>;


export type ChangeJourneyTriggerOwnershipMutation = { __typename?: 'Mutation', changeJourneyTriggerOwnership?: { __typename?: 'JourneyMutationResult', ok: boolean, error?: string | null, errors?: any | null, ownership?: { __typename?: 'JourneyOwnershipType', id: string, triggerFamily: string, mode: JourneyTriggerOwnershipMode, rollbackPolicy: string, changedAt: any } | null } | null };

export type JourneysQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type JourneysQuery = { __typename?: 'Query', journeys?: Array<{ __typename?: 'JourneyType', id: string, name: string, description: string, triggerFamily: string, status: JourneyStatus, createdAt: any, updatedAt: any, activeVersion?: { __typename?: 'JourneyVersionType', id: string, number: number, publishedAt: any } | null, draft?: { __typename?: 'JourneyDraftType', id: string, revision: number, schemaVersion: number, definition: any, lastValidation: any, updatedAt: any } | null } | null> | null };

export type JourneyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JourneyQuery = { __typename?: 'Query', journey?: { __typename?: 'JourneyType', id: string, name: string, description: string, triggerFamily: string, status: JourneyStatus, createdAt: any, updatedAt: any, activeVersion?: { __typename?: 'JourneyVersionType', id: string, number: number, definition: any, compiledPlan: any, checksum: string, publishedAt: any } | null, draft?: { __typename?: 'JourneyDraftType', id: string, revision: number, schemaVersion: number, definition: any, lastValidation: any, updatedAt: any } | null, versions: Array<{ __typename?: 'JourneyVersionType', id: string, number: number, schemaVersion: number, definition: any, checksum: string, publishedAt: any }> } | null };

export type JourneyOwnershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneyOwnershipsQuery = { __typename?: 'Query', journeyOwnerships?: Array<{ __typename?: 'JourneyOwnershipType', id: string, triggerFamily: string, mode: JourneyTriggerOwnershipMode, rollbackPolicy: string, changedAt: any } | null> | null };

export type JourneyCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneyCatalogQuery = { __typename?: 'Query', journeyCatalog?: any | null };

export type JourneyWhatsappTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneyWhatsappTemplatesQuery = { __typename?: 'Query', allTemplatesRelay?: { __typename?: 'WhatsappTemplateRelayTypeConnection', edges: Array<{ __typename?: 'WhatsappTemplateRelayTypeEdge', node?: { __typename?: 'WhatsappTemplateRelayType', pk: number, templateId?: string | null, name: string, message: string, category?: WhatsappTemplateCategory | null, status?: WhatsappTemplateStatus | null, provider?: string | null, components?: any | null, imageUrl?: string | null, videoUrl?: string | null } | null } | null> } | null };

export type JourneyTargetsQueryVariables = Exact<{
  productSearch?: InputMaybe<Scalars['String']['input']>;
  categorySearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type JourneyTargetsQuery = { __typename?: 'Query', journeyTargetProducts?: Array<{ __typename?: 'JourneyTargetType', id: string, name: string, active?: boolean | null } | null> | null, journeyTargetCategories?: Array<{ __typename?: 'JourneyTargetType', id: string, name: string, parentId?: string | null, active?: boolean | null } | null> | null };

export type JourneyAnalyticsQueryVariables = Exact<{
  journeyId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type JourneyAnalyticsQuery = { __typename?: 'Query', journeyNodeAnalytics?: { __typename?: 'JourneyAnalyticsType', versionId: string, versionNumber: number, dateFrom?: any | null, dateTo?: any | null, updatedAt?: any | null, definitions: any, nodes: Array<{ __typename?: 'JourneyNodeMetricType', nodeKey: string, nodeType: string, scheduledMessages: number, dueMessages: number, sentMessages: number, failedMessages: number, canceledMessages: number, skippedMessages: number, deliveryAttempts: number, reachedExecutions: number, reachedCustomers: number, sentCustomers: number, convertedExecutions: number, convertedCustomers: number, conversionRate: number, stoppedExecutions: number, preventedMessages: number, scheduledActions: number, dueActions: number, completedActions: number, failedActions: number, canceledActions: number, skippedActions: number, createdGiftbacks: number, engagement?: any | null } | null> } | null, journeyFunnel?: { __typename?: 'JourneyFunnelType', enrolledExecutions: number, enrolledCustomers: number, stages: Array<{ __typename?: 'JourneyFunnelStageType', nodeKey: string, reachedExecutions: number, reachedCustomers: number, sentMessages: number, canceledBefore: number, convertedExecutions: number, convertedCustomers: number } | null> } | null };

export type JourneyExecutionsQueryVariables = Exact<{
  journeyId?: InputMaybe<Scalars['ID']['input']>;
  versionId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type JourneyExecutionsQuery = { __typename?: 'Query', journeyExecutions?: Array<{ __typename?: 'JourneyExecutionType', id: string, subjectType: string, subjectId: string, enrollmentContext: any, planningTrace: any, summary: any, status: JourneyExecutionStatus, outcomeReason: string, isShadow: boolean, startedAt: any, completedAt?: any | null, updatedAt: any, journey: { __typename?: 'JourneyType', id: string, name: string }, journeyVersion: { __typename?: 'JourneyVersionType', id: string, number: number }, customer?: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null } | null, notificationIntents?: Array<{ __typename?: 'JourneyScheduledIntentType', id: string, journeyNodeKey?: string | null, sequence?: number | null, channel?: string | null, status: ScheduledNotificationIntentStatus, scheduledAt?: any | null, scheduledTime?: any | null, nextEligibleAt?: any | null, attemptCount?: number | null, maxAttempts?: number | null, lastError?: string | null, cancelReason?: string | null, skipReason?: string | null, messageSnapshot?: any | null, enrollmentContext?: any | null } | null> | null, actionIntents?: Array<{ __typename?: 'JourneyActionIntentType', id: string, nodeKey: string, sequence: number, actionType: JourneyActionIntentActionType, scheduledAt: any, status: JourneyActionIntentStatus } | null> | null, goalEvents?: Array<{ __typename?: 'JourneyGoalEventType', id: string, exitRuleKey: string, attributedNodeKey: string, occurredAt: any, preventedIntentCount: number, reversed: boolean, reversalReason: string, purchase?: { __typename?: 'PurchaseRelayType', pk: number, value: number, status: string, issueDate?: any | null } | null } | null> | null, deliveries?: Array<{ __typename?: 'JourneyDeliveryType', id: string, nodeKey: string, channel: string, provider: string, status: NotificationDeliveryLedgerStatus, externalMessageId: string, sanitizedError: string, attempts: number, acceptedAt?: any | null, sentAt?: any | null } | null> | null } | null> | null };

export type JourneyExecutionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JourneyExecutionQuery = { __typename?: 'Query', journeyExecution?: { __typename?: 'JourneyExecutionType', id: string, subjectType: string, subjectId: string, enrollmentContext: any, planningTrace: any, summary: any, status: JourneyExecutionStatus, outcomeReason: string, isShadow: boolean, startedAt: any, completedAt?: any | null, journey: { __typename?: 'JourneyType', id: string, name: string }, journeyVersion: { __typename?: 'JourneyVersionType', id: string, number: number, checksum: string }, customer?: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null } | null, notificationIntents?: Array<{ __typename?: 'JourneyScheduledIntentType', id: string, journeyNodeKey?: string | null, sequence?: number | null, channel?: string | null, status: ScheduledNotificationIntentStatus, scheduledAt?: any | null, scheduledTime?: any | null, nextEligibleAt?: any | null, attemptCount?: number | null, maxAttempts?: number | null, lastError?: string | null, cancelReason?: string | null, skipReason?: string | null, messageSnapshot?: any | null, enrollmentContext?: any | null, requiredJourneyAction?: { __typename?: 'JourneyActionIntentType', id: string, nodeKey: string, status: JourneyActionIntentStatus } | null, giftback?: { __typename?: 'GiftbackRelayType', pk: number, code: string, value: number, dueDate: any, status: GiftbackStatus } | null } | null> | null, actionIntents?: Array<{ __typename?: 'JourneyActionIntentType', id: string, nodeKey: string, sequence: number, actionType: JourneyActionIntentActionType, configSnapshot: any, scheduledAt: any, status: JourneyActionIntentStatus, attemptCount: number, maxAttempts: number, nextEligibleAt?: any | null, providerOutcome: any, lastError: string, cancelReason: string, canceledAt?: any | null, completedAt?: any | null, createdGiftback?: { __typename?: 'GiftbackType', pk: number, code: string, value: number, minValueToRedeem: number, availableFrom?: any | null, dueDate: any, status: GiftbackStatus, integrationId: string } | null } | null> | null, goalEvents?: Array<{ __typename?: 'JourneyGoalEventType', id: string, exitRuleKey: string, attributedNodeKey: string, matchedContext: any, occurredAt: any, preventedIntentCount: number, reversed: boolean, reversedAt?: any | null, reversalReason: string, purchase?: { __typename?: 'PurchaseRelayType', pk: number, value: number, status: string, issueDate?: any | null } | null } | null> | null, deliveries?: Array<{ __typename?: 'JourneyDeliveryType', id: string, nodeKey: string, channel: string, provider: string, status: NotificationDeliveryLedgerStatus, externalMessageId: string, sanitizedError: string, attempts: number, acceptedAt?: any | null, sentAt?: any | null } | null> | null } | null };

export type GetLoyaltyConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltyConfigurationQuery = { __typename?: 'Query', loyaltyProgram?: { __typename?: 'LoyaltyProgramType', id: string, name: string, description: string, primaryColor: string, isActive: boolean, pointsExpirationDays?: number | null, redemptionExpirationHours: number, store: { __typename?: 'StoreType', slug?: string | null, url?: string | null } } | null, loyaltyTiers?: Array<{ __typename?: 'LoyaltyTierType', id: string, name: string, minimumPoints: number, benefits: any, isActive: boolean } | null> | null, loyaltyRules?: Array<{ __typename?: 'LoyaltyRuleType', id: string, name: string, event: LoyaltyRuleEvent, conditions: any, pointsMode: LoyaltyRulePointsMode, pointsValue: number, maximumPoints?: number | null, validityDays?: number | null, occurrenceLimit?: number | null, priority: number, startsAt?: any | null, endsAt?: any | null, isActive: boolean } | null> | null, loyaltyRewards?: Array<{ __typename?: 'LoyaltyRewardType', id: string, name: string, description: string, rewardType: LoyaltyRewardRewardType, pointsCost: number, discountValue?: number | null, discountType: LoyaltyRewardDiscountType, availableInPdv: boolean, availableInPublicPage: boolean, allowPickup: boolean, allowCustomerPaidShipping: boolean, totalLimit?: number | null, perMemberLimit?: number | null, startsAt?: any | null, endsAt?: any | null, isActive: boolean, minimumTier?: { __typename?: 'LoyaltyTierType', id: string, name: string } | null, product?: { __typename?: 'ProductRelayType', id: string, pk: number, name: string } | null } | null> | null, loyaltyRedemptions?: Array<{ __typename?: 'LoyaltyRedemptionType', id: string, code: string, pointsCost: number, channel: LoyaltyRedemptionChannel, fulfillmentMethod: LoyaltyRedemptionFulfillmentMethod, status: LoyaltyRedemptionStatus, expiresAt: any, completedAt?: any | null, createdAt: any, reward: { __typename?: 'LoyaltyRewardType', id: string, name: string }, member: { __typename?: 'LoyaltyMemberType', id: string, customer: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null } } } | null> | null, allProductsRelay?: { __typename?: 'ProductRelayTypeConnection', edges: Array<{ __typename?: 'ProductRelayTypeEdge', node?: { __typename?: 'ProductRelayType', id: string, pk: number, name: string } | null } | null> } | null };

export type GetPdvLoyaltyMemberQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type GetPdvLoyaltyMemberQuery = { __typename?: 'Query', loyaltyMember?: { __typename?: 'LoyaltyMemberType', id: string, availablePoints: number, reservedPoints: number, currentTier?: { __typename?: 'LoyaltyTierType', id: string, name: string } | null, benefits: Array<{ __typename?: 'LoyaltyBenefitType', id: string, name: string, description: string, startsAt?: any | null, endsAt?: any | null, isActive: boolean }>, redemptions: Array<{ __typename?: 'LoyaltyRedemptionType', id: string, code: string, pointsCost: number, status: LoyaltyRedemptionStatus, fulfillmentMethod: LoyaltyRedemptionFulfillmentMethod, expiresAt: any, reward: { __typename?: 'LoyaltyRewardType', id: string, name: string } }>, eligiblePdvRewards?: Array<{ __typename?: 'LoyaltyRewardType', id: string, name: string, description: string, rewardType: LoyaltyRewardRewardType, pointsCost: number, allowPickup: boolean, allowCustomerPaidShipping: boolean, product?: { __typename?: 'ProductRelayType', id: string, name: string } | null } | null> | null } | null };

export type AdminUpdateLoyaltyProgramMutationVariables = Exact<{
  input: LoyaltyProgramInput;
}>;


export type AdminUpdateLoyaltyProgramMutation = { __typename?: 'Mutation', loyaltyProgramUpdate?: { __typename?: 'UpdateLoyaltyProgramMutation', success?: boolean | null, program?: { __typename?: 'LoyaltyProgramType', id: string, name: string, description: string, primaryColor: string, isActive: boolean, pointsExpirationDays?: number | null, redemptionExpirationHours: number } | null } | null };

export type AdminSaveLoyaltyTierMutationVariables = Exact<{
  input: LoyaltyTierInput;
}>;


export type AdminSaveLoyaltyTierMutation = { __typename?: 'Mutation', loyaltyTierSave?: { __typename?: 'SaveLoyaltyTierMutation', success?: boolean | null, tier?: { __typename?: 'LoyaltyTierType', id: string, name: string, minimumPoints: number, benefits: any, isActive: boolean } | null } | null };

export type AdminSaveLoyaltyRuleMutationVariables = Exact<{
  input: LoyaltyRuleInput;
}>;


export type AdminSaveLoyaltyRuleMutation = { __typename?: 'Mutation', loyaltyRuleSave?: { __typename?: 'SaveLoyaltyRuleMutation', success?: boolean | null, rule?: { __typename?: 'LoyaltyRuleType', id: string, name: string, event: LoyaltyRuleEvent, conditions: any, pointsMode: LoyaltyRulePointsMode, pointsValue: number, maximumPoints?: number | null, validityDays?: number | null, occurrenceLimit?: number | null, priority: number, startsAt?: any | null, endsAt?: any | null, isActive: boolean } | null } | null };

export type AdminSaveLoyaltyRewardMutationVariables = Exact<{
  input: LoyaltyRewardInput;
}>;


export type AdminSaveLoyaltyRewardMutation = { __typename?: 'Mutation', loyaltyRewardSave?: { __typename?: 'SaveLoyaltyRewardMutation', success?: boolean | null, reward?: { __typename?: 'LoyaltyRewardType', id: string, name: string, description: string, rewardType: LoyaltyRewardRewardType, pointsCost: number, discountValue?: number | null, discountType: LoyaltyRewardDiscountType, availableInPdv: boolean, availableInPublicPage: boolean, allowPickup: boolean, allowCustomerPaidShipping: boolean, totalLimit?: number | null, perMemberLimit?: number | null, startsAt?: any | null, endsAt?: any | null, isActive: boolean, minimumTier?: { __typename?: 'LoyaltyTierType', id: string, name: string } | null, product?: { __typename?: 'ProductRelayType', id: string, pk: number, name: string } | null } | null } | null };

export type AdminDeleteLoyaltyConfigurationMutationVariables = Exact<{
  kind: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteLoyaltyConfigurationMutation = { __typename?: 'Mutation', loyaltyConfigurationDelete?: { __typename?: 'DeleteLoyaltyConfigurationMutation', success?: boolean | null } | null };

export type CreatePdvLoyaltyRedemptionMutationVariables = Exact<{
  input: LoyaltyRedemptionInput;
}>;


export type CreatePdvLoyaltyRedemptionMutation = { __typename?: 'Mutation', loyaltyRedemptionCreate?: { __typename?: 'CreateLoyaltyRedemptionMutation', success?: boolean | null, redemption?: { __typename?: 'LoyaltyRedemptionType', id: string, code: string, pointsCost: number, status: LoyaltyRedemptionStatus, fulfillmentMethod: LoyaltyRedemptionFulfillmentMethod, expiresAt: any, reward: { __typename?: 'LoyaltyRewardType', id: string, name: string }, coupon?: { __typename?: 'CouponRelayType', id: string, code: string } | null } | null } | null };

export type ConfirmLoyaltyRewardDeliveryMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConfirmLoyaltyRewardDeliveryMutation = { __typename?: 'Mutation', loyaltyRewardDeliver?: { __typename?: 'DeliverLoyaltyRewardMutation', success?: boolean | null, redemption?: { __typename?: 'LoyaltyRedemptionType', id: string, code: string, status: LoyaltyRedemptionStatus, deliveredAt?: any | null, pointsCost: number, reward: { __typename?: 'LoyaltyRewardType', id: string, name: string }, member: { __typename?: 'LoyaltyMemberType', id: string, customer: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null } } } | null } | null };

export type BulkNotificationStatusCountsQueryVariables = Exact<{
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type BulkNotificationStatusCountsQuery = { __typename?: 'Query', statusAll?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusPending?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusProcessing?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusFailed?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusFinished?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusCanceled?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusPaused?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null, statusPausedByTimeLimit?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null } | null };

export type CancelMassCampaignMutationVariables = Exact<{
  input: BulkNotificationCancellInput;
}>;


export type CancelMassCampaignMutation = { __typename?: 'Mutation', cancelBulkNotification?: { __typename?: 'BulkNotificationCancellMutation', success?: boolean | null } | null };

export type ContinueMassCampaignMutationVariables = Exact<{
  input: BulkNotificationResumeInput;
}>;


export type ContinueMassCampaignMutation = { __typename?: 'Mutation', resumeBulkNotification?: { __typename?: 'BulkNotificationResumeMutation', success?: boolean | null } | null };

export type CreateMassCampaignMutationVariables = Exact<{
  input: BulkNotificationCreateInput;
}>;


export type CreateMassCampaignMutation = { __typename?: 'Mutation', createBulkNotification?: { __typename?: 'CreateBulkNotificationMutation', success?: boolean | null } | null };

export type CreateTemplateEmailMutationVariables = Exact<{
  input: EmailTemplateCreateInput;
}>;


export type CreateTemplateEmailMutation = { __typename?: 'Mutation', createEmailTemplate?: { __typename?: 'CreateEmailTemplateMutation', success?: boolean | null, message?: string | null } | null };

export type DeleteMassCampaignMutationVariables = Exact<{
  input: BulkNotificationDeleteInput;
}>;


export type DeleteMassCampaignMutation = { __typename?: 'Mutation', deleteBulkNotification?: { __typename?: 'BulkNotificationDeleteMutation', success?: boolean | null } | null };

export type GetMassCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMassCampaignQuery = { __typename?: 'Query', getBulkNotification?: { __typename?: 'BulkNotificationType', pk: number, title: string, status?: BulkNotificationStatus | null, fileAttachment?: string | null, progressCount: string, progressPercentage: number, viaWhatsapp: boolean, viaEmail: boolean, viaWhatsappOfficial: boolean, viaZekiCrm: boolean, zekiCrmChannelId?: string | null, zekiCrmChannelNumber?: string | null, startTime?: any | null, endTime?: any | null, startRunningDate?: any | null, purchaseQuantity: number, purchaseTotalValue: number, createdAt: any, messageTimeInterval: number, dailyMessageLimit: number, zekiCrmTemplateVariableMapping?: Array<{ __typename?: 'BulkNotificationZekiCrmTemplateVariableMappingType', templateVariable?: string | null, zekiVariable?: string | null } | null> | null, customerMessageStatusCounts: { __typename?: 'BulkNotificationCustomerMessageStatusCountsType', total: number, sent: number, pending: number, read: number, clicked: number, failed: number, canceled: number, delivered: number }, whatsappTemplate?: { __typename?: 'WhatsappTemplateRelayType', pk: number, name: string, message: string, status?: WhatsappTemplateStatus | null, reason?: string | null, category?: WhatsappTemplateCategory | null, provider?: string | null, zekiCrmParameters?: Array<string | null> | null, imageUrl?: string | null, videoUrl?: string | null } | null, bulknotificationmessageSet: Array<{ __typename?: 'BulkNotificationMessageType', active: boolean, pk: number, message: string, imageUrl?: string | null, videoUrl?: string | null, htmlMessage: string, emailMessage: string, emailTitle: string, buttonLabel?: string | null, buttonUrl?: string | null, reactEmailData: any, footer?: string | null, buttons: any }>, store: { __typename?: 'StoreType', id: string, name: string, telephone: string, email: string, url?: string | null, profileImageEmail?: string | null, emailFooterPrimaryColor: string, emailFooterSecondaryColor: string, emailFooterTertiaryColor: string, emailFooterImg?: string | null } } | null };

export type GetBulkNotificationCustomerIdsQueryVariables = Exact<{
  bulkNotificationId: Scalars['ID']['input'];
}>;


export type GetBulkNotificationCustomerIdsQuery = { __typename?: 'Query', getBulkNotificationCustomerIds?: Array<number | null> | null };

export type GetBulkNotificationMetricsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBulkNotificationMetricsQuery = { __typename?: 'Query', getBulkNotification?: { __typename?: 'BulkNotificationType', customerMessageStatusCounts: { __typename?: 'BulkNotificationCustomerMessageStatusCountsType', sent: number, read: number, failed: number, clicked: number, delivered: number } } | null };

export type GetMassCampaignTestSendsQueryVariables = Exact<{
  draftKey: Scalars['UUID']['input'];
}>;


export type GetMassCampaignTestSendsQuery = { __typename?: 'Query', bulkNotificationTestSends?: { __typename?: 'BulkNotificationTestSendsResultType', remainingTests: number, limit: number } | null };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { __typename?: 'Query', getEmailTemplates?: Array<{ __typename?: 'EmailTemplateType', pk: number, name: string, json: any, stores: Array<{ __typename?: 'StoreType', name: string }> } | null> | null };

export type ListBulkNotificationWhatsappTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBulkNotificationWhatsappTemplatesQuery = { __typename?: 'Query', allTemplatesRelay?: { __typename?: 'WhatsappTemplateRelayTypeConnection', totalCount?: number | null, edgeCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'WhatsappTemplateRelayTypeEdge', node?: { __typename?: 'WhatsappTemplateRelayType', pk: number, templateId?: string | null, name: string, message: string, status?: WhatsappTemplateStatus | null, isCurrentlySending: boolean, components?: any | null, imageUrl?: string | null, videoUrl?: string | null } | null } | null> } | null };

export type ListBulkNotificationsQueryVariables = Exact<{
  startRunningDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  startRunningDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  viaWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  viaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  viaWhatsappOfficial?: InputMaybe<Scalars['Boolean']['input']>;
  viaZekiCrm?: InputMaybe<Scalars['Boolean']['input']>;
  title_Icontains?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListBulkNotificationsQuery = { __typename?: 'Query', allBulkNotificationsRelay?: { __typename?: 'BulkNotificationRelayTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'BulkNotificationRelayTypeEdge', node?: { __typename?: 'BulkNotificationRelayType', pk: number, title: string, status?: BulkNotificationStatus | null, viaWhatsapp: boolean, viaEmail: boolean, viaWhatsappOfficial: boolean, viaZekiCrm: boolean, startTime?: any | null, startRunningDate?: any | null, createdAt: any, progressPercentage: number, purchaseQuantity: number, purchaseTotalValue: number, whatsappTemplate?: { __typename?: 'WhatsappTemplateRelayType', category?: WhatsappTemplateCategory | null, status?: WhatsappTemplateStatus | null } | null, bulknotificationcustomerSet: { __typename?: 'BulkNotificationCustomerRelayTypeConnection', totalCount?: number | null } } | null } | null> } | null };

export type GetMassCampaignCustomersQueryVariables = Exact<{
  bulkNotificationId: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmailOrPhone?: InputMaybe<Scalars['String']['input']>;
  status_In?: InputMaybe<Scalars['String']['input']>;
  messageStatus?: InputMaybe<Scalars['String']['input']>;
  hasPurchase?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMassCampaignCustomersQuery = { __typename?: 'Query', allBulkNotificationCustomersRelay?: { __typename?: 'BulkNotificationCustomerRelayTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'BulkNotificationCustomerRelayTypeEdge', node?: { __typename?: 'BulkNotificationCustomerRelayType', pk: number, name: string, email: string, phone: string, messageStatus?: BulkNotificationCustomerMessageStatus | null, status?: BulkNotificationCustomerStatus | null, customer?: { __typename?: 'CustomerTypeRelay', pk: number } | null, bulknotificationcustomersalesSet: Array<{ __typename?: 'BulkNotificationCustomerSalesType', value: number, purchase: { __typename?: 'PurchaseRelayType', pk: number, date?: any | null } }> } | null } | null> } | null };

export type PauseMassCampaignMutationVariables = Exact<{
  input: BulkNotificationPauseInput;
}>;


export type PauseMassCampaignMutation = { __typename?: 'Mutation', pauseBulkNotification?: { __typename?: 'BulkNotificationPauseMutation', success?: boolean | null } | null };

export type RescheduleCampaignMutationVariables = Exact<{
  input: BulkNotificationRescheduleCampaignInput;
}>;


export type RescheduleCampaignMutation = { __typename?: 'Mutation', rescheduleBulkNotificationCampaign?: { __typename?: 'BulkNotificationRescheduleCampaignMutation', success?: boolean | null, bulkNotification?: { __typename?: 'BulkNotificationType', pk: number } | null } | null };

export type SendCampaignMutationVariables = Exact<{
  input: BulkNotificationSendCampaignInput;
}>;


export type SendCampaignMutation = { __typename?: 'Mutation', sendBulkNotificationCampaign?: { __typename?: 'BulkNotificationSendCampaignMutation', success?: boolean | null } | null };

export type SendMassCampaignTestMutationVariables = Exact<{
  input: BulkNotificationTestSendInput;
}>;


export type SendMassCampaignTestMutation = { __typename?: 'Mutation', sendBulkNotificationTest?: { __typename?: 'SendBulkNotificationTestMutation', success?: boolean | null, message?: string | null, remainingTests?: number | null } | null };

export type UpdateMassCampaignMutationVariables = Exact<{
  input: BulkNotificationUpdateInput;
}>;


export type UpdateMassCampaignMutation = { __typename?: 'Mutation', updateBulkNotification?: { __typename?: 'BulkNotificationUpdateMutation', success?: boolean | null } | null };

export type UpdateBulkNotificationCustomerDataMutationVariables = Exact<{
  input: BulkNotificationUpdateCustomerDataInput;
}>;


export type UpdateBulkNotificationCustomerDataMutation = { __typename?: 'Mutation', updateBulkNotificationCustomerData?: { __typename?: 'BulkNotificationUpdateCustomerDataMutation', success?: boolean | null, message?: string | null } | null };

export type CashRegisterCashAvailableQueryVariables = Exact<{
  businessDate: Scalars['Date']['input'];
}>;


export type CashRegisterCashAvailableQuery = { __typename?: 'Query', cashRegisterCashAvailable?: any | null };

export type CashRegisterSangriasQueryVariables = Exact<{
  businessDate: Scalars['Date']['input'];
}>;


export type CashRegisterSangriasQuery = { __typename?: 'Query', cashRegisterSangrias?: Array<{ __typename?: 'CashRegisterMovementType', pk: number, amount: number, businessDate: any, notes: string, createdAt: any, operatorName?: string | null } | null> | null };

export type CreateCashRegisterSangriaMutationVariables = Exact<{
  input: CreateCashRegisterSangriaInput;
}>;


export type CreateCashRegisterSangriaMutation = { __typename?: 'Mutation', cashRegisterSangriaCreate?: { __typename?: 'CashRegisterSangriaCreateMutation', success?: boolean | null, error?: string | null, cashAvailable?: any | null, cashRegisterMovement?: { __typename?: 'CashRegisterMovementType', pk: number, amount: number, businessDate: any, notes: string, createdAt: any, operatorName?: string | null } | null } | null };

export type CreatePurchasePdvMutationVariables = Exact<{
  purchaseInput: CreatePurchaseInput;
}>;


export type CreatePurchasePdvMutation = { __typename?: 'Mutation', purchaseCreate?: { __typename?: 'CreatePurchaseMutation', success?: boolean | null, error?: string | null, purchase?: { __typename?: 'PurchaseType', pk: number } | null } | null };

export type GetCustomerStepQueryVariables = Exact<{
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneOrTaxDocument?: InputMaybe<Scalars['String']['input']>;
  taxDocument?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCustomerStepQuery = { __typename?: 'Query', allCustomersRelay?: { __typename?: 'CustomerTypeRelayConnection', edges: Array<{ __typename?: 'CustomerTypeRelayEdge', node?: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null, email?: string | null, phone?: string | null, taxDocument?: string | null, gender?: CustomerGender | null, state?: string | null, city?: string | null, id: string, dateOfBirth?: any | null, isActive: boolean, store: { __typename?: 'StoreType', giftbackconfig?: { __typename?: 'GiftbackConfigType', multiplegiftbackconfigSet: Array<{ __typename?: 'MultipleGiftbackConfigType', id: string, minPurchaseValueForRedeem: number, minimumValueType: MultipleGiftbackConfigMinimumValueType, maximumDiscountPercentage: number }> } | null }, tags: { __typename?: 'CustomerTagsRelayTypeConnection', edges: Array<{ __typename?: 'CustomerTagsRelayTypeEdge', node?: { __typename?: 'CustomerTagsRelayType', pk: number, name: string } | null } | null> }, giftbackSet: { __typename?: 'GiftbackRelayTypeConnection', edges: Array<{ __typename?: 'GiftbackRelayTypeEdge', node?: { __typename?: 'GiftbackRelayType', value: number, code: string, dueDate: any, minValueToRedeem: number, status: GiftbackStatus, importedFrom: GiftbackImportedFrom, purchase?: { __typename?: 'PurchaseRelayType', value: number, id: string } | null, store: { __typename?: 'StoreType', id: string } } | null } | null> } } | null } | null> } | null };

export type PlanningEventFieldsFragment = { __typename?: 'PlanningEvent', id: string, source: PlanningEventSource, sourceId: string, communityId?: string | null, title: string, startsAt?: any | null, date: any, allDay: boolean, timeZone: string, status: PlanningEventStatus, rawStatus: string, destination: string, channels: Array<string>, dateBasis: PlanningDateBasis };

export type PlanningEventsQueryVariables = Exact<{
  startsAt: Scalars['DateTime']['input'];
  endsAt: Scalars['DateTime']['input'];
  sources?: InputMaybe<Array<PlanningEventSource> | PlanningEventSource>;
  statuses?: InputMaybe<Array<PlanningEventStatus> | PlanningEventStatus>;
  communityId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlanningEventsQuery = { __typename?: 'Query', planningEvents: { __typename?: 'PlanningEventPage', total: number, hasNextPage: boolean, endCursor?: string | null, availableSources: Array<PlanningEventSource>, undatedCampaignCount: number, campaignTimeZone: string, items: Array<{ __typename?: 'PlanningEvent', id: string, source: PlanningEventSource, sourceId: string, communityId?: string | null, title: string, startsAt?: any | null, date: any, allDay: boolean, timeZone: string, status: PlanningEventStatus, rawStatus: string, destination: string, channels: Array<string>, dateBasis: PlanningDateBasis }> } };

export type GetStoreModulePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoreModulePermissionsQuery = { __typename?: 'Query', getStoreModulePermissions?: { __typename?: 'StoreModulePermissionsType', hasReports: boolean, hasRfm: boolean, hasMessageTemplates: boolean, hasDashboards: boolean, hasProducts: boolean, hasPdv: boolean, hasServices: boolean, hasAppointments: boolean, hasBulkNotification: boolean, hasJourneys: boolean, hasCoupons: boolean, hasLoyalty: boolean, hasOrderDeliveryDataPermission: boolean, hasCommunicationIntegrations: number, hasErpIntegrations: number, hasEcommerceIntegrations: number } | null };

export type ProductCreateMutationVariables = Exact<{
  productsInput?: InputMaybe<Array<InputMaybe<CreateProductBulkInput>> | InputMaybe<CreateProductBulkInput>>;
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', productBulkCreate?: { __typename?: 'CreateProductBulkMutation', ok?: boolean | null, error?: string | null, product?: { __typename?: 'ProductType', id: string, name: string, value: number, costValue: number, wholesaleValue: number } | null } | null };

export type CategoryListQueryVariables = Exact<{
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryListQuery = { __typename?: 'Query', categoryList?: { __typename?: 'CategoryRelayTypeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CategoryRelayTypeEdge', node?: { __typename?: 'CategoryRelayType', id: string, pk: number, name: string, integrationId: string } | null } | null> } | null };

export type GetAllProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllProductsQuery = { __typename?: 'Query', allProductsRelay?: { __typename?: 'ProductRelayTypeConnection', edges: Array<{ __typename?: 'ProductRelayTypeEdge', node?: { __typename?: 'ProductRelayType', pk: number, name: string, value: number, wholesaleValue: number, costValue: number, stock?: number | null } | null } | null> } | null };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'ProductType', id: string, name: string, value: number, costValue: number, wholesaleValue: number, stock?: number | null, integrationId?: string | null, importedFrom: ProductImportedFrom, categories: { __typename?: 'CategoryRelayTypeConnection', edges: Array<{ __typename?: 'CategoryRelayTypeEdge', node?: { __typename?: 'CategoryRelayType', id: string, pk: number, name: string } | null } | null> } } | null };

export type GetReportProductQueryVariables = Exact<{
  input: ProductFilterSetInput;
}>;


export type GetReportProductQuery = { __typename?: 'Query', productExcelReport?: { __typename?: 'ProductExcelReportType', relatorio?: string | null, background?: boolean | null } | null };

export type ListAllProductsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  name_Icontains?: InputMaybe<Scalars['String']['input']>;
  categoriesNames?: InputMaybe<Scalars['String']['input']>;
  importedFrom?: InputMaybe<Scalars['String']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  isActivated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListAllProductsQuery = { __typename?: 'Query', allProductsRelay?: { __typename?: 'ProductRelayTypeConnection', edgeCount?: number | null, totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'ProductRelayTypeEdge', node?: { __typename?: 'ProductRelayType', id: string, pk: number, name: string, integrationId?: string | null, isActivated: boolean, value: number, costValue: number, wholesaleValue: number, categories: { __typename?: 'CategoryRelayTypeConnection', edges: Array<{ __typename?: 'CategoryRelayTypeEdge', node?: { __typename?: 'CategoryRelayType', name: string } | null } | null> } } | null } | null> } | null };

export type ProductUpdateMutationVariables = Exact<{
  productInput: UpdateProductInput;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productUpdate?: { __typename?: 'UpdateProductMutation', ok?: boolean | null, product?: { __typename?: 'ProductType', id: string, value: number, costValue: number, wholesaleValue: number } | null } | null };

export type AcceptTermsMutationMutationVariables = Exact<{
  termsId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type AcceptTermsMutationMutation = { __typename?: 'Mutation', acceptTerms?: { __typename?: 'AcceptTermsMutation', ok?: boolean | null } | null };

export type GetConnectedStoreChartsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedStoreChartsConfigQuery = { __typename?: 'Query', me?: { __typename?: 'CustomUserNode', connectedStore?: { __typename?: 'StoreType', customerSet: { __typename?: 'CustomerTypeRelayConnection', edgeCount?: number | null }, chartsconfig?: { __typename?: 'ChartsConfigType', tags: boolean, gender: boolean, yearRange: boolean, city: boolean, state: boolean } | null } | null } | null };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', me?: { __typename?: 'CustomUserNode', email: string, firstName: string, lastName: string, pk?: number | null, name?: string | null, gender?: CustomUserGender | null, acceptedTerm?: boolean | null, connectedStore?: { __typename?: 'StoreType', id: string, name: string, plan: StorePlan, isActive: boolean, currencyType: StoreCurrencyType, profileImage?: string | null, hasCompletePdv: boolean, hasBulkNotificationPermission: boolean, totalNotificationCredits: number, usedNotificationCredits: number, extraNotificationCredits: number, availableNotificationCredits?: number | null } | null, permissions: Array<{ __typename?: 'PermissionType', id: string, userType?: PermissionUserType | null, store: { __typename?: 'StoreType', name: string, id: string, plan: StorePlan, isActive: boolean, profileImage?: string | null } }> } | null };

export type NotAcceptedTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotAcceptedTermsQuery = { __typename?: 'Query', allTerms?: Array<{ __typename?: 'AcceptationTermType', pk: number, termType: AcceptationTermTermType, content: string } | null> | null };

export type UpdateMyConnectedStoreMutationVariables = Exact<{
  storeId: Scalars['ID']['input'];
}>;


export type UpdateMyConnectedStoreMutation = { __typename?: 'Mutation', updateUserConnectedStore?: { __typename?: 'UpdateUserConnectedStoreMutation', ok?: boolean | null } | null };

export type CancelPurchaseActionMutationVariables = Exact<{
  purchaseInput: CancelPurchaseInput;
}>;


export type CancelPurchaseActionMutation = { __typename?: 'Mutation', cancelPurchase?: { __typename?: 'CancelPurchaseMutation', purchase?: { __typename?: 'PurchaseType', id: string, value: number, canceledBy?: string | null } | null } | null };

export type CashRegisterClosingFieldsFragment = { __typename?: 'CashRegisterClosingSummaryType', pk?: number | null, businessDate?: any | null, periodStartedAt?: any | null, closedAt?: any | null, closedByName?: string | null, closedByEmail?: string | null, sangriaTotal?: any | null, totalSales?: any | null, discountTotal?: any | null, receivedTotal?: any | null, canceledTotal?: any | null, finalTotal?: any | null, createdAt?: any | null, paymentMethods?: Array<{ __typename?: 'CashRegisterClosingPaymentMethodSummaryType', paymentMethodName?: string | null, calculatedAmount?: any | null, declaredAmount?: any | null, differenceAmount?: any | null } | null> | null };

export type CashRegisterClosingPreviewQueryVariables = Exact<{
  businessDate: Scalars['Date']['input'];
}>;


export type CashRegisterClosingPreviewQuery = { __typename?: 'Query', cashRegisterClosingPreview?: { __typename?: 'CashRegisterClosingSummaryType', pk?: number | null, businessDate?: any | null, periodStartedAt?: any | null, closedAt?: any | null, closedByName?: string | null, closedByEmail?: string | null, sangriaTotal?: any | null, totalSales?: any | null, discountTotal?: any | null, receivedTotal?: any | null, canceledTotal?: any | null, finalTotal?: any | null, createdAt?: any | null, paymentMethods?: Array<{ __typename?: 'CashRegisterClosingPaymentMethodSummaryType', paymentMethodName?: string | null, calculatedAmount?: any | null, declaredAmount?: any | null, differenceAmount?: any | null } | null> | null } | null };

export type CashRegisterClosingQueryVariables = Exact<{
  businessDate: Scalars['Date']['input'];
}>;


export type CashRegisterClosingQuery = { __typename?: 'Query', cashRegisterClosing?: { __typename?: 'CashRegisterClosingSummaryType', pk?: number | null, businessDate?: any | null, periodStartedAt?: any | null, closedAt?: any | null, closedByName?: string | null, closedByEmail?: string | null, sangriaTotal?: any | null, totalSales?: any | null, discountTotal?: any | null, receivedTotal?: any | null, canceledTotal?: any | null, finalTotal?: any | null, createdAt?: any | null, paymentMethods?: Array<{ __typename?: 'CashRegisterClosingPaymentMethodSummaryType', paymentMethodName?: string | null, calculatedAmount?: any | null, declaredAmount?: any | null, differenceAmount?: any | null } | null> | null } | null };

export type CashRegisterClosingsQueryVariables = Exact<{
  businessDate: Scalars['Date']['input'];
}>;


export type CashRegisterClosingsQuery = { __typename?: 'Query', cashRegisterClosings?: Array<{ __typename?: 'CashRegisterClosingSummaryType', pk?: number | null, businessDate?: any | null, periodStartedAt?: any | null, closedAt?: any | null, closedByName?: string | null, closedByEmail?: string | null, sangriaTotal?: any | null, totalSales?: any | null, discountTotal?: any | null, receivedTotal?: any | null, canceledTotal?: any | null, finalTotal?: any | null, createdAt?: any | null, paymentMethods?: Array<{ __typename?: 'CashRegisterClosingPaymentMethodSummaryType', paymentMethodName?: string | null, calculatedAmount?: any | null, declaredAmount?: any | null, differenceAmount?: any | null } | null> | null } | null> | null };

export type SaveCashRegisterClosingMutationVariables = Exact<{
  input: SaveCashRegisterClosingInput;
}>;


export type SaveCashRegisterClosingMutation = { __typename?: 'Mutation', cashRegisterClosingSave?: { __typename?: 'CashRegisterClosingSaveMutation', success?: boolean | null, error?: string | null, cashRegisterClosing?: { __typename?: 'CashRegisterClosingSummaryType', pk?: number | null, businessDate?: any | null, periodStartedAt?: any | null, closedAt?: any | null, closedByName?: string | null, closedByEmail?: string | null, sangriaTotal?: any | null, totalSales?: any | null, discountTotal?: any | null, receivedTotal?: any | null, canceledTotal?: any | null, finalTotal?: any | null, createdAt?: any | null, paymentMethods?: Array<{ __typename?: 'CashRegisterClosingPaymentMethodSummaryType', paymentMethodName?: string | null, calculatedAmount?: any | null, declaredAmount?: any | null, differenceAmount?: any | null } | null> | null } | null } | null };

export type GetPurchaseInvoiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPurchaseInvoiceDetailQuery = { __typename?: 'Query', getPurchase?: { __typename?: 'PurchaseType', pk: number, paymentMethod: string, issueDate?: any | null, status: string, importedFrom: PurchaseImportedFrom, shipmentValue: number, discountType: PurchaseDiscountType, discountValue: number, value: number, notes?: string | null, giftbackRedeemedValue: number, storeProfileImageBase64?: string | null, purchasepaymentmethodSet: Array<{ __typename?: 'PurchasePaymentMethodType', pk: number, name: string, value: number, installments?: number | null }>, store: { __typename?: 'StoreType', name: string, telephone: string, email: string, address?: string | null, profileImage?: string | null, profileImageEmail?: string | null }, customer: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null, phone?: string | null, state?: string | null, city?: string | null, address?: string | null }, user?: { __typename?: 'CustomUserNode', gender?: CustomUserGender | null } | null, purchaseproductSet: { __typename?: 'PurchaseProductRelayTypeConnection', edges: Array<{ __typename?: 'PurchaseProductRelayTypeEdge', node?: { __typename?: 'PurchaseProductRelayType', pk: number, quantity?: number | null, value: number, subtotal: number, product: { __typename?: 'ProductRelayType', name: string, unit: ProductUnit } } | null } | null> }, serviceItems: Array<{ __typename?: 'PurchaseServiceType', pk: number, serviceName: string, quantity: number, value: number, subtotal: number, service?: { __typename?: 'ServiceRelayType', pk: number, name: string } | null, appointment?: { __typename?: 'AppointmentType', pk: number } | null }> } | null };

export type GetDetailPurchaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDetailPurchaseQuery = { __typename?: 'Query', getPurchase?: { __typename?: 'PurchaseType', integrationId?: string | null, erpIntegrationId?: string | null, canceledBy?: string | null, canceledAt?: any | null, date?: any | null, value: number, paymentMethod: string, importedFrom: PurchaseImportedFrom, discountType: PurchaseDiscountType, discountValue: number, sellerName?: string | null, justification: string, pk: number, giftbackRedeemedValue: number, extraData?: any | null, nfeKey?: string | null, trackingCode?: string | null, trackingCodeUrl?: string | null, estimatedDeliveryDate?: any | null, deliveryAddress?: string | null, nfeLink?: string | null, volumesQuantity?: number | null, shipmentWeight?: number | null, transportCompany?: string | null, purchasepaymentmethodSet: Array<{ __typename?: 'PurchasePaymentMethodType', pk: number, name: string, value: number, installments?: number | null }>, coupon?: { __typename?: 'CouponRelayType', code: string, value: number, valueType: CouponValueType } | null, store: { __typename?: 'StoreType', name: string }, user?: { __typename?: 'CustomUserNode', name?: string | null } | null, customer: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null, email?: string | null, phone?: string | null, taxDocument?: string | null, state?: string | null, city?: string | null }, purchaseproductSet: { __typename?: 'PurchaseProductRelayTypeConnection', edges: Array<{ __typename?: 'PurchaseProductRelayTypeEdge', node?: { __typename?: 'PurchaseProductRelayType', quantity?: number | null, subtotal: number, value: number, product: { __typename?: 'ProductRelayType', pk: number, name: string, unit: ProductUnit } } | null } | null> }, serviceItems: Array<{ __typename?: 'PurchaseServiceType', pk: number, serviceName: string, quantity: number, subtotal: number, value: number, service?: { __typename?: 'ServiceRelayType', pk: number, name: string } | null, appointment?: { __typename?: 'AppointmentType', pk: number } | null }>, giftback?: { __typename?: 'GiftbackRelayType', pk: number, status: GiftbackStatus, value: number, dueDate: any, code: string } | null, giftbackRedeemed?: { __typename?: 'GiftbackRelayType', pk: number, code: string, id: string } | null, credithousepurchase?: { __typename?: 'CreditHousePurchaseType', installments: number, tax: number, pk: number } | null } | null };

export type RelatorioFechamentoDeCaixaQueryVariables = Exact<{
  periodStartedAt: Scalars['DateTime']['input'];
  closedAt: Scalars['DateTime']['input'];
}>;


export type RelatorioFechamentoDeCaixaQuery = { __typename?: 'Query', allPurchasesRelay?: { __typename?: 'PurchaseRelayTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PurchaseRelayTypeEdge', node?: { __typename?: 'PurchaseRelayType', value: number, pk: number, importedFrom: PurchaseImportedFrom, paymentMethod: string, canceledAt?: any | null, discountValue: number, purchasepaymentmethodSet: Array<{ __typename?: 'PurchasePaymentMethodType', pk: number, name: string, value: number, installments?: number | null }>, purchaseproductSet: { __typename?: 'PurchaseProductRelayTypeConnection', edges: Array<{ __typename?: 'PurchaseProductRelayTypeEdge', node?: { __typename?: 'PurchaseProductRelayType', quantity?: number | null, value: number, product: { __typename?: 'ProductRelayType', pk: number, name: string, unit: ProductUnit } } | null } | null> } } | null } | null> } | null };

export type ListPurchasesPageQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  customer_Phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  integrationId_In?: InputMaybe<Scalars['String']['input']>;
  usernameOrEmailUser?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailCustomer?: InputMaybe<Scalars['String']['input']>;
  value_Gte?: InputMaybe<Scalars['Float']['input']>;
  value_Lte?: InputMaybe<Scalars['Float']['input']>;
  date_Gte?: InputMaybe<Scalars['Date']['input']>;
  date_Lte?: InputMaybe<Scalars['Date']['input']>;
  importedFrom_In?: InputMaybe<Scalars['String']['input']>;
  approvedOrCanceledSales?: InputMaybe<Scalars['String']['input']>;
  sellerName_Icontains?: InputMaybe<Scalars['String']['input']>;
  createdRedeemedGiftback?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Scalars['String']['input']>;
  createdAt_Date_Gte?: InputMaybe<Scalars['Date']['input']>;
  createdAt_Date_Lte?: InputMaybe<Scalars['Date']['input']>;
  coupon_Code_Icontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListPurchasesPageQuery = { __typename?: 'Query', purchaseAll?: { __typename?: 'PurchaseRelayTypeConnection', totalCount?: number | null } | null, purchaseApproved?: { __typename?: 'PurchaseRelayTypeConnection', totalCount?: number | null } | null, purchaseCanceled?: { __typename?: 'PurchaseRelayTypeConnection', totalCount?: number | null } | null, allPurchasesRelay?: { __typename?: 'PurchaseRelayTypeConnection', edgeCount?: number | null, totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'PurchaseRelayTypeEdge', node?: { __typename?: 'PurchaseRelayType', id: string, pk: number, value: number, date?: any | null, importedFrom: PurchaseImportedFrom, canceledBy?: string | null, canceledAt?: any | null, customer: { __typename?: 'CustomerTypeRelay', pk: number, name?: string | null, email?: string | null }, purchaseproductSet: { __typename?: 'PurchaseProductRelayTypeConnection', edges: Array<{ __typename?: 'PurchaseProductRelayTypeEdge', node?: { __typename?: 'PurchaseProductRelayType', quantity?: number | null, product: { __typename?: 'ProductRelayType', pk: number, unit: ProductUnit } } | null } | null> } } | null } | null> } | null };

export type ListAllPurchasesQueryVariables = Exact<{
  customer_Id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAllPurchasesQuery = { __typename?: 'Query', allPurchasesRelay?: { __typename?: 'PurchaseRelayTypeConnection', edges: Array<{ __typename?: 'PurchaseRelayTypeEdge', node?: { __typename?: 'PurchaseRelayType', pk: number, value: number, date?: any | null, importedFrom: PurchaseImportedFrom, canceledBy?: string | null, canceledAt?: any | null, store: { __typename?: 'StoreType', name: string }, customeractivitySet: { __typename?: 'CustomerActivitiesTypeRelayConnection', edges: Array<{ __typename?: 'CustomerActivitiesTypeRelayEdge', node?: { __typename?: 'CustomerActivitiesTypeRelay', activity?: CustomerActivityActivity | null, title?: string | null, description: string, pk: number } | null } | null> }, purchaseproductSet: { __typename?: 'PurchaseProductRelayTypeConnection', edges: Array<{ __typename?: 'PurchaseProductRelayTypeEdge', node?: { __typename?: 'PurchaseProductRelayType', product: { __typename?: 'ProductRelayType', name: string } } | null } | null> }, serviceItems: Array<{ __typename?: 'PurchaseServiceType', serviceName: string }> } | null } | null> } | null };

export type PurchaseExcelReportQueryVariables = Exact<{
  input?: InputMaybe<PurchaseFilterSetInput>;
}>;


export type PurchaseExcelReportQuery = { __typename?: 'Query', purchaseExcelReport?: { __typename?: 'PurchaseExcelReportType', relatorio?: string | null, background?: boolean | null } | null };

export type UpdatePurchaseNotesActionMutationVariables = Exact<{
  purchaseInput: UpdatePurchaseNotesInput;
}>;


export type UpdatePurchaseNotesActionMutation = { __typename?: 'Mutation', purchaseNotesUpdate?: { __typename?: 'UpdatePurchaseNotesMutation', purchase?: { __typename?: 'PurchaseType', notes?: string | null } | null } | null };

export type ServicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  nameIcontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type ServicesQuery = { __typename?: 'Query', allServicesRelay?: { __typename?: 'ServiceRelayTypeConnection', edges: Array<{ __typename?: 'ServiceRelayTypeEdge', node?: { __typename?: 'ServiceRelayType', id: string, pk: number, name: string, description: string, value: number, costValue: number, promotionalValue: number, durationMinutes?: number | null, bufferBeforeMinutes: number, bufferAfterMinutes: number, recommendedReturnDays?: number | null, isActive: boolean, availableInPdv: boolean, availableForBooking: boolean, isPublic: boolean, category: { __typename?: 'ServiceCategoryType', id: string, pk: number, name: string } } | null } | null> } | null, serviceCategories?: Array<{ __typename?: 'ServiceCategoryType', id: string, pk: number, name: string, isActive: boolean } | null> | null };

export type ServiceDashboardQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Date']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ServiceDashboardQuery = { __typename?: 'Query', serviceDashboard?: { __typename?: 'ServiceDashboardType', activeServices?: number | null, pdvServices?: number | null, bookingServices?: number | null, servicesSold?: number | null, serviceRevenue?: any | null, averageServiceTicket?: any | null } | null };

export type SaveServiceCategoryFrontendMutationVariables = Exact<{
  input: SaveServiceCategoryInput;
}>;


export type SaveServiceCategoryFrontendMutation = { __typename?: 'Mutation', saveServiceCategory?: { __typename?: 'SaveServiceCategoryMutation', category?: { __typename?: 'ServiceCategoryType', id: string, pk: number, name: string, isActive: boolean } | null } | null };

export type SaveServiceFrontendMutationVariables = Exact<{
  input: SaveServiceInput;
}>;


export type SaveServiceFrontendMutation = { __typename?: 'Mutation', saveService?: { __typename?: 'SaveServiceMutation', service?: { __typename?: 'ServiceType', id: string, pk: number, name: string, description: string, value: number, costValue: number, promotionalValue: number, durationMinutes?: number | null, bufferBeforeMinutes: number, bufferAfterMinutes: number, recommendedReturnDays?: number | null, isActive: boolean, availableInPdv: boolean, availableForBooking: boolean, isPublic: boolean, category: { __typename?: 'ServiceCategoryType', id: string, pk: number, name: string } } | null } | null };

export type GetPublicStoreDataQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetPublicStoreDataQuery = { __typename?: 'Query', getStoreBySlug?: { __typename?: 'ReturnStorePublicData', pk?: string | null, url?: string | null, profileImage?: string | null } | null };

export type GetStoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoreQuery = { __typename?: 'Query', getStore?: { __typename?: 'StoreType', id: string, name: string, telephone: string, email: string, cnpj: string, plan: StorePlan, isActive: boolean, url?: string | null, profileImage?: string | null, currencyType: StoreCurrencyType, hasBulkNotificationPermission: boolean, totalNotificationCredits: number, usedNotificationCredits: number, extraNotificationCredits: number, availableBulkNotificationChannels: StoreAvailableBulkNotificationChannels, zekiMessage: StoreZekiMessage, profileImageEmail?: string | null, emailFooterPrimaryColor: string, emailFooterSecondaryColor: string, emailFooterTertiaryColor: string, emailFooterImg?: string | null, whatsappconfig?: { __typename?: 'WhatsappConfigType', connected: boolean, activated: boolean } | null, emailproviderstoreintegration?: { __typename?: 'EmailProviderStoreIntegrationType', isActive: boolean } | null, evolutionapiintegration?: { __typename?: 'EvolutionApiIntegrationType', connected: boolean } | null, zapiintegration?: { __typename?: 'ZApiIntegrationType', connected: boolean } | null, helenastoreintegration?: { __typename?: 'HelenaStoreIntegrationType', connected: boolean, activated: boolean } | null, connectedIntegration?: { __typename?: 'ConnectedStoreIntegrationType', integration?: string | null, isConnected?: boolean | null } | null } | null };

export type GetWatsappConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWatsappConfigQuery = { __typename?: 'Query', getStore?: { __typename?: 'StoreType', whatsappconfig?: { __typename?: 'WhatsappConfigType', connected: boolean, activated: boolean } | null } | null };

export type StoreUpdateMutationVariables = Exact<{
  input?: InputMaybe<UpdateStoreInput>;
}>;


export type StoreUpdateMutation = { __typename?: 'Mutation', storeUpdate?: { __typename?: 'UpdateStoreMutation', ok?: boolean | null, store?: { __typename?: 'StoreType', id: string, name: string, telephone: string, email: string, cnpj: string, plan: StorePlan, isActive: boolean } | null } | null };

export type CreatePurchaseViaTotemMutationVariables = Exact<{
  purchaseInput: CreatePurchaseTotemInput;
}>;


export type CreatePurchaseViaTotemMutation = { __typename?: 'Mutation', purchaseTotemCreate?: { __typename?: 'CreatePurchaseTotemMutation', success?: boolean | null, error?: string | null } | null };

export type GetCreditHouseGiftbackConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditHouseGiftbackConfigQuery = { __typename?: 'Query', getStore?: { __typename?: 'StoreType', credithouseconfig?: { __typename?: 'CreditHouseConfigType', credithousegiftbackconfigSet: Array<{ __typename?: 'CreditHouseGiftbackConfigType', id: string, pk: number, loanMinValue: number, loanMaxValue: number, taxMinValue: number, taxMaxValue: number, giftbackTypeValue: CreditHouseGiftbackConfigGiftbackTypeValue, giftbackValue: number }> } | null } | null };

export type GetDetailGiftbackQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type GetDetailGiftbackQuery = { __typename?: 'Query', getGiftbackByCodeCpfEmailPhone?: { __typename?: 'GiftbackType', pk: number, code: string, status: GiftbackStatus, dueDate: any, value: number, importedFrom: GiftbackImportedFrom, minValueToRedeem: number, purchase?: { __typename?: 'PurchaseRelayType', value: number } | null, customer: { __typename?: 'CustomerTypeRelay', id: string, pk: number }, store: { __typename?: 'StoreType', giftbackconfig?: { __typename?: 'GiftbackConfigType', multiplegiftbackconfigSet: Array<{ __typename?: 'MultipleGiftbackConfigType', id: string, minPurchaseValueForRedeem: number, minimumValueType: MultipleGiftbackConfigMinimumValueType, maximumDiscountPercentage: number }> } | null } } | null };

export type CreateUserMutationVariables = Exact<{
  userInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUserCustom?: { __typename?: 'CreateCustomUserMutation', ok?: boolean | null, customUser?: { __typename?: 'CustomUserType', id: string, name?: string | null } | null } | null };

export type UpdateUserCustomMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateUserCustomMutation = { __typename?: 'Mutation', updateUserCustom?: { __typename?: 'UpdateCustomUserMutation', ok?: boolean | null } | null };

export type ForgotEmailMutationVariables = Exact<{
  input: SendPasswordResetEmailInput;
}>;


export type ForgotEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: { __typename?: 'SendPasswordResetEmailPayload', success?: boolean | null, errors?: any | null } | null };

export type ListUserQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameOrEmail?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  cpf_Icontains?: InputMaybe<Scalars['String']['input']>;
  phone_Icontains?: InputMaybe<Scalars['String']['input']>;
  permissions_UserType_In?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListUserQuery = { __typename?: 'Query', usersAll?: { __typename?: 'CustomUserRelayTypeConnection', totalCount?: number | null } | null, userActive?: { __typename?: 'CustomUserRelayTypeConnection', totalCount?: number | null } | null, userInactive?: { __typename?: 'CustomUserRelayTypeConnection', totalCount?: number | null } | null, allUsersRelay?: { __typename?: 'CustomUserRelayTypeConnection', totalCount?: number | null, edgeCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CustomUserRelayTypeEdge', node?: { __typename?: 'CustomUserRelayType', id: string, pk: number, cpf?: string | null, name?: string | null, email: string, phone?: string | null, isActive: boolean, permissionInStore?: { __typename?: 'PermissionType', userType?: PermissionUserType | null } | null, permissions: Array<{ __typename?: 'PermissionType', userType?: PermissionUserType | null, store: { __typename?: 'StoreType', id: string, name: string } }> } | null } | null> } | null };

export type PasswordResetMutationVariables = Exact<{
  input: PasswordResetInput;
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: { __typename?: 'PasswordResetPayload', success?: boolean | null, errors?: any | null } | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  input: RedefinePasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', redefinePassword?: { __typename?: 'RedefinePasswordMutation', ok?: boolean | null } | null };

export type GetUserDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserDetailsQuery = { __typename?: 'Query', getUser?: { __typename?: 'CustomUserType', id: string, pk: number, username: string, email: string, name?: string | null, cpf?: string | null, gender?: CustomUserGender | null, phone?: string | null, birthdate?: any | null, isActive: boolean, isStaff: boolean, connectedStore?: { __typename?: 'StoreType', id: string } | null, permissions: Array<{ __typename?: 'PermissionType', userType?: PermissionUserType | null, store: { __typename?: 'StoreType', id: string } }> } | null };

export type LoginMutationVariables = Exact<{
  input: ObtainJsonWebTokenInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'ObtainJSONWebTokenPayload', success?: boolean | null, errors?: any | null, unarchiving?: boolean | null, token?: string | null, user?: { __typename?: 'UserNode', id: string, username: string } | null } | null };

export const CommunityFieldsFragmentDoc = gql`
    fragment CommunityFields on Community {
  id
  name
  description
  adminsOnly
  status
  groupJid
  audienceSelectionId
  sourceLabel
  connectionPhone
  instanceName
  totalCount
  eligibleCount
  addedCount
  failedCount
  invalidCount
  duplicateCount
  pendingCount
  lastError
  canRetry
  createdAt
  updatedAt
}
    `;
export const CommunityMessageFieldsFragmentDoc = gql`
    fragment CommunityMessageFields on CommunityScheduledMessage {
  id
  communityId
  text
  scheduledAt
  timeZone
  status
  revision
  canEdit
  canCancel
  lastError
  sentAt
  createdAt
  updatedAt
}
    `;
export const PlanningEventFieldsFragmentDoc = gql`
    fragment PlanningEventFields on PlanningEvent {
  id
  source
  sourceId
  communityId
  title
  startsAt
  date
  allDay
  timeZone
  status
  rawStatus
  destination
  channels
  dateBasis
}
    `;
export const CashRegisterClosingFieldsFragmentDoc = gql`
    fragment CashRegisterClosingFields on CashRegisterClosingSummaryType {
  pk
  businessDate
  periodStartedAt
  closedAt
  closedByName
  closedByEmail
  sangriaTotal
  totalSales
  discountTotal
  receivedTotal
  canceledTotal
  finalTotal
  createdAt
  paymentMethods {
    paymentMethodName
    calculatedAmount
    declaredAmount
    differenceAmount
  }
}
    `;
export const SaveBookingSettingsFrontendDocument = gql`
    mutation SaveBookingSettingsFrontend($input: SaveBookingSettingsInput!) {
  saveBookingSettings(input: $input) {
    workspace {
      unit {
        id
        pk
        name
        timezone
        address
        phone
      }
      bookingPage {
        id
        pk
        slug
        title
        description
        isPublished
        minimumLeadMinutes
        bookingHorizonDays
        cancellationLeadMinutes
        slotIntervalMinutes
        allowProfessionalPreference
        reminderOffsetMinutes
        reminderViaWhatsapp
        reminderViaEmail
        termsUrl
        privacyUrl
      }
      storefront {
        id
        pk
        preset
        primaryColor
        accentColor
        surfaceColor
        logoUrl
        logoAlt
        coverImageUrl
        coverImageAlt
        aboutTitle
        aboutText
        instagramUrl
        facebookUrl
        tiktokUrl
        websiteUrl
        mapsUrl
        latitude
        longitude
        seoTitle
        seoDescription
        publishedAt
      }
    }
  }
}
    `;
export type SaveBookingSettingsFrontendMutationFn = Apollo.MutationFunction<SaveBookingSettingsFrontendMutation, SaveBookingSettingsFrontendMutationVariables>;

/**
 * __useSaveBookingSettingsFrontendMutation__
 *
 * To run a mutation, you first call `useSaveBookingSettingsFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingSettingsFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingSettingsFrontendMutation, { data, loading, error }] = useSaveBookingSettingsFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBookingSettingsFrontendMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingSettingsFrontendMutation, SaveBookingSettingsFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingSettingsFrontendMutation, SaveBookingSettingsFrontendMutationVariables>(SaveBookingSettingsFrontendDocument, options);
      }
export type SaveBookingSettingsFrontendMutationHookResult = ReturnType<typeof useSaveBookingSettingsFrontendMutation>;
export type SaveBookingSettingsFrontendMutationResult = Apollo.MutationResult<SaveBookingSettingsFrontendMutation>;
export type SaveBookingSettingsFrontendMutationOptions = Apollo.BaseMutationOptions<SaveBookingSettingsFrontendMutation, SaveBookingSettingsFrontendMutationVariables>;
export const PublishBookingStorefrontFrontendDocument = gql`
    mutation PublishBookingStorefrontFrontend {
  publishBookingStorefront {
    workspace {
      bookingPage {
        id
        pk
        slug
        title
        description
        isPublished
      }
      storefront {
        id
        pk
        preset
        primaryColor
        accentColor
        surfaceColor
        logoUrl
        coverImageUrl
        aboutTitle
        aboutText
        publishedAt
      }
    }
  }
}
    `;
export type PublishBookingStorefrontFrontendMutationFn = Apollo.MutationFunction<PublishBookingStorefrontFrontendMutation, PublishBookingStorefrontFrontendMutationVariables>;

/**
 * __usePublishBookingStorefrontFrontendMutation__
 *
 * To run a mutation, you first call `usePublishBookingStorefrontFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishBookingStorefrontFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishBookingStorefrontFrontendMutation, { data, loading, error }] = usePublishBookingStorefrontFrontendMutation({
 *   variables: {
 *   },
 * });
 */
export function usePublishBookingStorefrontFrontendMutation(baseOptions?: Apollo.MutationHookOptions<PublishBookingStorefrontFrontendMutation, PublishBookingStorefrontFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishBookingStorefrontFrontendMutation, PublishBookingStorefrontFrontendMutationVariables>(PublishBookingStorefrontFrontendDocument, options);
      }
export type PublishBookingStorefrontFrontendMutationHookResult = ReturnType<typeof usePublishBookingStorefrontFrontendMutation>;
export type PublishBookingStorefrontFrontendMutationResult = Apollo.MutationResult<PublishBookingStorefrontFrontendMutation>;
export type PublishBookingStorefrontFrontendMutationOptions = Apollo.BaseMutationOptions<PublishBookingStorefrontFrontendMutation, PublishBookingStorefrontFrontendMutationVariables>;
export const SaveProfessionalFrontendDocument = gql`
    mutation SaveProfessionalFrontend($input: SaveProfessionalInput!) {
  saveAppointmentProfessional(input: $input) {
    professional {
      id
      pk
      publicName
      bio
      photoUrl
      isActive
      isPublic
      services {
        id
        pk
        name
      }
    }
  }
}
    `;
export type SaveProfessionalFrontendMutationFn = Apollo.MutationFunction<SaveProfessionalFrontendMutation, SaveProfessionalFrontendMutationVariables>;

/**
 * __useSaveProfessionalFrontendMutation__
 *
 * To run a mutation, you first call `useSaveProfessionalFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProfessionalFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProfessionalFrontendMutation, { data, loading, error }] = useSaveProfessionalFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProfessionalFrontendMutation(baseOptions?: Apollo.MutationHookOptions<SaveProfessionalFrontendMutation, SaveProfessionalFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProfessionalFrontendMutation, SaveProfessionalFrontendMutationVariables>(SaveProfessionalFrontendDocument, options);
      }
export type SaveProfessionalFrontendMutationHookResult = ReturnType<typeof useSaveProfessionalFrontendMutation>;
export type SaveProfessionalFrontendMutationResult = Apollo.MutationResult<SaveProfessionalFrontendMutation>;
export type SaveProfessionalFrontendMutationOptions = Apollo.BaseMutationOptions<SaveProfessionalFrontendMutation, SaveProfessionalFrontendMutationVariables>;
export const ReplaceWorkingHoursFrontendDocument = gql`
    mutation ReplaceWorkingHoursFrontend($hours: [WorkingHoursInput]!) {
  replaceAppointmentWorkingHours(hours: $hours) {
    workingHours {
      id
      pk
      scope
      weekday
      startTime
      endTime
      professional {
        id
        pk
        publicName
      }
    }
  }
}
    `;
export type ReplaceWorkingHoursFrontendMutationFn = Apollo.MutationFunction<ReplaceWorkingHoursFrontendMutation, ReplaceWorkingHoursFrontendMutationVariables>;

/**
 * __useReplaceWorkingHoursFrontendMutation__
 *
 * To run a mutation, you first call `useReplaceWorkingHoursFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceWorkingHoursFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceWorkingHoursFrontendMutation, { data, loading, error }] = useReplaceWorkingHoursFrontendMutation({
 *   variables: {
 *      hours: // value for 'hours'
 *   },
 * });
 */
export function useReplaceWorkingHoursFrontendMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceWorkingHoursFrontendMutation, ReplaceWorkingHoursFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceWorkingHoursFrontendMutation, ReplaceWorkingHoursFrontendMutationVariables>(ReplaceWorkingHoursFrontendDocument, options);
      }
export type ReplaceWorkingHoursFrontendMutationHookResult = ReturnType<typeof useReplaceWorkingHoursFrontendMutation>;
export type ReplaceWorkingHoursFrontendMutationResult = Apollo.MutationResult<ReplaceWorkingHoursFrontendMutation>;
export type ReplaceWorkingHoursFrontendMutationOptions = Apollo.BaseMutationOptions<ReplaceWorkingHoursFrontendMutation, ReplaceWorkingHoursFrontendMutationVariables>;
export const SaveScheduleAdjustmentFrontendDocument = gql`
    mutation SaveScheduleAdjustmentFrontend($input: SaveScheduleAdjustmentInput!) {
  saveScheduleAdjustment(input: $input) {
    adjustment {
      id
      pk
      kind
      startsAt
      endsAt
      reason
      repeatsWeekly
      professional {
        id
        pk
        publicName
      }
    }
  }
}
    `;
export type SaveScheduleAdjustmentFrontendMutationFn = Apollo.MutationFunction<SaveScheduleAdjustmentFrontendMutation, SaveScheduleAdjustmentFrontendMutationVariables>;

/**
 * __useSaveScheduleAdjustmentFrontendMutation__
 *
 * To run a mutation, you first call `useSaveScheduleAdjustmentFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleAdjustmentFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScheduleAdjustmentFrontendMutation, { data, loading, error }] = useSaveScheduleAdjustmentFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduleAdjustmentFrontendMutation(baseOptions?: Apollo.MutationHookOptions<SaveScheduleAdjustmentFrontendMutation, SaveScheduleAdjustmentFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveScheduleAdjustmentFrontendMutation, SaveScheduleAdjustmentFrontendMutationVariables>(SaveScheduleAdjustmentFrontendDocument, options);
      }
export type SaveScheduleAdjustmentFrontendMutationHookResult = ReturnType<typeof useSaveScheduleAdjustmentFrontendMutation>;
export type SaveScheduleAdjustmentFrontendMutationResult = Apollo.MutationResult<SaveScheduleAdjustmentFrontendMutation>;
export type SaveScheduleAdjustmentFrontendMutationOptions = Apollo.BaseMutationOptions<SaveScheduleAdjustmentFrontendMutation, SaveScheduleAdjustmentFrontendMutationVariables>;
export const CreateInternalAppointmentFrontendDocument = gql`
    mutation CreateInternalAppointmentFrontend($input: InternalAppointmentInput!) {
  createInternalAppointment(input: $input) {
    appointment {
      id
      pk
      publicId
      startsAt
      endsAt
      serviceName
      status
      customer {
        id
        pk
        name
      }
      professional {
        id
        pk
        publicName
      }
    }
  }
}
    `;
export type CreateInternalAppointmentFrontendMutationFn = Apollo.MutationFunction<CreateInternalAppointmentFrontendMutation, CreateInternalAppointmentFrontendMutationVariables>;

/**
 * __useCreateInternalAppointmentFrontendMutation__
 *
 * To run a mutation, you first call `useCreateInternalAppointmentFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalAppointmentFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalAppointmentFrontendMutation, { data, loading, error }] = useCreateInternalAppointmentFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalAppointmentFrontendMutation(baseOptions?: Apollo.MutationHookOptions<CreateInternalAppointmentFrontendMutation, CreateInternalAppointmentFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInternalAppointmentFrontendMutation, CreateInternalAppointmentFrontendMutationVariables>(CreateInternalAppointmentFrontendDocument, options);
      }
export type CreateInternalAppointmentFrontendMutationHookResult = ReturnType<typeof useCreateInternalAppointmentFrontendMutation>;
export type CreateInternalAppointmentFrontendMutationResult = Apollo.MutationResult<CreateInternalAppointmentFrontendMutation>;
export type CreateInternalAppointmentFrontendMutationOptions = Apollo.BaseMutationOptions<CreateInternalAppointmentFrontendMutation, CreateInternalAppointmentFrontendMutationVariables>;
export const ChangeAppointmentStatusFrontendDocument = gql`
    mutation ChangeAppointmentStatusFrontend($appointmentId: ID!, $status: String!, $reason: String) {
  changeAppointmentStatus(
    appointmentId: $appointmentId
    status: $status
    reason: $reason
  ) {
    appointment {
      id
      pk
      publicId
      startsAt
      endsAt
      serviceName
      status
      customer {
        id
        pk
        name
      }
      professional {
        id
        pk
        publicName
      }
    }
  }
}
    `;
export type ChangeAppointmentStatusFrontendMutationFn = Apollo.MutationFunction<ChangeAppointmentStatusFrontendMutation, ChangeAppointmentStatusFrontendMutationVariables>;

/**
 * __useChangeAppointmentStatusFrontendMutation__
 *
 * To run a mutation, you first call `useChangeAppointmentStatusFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAppointmentStatusFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAppointmentStatusFrontendMutation, { data, loading, error }] = useChangeAppointmentStatusFrontendMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useChangeAppointmentStatusFrontendMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAppointmentStatusFrontendMutation, ChangeAppointmentStatusFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAppointmentStatusFrontendMutation, ChangeAppointmentStatusFrontendMutationVariables>(ChangeAppointmentStatusFrontendDocument, options);
      }
export type ChangeAppointmentStatusFrontendMutationHookResult = ReturnType<typeof useChangeAppointmentStatusFrontendMutation>;
export type ChangeAppointmentStatusFrontendMutationResult = Apollo.MutationResult<ChangeAppointmentStatusFrontendMutation>;
export type ChangeAppointmentStatusFrontendMutationOptions = Apollo.BaseMutationOptions<ChangeAppointmentStatusFrontendMutation, ChangeAppointmentStatusFrontendMutationVariables>;
export const RescheduleAppointmentFrontendDocument = gql`
    mutation RescheduleAppointmentFrontend($appointmentId: ID!, $startsAt: DateTime!, $professionalId: ID) {
  rescheduleAppointment(
    appointmentId: $appointmentId
    startsAt: $startsAt
    professionalId: $professionalId
  ) {
    result {
      code
      message
      alternativeSlots {
        startsAt
        endsAt
        professionalId
        professionalName
      }
      appointment {
        publicId
        startsAt
        endsAt
        status
      }
    }
  }
}
    `;
export type RescheduleAppointmentFrontendMutationFn = Apollo.MutationFunction<RescheduleAppointmentFrontendMutation, RescheduleAppointmentFrontendMutationVariables>;

/**
 * __useRescheduleAppointmentFrontendMutation__
 *
 * To run a mutation, you first call `useRescheduleAppointmentFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleAppointmentFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleAppointmentFrontendMutation, { data, loading, error }] = useRescheduleAppointmentFrontendMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      startsAt: // value for 'startsAt'
 *      professionalId: // value for 'professionalId'
 *   },
 * });
 */
export function useRescheduleAppointmentFrontendMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleAppointmentFrontendMutation, RescheduleAppointmentFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleAppointmentFrontendMutation, RescheduleAppointmentFrontendMutationVariables>(RescheduleAppointmentFrontendDocument, options);
      }
export type RescheduleAppointmentFrontendMutationHookResult = ReturnType<typeof useRescheduleAppointmentFrontendMutation>;
export type RescheduleAppointmentFrontendMutationResult = Apollo.MutationResult<RescheduleAppointmentFrontendMutation>;
export type RescheduleAppointmentFrontendMutationOptions = Apollo.BaseMutationOptions<RescheduleAppointmentFrontendMutation, RescheduleAppointmentFrontendMutationVariables>;
export const AppointmentWorkspaceDocument = gql`
    query AppointmentWorkspace {
  appointmentWorkspace {
    unit {
      id
      pk
      name
      timezone
      address
      phone
      isPrimary
      isActive
    }
    bookingPage {
      id
      pk
      slug
      title
      description
      isPublished
      minimumLeadMinutes
      bookingHorizonDays
      cancellationLeadMinutes
      slotIntervalMinutes
      allowProfessionalPreference
      reminderOffsetMinutes
      reminderViaWhatsapp
      reminderViaEmail
      termsUrl
      privacyUrl
    }
    storefront {
      id
      pk
      preset
      primaryColor
      accentColor
      surfaceColor
      logoUrl
      logoAlt
      coverImageUrl
      coverImageAlt
      aboutTitle
      aboutText
      instagramUrl
      facebookUrl
      tiktokUrl
      websiteUrl
      mapsUrl
      latitude
      longitude
      seoTitle
      seoDescription
      publishedAt
    }
    professionals {
      id
      pk
      publicName
      bio
      photoUrl
      isActive
      isPublic
      user {
        id
        pk
        name
        email
      }
      services {
        id
        pk
        name
        durationMinutes
        value
      }
    }
    workingHours {
      id
      pk
      scope
      weekday
      startTime
      endTime
      professional {
        id
        pk
        publicName
      }
    }
    adjustments {
      id
      pk
      kind
      startsAt
      endsAt
      reason
      notes
      repeatsWeekly
      repeatsUntil
      professional {
        id
        pk
        publicName
      }
    }
  }
}
    `;

/**
 * __useAppointmentWorkspaceQuery__
 *
 * To run a query within a React component, call `useAppointmentWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentWorkspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppointmentWorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>(AppointmentWorkspaceDocument, options);
      }
export function useAppointmentWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>(AppointmentWorkspaceDocument, options);
        }
export function useAppointmentWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>(AppointmentWorkspaceDocument, options);
        }
export type AppointmentWorkspaceQueryHookResult = ReturnType<typeof useAppointmentWorkspaceQuery>;
export type AppointmentWorkspaceLazyQueryHookResult = ReturnType<typeof useAppointmentWorkspaceLazyQuery>;
export type AppointmentWorkspaceSuspenseQueryHookResult = ReturnType<typeof useAppointmentWorkspaceSuspenseQuery>;
export type AppointmentWorkspaceQueryResult = Apollo.QueryResult<AppointmentWorkspaceQuery, AppointmentWorkspaceQueryVariables>;
export const AppointmentStorefrontPreviewDocument = gql`
    query AppointmentStorefrontPreview {
  appointmentStorefrontPreview {
    slug
    storeName
    logo
    title
    description
    timezone
    address
    phone
    allowProfessionalPreference
    termsUrl
    privacyUrl
    storefront {
      preset
      primaryColor
      accentColor
      surfaceColor
      logoUrl
      logoAlt
      coverImageUrl
      coverImageAlt
      aboutTitle
      aboutText
      instagramUrl
      facebookUrl
      tiktokUrl
      websiteUrl
      mapsUrl
      latitude
      longitude
      seoTitle
      seoDescription
    }
    workingHours {
      id
      pk
      scope
      weekday
      startTime
      endTime
    }
    services {
      id
      categoryId
      categoryName
      name
      description
      value
      durationMinutes
    }
    professionals {
      id
      name
      bio
      photoUrl
      serviceIds
    }
  }
}
    `;

/**
 * __useAppointmentStorefrontPreviewQuery__
 *
 * To run a query within a React component, call `useAppointmentStorefrontPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentStorefrontPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentStorefrontPreviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppointmentStorefrontPreviewQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>(AppointmentStorefrontPreviewDocument, options);
      }
export function useAppointmentStorefrontPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>(AppointmentStorefrontPreviewDocument, options);
        }
export function useAppointmentStorefrontPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>(AppointmentStorefrontPreviewDocument, options);
        }
export type AppointmentStorefrontPreviewQueryHookResult = ReturnType<typeof useAppointmentStorefrontPreviewQuery>;
export type AppointmentStorefrontPreviewLazyQueryHookResult = ReturnType<typeof useAppointmentStorefrontPreviewLazyQuery>;
export type AppointmentStorefrontPreviewSuspenseQueryHookResult = ReturnType<typeof useAppointmentStorefrontPreviewSuspenseQuery>;
export type AppointmentStorefrontPreviewQueryResult = Apollo.QueryResult<AppointmentStorefrontPreviewQuery, AppointmentStorefrontPreviewQueryVariables>;
export const AppointmentsDocument = gql`
    query Appointments($start: DateTime!, $end: DateTime!, $professionalIds: [ID], $statuses: [String], $search: String) {
  appointments(
    start: $start
    end: $end
    professionalIds: $professionalIds
    statuses: $statuses
    search: $search
  ) {
    id
    pk
    publicId
    startsAt
    endsAt
    occupiedStartsAt
    occupiedEndsAt
    serviceName
    serviceValue
    durationMinutes
    status
    origin
    notes
    cancellationReason
    version
    customer {
      id
      pk
      name
      phone
      email
    }
    professional {
      id
      pk
      publicName
    }
    service {
      id
      pk
      name
      category {
        id
        pk
        name
      }
    }
  }
}
    `;

/**
 * __useAppointmentsQuery__
 *
 * To run a query within a React component, call `useAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      professionalIds: // value for 'professionalIds'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
      }
export function useAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
        }
export function useAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
        }
export type AppointmentsQueryHookResult = ReturnType<typeof useAppointmentsQuery>;
export type AppointmentsLazyQueryHookResult = ReturnType<typeof useAppointmentsLazyQuery>;
export type AppointmentsSuspenseQueryHookResult = ReturnType<typeof useAppointmentsSuspenseQuery>;
export type AppointmentsQueryResult = Apollo.QueryResult<AppointmentsQuery, AppointmentsQueryVariables>;
export const AppointmentAvailabilityDocument = gql`
    query AppointmentAvailability($serviceId: ID!, $start: Date!, $end: Date!, $professionalId: ID) {
  appointmentAvailability(
    serviceId: $serviceId
    start: $start
    end: $end
    professionalId: $professionalId
  ) {
    startsAt
    endsAt
    professionalId
    professionalName
  }
}
    `;

/**
 * __useAppointmentAvailabilityQuery__
 *
 * To run a query within a React component, call `useAppointmentAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentAvailabilityQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      professionalId: // value for 'professionalId'
 *   },
 * });
 */
export function useAppointmentAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>(AppointmentAvailabilityDocument, options);
      }
export function useAppointmentAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>(AppointmentAvailabilityDocument, options);
        }
export function useAppointmentAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>(AppointmentAvailabilityDocument, options);
        }
export type AppointmentAvailabilityQueryHookResult = ReturnType<typeof useAppointmentAvailabilityQuery>;
export type AppointmentAvailabilityLazyQueryHookResult = ReturnType<typeof useAppointmentAvailabilityLazyQuery>;
export type AppointmentAvailabilitySuspenseQueryHookResult = ReturnType<typeof useAppointmentAvailabilitySuspenseQuery>;
export type AppointmentAvailabilityQueryResult = Apollo.QueryResult<AppointmentAvailabilityQuery, AppointmentAvailabilityQueryVariables>;
export const AppointmentDashboardDocument = gql`
    query AppointmentDashboard($start: DateTime!, $end: DateTime!) {
  appointmentDashboard(start: $start, end: $end) {
    total
    occupancyRate
    confirmationRate
    attendanceRate
    cancellationRate
    noShowRate
    estimatedValue
    realizedRevenue
  }
}
    `;

/**
 * __useAppointmentDashboardQuery__
 *
 * To run a query within a React component, call `useAppointmentDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentDashboardQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useAppointmentDashboardQuery(baseOptions: Apollo.QueryHookOptions<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>(AppointmentDashboardDocument, options);
      }
export function useAppointmentDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>(AppointmentDashboardDocument, options);
        }
export function useAppointmentDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>(AppointmentDashboardDocument, options);
        }
export type AppointmentDashboardQueryHookResult = ReturnType<typeof useAppointmentDashboardQuery>;
export type AppointmentDashboardLazyQueryHookResult = ReturnType<typeof useAppointmentDashboardLazyQuery>;
export type AppointmentDashboardSuspenseQueryHookResult = ReturnType<typeof useAppointmentDashboardSuspenseQuery>;
export type AppointmentDashboardQueryResult = Apollo.QueryResult<AppointmentDashboardQuery, AppointmentDashboardQueryVariables>;
export const AppointmentCustomersDocument = gql`
    query AppointmentCustomers($search: String) {
  allCustomersRelay(first: 100, name_Icontains: $search) {
    edges {
      node {
        id
        pk
        name
        phone
        email
      }
    }
  }
}
    `;

/**
 * __useAppointmentCustomersQuery__
 *
 * To run a query within a React component, call `useAppointmentCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentCustomersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAppointmentCustomersQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>(AppointmentCustomersDocument, options);
      }
export function useAppointmentCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>(AppointmentCustomersDocument, options);
        }
export function useAppointmentCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>(AppointmentCustomersDocument, options);
        }
export type AppointmentCustomersQueryHookResult = ReturnType<typeof useAppointmentCustomersQuery>;
export type AppointmentCustomersLazyQueryHookResult = ReturnType<typeof useAppointmentCustomersLazyQuery>;
export type AppointmentCustomersSuspenseQueryHookResult = ReturnType<typeof useAppointmentCustomersSuspenseQuery>;
export type AppointmentCustomersQueryResult = Apollo.QueryResult<AppointmentCustomersQuery, AppointmentCustomersQueryVariables>;
export const PublicAppointmentPageDocument = gql`
    query PublicAppointmentPage($slug: String!) {
  publicAppointmentPage(slug: $slug) {
    slug
    storeName
    logo
    title
    description
    timezone
    address
    phone
    allowProfessionalPreference
    termsUrl
    privacyUrl
    storefront {
      preset
      primaryColor
      accentColor
      surfaceColor
      logoUrl
      logoAlt
      coverImageUrl
      coverImageAlt
      aboutTitle
      aboutText
      instagramUrl
      facebookUrl
      tiktokUrl
      websiteUrl
      mapsUrl
      latitude
      longitude
      seoTitle
      seoDescription
    }
    workingHours {
      id
      pk
      scope
      weekday
      startTime
      endTime
    }
    services {
      id
      categoryId
      categoryName
      name
      description
      value
      durationMinutes
    }
    professionals {
      id
      name
      bio
      photoUrl
      serviceIds
    }
  }
}
    `;

/**
 * __usePublicAppointmentPageQuery__
 *
 * To run a query within a React component, call `usePublicAppointmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAppointmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAppointmentPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicAppointmentPageQuery(baseOptions: Apollo.QueryHookOptions<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>(PublicAppointmentPageDocument, options);
      }
export function usePublicAppointmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>(PublicAppointmentPageDocument, options);
        }
export function usePublicAppointmentPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>(PublicAppointmentPageDocument, options);
        }
export type PublicAppointmentPageQueryHookResult = ReturnType<typeof usePublicAppointmentPageQuery>;
export type PublicAppointmentPageLazyQueryHookResult = ReturnType<typeof usePublicAppointmentPageLazyQuery>;
export type PublicAppointmentPageSuspenseQueryHookResult = ReturnType<typeof usePublicAppointmentPageSuspenseQuery>;
export type PublicAppointmentPageQueryResult = Apollo.QueryResult<PublicAppointmentPageQuery, PublicAppointmentPageQueryVariables>;
export const PublicAppointmentAvailabilityDocument = gql`
    query PublicAppointmentAvailability($slug: String!, $serviceId: ID!, $start: Date!, $end: Date!, $professionalId: ID) {
  publicAppointmentAvailability(
    slug: $slug
    serviceId: $serviceId
    start: $start
    end: $end
    professionalId: $professionalId
  ) {
    startsAt
    endsAt
    professionalId
    professionalName
  }
}
    `;

/**
 * __usePublicAppointmentAvailabilityQuery__
 *
 * To run a query within a React component, call `usePublicAppointmentAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAppointmentAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAppointmentAvailabilityQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      serviceId: // value for 'serviceId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      professionalId: // value for 'professionalId'
 *   },
 * });
 */
export function usePublicAppointmentAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>(PublicAppointmentAvailabilityDocument, options);
      }
export function usePublicAppointmentAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>(PublicAppointmentAvailabilityDocument, options);
        }
export function usePublicAppointmentAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>(PublicAppointmentAvailabilityDocument, options);
        }
export type PublicAppointmentAvailabilityQueryHookResult = ReturnType<typeof usePublicAppointmentAvailabilityQuery>;
export type PublicAppointmentAvailabilityLazyQueryHookResult = ReturnType<typeof usePublicAppointmentAvailabilityLazyQuery>;
export type PublicAppointmentAvailabilitySuspenseQueryHookResult = ReturnType<typeof usePublicAppointmentAvailabilitySuspenseQuery>;
export type PublicAppointmentAvailabilityQueryResult = Apollo.QueryResult<PublicAppointmentAvailabilityQuery, PublicAppointmentAvailabilityQueryVariables>;
export const PublicAppointmentByTokenDocument = gql`
    query PublicAppointmentByToken($token: String!) {
  publicAppointmentByToken(token: $token) {
    publicId
    bookingSlug
    storeName
    storefront {
      primaryColor
      accentColor
      surfaceColor
    }
    serviceId
    serviceName
    professionalName
    startsAt
    endsAt
    timezone
    status
    canCancel
    canReschedule
  }
}
    `;

/**
 * __usePublicAppointmentByTokenQuery__
 *
 * To run a query within a React component, call `usePublicAppointmentByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAppointmentByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAppointmentByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePublicAppointmentByTokenQuery(baseOptions: Apollo.QueryHookOptions<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>(PublicAppointmentByTokenDocument, options);
      }
export function usePublicAppointmentByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>(PublicAppointmentByTokenDocument, options);
        }
export function usePublicAppointmentByTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>(PublicAppointmentByTokenDocument, options);
        }
export type PublicAppointmentByTokenQueryHookResult = ReturnType<typeof usePublicAppointmentByTokenQuery>;
export type PublicAppointmentByTokenLazyQueryHookResult = ReturnType<typeof usePublicAppointmentByTokenLazyQuery>;
export type PublicAppointmentByTokenSuspenseQueryHookResult = ReturnType<typeof usePublicAppointmentByTokenSuspenseQuery>;
export type PublicAppointmentByTokenQueryResult = Apollo.QueryResult<PublicAppointmentByTokenQuery, PublicAppointmentByTokenQueryVariables>;
export const CreatePublicAppointmentFrontendDocument = gql`
    mutation CreatePublicAppointmentFrontend($input: PublicAppointmentInput!) {
  createPublicAppointment(input: $input) {
    result {
      code
      message
      idempotentReplay
      managementToken
      managementUrl
      googleCalendarUrl
      outlookCalendarUrl
      icsUrl
      alternativeSlots {
        startsAt
        endsAt
        professionalId
        professionalName
      }
      appointment {
        publicId
        serviceId
        serviceName
        professionalName
        startsAt
        endsAt
        timezone
        status
        canCancel
        canReschedule
      }
    }
  }
}
    `;
export type CreatePublicAppointmentFrontendMutationFn = Apollo.MutationFunction<CreatePublicAppointmentFrontendMutation, CreatePublicAppointmentFrontendMutationVariables>;

/**
 * __useCreatePublicAppointmentFrontendMutation__
 *
 * To run a mutation, you first call `useCreatePublicAppointmentFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicAppointmentFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicAppointmentFrontendMutation, { data, loading, error }] = useCreatePublicAppointmentFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePublicAppointmentFrontendMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicAppointmentFrontendMutation, CreatePublicAppointmentFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicAppointmentFrontendMutation, CreatePublicAppointmentFrontendMutationVariables>(CreatePublicAppointmentFrontendDocument, options);
      }
export type CreatePublicAppointmentFrontendMutationHookResult = ReturnType<typeof useCreatePublicAppointmentFrontendMutation>;
export type CreatePublicAppointmentFrontendMutationResult = Apollo.MutationResult<CreatePublicAppointmentFrontendMutation>;
export type CreatePublicAppointmentFrontendMutationOptions = Apollo.BaseMutationOptions<CreatePublicAppointmentFrontendMutation, CreatePublicAppointmentFrontendMutationVariables>;
export const PublicCancelAppointmentFrontendDocument = gql`
    mutation PublicCancelAppointmentFrontend($token: String!, $reason: String) {
  publicCancelAppointment(token: $token, reason: $reason) {
    appointment {
      publicId
      serviceId
      serviceName
      professionalName
      startsAt
      endsAt
      timezone
      status
      canCancel
      canReschedule
    }
  }
}
    `;
export type PublicCancelAppointmentFrontendMutationFn = Apollo.MutationFunction<PublicCancelAppointmentFrontendMutation, PublicCancelAppointmentFrontendMutationVariables>;

/**
 * __usePublicCancelAppointmentFrontendMutation__
 *
 * To run a mutation, you first call `usePublicCancelAppointmentFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicCancelAppointmentFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicCancelAppointmentFrontendMutation, { data, loading, error }] = usePublicCancelAppointmentFrontendMutation({
 *   variables: {
 *      token: // value for 'token'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePublicCancelAppointmentFrontendMutation(baseOptions?: Apollo.MutationHookOptions<PublicCancelAppointmentFrontendMutation, PublicCancelAppointmentFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicCancelAppointmentFrontendMutation, PublicCancelAppointmentFrontendMutationVariables>(PublicCancelAppointmentFrontendDocument, options);
      }
export type PublicCancelAppointmentFrontendMutationHookResult = ReturnType<typeof usePublicCancelAppointmentFrontendMutation>;
export type PublicCancelAppointmentFrontendMutationResult = Apollo.MutationResult<PublicCancelAppointmentFrontendMutation>;
export type PublicCancelAppointmentFrontendMutationOptions = Apollo.BaseMutationOptions<PublicCancelAppointmentFrontendMutation, PublicCancelAppointmentFrontendMutationVariables>;
export const PublicRescheduleAppointmentFrontendDocument = gql`
    mutation PublicRescheduleAppointmentFrontend($token: String!, $startsAt: DateTime!, $professionalId: ID) {
  publicRescheduleAppointment(
    token: $token
    startsAt: $startsAt
    professionalId: $professionalId
  ) {
    result {
      code
      message
      alternativeSlots {
        startsAt
        endsAt
        professionalId
        professionalName
      }
      appointment {
        publicId
        serviceId
        serviceName
        professionalName
        startsAt
        endsAt
        timezone
        status
        canCancel
        canReschedule
      }
    }
  }
}
    `;
export type PublicRescheduleAppointmentFrontendMutationFn = Apollo.MutationFunction<PublicRescheduleAppointmentFrontendMutation, PublicRescheduleAppointmentFrontendMutationVariables>;

/**
 * __usePublicRescheduleAppointmentFrontendMutation__
 *
 * To run a mutation, you first call `usePublicRescheduleAppointmentFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicRescheduleAppointmentFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicRescheduleAppointmentFrontendMutation, { data, loading, error }] = usePublicRescheduleAppointmentFrontendMutation({
 *   variables: {
 *      token: // value for 'token'
 *      startsAt: // value for 'startsAt'
 *      professionalId: // value for 'professionalId'
 *   },
 * });
 */
export function usePublicRescheduleAppointmentFrontendMutation(baseOptions?: Apollo.MutationHookOptions<PublicRescheduleAppointmentFrontendMutation, PublicRescheduleAppointmentFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicRescheduleAppointmentFrontendMutation, PublicRescheduleAppointmentFrontendMutationVariables>(PublicRescheduleAppointmentFrontendDocument, options);
      }
export type PublicRescheduleAppointmentFrontendMutationHookResult = ReturnType<typeof usePublicRescheduleAppointmentFrontendMutation>;
export type PublicRescheduleAppointmentFrontendMutationResult = Apollo.MutationResult<PublicRescheduleAppointmentFrontendMutation>;
export type PublicRescheduleAppointmentFrontendMutationOptions = Apollo.BaseMutationOptions<PublicRescheduleAppointmentFrontendMutation, PublicRescheduleAppointmentFrontendMutationVariables>;
export const TrackBookingFunnelEventFrontendDocument = gql`
    mutation TrackBookingFunnelEventFrontend($slug: String!, $sessionId: UUID!, $eventType: String!, $platform: String, $attribution: GenericScalar) {
  trackBookingFunnelEvent(
    slug: $slug
    sessionId: $sessionId
    eventType: $eventType
    platform: $platform
    attribution: $attribution
  ) {
    ok
  }
}
    `;
export type TrackBookingFunnelEventFrontendMutationFn = Apollo.MutationFunction<TrackBookingFunnelEventFrontendMutation, TrackBookingFunnelEventFrontendMutationVariables>;

/**
 * __useTrackBookingFunnelEventFrontendMutation__
 *
 * To run a mutation, you first call `useTrackBookingFunnelEventFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackBookingFunnelEventFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackBookingFunnelEventFrontendMutation, { data, loading, error }] = useTrackBookingFunnelEventFrontendMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      sessionId: // value for 'sessionId'
 *      eventType: // value for 'eventType'
 *      platform: // value for 'platform'
 *      attribution: // value for 'attribution'
 *   },
 * });
 */
export function useTrackBookingFunnelEventFrontendMutation(baseOptions?: Apollo.MutationHookOptions<TrackBookingFunnelEventFrontendMutation, TrackBookingFunnelEventFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackBookingFunnelEventFrontendMutation, TrackBookingFunnelEventFrontendMutationVariables>(TrackBookingFunnelEventFrontendDocument, options);
      }
export type TrackBookingFunnelEventFrontendMutationHookResult = ReturnType<typeof useTrackBookingFunnelEventFrontendMutation>;
export type TrackBookingFunnelEventFrontendMutationResult = Apollo.MutationResult<TrackBookingFunnelEventFrontendMutation>;
export type TrackBookingFunnelEventFrontendMutationOptions = Apollo.BaseMutationOptions<TrackBookingFunnelEventFrontendMutation, TrackBookingFunnelEventFrontendMutationVariables>;
export const ActiveOrInactiveTemplateDocument = gql`
    mutation ActiveOrInactiveTemplate($input: ActiveOrInactiveCampaignInput!) {
  activeOrInactiveCampaign(input: $input) {
    success
  }
}
    `;
export type ActiveOrInactiveTemplateMutationFn = Apollo.MutationFunction<ActiveOrInactiveTemplateMutation, ActiveOrInactiveTemplateMutationVariables>;

/**
 * __useActiveOrInactiveTemplateMutation__
 *
 * To run a mutation, you first call `useActiveOrInactiveTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActiveOrInactiveTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activeOrInactiveTemplateMutation, { data, loading, error }] = useActiveOrInactiveTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActiveOrInactiveTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ActiveOrInactiveTemplateMutation, ActiveOrInactiveTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActiveOrInactiveTemplateMutation, ActiveOrInactiveTemplateMutationVariables>(ActiveOrInactiveTemplateDocument, options);
      }
export type ActiveOrInactiveTemplateMutationHookResult = ReturnType<typeof useActiveOrInactiveTemplateMutation>;
export type ActiveOrInactiveTemplateMutationResult = Apollo.MutationResult<ActiveOrInactiveTemplateMutation>;
export type ActiveOrInactiveTemplateMutationOptions = Apollo.BaseMutationOptions<ActiveOrInactiveTemplateMutation, ActiveOrInactiveTemplateMutationVariables>;
export const CreateNewCampaignDocument = gql`
    mutation CreateNewCampaign($campaignInput: CreateCampaignInput!) {
  createCampaign(campaignInput: $campaignInput) {
    success
    error
  }
}
    `;
export type CreateNewCampaignMutationFn = Apollo.MutationFunction<CreateNewCampaignMutation, CreateNewCampaignMutationVariables>;

/**
 * __useCreateNewCampaignMutation__
 *
 * To run a mutation, you first call `useCreateNewCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCampaignMutation, { data, loading, error }] = useCreateNewCampaignMutation({
 *   variables: {
 *      campaignInput: // value for 'campaignInput'
 *   },
 * });
 */
export function useCreateNewCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewCampaignMutation, CreateNewCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewCampaignMutation, CreateNewCampaignMutationVariables>(CreateNewCampaignDocument, options);
      }
export type CreateNewCampaignMutationHookResult = ReturnType<typeof useCreateNewCampaignMutation>;
export type CreateNewCampaignMutationResult = Apollo.MutationResult<CreateNewCampaignMutation>;
export type CreateNewCampaignMutationOptions = Apollo.BaseMutationOptions<CreateNewCampaignMutation, CreateNewCampaignMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($input: CreateWhatsappTemplateByCampaignInput!) {
  createTemplateByCampaign(input: $input) {
    success
  }
}
    `;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const GetCampaignDetailsDocument = gql`
    query GetCampaignDetails($id: ID!) {
  readCampaign(id: $id) {
    pk
    title
    subject
    messageSms
    message
    messageEmail
    daysToTrigger
    tag
    triggerCustomerTag {
      pk
      name
    }
    buttonLabelEmail
    buttonUrlEmail
    footerEmail
    createdAt
    updatedAt
    footer
    buttons
    viaWhatsapp
    viaWhatsappOfficial
    viaZekiCrm
    zekiCrmChannelId
    zekiCrmChannelNumber
    zekiCrmTemplateVariableMapping {
      templateVariable
      zekiVariable
    }
    viaSms
    viaEmail
    isActive
    whatsappTemplate {
      pk
      name
      category
      status
    }
    zekiCrmTemplate {
      pk
      templateId
      name
      message
      status
      provider
      zekiCrmParameters
    }
  }
}
    `;

/**
 * __useGetCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useGetCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>(GetCampaignDetailsDocument, options);
      }
export function useGetCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>(GetCampaignDetailsDocument, options);
        }
export function useGetCampaignDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>(GetCampaignDetailsDocument, options);
        }
export type GetCampaignDetailsQueryHookResult = ReturnType<typeof useGetCampaignDetailsQuery>;
export type GetCampaignDetailsLazyQueryHookResult = ReturnType<typeof useGetCampaignDetailsLazyQuery>;
export type GetCampaignDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignDetailsSuspenseQuery>;
export type GetCampaignDetailsQueryResult = Apollo.QueryResult<GetCampaignDetailsQuery, GetCampaignDetailsQueryVariables>;
export const ListCampaignsDocument = gql`
    query ListCampaigns($before: String, $after: String, $first: Int = 12, $last: Int, $titleOrMessage: String, $viaWhatsapp: Boolean, $viaWhatsappOfficial: Boolean, $viaZekiCrm: Boolean, $viaSms: Boolean, $viaEmail: Boolean, $createdAt_Gte: DateTime, $createdAt_Lte: DateTime, $tag_Icontains: String, $isActive: Boolean) {
  listCampaigns(
    before: $before
    after: $after
    first: $first
    last: $last
    titleOrMessage: $titleOrMessage
    viaWhatsapp: $viaWhatsapp
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    viaSms: $viaSms
    viaEmail: $viaEmail
    createdAt_Gte: $createdAt_Gte
    createdAt_Lte: $createdAt_Lte
    tag_Icontains: $tag_Icontains
    isActive: $isActive
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        pk
        id
        tag
        title
        messageEmail
        messageSms
        message
        buttonLabelEmail
        buttonUrlEmail
        createdAt
        updatedAt
        viaWhatsapp
        viaWhatsappOfficial
        viaZekiCrm
        viaSms
        viaEmail
        isActive
        whatsappTemplate {
          pk
          category
          status
        }
      }
    }
  }
}
    `;

/**
 * __useListCampaignsQuery__
 *
 * To run a query within a React component, call `useListCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCampaignsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      titleOrMessage: // value for 'titleOrMessage'
 *      viaWhatsapp: // value for 'viaWhatsapp'
 *      viaWhatsappOfficial: // value for 'viaWhatsappOfficial'
 *      viaZekiCrm: // value for 'viaZekiCrm'
 *      viaSms: // value for 'viaSms'
 *      viaEmail: // value for 'viaEmail'
 *      createdAt_Gte: // value for 'createdAt_Gte'
 *      createdAt_Lte: // value for 'createdAt_Lte'
 *      tag_Icontains: // value for 'tag_Icontains'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useListCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<ListCampaignsQuery, ListCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCampaignsQuery, ListCampaignsQueryVariables>(ListCampaignsDocument, options);
      }
export function useListCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCampaignsQuery, ListCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCampaignsQuery, ListCampaignsQueryVariables>(ListCampaignsDocument, options);
        }
export function useListCampaignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCampaignsQuery, ListCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCampaignsQuery, ListCampaignsQueryVariables>(ListCampaignsDocument, options);
        }
export type ListCampaignsQueryHookResult = ReturnType<typeof useListCampaignsQuery>;
export type ListCampaignsLazyQueryHookResult = ReturnType<typeof useListCampaignsLazyQuery>;
export type ListCampaignsSuspenseQueryHookResult = ReturnType<typeof useListCampaignsSuspenseQuery>;
export type ListCampaignsQueryResult = Apollo.QueryResult<ListCampaignsQuery, ListCampaignsQueryVariables>;
export const ListZekiCrmChannelsDocument = gql`
    query ListZekiCrmChannels {
  getHelenaChannels {
    id
    number
    numberFormatted
    active
  }
}
    `;

/**
 * __useListZekiCrmChannelsQuery__
 *
 * To run a query within a React component, call `useListZekiCrmChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListZekiCrmChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListZekiCrmChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListZekiCrmChannelsQuery(baseOptions?: Apollo.QueryHookOptions<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>(ListZekiCrmChannelsDocument, options);
      }
export function useListZekiCrmChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>(ListZekiCrmChannelsDocument, options);
        }
export function useListZekiCrmChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>(ListZekiCrmChannelsDocument, options);
        }
export type ListZekiCrmChannelsQueryHookResult = ReturnType<typeof useListZekiCrmChannelsQuery>;
export type ListZekiCrmChannelsLazyQueryHookResult = ReturnType<typeof useListZekiCrmChannelsLazyQuery>;
export type ListZekiCrmChannelsSuspenseQueryHookResult = ReturnType<typeof useListZekiCrmChannelsSuspenseQuery>;
export type ListZekiCrmChannelsQueryResult = Apollo.QueryResult<ListZekiCrmChannelsQuery, ListZekiCrmChannelsQueryVariables>;
export const ListZekiCrmWhatsappTemplatesDocument = gql`
    query ListZekiCrmWhatsappTemplates($channelId: String) {
  listHelenaWhatsappTemplates(channelId: $channelId) {
    pk
    templateId
    name
    message
    status
    provider
    zekiCrmParameters
  }
}
    `;

/**
 * __useListZekiCrmWhatsappTemplatesQuery__
 *
 * To run a query within a React component, call `useListZekiCrmWhatsappTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListZekiCrmWhatsappTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListZekiCrmWhatsappTemplatesQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useListZekiCrmWhatsappTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>(ListZekiCrmWhatsappTemplatesDocument, options);
      }
export function useListZekiCrmWhatsappTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>(ListZekiCrmWhatsappTemplatesDocument, options);
        }
export function useListZekiCrmWhatsappTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>(ListZekiCrmWhatsappTemplatesDocument, options);
        }
export type ListZekiCrmWhatsappTemplatesQueryHookResult = ReturnType<typeof useListZekiCrmWhatsappTemplatesQuery>;
export type ListZekiCrmWhatsappTemplatesLazyQueryHookResult = ReturnType<typeof useListZekiCrmWhatsappTemplatesLazyQuery>;
export type ListZekiCrmWhatsappTemplatesSuspenseQueryHookResult = ReturnType<typeof useListZekiCrmWhatsappTemplatesSuspenseQuery>;
export type ListZekiCrmWhatsappTemplatesQueryResult = Apollo.QueryResult<ListZekiCrmWhatsappTemplatesQuery, ListZekiCrmWhatsappTemplatesQueryVariables>;
export const EditCampaignDocument = gql`
    mutation EditCampaign($campaignInput: UpdateCampaignInput!) {
  updateCampaign(campaignInput: $campaignInput) {
    success
    error
  }
}
    `;
export type EditCampaignMutationFn = Apollo.MutationFunction<EditCampaignMutation, EditCampaignMutationVariables>;

/**
 * __useEditCampaignMutation__
 *
 * To run a mutation, you first call `useEditCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCampaignMutation, { data, loading, error }] = useEditCampaignMutation({
 *   variables: {
 *      campaignInput: // value for 'campaignInput'
 *   },
 * });
 */
export function useEditCampaignMutation(baseOptions?: Apollo.MutationHookOptions<EditCampaignMutation, EditCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCampaignMutation, EditCampaignMutationVariables>(EditCampaignDocument, options);
      }
export type EditCampaignMutationHookResult = ReturnType<typeof useEditCampaignMutation>;
export type EditCampaignMutationResult = Apollo.MutationResult<EditCampaignMutation>;
export type EditCampaignMutationOptions = Apollo.BaseMutationOptions<EditCampaignMutation, EditCampaignMutationVariables>;
export const CategoryCreateDocument = gql`
    mutation CategoryCreate($categoryInput: CreateCategoryInput!) {
  categoryCreate(categoryInput: $categoryInput) {
    success
    error
    categories {
      id
      pk
      name
    }
  }
}
    `;
export type CategoryCreateMutationFn = Apollo.MutationFunction<CategoryCreateMutation, CategoryCreateMutationVariables>;

/**
 * __useCategoryCreateMutation__
 *
 * To run a mutation, you first call `useCategoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryCreateMutation, { data, loading, error }] = useCategoryCreateMutation({
 *   variables: {
 *      categoryInput: // value for 'categoryInput'
 *   },
 * });
 */
export function useCategoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<CategoryCreateMutation, CategoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CategoryCreateMutation, CategoryCreateMutationVariables>(CategoryCreateDocument, options);
      }
export type CategoryCreateMutationHookResult = ReturnType<typeof useCategoryCreateMutation>;
export type CategoryCreateMutationResult = Apollo.MutationResult<CategoryCreateMutation>;
export type CategoryCreateMutationOptions = Apollo.BaseMutationOptions<CategoryCreateMutation, CategoryCreateMutationVariables>;
export const CategoryDeleteDocument = gql`
    mutation CategoryDelete($categoryInput: DeleteCategoryInput!) {
  categoryDelete(categoryInput: $categoryInput) {
    success
    error
  }
}
    `;
export type CategoryDeleteMutationFn = Apollo.MutationFunction<CategoryDeleteMutation, CategoryDeleteMutationVariables>;

/**
 * __useCategoryDeleteMutation__
 *
 * To run a mutation, you first call `useCategoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryDeleteMutation, { data, loading, error }] = useCategoryDeleteMutation({
 *   variables: {
 *      categoryInput: // value for 'categoryInput'
 *   },
 * });
 */
export function useCategoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CategoryDeleteMutation, CategoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CategoryDeleteMutation, CategoryDeleteMutationVariables>(CategoryDeleteDocument, options);
      }
export type CategoryDeleteMutationHookResult = ReturnType<typeof useCategoryDeleteMutation>;
export type CategoryDeleteMutationResult = Apollo.MutationResult<CategoryDeleteMutation>;
export type CategoryDeleteMutationOptions = Apollo.BaseMutationOptions<CategoryDeleteMutation, CategoryDeleteMutationVariables>;
export const CategoryUpdateDocument = gql`
    mutation CategoryUpdate($categoryInput: UpdateCategoryInput!) {
  categoryUpdate(categoryInput: $categoryInput) {
    success
    error
  }
}
    `;
export type CategoryUpdateMutationFn = Apollo.MutationFunction<CategoryUpdateMutation, CategoryUpdateMutationVariables>;

/**
 * __useCategoryUpdateMutation__
 *
 * To run a mutation, you first call `useCategoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCategoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [categoryUpdateMutation, { data, loading, error }] = useCategoryUpdateMutation({
 *   variables: {
 *      categoryInput: // value for 'categoryInput'
 *   },
 * });
 */
export function useCategoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CategoryUpdateMutation, CategoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CategoryUpdateMutation, CategoryUpdateMutationVariables>(CategoryUpdateDocument, options);
      }
export type CategoryUpdateMutationHookResult = ReturnType<typeof useCategoryUpdateMutation>;
export type CategoryUpdateMutationResult = Apollo.MutationResult<CategoryUpdateMutation>;
export type CategoryUpdateMutationOptions = Apollo.BaseMutationOptions<CategoryUpdateMutation, CategoryUpdateMutationVariables>;
export const CommunityCapabilityDocument = gql`
    query CommunityCapability {
  communityCapability {
    enabled
    reason
    maxMembers
    connectionPhone
    instanceName
  }
}
    `;

/**
 * __useCommunityCapabilityQuery__
 *
 * To run a query within a React component, call `useCommunityCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityCapabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityCapabilityQuery(baseOptions?: Apollo.QueryHookOptions<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>(CommunityCapabilityDocument, options);
      }
export function useCommunityCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>(CommunityCapabilityDocument, options);
        }
export function useCommunityCapabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>(CommunityCapabilityDocument, options);
        }
export type CommunityCapabilityQueryHookResult = ReturnType<typeof useCommunityCapabilityQuery>;
export type CommunityCapabilityLazyQueryHookResult = ReturnType<typeof useCommunityCapabilityLazyQuery>;
export type CommunityCapabilitySuspenseQueryHookResult = ReturnType<typeof useCommunityCapabilitySuspenseQuery>;
export type CommunityCapabilityQueryResult = Apollo.QueryResult<CommunityCapabilityQuery, CommunityCapabilityQueryVariables>;
export const CommunitiesDocument = gql`
    query Communities($first: Int, $after: ID) {
  communities(first: $first, after: $after) {
    items {
      ...CommunityFields
    }
    total
    hasNextPage
    endCursor
  }
}
    ${CommunityFieldsFragmentDoc}`;

/**
 * __useCommunitiesQuery__
 *
 * To run a query within a React component, call `useCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
      }
export function useCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
        }
export function useCommunitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
        }
export type CommunitiesQueryHookResult = ReturnType<typeof useCommunitiesQuery>;
export type CommunitiesLazyQueryHookResult = ReturnType<typeof useCommunitiesLazyQuery>;
export type CommunitiesSuspenseQueryHookResult = ReturnType<typeof useCommunitiesSuspenseQuery>;
export type CommunitiesQueryResult = Apollo.QueryResult<CommunitiesQuery, CommunitiesQueryVariables>;
export const CommunityDetailDocument = gql`
    query CommunityDetail($id: ID!) {
  community(id: $id) {
    ...CommunityFields
  }
}
    ${CommunityFieldsFragmentDoc}`;

/**
 * __useCommunityDetailQuery__
 *
 * To run a query within a React component, call `useCommunityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityDetailQuery(baseOptions: Apollo.QueryHookOptions<CommunityDetailQuery, CommunityDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityDetailQuery, CommunityDetailQueryVariables>(CommunityDetailDocument, options);
      }
export function useCommunityDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityDetailQuery, CommunityDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityDetailQuery, CommunityDetailQueryVariables>(CommunityDetailDocument, options);
        }
export function useCommunityDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityDetailQuery, CommunityDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityDetailQuery, CommunityDetailQueryVariables>(CommunityDetailDocument, options);
        }
export type CommunityDetailQueryHookResult = ReturnType<typeof useCommunityDetailQuery>;
export type CommunityDetailLazyQueryHookResult = ReturnType<typeof useCommunityDetailLazyQuery>;
export type CommunityDetailSuspenseQueryHookResult = ReturnType<typeof useCommunityDetailSuspenseQuery>;
export type CommunityDetailQueryResult = Apollo.QueryResult<CommunityDetailQuery, CommunityDetailQueryVariables>;
export const CommunityMembersDocument = gql`
    query CommunityMembers($communityId: ID!, $first: Int, $after: ID, $status: String) {
  communityMembers(
    communityId: $communityId
    first: $first
    after: $after
    status: $status
  ) {
    items {
      id
      customerId
      name
      phone
      status
      reason
    }
    total
    hasNextPage
    endCursor
  }
}
    `;

/**
 * __useCommunityMembersQuery__
 *
 * To run a query within a React component, call `useCommunityMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityMembersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCommunityMembersQuery(baseOptions: Apollo.QueryHookOptions<CommunityMembersQuery, CommunityMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityMembersQuery, CommunityMembersQueryVariables>(CommunityMembersDocument, options);
      }
export function useCommunityMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityMembersQuery, CommunityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityMembersQuery, CommunityMembersQueryVariables>(CommunityMembersDocument, options);
        }
export function useCommunityMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityMembersQuery, CommunityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityMembersQuery, CommunityMembersQueryVariables>(CommunityMembersDocument, options);
        }
export type CommunityMembersQueryHookResult = ReturnType<typeof useCommunityMembersQuery>;
export type CommunityMembersLazyQueryHookResult = ReturnType<typeof useCommunityMembersLazyQuery>;
export type CommunityMembersSuspenseQueryHookResult = ReturnType<typeof useCommunityMembersSuspenseQuery>;
export type CommunityMembersQueryResult = Apollo.QueryResult<CommunityMembersQuery, CommunityMembersQueryVariables>;
export const PrepareCommunityDocument = gql`
    mutation PrepareCommunity($input: PrepareCommunityInput!) {
  prepareCommunity(input: $input) {
    community {
      ...CommunityFields
    }
  }
}
    ${CommunityFieldsFragmentDoc}`;
export type PrepareCommunityMutationFn = Apollo.MutationFunction<PrepareCommunityMutation, PrepareCommunityMutationVariables>;

/**
 * __usePrepareCommunityMutation__
 *
 * To run a mutation, you first call `usePrepareCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareCommunityMutation, { data, loading, error }] = usePrepareCommunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareCommunityMutation(baseOptions?: Apollo.MutationHookOptions<PrepareCommunityMutation, PrepareCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareCommunityMutation, PrepareCommunityMutationVariables>(PrepareCommunityDocument, options);
      }
export type PrepareCommunityMutationHookResult = ReturnType<typeof usePrepareCommunityMutation>;
export type PrepareCommunityMutationResult = Apollo.MutationResult<PrepareCommunityMutation>;
export type PrepareCommunityMutationOptions = Apollo.BaseMutationOptions<PrepareCommunityMutation, PrepareCommunityMutationVariables>;
export const ConfirmCommunityDocument = gql`
    mutation ConfirmCommunity($input: ConfirmCommunityInput!) {
  confirmCommunity(input: $input) {
    community {
      ...CommunityFields
    }
  }
}
    ${CommunityFieldsFragmentDoc}`;
export type ConfirmCommunityMutationFn = Apollo.MutationFunction<ConfirmCommunityMutation, ConfirmCommunityMutationVariables>;

/**
 * __useConfirmCommunityMutation__
 *
 * To run a mutation, you first call `useConfirmCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCommunityMutation, { data, loading, error }] = useConfirmCommunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmCommunityMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCommunityMutation, ConfirmCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCommunityMutation, ConfirmCommunityMutationVariables>(ConfirmCommunityDocument, options);
      }
export type ConfirmCommunityMutationHookResult = ReturnType<typeof useConfirmCommunityMutation>;
export type ConfirmCommunityMutationResult = Apollo.MutationResult<ConfirmCommunityMutation>;
export type ConfirmCommunityMutationOptions = Apollo.BaseMutationOptions<ConfirmCommunityMutation, ConfirmCommunityMutationVariables>;
export const RetryCommunityDocument = gql`
    mutation RetryCommunity($communityId: ID!) {
  retryCommunity(communityId: $communityId) {
    community {
      ...CommunityFields
    }
  }
}
    ${CommunityFieldsFragmentDoc}`;
export type RetryCommunityMutationFn = Apollo.MutationFunction<RetryCommunityMutation, RetryCommunityMutationVariables>;

/**
 * __useRetryCommunityMutation__
 *
 * To run a mutation, you first call `useRetryCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryCommunityMutation, { data, loading, error }] = useRetryCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useRetryCommunityMutation(baseOptions?: Apollo.MutationHookOptions<RetryCommunityMutation, RetryCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryCommunityMutation, RetryCommunityMutationVariables>(RetryCommunityDocument, options);
      }
export type RetryCommunityMutationHookResult = ReturnType<typeof useRetryCommunityMutation>;
export type RetryCommunityMutationResult = Apollo.MutationResult<RetryCommunityMutation>;
export type RetryCommunityMutationOptions = Apollo.BaseMutationOptions<RetryCommunityMutation, RetryCommunityMutationVariables>;
export const CommunityScheduledMessagesDocument = gql`
    query CommunityScheduledMessages($communityId: ID!, $startsAt: DateTime!, $endsAt: DateTime!, $first: Int, $after: ID) {
  communityScheduledMessages(
    communityId: $communityId
    startsAt: $startsAt
    endsAt: $endsAt
    first: $first
    after: $after
  ) {
    items {
      ...CommunityMessageFields
    }
    total
    hasNextPage
    endCursor
  }
}
    ${CommunityMessageFieldsFragmentDoc}`;

/**
 * __useCommunityScheduledMessagesQuery__
 *
 * To run a query within a React component, call `useCommunityScheduledMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityScheduledMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityScheduledMessagesQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityScheduledMessagesQuery(baseOptions: Apollo.QueryHookOptions<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>(CommunityScheduledMessagesDocument, options);
      }
export function useCommunityScheduledMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>(CommunityScheduledMessagesDocument, options);
        }
export function useCommunityScheduledMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>(CommunityScheduledMessagesDocument, options);
        }
export type CommunityScheduledMessagesQueryHookResult = ReturnType<typeof useCommunityScheduledMessagesQuery>;
export type CommunityScheduledMessagesLazyQueryHookResult = ReturnType<typeof useCommunityScheduledMessagesLazyQuery>;
export type CommunityScheduledMessagesSuspenseQueryHookResult = ReturnType<typeof useCommunityScheduledMessagesSuspenseQuery>;
export type CommunityScheduledMessagesQueryResult = Apollo.QueryResult<CommunityScheduledMessagesQuery, CommunityScheduledMessagesQueryVariables>;
export const CommunityWhatsappLinkDocument = gql`
    query CommunityWhatsappLink($communityId: ID!) {
  communityWhatsappLink(communityId: $communityId)
}
    `;

/**
 * __useCommunityWhatsappLinkQuery__
 *
 * To run a query within a React component, call `useCommunityWhatsappLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityWhatsappLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityWhatsappLinkQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityWhatsappLinkQuery(baseOptions: Apollo.QueryHookOptions<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>(CommunityWhatsappLinkDocument, options);
      }
export function useCommunityWhatsappLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>(CommunityWhatsappLinkDocument, options);
        }
export function useCommunityWhatsappLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>(CommunityWhatsappLinkDocument, options);
        }
export type CommunityWhatsappLinkQueryHookResult = ReturnType<typeof useCommunityWhatsappLinkQuery>;
export type CommunityWhatsappLinkLazyQueryHookResult = ReturnType<typeof useCommunityWhatsappLinkLazyQuery>;
export type CommunityWhatsappLinkSuspenseQueryHookResult = ReturnType<typeof useCommunityWhatsappLinkSuspenseQuery>;
export type CommunityWhatsappLinkQueryResult = Apollo.QueryResult<CommunityWhatsappLinkQuery, CommunityWhatsappLinkQueryVariables>;
export const ScheduleCommunityMessageDocument = gql`
    mutation ScheduleCommunityMessage($input: ScheduleCommunityMessageInput!) {
  scheduleCommunityMessage(input: $input) {
    message {
      ...CommunityMessageFields
    }
  }
}
    ${CommunityMessageFieldsFragmentDoc}`;
export type ScheduleCommunityMessageMutationFn = Apollo.MutationFunction<ScheduleCommunityMessageMutation, ScheduleCommunityMessageMutationVariables>;

/**
 * __useScheduleCommunityMessageMutation__
 *
 * To run a mutation, you first call `useScheduleCommunityMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCommunityMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCommunityMessageMutation, { data, loading, error }] = useScheduleCommunityMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleCommunityMessageMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCommunityMessageMutation, ScheduleCommunityMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCommunityMessageMutation, ScheduleCommunityMessageMutationVariables>(ScheduleCommunityMessageDocument, options);
      }
export type ScheduleCommunityMessageMutationHookResult = ReturnType<typeof useScheduleCommunityMessageMutation>;
export type ScheduleCommunityMessageMutationResult = Apollo.MutationResult<ScheduleCommunityMessageMutation>;
export type ScheduleCommunityMessageMutationOptions = Apollo.BaseMutationOptions<ScheduleCommunityMessageMutation, ScheduleCommunityMessageMutationVariables>;
export const UpdateCommunityScheduledMessageDocument = gql`
    mutation UpdateCommunityScheduledMessage($input: UpdateCommunityScheduledMessageInput!) {
  updateCommunityScheduledMessage(input: $input) {
    message {
      ...CommunityMessageFields
    }
  }
}
    ${CommunityMessageFieldsFragmentDoc}`;
export type UpdateCommunityScheduledMessageMutationFn = Apollo.MutationFunction<UpdateCommunityScheduledMessageMutation, UpdateCommunityScheduledMessageMutationVariables>;

/**
 * __useUpdateCommunityScheduledMessageMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityScheduledMessageMutation, { data, loading, error }] = useUpdateCommunityScheduledMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityScheduledMessageMutation, UpdateCommunityScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityScheduledMessageMutation, UpdateCommunityScheduledMessageMutationVariables>(UpdateCommunityScheduledMessageDocument, options);
      }
export type UpdateCommunityScheduledMessageMutationHookResult = ReturnType<typeof useUpdateCommunityScheduledMessageMutation>;
export type UpdateCommunityScheduledMessageMutationResult = Apollo.MutationResult<UpdateCommunityScheduledMessageMutation>;
export type UpdateCommunityScheduledMessageMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityScheduledMessageMutation, UpdateCommunityScheduledMessageMutationVariables>;
export const CancelCommunityScheduledMessageDocument = gql`
    mutation CancelCommunityScheduledMessage($messageId: ID!, $expectedRevision: Int!) {
  cancelCommunityScheduledMessage(
    messageId: $messageId
    expectedRevision: $expectedRevision
  ) {
    message {
      ...CommunityMessageFields
    }
  }
}
    ${CommunityMessageFieldsFragmentDoc}`;
export type CancelCommunityScheduledMessageMutationFn = Apollo.MutationFunction<CancelCommunityScheduledMessageMutation, CancelCommunityScheduledMessageMutationVariables>;

/**
 * __useCancelCommunityScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCancelCommunityScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCommunityScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCommunityScheduledMessageMutation, { data, loading, error }] = useCancelCommunityScheduledMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      expectedRevision: // value for 'expectedRevision'
 *   },
 * });
 */
export function useCancelCommunityScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CancelCommunityScheduledMessageMutation, CancelCommunityScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCommunityScheduledMessageMutation, CancelCommunityScheduledMessageMutationVariables>(CancelCommunityScheduledMessageDocument, options);
      }
export type CancelCommunityScheduledMessageMutationHookResult = ReturnType<typeof useCancelCommunityScheduledMessageMutation>;
export type CancelCommunityScheduledMessageMutationResult = Apollo.MutationResult<CancelCommunityScheduledMessageMutation>;
export type CancelCommunityScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CancelCommunityScheduledMessageMutation, CancelCommunityScheduledMessageMutationVariables>;
export const ConnectOrDisconnectEvolutionApiDocument = gql`
    mutation ConnectOrDisconnectEvolutionApi($input: ConnectOrDisconnectEvolutionApiIntegrationInput!) {
  connectOrDisconnectEvolutionApiIntegration(input: $input) {
    ok
    response
  }
}
    `;
export type ConnectOrDisconnectEvolutionApiMutationFn = Apollo.MutationFunction<ConnectOrDisconnectEvolutionApiMutation, ConnectOrDisconnectEvolutionApiMutationVariables>;

/**
 * __useConnectOrDisconnectEvolutionApiMutation__
 *
 * To run a mutation, you first call `useConnectOrDisconnectEvolutionApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectOrDisconnectEvolutionApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectOrDisconnectEvolutionApiMutation, { data, loading, error }] = useConnectOrDisconnectEvolutionApiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectOrDisconnectEvolutionApiMutation(baseOptions?: Apollo.MutationHookOptions<ConnectOrDisconnectEvolutionApiMutation, ConnectOrDisconnectEvolutionApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectOrDisconnectEvolutionApiMutation, ConnectOrDisconnectEvolutionApiMutationVariables>(ConnectOrDisconnectEvolutionApiDocument, options);
      }
export type ConnectOrDisconnectEvolutionApiMutationHookResult = ReturnType<typeof useConnectOrDisconnectEvolutionApiMutation>;
export type ConnectOrDisconnectEvolutionApiMutationResult = Apollo.MutationResult<ConnectOrDisconnectEvolutionApiMutation>;
export type ConnectOrDisconnectEvolutionApiMutationOptions = Apollo.BaseMutationOptions<ConnectOrDisconnectEvolutionApiMutation, ConnectOrDisconnectEvolutionApiMutationVariables>;
export const GetAllRfmDocument = gql`
    query getAllRFM {
  frequency: getRfmFrequency {
    id
    zoneOneMin
    zoneOneMax
    zoneTwoMin
    zoneTwoMax
    zoneThreeMin
    zoneThreeMax
    zoneFourMin
    zoneFourMax
    zoneFiveMin
    zoneFiveMax
  }
  recency: getRfmRecency {
    id
    zoneOneMin
    zoneOneMax
    zoneTwoMin
    zoneTwoMax
    zoneThreeMin
    zoneThreeMax
    zoneFourMin
    zoneFourMax
    zoneFiveMin
    zoneFiveMax
  }
  value: getRfmValue {
    id
    zoneOneMin
    zoneOneMax
    zoneTwoMin
    zoneTwoMax
    zoneThreeMin
    zoneThreeMax
    zoneFourMin
    zoneFourMax
    zoneFiveMin
    zoneFiveMax
  }
}
    `;

/**
 * __useGetAllRfmQuery__
 *
 * To run a query within a React component, call `useGetAllRfmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRfmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRfmQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRfmQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRfmQuery, GetAllRfmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRfmQuery, GetAllRfmQueryVariables>(GetAllRfmDocument, options);
      }
export function useGetAllRfmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRfmQuery, GetAllRfmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRfmQuery, GetAllRfmQueryVariables>(GetAllRfmDocument, options);
        }
export function useGetAllRfmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllRfmQuery, GetAllRfmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRfmQuery, GetAllRfmQueryVariables>(GetAllRfmDocument, options);
        }
export type GetAllRfmQueryHookResult = ReturnType<typeof useGetAllRfmQuery>;
export type GetAllRfmLazyQueryHookResult = ReturnType<typeof useGetAllRfmLazyQuery>;
export type GetAllRfmSuspenseQueryHookResult = ReturnType<typeof useGetAllRfmSuspenseQuery>;
export type GetAllRfmQueryResult = Apollo.QueryResult<GetAllRfmQuery, GetAllRfmQueryVariables>;
export const GetAllStatesDocument = gql`
    query GetAllStates {
  allStates {
    id
    sigla
    nome
  }
}
    `;

/**
 * __useGetAllStatesQuery__
 *
 * To run a query within a React component, call `useGetAllStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStatesQuery, GetAllStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStatesQuery, GetAllStatesQueryVariables>(GetAllStatesDocument, options);
      }
export function useGetAllStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStatesQuery, GetAllStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStatesQuery, GetAllStatesQueryVariables>(GetAllStatesDocument, options);
        }
export function useGetAllStatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStatesQuery, GetAllStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStatesQuery, GetAllStatesQueryVariables>(GetAllStatesDocument, options);
        }
export type GetAllStatesQueryHookResult = ReturnType<typeof useGetAllStatesQuery>;
export type GetAllStatesLazyQueryHookResult = ReturnType<typeof useGetAllStatesLazyQuery>;
export type GetAllStatesSuspenseQueryHookResult = ReturnType<typeof useGetAllStatesSuspenseQuery>;
export type GetAllStatesQueryResult = Apollo.QueryResult<GetAllStatesQuery, GetAllStatesQueryVariables>;
export const GetGiftbackConfigDocument = gql`
    query GetGiftbackConfig {
  getGiftbackConfig {
    id
    dueDate
    cumulative
    couponProductScope
    couponScopeMode
    couponScopeProducts {
      id
      pk
      name
      integrationId
    }
    couponScopeCategories {
      id
      pk
      name
      integrationId
    }
    pk
    multiplegiftbackconfigSet {
      id
      value
      valueType
      minPurchaseValueForCreate
      minimumValueType
      maximumDiscountPercentage
      discountLimitEnabled
      discountLimit
      minPurchaseValueForRedeem
      pk
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetGiftbackConfigQuery__
 *
 * To run a query within a React component, call `useGetGiftbackConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftbackConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftbackConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGiftbackConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>(GetGiftbackConfigDocument, options);
      }
export function useGetGiftbackConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>(GetGiftbackConfigDocument, options);
        }
export function useGetGiftbackConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>(GetGiftbackConfigDocument, options);
        }
export type GetGiftbackConfigQueryHookResult = ReturnType<typeof useGetGiftbackConfigQuery>;
export type GetGiftbackConfigLazyQueryHookResult = ReturnType<typeof useGetGiftbackConfigLazyQuery>;
export type GetGiftbackConfigSuspenseQueryHookResult = ReturnType<typeof useGetGiftbackConfigSuspenseQuery>;
export type GetGiftbackConfigQueryResult = Apollo.QueryResult<GetGiftbackConfigQuery, GetGiftbackConfigQueryVariables>;
export const GetWhatsappIntegrationDocument = gql`
    query GetWhatsappIntegration {
  getWhatsappIntegration {
    id
    whatsappBusinessAccountId
    whatsappAccessToken
    phoneNumberId
    activated
    connected
  }
}
    `;

/**
 * __useGetWhatsappIntegrationQuery__
 *
 * To run a query within a React component, call `useGetWhatsappIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhatsappIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhatsappIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWhatsappIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>(GetWhatsappIntegrationDocument, options);
      }
export function useGetWhatsappIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>(GetWhatsappIntegrationDocument, options);
        }
export function useGetWhatsappIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>(GetWhatsappIntegrationDocument, options);
        }
export type GetWhatsappIntegrationQueryHookResult = ReturnType<typeof useGetWhatsappIntegrationQuery>;
export type GetWhatsappIntegrationLazyQueryHookResult = ReturnType<typeof useGetWhatsappIntegrationLazyQuery>;
export type GetWhatsappIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetWhatsappIntegrationSuspenseQuery>;
export type GetWhatsappIntegrationQueryResult = Apollo.QueryResult<GetWhatsappIntegrationQuery, GetWhatsappIntegrationQueryVariables>;
export const GetEvolutionApiInstanceStatusDocument = gql`
    query GetEvolutionApiInstanceStatus {
  getEvolutionApiConnectionStatus {
    equalStatus
  }
}
    `;

/**
 * __useGetEvolutionApiInstanceStatusQuery__
 *
 * To run a query within a React component, call `useGetEvolutionApiInstanceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvolutionApiInstanceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvolutionApiInstanceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEvolutionApiInstanceStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>(GetEvolutionApiInstanceStatusDocument, options);
      }
export function useGetEvolutionApiInstanceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>(GetEvolutionApiInstanceStatusDocument, options);
        }
export function useGetEvolutionApiInstanceStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>(GetEvolutionApiInstanceStatusDocument, options);
        }
export type GetEvolutionApiInstanceStatusQueryHookResult = ReturnType<typeof useGetEvolutionApiInstanceStatusQuery>;
export type GetEvolutionApiInstanceStatusLazyQueryHookResult = ReturnType<typeof useGetEvolutionApiInstanceStatusLazyQuery>;
export type GetEvolutionApiInstanceStatusSuspenseQueryHookResult = ReturnType<typeof useGetEvolutionApiInstanceStatusSuspenseQuery>;
export type GetEvolutionApiInstanceStatusQueryResult = Apollo.QueryResult<GetEvolutionApiInstanceStatusQuery, GetEvolutionApiInstanceStatusQueryVariables>;
export const GetRfmAutomationDocument = gql`
    query GetRfmAutomation {
  getRfmAutomation {
    dailyRefreshEnabled
    lastCompletedAt
  }
}
    `;

/**
 * __useGetRfmAutomationQuery__
 *
 * To run a query within a React component, call `useGetRfmAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfmAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfmAutomationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRfmAutomationQuery(baseOptions?: Apollo.QueryHookOptions<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>(GetRfmAutomationDocument, options);
      }
export function useGetRfmAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>(GetRfmAutomationDocument, options);
        }
export function useGetRfmAutomationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>(GetRfmAutomationDocument, options);
        }
export type GetRfmAutomationQueryHookResult = ReturnType<typeof useGetRfmAutomationQuery>;
export type GetRfmAutomationLazyQueryHookResult = ReturnType<typeof useGetRfmAutomationLazyQuery>;
export type GetRfmAutomationSuspenseQueryHookResult = ReturnType<typeof useGetRfmAutomationSuspenseQuery>;
export type GetRfmAutomationQueryResult = Apollo.QueryResult<GetRfmAutomationQuery, GetRfmAutomationQueryVariables>;
export const GetRfmFrequencyDocument = gql`
    query GetRFMFrequency {
  getRfmFrequency {
    id
    zoneOneMin
    zoneOneMax
    zoneTwoMin
    zoneTwoMax
    zoneThreeMin
    zoneThreeMax
    zoneFourMin
    zoneFourMax
    zoneFiveMin
    zoneFiveMax
  }
}
    `;

/**
 * __useGetRfmFrequencyQuery__
 *
 * To run a query within a React component, call `useGetRfmFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfmFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfmFrequencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRfmFrequencyQuery(baseOptions?: Apollo.QueryHookOptions<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>(GetRfmFrequencyDocument, options);
      }
export function useGetRfmFrequencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>(GetRfmFrequencyDocument, options);
        }
export function useGetRfmFrequencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>(GetRfmFrequencyDocument, options);
        }
export type GetRfmFrequencyQueryHookResult = ReturnType<typeof useGetRfmFrequencyQuery>;
export type GetRfmFrequencyLazyQueryHookResult = ReturnType<typeof useGetRfmFrequencyLazyQuery>;
export type GetRfmFrequencySuspenseQueryHookResult = ReturnType<typeof useGetRfmFrequencySuspenseQuery>;
export type GetRfmFrequencyQueryResult = Apollo.QueryResult<GetRfmFrequencyQuery, GetRfmFrequencyQueryVariables>;
export const GetRfmRecencyDocument = gql`
    query GetRFMRecency {
  getRfmRecency {
    id
    zoneOneMin
    zoneOneMax
    zoneTwoMin
    zoneTwoMax
    zoneThreeMin
    zoneThreeMax
    zoneFourMin
    zoneFourMax
    zoneFiveMin
    zoneFiveMax
  }
}
    `;

/**
 * __useGetRfmRecencyQuery__
 *
 * To run a query within a React component, call `useGetRfmRecencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfmRecencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfmRecencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRfmRecencyQuery(baseOptions?: Apollo.QueryHookOptions<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>(GetRfmRecencyDocument, options);
      }
export function useGetRfmRecencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>(GetRfmRecencyDocument, options);
        }
export function useGetRfmRecencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>(GetRfmRecencyDocument, options);
        }
export type GetRfmRecencyQueryHookResult = ReturnType<typeof useGetRfmRecencyQuery>;
export type GetRfmRecencyLazyQueryHookResult = ReturnType<typeof useGetRfmRecencyLazyQuery>;
export type GetRfmRecencySuspenseQueryHookResult = ReturnType<typeof useGetRfmRecencySuspenseQuery>;
export type GetRfmRecencyQueryResult = Apollo.QueryResult<GetRfmRecencyQuery, GetRfmRecencyQueryVariables>;
export const GetRfmValueDocument = gql`
    query GetRFMValue {
  getRfmValue {
    id
    zoneOneMin
    zoneOneMax
    zoneTwoMin
    zoneTwoMax
    zoneThreeMin
    zoneThreeMax
    zoneFourMin
    zoneFourMax
    zoneFiveMin
    zoneFiveMax
  }
}
    `;

/**
 * __useGetRfmValueQuery__
 *
 * To run a query within a React component, call `useGetRfmValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfmValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfmValueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRfmValueQuery(baseOptions?: Apollo.QueryHookOptions<GetRfmValueQuery, GetRfmValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfmValueQuery, GetRfmValueQueryVariables>(GetRfmValueDocument, options);
      }
export function useGetRfmValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfmValueQuery, GetRfmValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfmValueQuery, GetRfmValueQueryVariables>(GetRfmValueDocument, options);
        }
export function useGetRfmValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRfmValueQuery, GetRfmValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRfmValueQuery, GetRfmValueQueryVariables>(GetRfmValueDocument, options);
        }
export type GetRfmValueQueryHookResult = ReturnType<typeof useGetRfmValueQuery>;
export type GetRfmValueLazyQueryHookResult = ReturnType<typeof useGetRfmValueLazyQuery>;
export type GetRfmValueSuspenseQueryHookResult = ReturnType<typeof useGetRfmValueSuspenseQuery>;
export type GetRfmValueQueryResult = Apollo.QueryResult<GetRfmValueQuery, GetRfmValueQueryVariables>;
export const GetShopifyOauthUrlDocument = gql`
    query GetShopifyOauthUrl($shop: String!) {
  shopifyOauthUrl(shop: $shop)
}
    `;

/**
 * __useGetShopifyOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetShopifyOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopifyOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopifyOauthUrlQuery({
 *   variables: {
 *      shop: // value for 'shop'
 *   },
 * });
 */
export function useGetShopifyOauthUrlQuery(baseOptions: Apollo.QueryHookOptions<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>(GetShopifyOauthUrlDocument, options);
      }
export function useGetShopifyOauthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>(GetShopifyOauthUrlDocument, options);
        }
export function useGetShopifyOauthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>(GetShopifyOauthUrlDocument, options);
        }
export type GetShopifyOauthUrlQueryHookResult = ReturnType<typeof useGetShopifyOauthUrlQuery>;
export type GetShopifyOauthUrlLazyQueryHookResult = ReturnType<typeof useGetShopifyOauthUrlLazyQuery>;
export type GetShopifyOauthUrlSuspenseQueryHookResult = ReturnType<typeof useGetShopifyOauthUrlSuspenseQuery>;
export type GetShopifyOauthUrlQueryResult = Apollo.QueryResult<GetShopifyOauthUrlQuery, GetShopifyOauthUrlQueryVariables>;
export const GetStoreIntegrationsDocument = gql`
    query GetStoreIntegrations {
  infoIntegration: getStore {
    zekiMessage
    traystoreintegration {
      integrationId
      code
      apiKey
      connected
    }
    whatsappconfig {
      id
      connected
      activated
      whatsappAccessToken
      whatsappPhoneNumber
      phoneNumberId
      whatsappBusinessAccountId
    }
    omiestoreintegration {
      id
      appKey
      appSecret
      connected
      activated
      nfce
      nfe
      nfse
    }
    smsinfobipintegration {
      id
      connected
      activated
    }
    blingstoreintegration {
      id
      connected
      activated
    }
    webpicstoreintegration {
      id
      integrationToken
      companyId
      havePdv
      haveInvoice
      connected
    }
    emailproviderstoreintegration {
      emailToSend
      provider
      isActive
    }
    hostgatorstoreintegration {
      id
      storeUrl
      storeIntegrationId
      appKey
      connected
    }
    evolutionapiintegration {
      id
      apiKey
      instance
      phoneNumber
      connected
    }
    nuvemshopstoreintegration {
      id
      appName
      appEmail
      userId
      accessToken
      connected
    }
    shopifystoreintegration {
      id
      baseUrl
      accessToken
      activated
    }
    zapiintegration {
      zApiId
      zApiToken
      token
      pk
      connected
    }
    lojaintegradastoreintegration {
      id
      connected
      apiKey
    }
    yampistoreintegration {
      id
      connected
      merchantAlias
    }
    trinksstoreintegration {
      id
      integrationId
      apiKey
      activated
      connected
    }
  }
}
    `;

/**
 * __useGetStoreIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetStoreIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoreIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>(GetStoreIntegrationsDocument, options);
      }
export function useGetStoreIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>(GetStoreIntegrationsDocument, options);
        }
export function useGetStoreIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>(GetStoreIntegrationsDocument, options);
        }
export type GetStoreIntegrationsQueryHookResult = ReturnType<typeof useGetStoreIntegrationsQuery>;
export type GetStoreIntegrationsLazyQueryHookResult = ReturnType<typeof useGetStoreIntegrationsLazyQuery>;
export type GetStoreIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetStoreIntegrationsSuspenseQuery>;
export type GetStoreIntegrationsQueryResult = Apollo.QueryResult<GetStoreIntegrationsQuery, GetStoreIntegrationsQueryVariables>;
export const GetYampiAuthorizationUrlDocument = gql`
    query GetYampiAuthorizationUrl {
  getYampiAuthorizationUrl {
    url
    codeVerifier
    state
  }
}
    `;

/**
 * __useGetYampiAuthorizationUrlQuery__
 *
 * To run a query within a React component, call `useGetYampiAuthorizationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYampiAuthorizationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYampiAuthorizationUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYampiAuthorizationUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>(GetYampiAuthorizationUrlDocument, options);
      }
export function useGetYampiAuthorizationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>(GetYampiAuthorizationUrlDocument, options);
        }
export function useGetYampiAuthorizationUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>(GetYampiAuthorizationUrlDocument, options);
        }
export type GetYampiAuthorizationUrlQueryHookResult = ReturnType<typeof useGetYampiAuthorizationUrlQuery>;
export type GetYampiAuthorizationUrlLazyQueryHookResult = ReturnType<typeof useGetYampiAuthorizationUrlLazyQuery>;
export type GetYampiAuthorizationUrlSuspenseQueryHookResult = ReturnType<typeof useGetYampiAuthorizationUrlSuspenseQuery>;
export type GetYampiAuthorizationUrlQueryResult = Apollo.QueryResult<GetYampiAuthorizationUrlQuery, GetYampiAuthorizationUrlQueryVariables>;
export const GetZapiIntegrationDocument = gql`
    query GetZapiIntegration {
  getZApiIntegration {
    zApiId
    zApiToken
    token
    pk
    connected
  }
}
    `;

/**
 * __useGetZapiIntegrationQuery__
 *
 * To run a query within a React component, call `useGetZapiIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZapiIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZapiIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZapiIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>(GetZapiIntegrationDocument, options);
      }
export function useGetZapiIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>(GetZapiIntegrationDocument, options);
        }
export function useGetZapiIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>(GetZapiIntegrationDocument, options);
        }
export type GetZapiIntegrationQueryHookResult = ReturnType<typeof useGetZapiIntegrationQuery>;
export type GetZapiIntegrationLazyQueryHookResult = ReturnType<typeof useGetZapiIntegrationLazyQuery>;
export type GetZapiIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetZapiIntegrationSuspenseQuery>;
export type GetZapiIntegrationQueryResult = Apollo.QueryResult<GetZapiIntegrationQuery, GetZapiIntegrationQueryVariables>;
export const UpdateRfmAutomationDocument = gql`
    mutation UpdateRfmAutomation($dailyRefreshEnabled: Boolean!) {
  saveRfmAutomation(dailyRefreshEnabled: $dailyRefreshEnabled) {
    dailyRefreshEnabled
    lastCompletedAt
  }
}
    `;
export type UpdateRfmAutomationMutationFn = Apollo.MutationFunction<UpdateRfmAutomationMutation, UpdateRfmAutomationMutationVariables>;

/**
 * __useUpdateRfmAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateRfmAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRfmAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRfmAutomationMutation, { data, loading, error }] = useUpdateRfmAutomationMutation({
 *   variables: {
 *      dailyRefreshEnabled: // value for 'dailyRefreshEnabled'
 *   },
 * });
 */
export function useUpdateRfmAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRfmAutomationMutation, UpdateRfmAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRfmAutomationMutation, UpdateRfmAutomationMutationVariables>(UpdateRfmAutomationDocument, options);
      }
export type UpdateRfmAutomationMutationHookResult = ReturnType<typeof useUpdateRfmAutomationMutation>;
export type UpdateRfmAutomationMutationResult = Apollo.MutationResult<UpdateRfmAutomationMutation>;
export type UpdateRfmAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateRfmAutomationMutation, UpdateRfmAutomationMutationVariables>;
export const SetTrinksStoreIntegrationDocument = gql`
    mutation SetTrinksStoreIntegration($input: SetTrinksStoreIntegrationInput!) {
  setTrinksStoreIntegration(input: $input) {
    ok
    trinksIntegration {
      id
      integrationId
      apiKey
      activated
      connected
    }
  }
}
    `;
export type SetTrinksStoreIntegrationMutationFn = Apollo.MutationFunction<SetTrinksStoreIntegrationMutation, SetTrinksStoreIntegrationMutationVariables>;

/**
 * __useSetTrinksStoreIntegrationMutation__
 *
 * To run a mutation, you first call `useSetTrinksStoreIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTrinksStoreIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTrinksStoreIntegrationMutation, { data, loading, error }] = useSetTrinksStoreIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTrinksStoreIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SetTrinksStoreIntegrationMutation, SetTrinksStoreIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTrinksStoreIntegrationMutation, SetTrinksStoreIntegrationMutationVariables>(SetTrinksStoreIntegrationDocument, options);
      }
export type SetTrinksStoreIntegrationMutationHookResult = ReturnType<typeof useSetTrinksStoreIntegrationMutation>;
export type SetTrinksStoreIntegrationMutationResult = Apollo.MutationResult<SetTrinksStoreIntegrationMutation>;
export type SetTrinksStoreIntegrationMutationOptions = Apollo.BaseMutationOptions<SetTrinksStoreIntegrationMutation, SetTrinksStoreIntegrationMutationVariables>;
export const SetYampiStoreIntegrationDocument = gql`
    mutation SetYampiStoreIntegration($input: SetYampiStoreIntegrationInput!) {
  setYampiStoreIntegration(input: $input) {
    ok
    yampiIntegration {
      pk
      connected
      merchantAlias
    }
  }
}
    `;
export type SetYampiStoreIntegrationMutationFn = Apollo.MutationFunction<SetYampiStoreIntegrationMutation, SetYampiStoreIntegrationMutationVariables>;

/**
 * __useSetYampiStoreIntegrationMutation__
 *
 * To run a mutation, you first call `useSetYampiStoreIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetYampiStoreIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setYampiStoreIntegrationMutation, { data, loading, error }] = useSetYampiStoreIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetYampiStoreIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SetYampiStoreIntegrationMutation, SetYampiStoreIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetYampiStoreIntegrationMutation, SetYampiStoreIntegrationMutationVariables>(SetYampiStoreIntegrationDocument, options);
      }
export type SetYampiStoreIntegrationMutationHookResult = ReturnType<typeof useSetYampiStoreIntegrationMutation>;
export type SetYampiStoreIntegrationMutationResult = Apollo.MutationResult<SetYampiStoreIntegrationMutation>;
export type SetYampiStoreIntegrationMutationOptions = Apollo.BaseMutationOptions<SetYampiStoreIntegrationMutation, SetYampiStoreIntegrationMutationVariables>;
export const TestWhatsappConnectionRequestDocument = gql`
    mutation TestWhatsappConnectionRequest {
  testWhatsappConnection {
    ok
    message
    businessId
    businessName
    currency
  }
}
    `;
export type TestWhatsappConnectionRequestMutationFn = Apollo.MutationFunction<TestWhatsappConnectionRequestMutation, TestWhatsappConnectionRequestMutationVariables>;

/**
 * __useTestWhatsappConnectionRequestMutation__
 *
 * To run a mutation, you first call `useTestWhatsappConnectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestWhatsappConnectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testWhatsappConnectionRequestMutation, { data, loading, error }] = useTestWhatsappConnectionRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useTestWhatsappConnectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<TestWhatsappConnectionRequestMutation, TestWhatsappConnectionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestWhatsappConnectionRequestMutation, TestWhatsappConnectionRequestMutationVariables>(TestWhatsappConnectionRequestDocument, options);
      }
export type TestWhatsappConnectionRequestMutationHookResult = ReturnType<typeof useTestWhatsappConnectionRequestMutation>;
export type TestWhatsappConnectionRequestMutationResult = Apollo.MutationResult<TestWhatsappConnectionRequestMutation>;
export type TestWhatsappConnectionRequestMutationOptions = Apollo.BaseMutationOptions<TestWhatsappConnectionRequestMutation, TestWhatsappConnectionRequestMutationVariables>;
export const BlingIntegrationDocument = gql`
    mutation BlingIntegration($code: String, $isActive: Boolean) {
  setBlingStoreIntegration(code: $code, isActive: $isActive) {
    ok
    blingIntegration {
      pk
    }
  }
}
    `;
export type BlingIntegrationMutationFn = Apollo.MutationFunction<BlingIntegrationMutation, BlingIntegrationMutationVariables>;

/**
 * __useBlingIntegrationMutation__
 *
 * To run a mutation, you first call `useBlingIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlingIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blingIntegrationMutation, { data, loading, error }] = useBlingIntegrationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useBlingIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<BlingIntegrationMutation, BlingIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlingIntegrationMutation, BlingIntegrationMutationVariables>(BlingIntegrationDocument, options);
      }
export type BlingIntegrationMutationHookResult = ReturnType<typeof useBlingIntegrationMutation>;
export type BlingIntegrationMutationResult = Apollo.MutationResult<BlingIntegrationMutation>;
export type BlingIntegrationMutationOptions = Apollo.BaseMutationOptions<BlingIntegrationMutation, BlingIntegrationMutationVariables>;
export const SaveEvolutionApiConfigDocument = gql`
    mutation SaveEvolutionApiConfig($input: EvolutionApiIntegrationInput!) {
  saveEvolutionApiIntegration(input: $input) {
    ok
    isCreated
  }
}
    `;
export type SaveEvolutionApiConfigMutationFn = Apollo.MutationFunction<SaveEvolutionApiConfigMutation, SaveEvolutionApiConfigMutationVariables>;

/**
 * __useSaveEvolutionApiConfigMutation__
 *
 * To run a mutation, you first call `useSaveEvolutionApiConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEvolutionApiConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEvolutionApiConfigMutation, { data, loading, error }] = useSaveEvolutionApiConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEvolutionApiConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveEvolutionApiConfigMutation, SaveEvolutionApiConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEvolutionApiConfigMutation, SaveEvolutionApiConfigMutationVariables>(SaveEvolutionApiConfigDocument, options);
      }
export type SaveEvolutionApiConfigMutationHookResult = ReturnType<typeof useSaveEvolutionApiConfigMutation>;
export type SaveEvolutionApiConfigMutationResult = Apollo.MutationResult<SaveEvolutionApiConfigMutation>;
export type SaveEvolutionApiConfigMutationOptions = Apollo.BaseMutationOptions<SaveEvolutionApiConfigMutation, SaveEvolutionApiConfigMutationVariables>;
export const UpdateGiftbackConfigDocument = gql`
    mutation UpdateGiftbackConfig($input: GiftbackConfigInput) {
  saveGiftbackConfig(input: $input) {
    giftback {
      id
      dueDate
      cumulative
      couponProductScope
      couponScopeMode
      couponScopeProducts {
        id
        pk
        name
        integrationId
      }
      couponScopeCategories {
        id
        pk
        name
        integrationId
      }
      pk
      multiplegiftbackconfigSet {
        value
        valueType
        minPurchaseValueForCreate
        minimumValueType
        maximumDiscountPercentage
        discountLimitEnabled
        discountLimit
        minPurchaseValueForRedeem
        pk
        tags {
          id
          name
        }
      }
    }
  }
}
    `;
export type UpdateGiftbackConfigMutationFn = Apollo.MutationFunction<UpdateGiftbackConfigMutation, UpdateGiftbackConfigMutationVariables>;

/**
 * __useUpdateGiftbackConfigMutation__
 *
 * To run a mutation, you first call `useUpdateGiftbackConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftbackConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftbackConfigMutation, { data, loading, error }] = useUpdateGiftbackConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGiftbackConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGiftbackConfigMutation, UpdateGiftbackConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGiftbackConfigMutation, UpdateGiftbackConfigMutationVariables>(UpdateGiftbackConfigDocument, options);
      }
export type UpdateGiftbackConfigMutationHookResult = ReturnType<typeof useUpdateGiftbackConfigMutation>;
export type UpdateGiftbackConfigMutationResult = Apollo.MutationResult<UpdateGiftbackConfigMutation>;
export type UpdateGiftbackConfigMutationOptions = Apollo.BaseMutationOptions<UpdateGiftbackConfigMutation, UpdateGiftbackConfigMutationVariables>;
export const SaveHostgatorConfigDocument = gql`
    mutation SaveHostgatorConfig($input: SaveHostgatorStoreIntegrationInput!) {
  saveHostgatorStoreIntegration(input: $input) {
    ok
  }
}
    `;
export type SaveHostgatorConfigMutationFn = Apollo.MutationFunction<SaveHostgatorConfigMutation, SaveHostgatorConfigMutationVariables>;

/**
 * __useSaveHostgatorConfigMutation__
 *
 * To run a mutation, you first call `useSaveHostgatorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHostgatorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHostgatorConfigMutation, { data, loading, error }] = useSaveHostgatorConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHostgatorConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveHostgatorConfigMutation, SaveHostgatorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHostgatorConfigMutation, SaveHostgatorConfigMutationVariables>(SaveHostgatorConfigDocument, options);
      }
export type SaveHostgatorConfigMutationHookResult = ReturnType<typeof useSaveHostgatorConfigMutation>;
export type SaveHostgatorConfigMutationResult = Apollo.MutationResult<SaveHostgatorConfigMutation>;
export type SaveHostgatorConfigMutationOptions = Apollo.BaseMutationOptions<SaveHostgatorConfigMutation, SaveHostgatorConfigMutationVariables>;
export const UpdateLojaIntegradaConfigDocument = gql`
    mutation UpdateLojaIntegradaConfig($input: SaveLojaIntegradaStoreIntegrationInput!) {
  saveLojaIntegradaStoreIntegration(input: $input) {
    ok
  }
}
    `;
export type UpdateLojaIntegradaConfigMutationFn = Apollo.MutationFunction<UpdateLojaIntegradaConfigMutation, UpdateLojaIntegradaConfigMutationVariables>;

/**
 * __useUpdateLojaIntegradaConfigMutation__
 *
 * To run a mutation, you first call `useUpdateLojaIntegradaConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLojaIntegradaConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLojaIntegradaConfigMutation, { data, loading, error }] = useUpdateLojaIntegradaConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLojaIntegradaConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLojaIntegradaConfigMutation, UpdateLojaIntegradaConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLojaIntegradaConfigMutation, UpdateLojaIntegradaConfigMutationVariables>(UpdateLojaIntegradaConfigDocument, options);
      }
export type UpdateLojaIntegradaConfigMutationHookResult = ReturnType<typeof useUpdateLojaIntegradaConfigMutation>;
export type UpdateLojaIntegradaConfigMutationResult = Apollo.MutationResult<UpdateLojaIntegradaConfigMutation>;
export type UpdateLojaIntegradaConfigMutationOptions = Apollo.BaseMutationOptions<UpdateLojaIntegradaConfigMutation, UpdateLojaIntegradaConfigMutationVariables>;
export const UpdateNuvemshopStoreIntegrationMutationDocument = gql`
    mutation UpdateNuvemshopStoreIntegrationMutation($input: SaveNuvemshopStoreIntegrationInput!) {
  saveNuvemshopStoreIntegration(input: $input) {
    ok
  }
}
    `;
export type UpdateNuvemshopStoreIntegrationMutationMutationFn = Apollo.MutationFunction<UpdateNuvemshopStoreIntegrationMutationMutation, UpdateNuvemshopStoreIntegrationMutationMutationVariables>;

/**
 * __useUpdateNuvemshopStoreIntegrationMutationMutation__
 *
 * To run a mutation, you first call `useUpdateNuvemshopStoreIntegrationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNuvemshopStoreIntegrationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNuvemshopStoreIntegrationMutationMutation, { data, loading, error }] = useUpdateNuvemshopStoreIntegrationMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNuvemshopStoreIntegrationMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNuvemshopStoreIntegrationMutationMutation, UpdateNuvemshopStoreIntegrationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNuvemshopStoreIntegrationMutationMutation, UpdateNuvemshopStoreIntegrationMutationMutationVariables>(UpdateNuvemshopStoreIntegrationMutationDocument, options);
      }
export type UpdateNuvemshopStoreIntegrationMutationMutationHookResult = ReturnType<typeof useUpdateNuvemshopStoreIntegrationMutationMutation>;
export type UpdateNuvemshopStoreIntegrationMutationMutationResult = Apollo.MutationResult<UpdateNuvemshopStoreIntegrationMutationMutation>;
export type UpdateNuvemshopStoreIntegrationMutationMutationOptions = Apollo.BaseMutationOptions<UpdateNuvemshopStoreIntegrationMutationMutation, UpdateNuvemshopStoreIntegrationMutationMutationVariables>;
export const NuvemshopAuthenticationDocument = gql`
    mutation NuvemshopAuthentication($input: NuvemshopAuthenticationRequestInput!) {
  nuvemshopAuthenticationRequest(input: $input) {
    ok
  }
}
    `;
export type NuvemshopAuthenticationMutationFn = Apollo.MutationFunction<NuvemshopAuthenticationMutation, NuvemshopAuthenticationMutationVariables>;

/**
 * __useNuvemshopAuthenticationMutation__
 *
 * To run a mutation, you first call `useNuvemshopAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNuvemshopAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nuvemshopAuthenticationMutation, { data, loading, error }] = useNuvemshopAuthenticationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNuvemshopAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<NuvemshopAuthenticationMutation, NuvemshopAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NuvemshopAuthenticationMutation, NuvemshopAuthenticationMutationVariables>(NuvemshopAuthenticationDocument, options);
      }
export type NuvemshopAuthenticationMutationHookResult = ReturnType<typeof useNuvemshopAuthenticationMutation>;
export type NuvemshopAuthenticationMutationResult = Apollo.MutationResult<NuvemshopAuthenticationMutation>;
export type NuvemshopAuthenticationMutationOptions = Apollo.BaseMutationOptions<NuvemshopAuthenticationMutation, NuvemshopAuthenticationMutationVariables>;
export const OmieIntegrationDocument = gql`
    mutation OmieIntegration($input: SetOmieStoreIntegrationInput!) {
  setOmieStoreIntegration(input: $input) {
    ok
    omieIntegration {
      appKey
      appSecret
      connected
      activated
      nfce
      nfe
      nfse
    }
  }
}
    `;
export type OmieIntegrationMutationFn = Apollo.MutationFunction<OmieIntegrationMutation, OmieIntegrationMutationVariables>;

/**
 * __useOmieIntegrationMutation__
 *
 * To run a mutation, you first call `useOmieIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOmieIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [omieIntegrationMutation, { data, loading, error }] = useOmieIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmieIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<OmieIntegrationMutation, OmieIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OmieIntegrationMutation, OmieIntegrationMutationVariables>(OmieIntegrationDocument, options);
      }
export type OmieIntegrationMutationHookResult = ReturnType<typeof useOmieIntegrationMutation>;
export type OmieIntegrationMutationResult = Apollo.MutationResult<OmieIntegrationMutation>;
export type OmieIntegrationMutationOptions = Apollo.BaseMutationOptions<OmieIntegrationMutation, OmieIntegrationMutationVariables>;
export const SetShopifyIntegrationDocument = gql`
    mutation SetShopifyIntegration($input: SetShopifyStoreIntegrationInput!) {
  setShopifyStoreIntegration(input: $input) {
    ok
    shopifyIntegration {
      pk
      baseUrl
      accessToken
      connected
      activated
    }
  }
}
    `;
export type SetShopifyIntegrationMutationFn = Apollo.MutationFunction<SetShopifyIntegrationMutation, SetShopifyIntegrationMutationVariables>;

/**
 * __useSetShopifyIntegrationMutation__
 *
 * To run a mutation, you first call `useSetShopifyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShopifyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShopifyIntegrationMutation, { data, loading, error }] = useSetShopifyIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetShopifyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SetShopifyIntegrationMutation, SetShopifyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShopifyIntegrationMutation, SetShopifyIntegrationMutationVariables>(SetShopifyIntegrationDocument, options);
      }
export type SetShopifyIntegrationMutationHookResult = ReturnType<typeof useSetShopifyIntegrationMutation>;
export type SetShopifyIntegrationMutationResult = Apollo.MutationResult<SetShopifyIntegrationMutation>;
export type SetShopifyIntegrationMutationOptions = Apollo.BaseMutationOptions<SetShopifyIntegrationMutation, SetShopifyIntegrationMutationVariables>;
export const SmsInfobipIntegrationDocument = gql`
    mutation SMSInfobipIntegration($input: SetSMSInfoBipIntegrationInput!) {
  setSmsInfoBipIntegration(input: $input) {
    ok
    smsInfoBipIntegration {
      id
      connected
      activated
      store {
        name
      }
    }
  }
}
    `;
export type SmsInfobipIntegrationMutationFn = Apollo.MutationFunction<SmsInfobipIntegrationMutation, SmsInfobipIntegrationMutationVariables>;

/**
 * __useSmsInfobipIntegrationMutation__
 *
 * To run a mutation, you first call `useSmsInfobipIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsInfobipIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsInfobipIntegrationMutation, { data, loading, error }] = useSmsInfobipIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSmsInfobipIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SmsInfobipIntegrationMutation, SmsInfobipIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsInfobipIntegrationMutation, SmsInfobipIntegrationMutationVariables>(SmsInfobipIntegrationDocument, options);
      }
export type SmsInfobipIntegrationMutationHookResult = ReturnType<typeof useSmsInfobipIntegrationMutation>;
export type SmsInfobipIntegrationMutationResult = Apollo.MutationResult<SmsInfobipIntegrationMutation>;
export type SmsInfobipIntegrationMutationOptions = Apollo.BaseMutationOptions<SmsInfobipIntegrationMutation, SmsInfobipIntegrationMutationVariables>;
export const CreateTrayStoreIntegrationDocument = gql`
    mutation createTrayStoreIntegration($trayInput: CreateTrayStoreIntegrationInput!) {
  createTrayStoreIntegration(trayInput: $trayInput) {
    success
    error
  }
}
    `;
export type CreateTrayStoreIntegrationMutationFn = Apollo.MutationFunction<CreateTrayStoreIntegrationMutation, CreateTrayStoreIntegrationMutationVariables>;

/**
 * __useCreateTrayStoreIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateTrayStoreIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrayStoreIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrayStoreIntegrationMutation, { data, loading, error }] = useCreateTrayStoreIntegrationMutation({
 *   variables: {
 *      trayInput: // value for 'trayInput'
 *   },
 * });
 */
export function useCreateTrayStoreIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrayStoreIntegrationMutation, CreateTrayStoreIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrayStoreIntegrationMutation, CreateTrayStoreIntegrationMutationVariables>(CreateTrayStoreIntegrationDocument, options);
      }
export type CreateTrayStoreIntegrationMutationHookResult = ReturnType<typeof useCreateTrayStoreIntegrationMutation>;
export type CreateTrayStoreIntegrationMutationResult = Apollo.MutationResult<CreateTrayStoreIntegrationMutation>;
export type CreateTrayStoreIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateTrayStoreIntegrationMutation, CreateTrayStoreIntegrationMutationVariables>;
export const CreateWebPicIntegrationDocument = gql`
    mutation CreateWebPicIntegration($input: SaveWebpicStoreIntegrationInput!) {
  saveWebpicStoreIntegration(input: $input) {
    ok
  }
}
    `;
export type CreateWebPicIntegrationMutationFn = Apollo.MutationFunction<CreateWebPicIntegrationMutation, CreateWebPicIntegrationMutationVariables>;

/**
 * __useCreateWebPicIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateWebPicIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebPicIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebPicIntegrationMutation, { data, loading, error }] = useCreateWebPicIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebPicIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebPicIntegrationMutation, CreateWebPicIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebPicIntegrationMutation, CreateWebPicIntegrationMutationVariables>(CreateWebPicIntegrationDocument, options);
      }
export type CreateWebPicIntegrationMutationHookResult = ReturnType<typeof useCreateWebPicIntegrationMutation>;
export type CreateWebPicIntegrationMutationResult = Apollo.MutationResult<CreateWebPicIntegrationMutation>;
export type CreateWebPicIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateWebPicIntegrationMutation, CreateWebPicIntegrationMutationVariables>;
export const SaveWhatsappIntegrationDocument = gql`
    mutation SaveWhatsappIntegration($input: WhatsappConfigInput) {
  saveWhatsapp(input: $input) {
    whatsappIntegration {
      id
      whatsappAccessToken
      phoneNumberId
      whatsappBusinessAccountId
      connected
      activated
      pk
    }
    ok
  }
}
    `;
export type SaveWhatsappIntegrationMutationFn = Apollo.MutationFunction<SaveWhatsappIntegrationMutation, SaveWhatsappIntegrationMutationVariables>;

/**
 * __useSaveWhatsappIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveWhatsappIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWhatsappIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWhatsappIntegrationMutation, { data, loading, error }] = useSaveWhatsappIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveWhatsappIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveWhatsappIntegrationMutation, SaveWhatsappIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWhatsappIntegrationMutation, SaveWhatsappIntegrationMutationVariables>(SaveWhatsappIntegrationDocument, options);
      }
export type SaveWhatsappIntegrationMutationHookResult = ReturnType<typeof useSaveWhatsappIntegrationMutation>;
export type SaveWhatsappIntegrationMutationResult = Apollo.MutationResult<SaveWhatsappIntegrationMutation>;
export type SaveWhatsappIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveWhatsappIntegrationMutation, SaveWhatsappIntegrationMutationVariables>;
export const SetEmailProviderDocument = gql`
    mutation SetEmailProvider($input: EmailProviderStoreIntegrationInput) {
  saveEmailProvider(input: $input) {
    ok
    emailProvider {
      emailToSend
      provider
      isActive
    }
  }
}
    `;
export type SetEmailProviderMutationFn = Apollo.MutationFunction<SetEmailProviderMutation, SetEmailProviderMutationVariables>;

/**
 * __useSetEmailProviderMutation__
 *
 * To run a mutation, you first call `useSetEmailProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmailProviderMutation, { data, loading, error }] = useSetEmailProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEmailProviderMutation(baseOptions?: Apollo.MutationHookOptions<SetEmailProviderMutation, SetEmailProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmailProviderMutation, SetEmailProviderMutationVariables>(SetEmailProviderDocument, options);
      }
export type SetEmailProviderMutationHookResult = ReturnType<typeof useSetEmailProviderMutation>;
export type SetEmailProviderMutationResult = Apollo.MutationResult<SetEmailProviderMutation>;
export type SetEmailProviderMutationOptions = Apollo.BaseMutationOptions<SetEmailProviderMutation, SetEmailProviderMutationVariables>;
export const UpdateRfmConfigDocument = gql`
    mutation UpdateRFMConfig($recency: RecencyRFMInput!, $frequency: FrequencyRFMInput!, $value: ValueRFMInput!) {
  saveRfmConfig(
    valueInput: $value
    recencyInput: $recency
    frequencyInput: $frequency
  ) {
    recency {
      id
      zoneOneMin
      zoneOneMax
      zoneTwoMin
      zoneTwoMax
      zoneThreeMin
      zoneThreeMax
      zoneFourMin
      zoneFourMax
      zoneFiveMin
      zoneFiveMax
    }
    frequency {
      id
      zoneOneMin
      zoneOneMax
      zoneTwoMin
      zoneTwoMax
      zoneThreeMin
      zoneThreeMax
      zoneFourMin
      zoneFourMax
      zoneFiveMin
      zoneFiveMax
    }
    value {
      id
      zoneOneMin
      zoneOneMax
      zoneTwoMin
      zoneTwoMax
      zoneThreeMin
      zoneThreeMax
      zoneFourMin
      zoneFourMax
      zoneFiveMin
      zoneFiveMax
    }
  }
}
    `;
export type UpdateRfmConfigMutationFn = Apollo.MutationFunction<UpdateRfmConfigMutation, UpdateRfmConfigMutationVariables>;

/**
 * __useUpdateRfmConfigMutation__
 *
 * To run a mutation, you first call `useUpdateRfmConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRfmConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRfmConfigMutation, { data, loading, error }] = useUpdateRfmConfigMutation({
 *   variables: {
 *      recency: // value for 'recency'
 *      frequency: // value for 'frequency'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateRfmConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRfmConfigMutation, UpdateRfmConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRfmConfigMutation, UpdateRfmConfigMutationVariables>(UpdateRfmConfigDocument, options);
      }
export type UpdateRfmConfigMutationHookResult = ReturnType<typeof useUpdateRfmConfigMutation>;
export type UpdateRfmConfigMutationResult = Apollo.MutationResult<UpdateRfmConfigMutation>;
export type UpdateRfmConfigMutationOptions = Apollo.BaseMutationOptions<UpdateRfmConfigMutation, UpdateRfmConfigMutationVariables>;
export const SaveZapiIntegrationDocument = gql`
    mutation SaveZapiIntegration($input: ZApiIntegrationInput!) {
  saveZApi(input: $input) {
    zApiIntegration {
      zApiId
      zApiToken
      token
      connected
      pk
    }
    ok
  }
}
    `;
export type SaveZapiIntegrationMutationFn = Apollo.MutationFunction<SaveZapiIntegrationMutation, SaveZapiIntegrationMutationVariables>;

/**
 * __useSaveZapiIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveZapiIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveZapiIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveZapiIntegrationMutation, { data, loading, error }] = useSaveZapiIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveZapiIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveZapiIntegrationMutation, SaveZapiIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveZapiIntegrationMutation, SaveZapiIntegrationMutationVariables>(SaveZapiIntegrationDocument, options);
      }
export type SaveZapiIntegrationMutationHookResult = ReturnType<typeof useSaveZapiIntegrationMutation>;
export type SaveZapiIntegrationMutationResult = Apollo.MutationResult<SaveZapiIntegrationMutation>;
export type SaveZapiIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveZapiIntegrationMutation, SaveZapiIntegrationMutationVariables>;
export const CouponCreateDocument = gql`
    mutation CouponCreate($couponInput: CouponInput!) {
  couponCreate(couponInput: $couponInput) {
    success
    error
    coupon {
      id
      pk
      code
      description
      value
      valueType
      startsAt
      expiresAt
      usageLimit
      isCumulative
      isFreeShipping
      integrationId
    }
  }
}
    `;
export type CouponCreateMutationFn = Apollo.MutationFunction<CouponCreateMutation, CouponCreateMutationVariables>;

/**
 * __useCouponCreateMutation__
 *
 * To run a mutation, you first call `useCouponCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponCreateMutation, { data, loading, error }] = useCouponCreateMutation({
 *   variables: {
 *      couponInput: // value for 'couponInput'
 *   },
 * });
 */
export function useCouponCreateMutation(baseOptions?: Apollo.MutationHookOptions<CouponCreateMutation, CouponCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponCreateMutation, CouponCreateMutationVariables>(CouponCreateDocument, options);
      }
export type CouponCreateMutationHookResult = ReturnType<typeof useCouponCreateMutation>;
export type CouponCreateMutationResult = Apollo.MutationResult<CouponCreateMutation>;
export type CouponCreateMutationOptions = Apollo.BaseMutationOptions<CouponCreateMutation, CouponCreateMutationVariables>;
export const CouponDeleteDocument = gql`
    mutation CouponDelete($couponInput: DeleteCouponInput!) {
  couponDelete(couponInput: $couponInput) {
    success
    error
  }
}
    `;
export type CouponDeleteMutationFn = Apollo.MutationFunction<CouponDeleteMutation, CouponDeleteMutationVariables>;

/**
 * __useCouponDeleteMutation__
 *
 * To run a mutation, you first call `useCouponDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponDeleteMutation, { data, loading, error }] = useCouponDeleteMutation({
 *   variables: {
 *      couponInput: // value for 'couponInput'
 *   },
 * });
 */
export function useCouponDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CouponDeleteMutation, CouponDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponDeleteMutation, CouponDeleteMutationVariables>(CouponDeleteDocument, options);
      }
export type CouponDeleteMutationHookResult = ReturnType<typeof useCouponDeleteMutation>;
export type CouponDeleteMutationResult = Apollo.MutationResult<CouponDeleteMutation>;
export type CouponDeleteMutationOptions = Apollo.BaseMutationOptions<CouponDeleteMutation, CouponDeleteMutationVariables>;
export const GetCouponDocument = gql`
    query GetCoupon($couponId: ID!) {
  coupon(couponId: $couponId) {
    id
    pk
    code
    description
    value
    valueType
    startsAt
    expiresAt
    usageLimit
    isCumulative
    isFreeShipping
    importedFrom
    integrationId
    eligibleProducts {
      edges {
        node {
          id
          pk
          name
        }
      }
    }
    eligibleCategories {
      edges {
        node {
          id
          pk
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCouponQuery__
 *
 * To run a query within a React component, call `useGetCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponQuery({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useGetCouponQuery(baseOptions: Apollo.QueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
      }
export function useGetCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export function useGetCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export type GetCouponQueryHookResult = ReturnType<typeof useGetCouponQuery>;
export type GetCouponLazyQueryHookResult = ReturnType<typeof useGetCouponLazyQuery>;
export type GetCouponSuspenseQueryHookResult = ReturnType<typeof useGetCouponSuspenseQuery>;
export type GetCouponQueryResult = Apollo.QueryResult<GetCouponQuery, GetCouponQueryVariables>;
export const ListCouponsDocument = gql`
    query ListCoupons($before: String, $after: String, $first: Int, $last: Int, $code_Icontains: String, $valueType: String, $importedFrom: String, $isCumulative: Boolean) {
  couponList(
    before: $before
    after: $after
    first: $first
    last: $last
    code_Icontains: $code_Icontains
    valueType: $valueType
    importedFrom: $importedFrom
    isCumulative: $isCumulative
  ) {
    edgeCount
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        pk
        code
        description
        value
        valueType
        startsAt
        expiresAt
        usageLimit
        isCumulative
        isFreeShipping
        importedFrom
        integrationId
        createdAt
      }
    }
  }
}
    `;

/**
 * __useListCouponsQuery__
 *
 * To run a query within a React component, call `useListCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCouponsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      code_Icontains: // value for 'code_Icontains'
 *      valueType: // value for 'valueType'
 *      importedFrom: // value for 'importedFrom'
 *      isCumulative: // value for 'isCumulative'
 *   },
 * });
 */
export function useListCouponsQuery(baseOptions?: Apollo.QueryHookOptions<ListCouponsQuery, ListCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCouponsQuery, ListCouponsQueryVariables>(ListCouponsDocument, options);
      }
export function useListCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCouponsQuery, ListCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCouponsQuery, ListCouponsQueryVariables>(ListCouponsDocument, options);
        }
export function useListCouponsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCouponsQuery, ListCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCouponsQuery, ListCouponsQueryVariables>(ListCouponsDocument, options);
        }
export type ListCouponsQueryHookResult = ReturnType<typeof useListCouponsQuery>;
export type ListCouponsLazyQueryHookResult = ReturnType<typeof useListCouponsLazyQuery>;
export type ListCouponsSuspenseQueryHookResult = ReturnType<typeof useListCouponsSuspenseQuery>;
export type ListCouponsQueryResult = Apollo.QueryResult<ListCouponsQuery, ListCouponsQueryVariables>;
export const CouponUpdateDocument = gql`
    mutation CouponUpdate($couponInput: UpdateCouponInput!) {
  couponUpdate(couponInput: $couponInput) {
    success
    error
    coupon {
      id
      pk
      code
      description
      value
      valueType
      startsAt
      expiresAt
      usageLimit
      isCumulative
      isFreeShipping
    }
  }
}
    `;
export type CouponUpdateMutationFn = Apollo.MutationFunction<CouponUpdateMutation, CouponUpdateMutationVariables>;

/**
 * __useCouponUpdateMutation__
 *
 * To run a mutation, you first call `useCouponUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponUpdateMutation, { data, loading, error }] = useCouponUpdateMutation({
 *   variables: {
 *      couponInput: // value for 'couponInput'
 *   },
 * });
 */
export function useCouponUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CouponUpdateMutation, CouponUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponUpdateMutation, CouponUpdateMutationVariables>(CouponUpdateDocument, options);
      }
export type CouponUpdateMutationHookResult = ReturnType<typeof useCouponUpdateMutation>;
export type CouponUpdateMutationResult = Apollo.MutationResult<CouponUpdateMutation>;
export type CouponUpdateMutationOptions = Apollo.BaseMutationOptions<CouponUpdateMutation, CouponUpdateMutationVariables>;
export const CustomerAcquisitionChannelsDocument = gql`
    query CustomerAcquisitionChannels($isActive: Boolean) {
  customerAcquisitionChannels(isActive: $isActive) {
    edges {
      node {
        id
        pk
        name
        isActive
        position
      }
    }
  }
}
    `;

/**
 * __useCustomerAcquisitionChannelsQuery__
 *
 * To run a query within a React component, call `useCustomerAcquisitionChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAcquisitionChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAcquisitionChannelsQuery({
 *   variables: {
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCustomerAcquisitionChannelsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>(CustomerAcquisitionChannelsDocument, options);
      }
export function useCustomerAcquisitionChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>(CustomerAcquisitionChannelsDocument, options);
        }
export function useCustomerAcquisitionChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>(CustomerAcquisitionChannelsDocument, options);
        }
export type CustomerAcquisitionChannelsQueryHookResult = ReturnType<typeof useCustomerAcquisitionChannelsQuery>;
export type CustomerAcquisitionChannelsLazyQueryHookResult = ReturnType<typeof useCustomerAcquisitionChannelsLazyQuery>;
export type CustomerAcquisitionChannelsSuspenseQueryHookResult = ReturnType<typeof useCustomerAcquisitionChannelsSuspenseQuery>;
export type CustomerAcquisitionChannelsQueryResult = Apollo.QueryResult<CustomerAcquisitionChannelsQuery, CustomerAcquisitionChannelsQueryVariables>;
export const SaveCustomerAcquisitionChannelDocument = gql`
    mutation SaveCustomerAcquisitionChannel($input: SaveCustomerAcquisitionChannelInput!) {
  saveCustomerAcquisitionChannel(input: $input) {
    channel {
      id
      pk
      name
      isActive
      position
    }
  }
}
    `;
export type SaveCustomerAcquisitionChannelMutationFn = Apollo.MutationFunction<SaveCustomerAcquisitionChannelMutation, SaveCustomerAcquisitionChannelMutationVariables>;

/**
 * __useSaveCustomerAcquisitionChannelMutation__
 *
 * To run a mutation, you first call `useSaveCustomerAcquisitionChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomerAcquisitionChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomerAcquisitionChannelMutation, { data, loading, error }] = useSaveCustomerAcquisitionChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCustomerAcquisitionChannelMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomerAcquisitionChannelMutation, SaveCustomerAcquisitionChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomerAcquisitionChannelMutation, SaveCustomerAcquisitionChannelMutationVariables>(SaveCustomerAcquisitionChannelDocument, options);
      }
export type SaveCustomerAcquisitionChannelMutationHookResult = ReturnType<typeof useSaveCustomerAcquisitionChannelMutation>;
export type SaveCustomerAcquisitionChannelMutationResult = Apollo.MutationResult<SaveCustomerAcquisitionChannelMutation>;
export type SaveCustomerAcquisitionChannelMutationOptions = Apollo.BaseMutationOptions<SaveCustomerAcquisitionChannelMutation, SaveCustomerAcquisitionChannelMutationVariables>;
export const ReorderCustomerAcquisitionChannelsDocument = gql`
    mutation ReorderCustomerAcquisitionChannels($input: ReorderCustomerAcquisitionChannelsInput!) {
  reorderCustomerAcquisitionChannels(input: $input) {
    ok
  }
}
    `;
export type ReorderCustomerAcquisitionChannelsMutationFn = Apollo.MutationFunction<ReorderCustomerAcquisitionChannelsMutation, ReorderCustomerAcquisitionChannelsMutationVariables>;

/**
 * __useReorderCustomerAcquisitionChannelsMutation__
 *
 * To run a mutation, you first call `useReorderCustomerAcquisitionChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCustomerAcquisitionChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCustomerAcquisitionChannelsMutation, { data, loading, error }] = useReorderCustomerAcquisitionChannelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderCustomerAcquisitionChannelsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderCustomerAcquisitionChannelsMutation, ReorderCustomerAcquisitionChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCustomerAcquisitionChannelsMutation, ReorderCustomerAcquisitionChannelsMutationVariables>(ReorderCustomerAcquisitionChannelsDocument, options);
      }
export type ReorderCustomerAcquisitionChannelsMutationHookResult = ReturnType<typeof useReorderCustomerAcquisitionChannelsMutation>;
export type ReorderCustomerAcquisitionChannelsMutationResult = Apollo.MutationResult<ReorderCustomerAcquisitionChannelsMutation>;
export type ReorderCustomerAcquisitionChannelsMutationOptions = Apollo.BaseMutationOptions<ReorderCustomerAcquisitionChannelsMutation, ReorderCustomerAcquisitionChannelsMutationVariables>;
export const CreateCustomerAudienceSelectionDocument = gql`
    mutation CreateCustomerAudienceSelection($input: CustomerFilterSetInput!, $purchaseInput: PurchaseProductFilterSetInput, $salesInput: PurchaseFilterSetInput, $giftbackInput: GiftbackFilterSetInput, $first: Int!) {
  createCustomerAudienceSelection(
    input: $input
    purchaseInput: $purchaseInput
    salesInput: $salesInput
    giftbackInput: $giftbackInput
    first: $first
  ) {
    selectionId
    total
    expiresAt
  }
}
    `;
export type CreateCustomerAudienceSelectionMutationFn = Apollo.MutationFunction<CreateCustomerAudienceSelectionMutation, CreateCustomerAudienceSelectionMutationVariables>;

/**
 * __useCreateCustomerAudienceSelectionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerAudienceSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerAudienceSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerAudienceSelectionMutation, { data, loading, error }] = useCreateCustomerAudienceSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      purchaseInput: // value for 'purchaseInput'
 *      salesInput: // value for 'salesInput'
 *      giftbackInput: // value for 'giftbackInput'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCreateCustomerAudienceSelectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerAudienceSelectionMutation, CreateCustomerAudienceSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerAudienceSelectionMutation, CreateCustomerAudienceSelectionMutationVariables>(CreateCustomerAudienceSelectionDocument, options);
      }
export type CreateCustomerAudienceSelectionMutationHookResult = ReturnType<typeof useCreateCustomerAudienceSelectionMutation>;
export type CreateCustomerAudienceSelectionMutationResult = Apollo.MutationResult<CreateCustomerAudienceSelectionMutation>;
export type CreateCustomerAudienceSelectionMutationOptions = Apollo.BaseMutationOptions<CreateCustomerAudienceSelectionMutation, CreateCustomerAudienceSelectionMutationVariables>;
export const CampaignAudienceCustomersDocument = gql`
    query CampaignAudienceCustomers($selectionId: ID!, $first: Int!, $after: String) {
  customerAudienceSelection(
    selectionId: $selectionId
    first: $first
    after: $after
  ) {
    selectionId
    total
    expiresAt
    customers {
      id
      name
      email
      phone
      rfmClassification
      purchaseCount
      purchaseValue
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    `;

/**
 * __useCampaignAudienceCustomersQuery__
 *
 * To run a query within a React component, call `useCampaignAudienceCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAudienceCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAudienceCustomersQuery({
 *   variables: {
 *      selectionId: // value for 'selectionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCampaignAudienceCustomersQuery(baseOptions: Apollo.QueryHookOptions<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>(CampaignAudienceCustomersDocument, options);
      }
export function useCampaignAudienceCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>(CampaignAudienceCustomersDocument, options);
        }
export function useCampaignAudienceCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>(CampaignAudienceCustomersDocument, options);
        }
export type CampaignAudienceCustomersQueryHookResult = ReturnType<typeof useCampaignAudienceCustomersQuery>;
export type CampaignAudienceCustomersLazyQueryHookResult = ReturnType<typeof useCampaignAudienceCustomersLazyQuery>;
export type CampaignAudienceCustomersSuspenseQueryHookResult = ReturnType<typeof useCampaignAudienceCustomersSuspenseQuery>;
export type CampaignAudienceCustomersQueryResult = Apollo.QueryResult<CampaignAudienceCustomersQuery, CampaignAudienceCustomersQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    customer {
      id
      name
      taxDocument
      acquisitionChannel {
        pk
        name
      }
    }
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CustomerCustomFieldsDocument = gql`
    query CustomerCustomFields {
  customerCustomFields {
    id
    pk
    key
    label
    fieldType
    isActive
    metadataPath
  }
}
    `;

/**
 * __useCustomerCustomFieldsQuery__
 *
 * To run a query within a React component, call `useCustomerCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>(CustomerCustomFieldsDocument, options);
      }
export function useCustomerCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>(CustomerCustomFieldsDocument, options);
        }
export function useCustomerCustomFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>(CustomerCustomFieldsDocument, options);
        }
export type CustomerCustomFieldsQueryHookResult = ReturnType<typeof useCustomerCustomFieldsQuery>;
export type CustomerCustomFieldsLazyQueryHookResult = ReturnType<typeof useCustomerCustomFieldsLazyQuery>;
export type CustomerCustomFieldsSuspenseQueryHookResult = ReturnType<typeof useCustomerCustomFieldsSuspenseQuery>;
export type CustomerCustomFieldsQueryResult = Apollo.QueryResult<CustomerCustomFieldsQuery, CustomerCustomFieldsQueryVariables>;
export const CustomerMetadataSampleCustomersDocument = gql`
    query CustomerMetadataSampleCustomers($search: String) {
  allCustomersRelay(first: 20, nameOrEmail: $search) {
    edges {
      node {
        pk
        name
        email
      }
    }
  }
}
    `;

/**
 * __useCustomerMetadataSampleCustomersQuery__
 *
 * To run a query within a React component, call `useCustomerMetadataSampleCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerMetadataSampleCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerMetadataSampleCustomersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomerMetadataSampleCustomersQuery(baseOptions?: Apollo.QueryHookOptions<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>(CustomerMetadataSampleCustomersDocument, options);
      }
export function useCustomerMetadataSampleCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>(CustomerMetadataSampleCustomersDocument, options);
        }
export function useCustomerMetadataSampleCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>(CustomerMetadataSampleCustomersDocument, options);
        }
export type CustomerMetadataSampleCustomersQueryHookResult = ReturnType<typeof useCustomerMetadataSampleCustomersQuery>;
export type CustomerMetadataSampleCustomersLazyQueryHookResult = ReturnType<typeof useCustomerMetadataSampleCustomersLazyQuery>;
export type CustomerMetadataSampleCustomersSuspenseQueryHookResult = ReturnType<typeof useCustomerMetadataSampleCustomersSuspenseQuery>;
export type CustomerMetadataSampleCustomersQueryResult = Apollo.QueryResult<CustomerMetadataSampleCustomersQuery, CustomerMetadataSampleCustomersQueryVariables>;
export const CustomerMetadataSampleDocument = gql`
    query CustomerMetadataSample($customerId: ID!) {
  customerMetadataSample(customerId: $customerId) {
    customerId
    truncated
    unsupportedCount
    fields {
      path
      preview
      previewTruncated
      suggestedType
    }
  }
}
    `;

/**
 * __useCustomerMetadataSampleQuery__
 *
 * To run a query within a React component, call `useCustomerMetadataSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerMetadataSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerMetadataSampleQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCustomerMetadataSampleQuery(baseOptions: Apollo.QueryHookOptions<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>(CustomerMetadataSampleDocument, options);
      }
export function useCustomerMetadataSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>(CustomerMetadataSampleDocument, options);
        }
export function useCustomerMetadataSampleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>(CustomerMetadataSampleDocument, options);
        }
export type CustomerMetadataSampleQueryHookResult = ReturnType<typeof useCustomerMetadataSampleQuery>;
export type CustomerMetadataSampleLazyQueryHookResult = ReturnType<typeof useCustomerMetadataSampleLazyQuery>;
export type CustomerMetadataSampleSuspenseQueryHookResult = ReturnType<typeof useCustomerMetadataSampleSuspenseQuery>;
export type CustomerMetadataSampleQueryResult = Apollo.QueryResult<CustomerMetadataSampleQuery, CustomerMetadataSampleQueryVariables>;
export const SaveCustomerCustomFieldDocument = gql`
    mutation SaveCustomerCustomField($input: SaveCustomerCustomFieldInput!) {
  saveCustomerCustomField(input: $input) {
    field {
      id
      pk
      key
      label
      fieldType
      isActive
      metadataPath
    }
  }
}
    `;
export type SaveCustomerCustomFieldMutationFn = Apollo.MutationFunction<SaveCustomerCustomFieldMutation, SaveCustomerCustomFieldMutationVariables>;

/**
 * __useSaveCustomerCustomFieldMutation__
 *
 * To run a mutation, you first call `useSaveCustomerCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomerCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomerCustomFieldMutation, { data, loading, error }] = useSaveCustomerCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCustomerCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomerCustomFieldMutation, SaveCustomerCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomerCustomFieldMutation, SaveCustomerCustomFieldMutationVariables>(SaveCustomerCustomFieldDocument, options);
      }
export type SaveCustomerCustomFieldMutationHookResult = ReturnType<typeof useSaveCustomerCustomFieldMutation>;
export type SaveCustomerCustomFieldMutationResult = Apollo.MutationResult<SaveCustomerCustomFieldMutation>;
export type SaveCustomerCustomFieldMutationOptions = Apollo.BaseMutationOptions<SaveCustomerCustomFieldMutation, SaveCustomerCustomFieldMutationVariables>;
export const DeleteCustomerCustomFieldDocument = gql`
    mutation DeleteCustomerCustomField($fieldId: ID!) {
  deleteCustomerCustomField(fieldId: $fieldId) {
    success
  }
}
    `;
export type DeleteCustomerCustomFieldMutationFn = Apollo.MutationFunction<DeleteCustomerCustomFieldMutation, DeleteCustomerCustomFieldMutationVariables>;

/**
 * __useDeleteCustomerCustomFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerCustomFieldMutation, { data, loading, error }] = useDeleteCustomerCustomFieldMutation({
 *   variables: {
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useDeleteCustomerCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerCustomFieldMutation, DeleteCustomerCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerCustomFieldMutation, DeleteCustomerCustomFieldMutationVariables>(DeleteCustomerCustomFieldDocument, options);
      }
export type DeleteCustomerCustomFieldMutationHookResult = ReturnType<typeof useDeleteCustomerCustomFieldMutation>;
export type DeleteCustomerCustomFieldMutationResult = Apollo.MutationResult<DeleteCustomerCustomFieldMutation>;
export type DeleteCustomerCustomFieldMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerCustomFieldMutation, DeleteCustomerCustomFieldMutationVariables>;
export const PrepareCustomerAudienceDocument = gql`
    mutation PrepareCustomerAudience($input: CustomerFilterSetInput!, $purchaseInput: PurchaseProductFilterSetInput, $salesInput: PurchaseFilterSetInput, $giftbackInput: GiftbackFilterSetInput, $filterContext: CustomerAudienceFilterContext, $first: Int!) {
  createCustomerAudienceSelection(
    input: $input
    purchaseInput: $purchaseInput
    salesInput: $salesInput
    giftbackInput: $giftbackInput
    filterContext: $filterContext
    first: $first
  ) {
    selectionId
    total
    expiresAt
    customers {
      id
      name
      email
      phone
      rfmClassification
      purchaseCount
      purchaseValue
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    `;
export type PrepareCustomerAudienceMutationFn = Apollo.MutationFunction<PrepareCustomerAudienceMutation, PrepareCustomerAudienceMutationVariables>;

/**
 * __usePrepareCustomerAudienceMutation__
 *
 * To run a mutation, you first call `usePrepareCustomerAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareCustomerAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareCustomerAudienceMutation, { data, loading, error }] = usePrepareCustomerAudienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      purchaseInput: // value for 'purchaseInput'
 *      salesInput: // value for 'salesInput'
 *      giftbackInput: // value for 'giftbackInput'
 *      filterContext: // value for 'filterContext'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePrepareCustomerAudienceMutation(baseOptions?: Apollo.MutationHookOptions<PrepareCustomerAudienceMutation, PrepareCustomerAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareCustomerAudienceMutation, PrepareCustomerAudienceMutationVariables>(PrepareCustomerAudienceDocument, options);
      }
export type PrepareCustomerAudienceMutationHookResult = ReturnType<typeof usePrepareCustomerAudienceMutation>;
export type PrepareCustomerAudienceMutationResult = Apollo.MutationResult<PrepareCustomerAudienceMutation>;
export type PrepareCustomerAudienceMutationOptions = Apollo.BaseMutationOptions<PrepareCustomerAudienceMutation, PrepareCustomerAudienceMutationVariables>;
export const CustomerCustomFieldValueOptionsDocument = gql`
    query CustomerCustomFieldValueOptions($fieldId: ID!, $search: String) {
  customerCustomFieldValueOptions(fieldId: $fieldId, search: $search) {
    values
    hasMore
  }
}
    `;

/**
 * __useCustomerCustomFieldValueOptionsQuery__
 *
 * To run a query within a React component, call `useCustomerCustomFieldValueOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCustomFieldValueOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCustomFieldValueOptionsQuery({
 *   variables: {
 *      fieldId: // value for 'fieldId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomerCustomFieldValueOptionsQuery(baseOptions: Apollo.QueryHookOptions<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>(CustomerCustomFieldValueOptionsDocument, options);
      }
export function useCustomerCustomFieldValueOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>(CustomerCustomFieldValueOptionsDocument, options);
        }
export function useCustomerCustomFieldValueOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>(CustomerCustomFieldValueOptionsDocument, options);
        }
export type CustomerCustomFieldValueOptionsQueryHookResult = ReturnType<typeof useCustomerCustomFieldValueOptionsQuery>;
export type CustomerCustomFieldValueOptionsLazyQueryHookResult = ReturnType<typeof useCustomerCustomFieldValueOptionsLazyQuery>;
export type CustomerCustomFieldValueOptionsSuspenseQueryHookResult = ReturnType<typeof useCustomerCustomFieldValueOptionsSuspenseQuery>;
export type CustomerCustomFieldValueOptionsQueryResult = Apollo.QueryResult<CustomerCustomFieldValueOptionsQuery, CustomerCustomFieldValueOptionsQueryVariables>;
export const CustomerExcelReportDocument = gql`
    query CustomerExcelReport($input: CustomerExcelReportInput) {
  customerExcelReport(input: $input) {
    relatorio
  }
}
    `;

/**
 * __useCustomerExcelReportQuery__
 *
 * To run a query within a React component, call `useCustomerExcelReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerExcelReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerExcelReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerExcelReportQuery(baseOptions?: Apollo.QueryHookOptions<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>(CustomerExcelReportDocument, options);
      }
export function useCustomerExcelReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>(CustomerExcelReportDocument, options);
        }
export function useCustomerExcelReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>(CustomerExcelReportDocument, options);
        }
export type CustomerExcelReportQueryHookResult = ReturnType<typeof useCustomerExcelReportQuery>;
export type CustomerExcelReportLazyQueryHookResult = ReturnType<typeof useCustomerExcelReportLazyQuery>;
export type CustomerExcelReportSuspenseQueryHookResult = ReturnType<typeof useCustomerExcelReportSuspenseQuery>;
export type CustomerExcelReportQueryResult = Apollo.QueryResult<CustomerExcelReportQuery, CustomerExcelReportQueryVariables>;
export const GetAllStateCitiesDocument = gql`
    query GetAllStateCities($uf: String!) {
  allStateCities(uf: $uf) {
    id
    nome
  }
}
    `;

/**
 * __useGetAllStateCitiesQuery__
 *
 * To run a query within a React component, call `useGetAllStateCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStateCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStateCitiesQuery({
 *   variables: {
 *      uf: // value for 'uf'
 *   },
 * });
 */
export function useGetAllStateCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>(GetAllStateCitiesDocument, options);
      }
export function useGetAllStateCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>(GetAllStateCitiesDocument, options);
        }
export function useGetAllStateCitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>(GetAllStateCitiesDocument, options);
        }
export type GetAllStateCitiesQueryHookResult = ReturnType<typeof useGetAllStateCitiesQuery>;
export type GetAllStateCitiesLazyQueryHookResult = ReturnType<typeof useGetAllStateCitiesLazyQuery>;
export type GetAllStateCitiesSuspenseQueryHookResult = ReturnType<typeof useGetAllStateCitiesSuspenseQuery>;
export type GetAllStateCitiesQueryResult = Apollo.QueryResult<GetAllStateCitiesQuery, GetAllStateCitiesQueryVariables>;
export const GetCustomerDetailsDocument = gql`
    query GetCustomerDetails($id: ID!) {
  getCustomer(id: $id) {
    id
    name
    email
    phone
    taxDocument
    importedFrom
    gender
    state
    city
    address
    rfmClassification
    averageTicket
    integrationId
    dateOfBirth
    isActive
    customFields {
      status
      field {
        id
        label
        fieldType
      }
      value
    }
    acquisitionChannel {
      pk
      name
      isActive
    }
    tags {
      edges {
        node {
          name
          pk
        }
      }
    }
    notes
    giftbackSet(status: "ACTIVE", orderBy: "due_date") {
      totalCount
      edges {
        node {
          value
          dueDate
          code
          pk
          importedFrom
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
      }
export function useGetCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
export function useGetCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
export type GetCustomerDetailsQueryHookResult = ReturnType<typeof useGetCustomerDetailsQuery>;
export type GetCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsLazyQuery>;
export type GetCustomerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDetailsSuspenseQuery>;
export type GetCustomerDetailsQueryResult = Apollo.QueryResult<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>;
export const GetAllCustomerGiftbackStatusCountDocument = gql`
    query GetAllCustomerGiftbackStatusCount {
  giftbackAll: allCustomersRelay {
    totalCount
  }
  giftbackActive: allCustomersRelay(giftback_Status: "ACTIVE") {
    totalCount
  }
  giftbackExpired: allCustomersRelay(giftback_Status: "EXPIRED") {
    totalCount
  }
  giftbackRedeemed: allCustomersRelay(giftback_Status: "REDEEMED") {
    totalCount
  }
  giftbackCancelled: allCustomersRelay(giftback_Status: "CANCELLED") {
    totalCount
  }
  giftbackOverdue: allCustomersRelay(giftback_Status: "OVERDUE") {
    totalCount
  }
}
    `;

/**
 * __useGetAllCustomerGiftbackStatusCountQuery__
 *
 * To run a query within a React component, call `useGetAllCustomerGiftbackStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCustomerGiftbackStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCustomerGiftbackStatusCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCustomerGiftbackStatusCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>(GetAllCustomerGiftbackStatusCountDocument, options);
      }
export function useGetAllCustomerGiftbackStatusCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>(GetAllCustomerGiftbackStatusCountDocument, options);
        }
export function useGetAllCustomerGiftbackStatusCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>(GetAllCustomerGiftbackStatusCountDocument, options);
        }
export type GetAllCustomerGiftbackStatusCountQueryHookResult = ReturnType<typeof useGetAllCustomerGiftbackStatusCountQuery>;
export type GetAllCustomerGiftbackStatusCountLazyQueryHookResult = ReturnType<typeof useGetAllCustomerGiftbackStatusCountLazyQuery>;
export type GetAllCustomerGiftbackStatusCountSuspenseQueryHookResult = ReturnType<typeof useGetAllCustomerGiftbackStatusCountSuspenseQuery>;
export type GetAllCustomerGiftbackStatusCountQueryResult = Apollo.QueryResult<GetAllCustomerGiftbackStatusCountQuery, GetAllCustomerGiftbackStatusCountQueryVariables>;
export const ListCustomerGiftbacksDocument = gql`
    query ListCustomerGiftbacks($customer: ID, $orderBy: String) {
  allGiftbacksRelay(customer: $customer, orderBy: $orderBy) {
    edges {
      node {
        pk
        code
        value
        dueDate
        status
        createdAt
        updatedAt
        customeractivitySet {
          edges {
            node {
              activity
              title
              description
              pk
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListCustomerGiftbacksQuery__
 *
 * To run a query within a React component, call `useListCustomerGiftbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomerGiftbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomerGiftbacksQuery({
 *   variables: {
 *      customer: // value for 'customer'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListCustomerGiftbacksQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>(ListCustomerGiftbacksDocument, options);
      }
export function useListCustomerGiftbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>(ListCustomerGiftbacksDocument, options);
        }
export function useListCustomerGiftbacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>(ListCustomerGiftbacksDocument, options);
        }
export type ListCustomerGiftbacksQueryHookResult = ReturnType<typeof useListCustomerGiftbacksQuery>;
export type ListCustomerGiftbacksLazyQueryHookResult = ReturnType<typeof useListCustomerGiftbacksLazyQuery>;
export type ListCustomerGiftbacksSuspenseQueryHookResult = ReturnType<typeof useListCustomerGiftbacksSuspenseQuery>;
export type ListCustomerGiftbacksQueryResult = Apollo.QueryResult<ListCustomerGiftbacksQuery, ListCustomerGiftbacksQueryVariables>;
export const ListCustomerActivitiesDocument = gql`
    query ListCustomerActivities($customer_Id: ID) {
  allCustomerActivitiesRelay(customer_Id: $customer_Id) {
    edges {
      node {
        activity
        pk
        title
        description
        updatedAt
        messageStatus
        user {
          pk
          email
        }
        giftback {
          value
          dueDate
          pk
          status
          createdAt
          updatedAt
          customeractivitySet {
            edges {
              node {
                title
                description
                createdAt
              }
            }
          }
        }
        purchase {
          pk
          value
          date
          status
          canceledBy
          canceledAt
          createdAt
          updatedAt
        }
        appointment {
          pk
          publicId
          serviceName
          startsAt
          status
          professional {
            publicName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListCustomerActivitiesQuery__
 *
 * To run a query within a React component, call `useListCustomerActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomerActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomerActivitiesQuery({
 *   variables: {
 *      customer_Id: // value for 'customer_Id'
 *   },
 * });
 */
export function useListCustomerActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>(ListCustomerActivitiesDocument, options);
      }
export function useListCustomerActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>(ListCustomerActivitiesDocument, options);
        }
export function useListCustomerActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>(ListCustomerActivitiesDocument, options);
        }
export type ListCustomerActivitiesQueryHookResult = ReturnType<typeof useListCustomerActivitiesQuery>;
export type ListCustomerActivitiesLazyQueryHookResult = ReturnType<typeof useListCustomerActivitiesLazyQuery>;
export type ListCustomerActivitiesSuspenseQueryHookResult = ReturnType<typeof useListCustomerActivitiesSuspenseQuery>;
export type ListCustomerActivitiesQueryResult = Apollo.QueryResult<ListCustomerActivitiesQuery, ListCustomerActivitiesQueryVariables>;
export const ListCustomerCampaignDocument = gql`
    query ListCustomerCampaign($customFields: String, $nameOrEmail: String, $taxDocument: String, $phone_Icontains: String, $rfmClassification_In: String, $purchase_Date_Gte: Date, $purchase_Date_Lte: Date, $giftback_Status: String, $giftback_Active: String, $createdAt_Date_Gte: Date, $createdAt_Date_Lte: Date, $importedFrom_In: String, $importedFrom: String, $containsTag: String, $doesNotContainTag: String, $productsBought: String, $productsNotBought: String, $byCategory: String, $byCategoryExclude: String, $gender_In: String, $notes_Icontains: String, $isActive: Boolean, $city: String, $state: String, $totalPurchasesCount_Lte: Int, $totalPurchasesCount_Gte: Int, $birthdatesByMonthAndDate: String, $daysWithoutPurchaseMin: Float, $daysWithoutPurchaseMax: Float, $havePhone: String, $haveEmail: String, $hasWhatsapp: String, $includedInCampaign: String, $notIncludedInCampaign: String, $totalMonetaryValue_Gte: Float, $totalMonetaryValue_Lte: Float) {
  allCustomersRelay(
    customFields: $customFields
    nameOrEmail: $nameOrEmail
    taxDocument: $taxDocument
    phone_Icontains: $phone_Icontains
    rfmClassification_In: $rfmClassification_In
    purchase_Date_Gte: $purchase_Date_Gte
    purchase_Date_Lte: $purchase_Date_Lte
    giftback_Status: $giftback_Status
    giftback_Active: $giftback_Active
    createdAt_Date_Gte: $createdAt_Date_Gte
    createdAt_Date_Lte: $createdAt_Date_Lte
    importedFrom: $importedFrom
    importedFrom_In: $importedFrom_In
    containsTag: $containsTag
    doesNotContainTag: $doesNotContainTag
    productsBought: $productsBought
    productsNotBought: $productsNotBought
    byCategory: $byCategory
    byCategoryExclude: $byCategoryExclude
    gender_In: $gender_In
    notes_Icontains: $notes_Icontains
    isActive: $isActive
    city: $city
    state: $state
    totalPurchasesCount_Lte: $totalPurchasesCount_Lte
    totalPurchasesCount_Gte: $totalPurchasesCount_Gte
    birthdatesByMonthAndDate: $birthdatesByMonthAndDate
    daysWithoutPurchaseMin: $daysWithoutPurchaseMin
    daysWithoutPurchaseMax: $daysWithoutPurchaseMax
    havePhone: $havePhone
    haveEmail: $haveEmail
    hasWhatsapp: $hasWhatsapp
    includedInCampaign: $includedInCampaign
    notIncludedInCampaign: $notIncludedInCampaign
    totalMonetaryValue_Gte: $totalMonetaryValue_Gte
    totalMonetaryValue_Lte: $totalMonetaryValue_Lte
  ) {
    edges {
      node {
        pk
      }
    }
  }
}
    `;

/**
 * __useListCustomerCampaignQuery__
 *
 * To run a query within a React component, call `useListCustomerCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomerCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomerCampaignQuery({
 *   variables: {
 *      customFields: // value for 'customFields'
 *      nameOrEmail: // value for 'nameOrEmail'
 *      taxDocument: // value for 'taxDocument'
 *      phone_Icontains: // value for 'phone_Icontains'
 *      rfmClassification_In: // value for 'rfmClassification_In'
 *      purchase_Date_Gte: // value for 'purchase_Date_Gte'
 *      purchase_Date_Lte: // value for 'purchase_Date_Lte'
 *      giftback_Status: // value for 'giftback_Status'
 *      giftback_Active: // value for 'giftback_Active'
 *      createdAt_Date_Gte: // value for 'createdAt_Date_Gte'
 *      createdAt_Date_Lte: // value for 'createdAt_Date_Lte'
 *      importedFrom_In: // value for 'importedFrom_In'
 *      importedFrom: // value for 'importedFrom'
 *      containsTag: // value for 'containsTag'
 *      doesNotContainTag: // value for 'doesNotContainTag'
 *      productsBought: // value for 'productsBought'
 *      productsNotBought: // value for 'productsNotBought'
 *      byCategory: // value for 'byCategory'
 *      byCategoryExclude: // value for 'byCategoryExclude'
 *      gender_In: // value for 'gender_In'
 *      notes_Icontains: // value for 'notes_Icontains'
 *      isActive: // value for 'isActive'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      totalPurchasesCount_Lte: // value for 'totalPurchasesCount_Lte'
 *      totalPurchasesCount_Gte: // value for 'totalPurchasesCount_Gte'
 *      birthdatesByMonthAndDate: // value for 'birthdatesByMonthAndDate'
 *      daysWithoutPurchaseMin: // value for 'daysWithoutPurchaseMin'
 *      daysWithoutPurchaseMax: // value for 'daysWithoutPurchaseMax'
 *      havePhone: // value for 'havePhone'
 *      haveEmail: // value for 'haveEmail'
 *      hasWhatsapp: // value for 'hasWhatsapp'
 *      includedInCampaign: // value for 'includedInCampaign'
 *      notIncludedInCampaign: // value for 'notIncludedInCampaign'
 *      totalMonetaryValue_Gte: // value for 'totalMonetaryValue_Gte'
 *      totalMonetaryValue_Lte: // value for 'totalMonetaryValue_Lte'
 *   },
 * });
 */
export function useListCustomerCampaignQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>(ListCustomerCampaignDocument, options);
      }
export function useListCustomerCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>(ListCustomerCampaignDocument, options);
        }
export function useListCustomerCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>(ListCustomerCampaignDocument, options);
        }
export type ListCustomerCampaignQueryHookResult = ReturnType<typeof useListCustomerCampaignQuery>;
export type ListCustomerCampaignLazyQueryHookResult = ReturnType<typeof useListCustomerCampaignLazyQuery>;
export type ListCustomerCampaignSuspenseQueryHookResult = ReturnType<typeof useListCustomerCampaignSuspenseQuery>;
export type ListCustomerCampaignQueryResult = Apollo.QueryResult<ListCustomerCampaignQuery, ListCustomerCampaignQueryVariables>;
export const ListCustomerDocument = gql`
    query ListCustomer($before: String, $after: String, $first: Int = 12, $last: Int, $customFields: String, $nameOrEmail: String, $taxDocument: String, $phone_Icontains: String, $rfmClassification_In: String, $purchase_Date_Gte: Date, $purchase_Date_Lte: Date, $giftback_Status: String, $giftback_Active: String, $createdAt_Date_Gte: Date, $createdAt_Date_Lte: Date, $importedFrom_In: String, $importedFrom: String, $containsTag: String, $doesNotContainTag: String, $productsBought: String, $productsNotBought: String, $byCategory: String, $byCategoryExclude: String, $gender_In: String, $notes_Icontains: String, $isActive: Boolean, $city: String, $state: String, $totalPurchasesCount_Lte: Int, $totalPurchasesCount_Gte: Int, $birthdatesByMonthAndDate: String, $daysWithoutPurchaseMin: Float, $daysWithoutPurchaseMax: Float, $havePhone: String, $haveEmail: String, $hasWhatsapp: String, $includedInCampaign: String, $notIncludedInCampaign: String, $totalMonetaryValue_Gte: Float, $totalMonetaryValue_Lte: Float, $address: String, $purchase_Coupon_Code: String, $acquisitionChannelId: Float, $acquisitionChannelUninformed: Boolean) {
  allCustomersRelay(
    before: $before
    after: $after
    first: $first
    last: $last
    customFields: $customFields
    nameOrEmail: $nameOrEmail
    taxDocument: $taxDocument
    phone_Icontains: $phone_Icontains
    rfmClassification_In: $rfmClassification_In
    purchase_Date_Gte: $purchase_Date_Gte
    purchase_Date_Lte: $purchase_Date_Lte
    giftback_Status: $giftback_Status
    giftback_Active: $giftback_Active
    createdAt_Date_Gte: $createdAt_Date_Gte
    createdAt_Date_Lte: $createdAt_Date_Lte
    importedFrom: $importedFrom
    importedFrom_In: $importedFrom_In
    containsTag: $containsTag
    doesNotContainTag: $doesNotContainTag
    productsBought: $productsBought
    productsNotBought: $productsNotBought
    byCategory: $byCategory
    byCategoryExclude: $byCategoryExclude
    gender_In: $gender_In
    notes_Icontains: $notes_Icontains
    isActive: $isActive
    city: $city
    state: $state
    totalPurchasesCount_Lte: $totalPurchasesCount_Lte
    totalPurchasesCount_Gte: $totalPurchasesCount_Gte
    birthdatesByMonthAndDate: $birthdatesByMonthAndDate
    daysWithoutPurchaseMin: $daysWithoutPurchaseMin
    daysWithoutPurchaseMax: $daysWithoutPurchaseMax
    havePhone: $havePhone
    haveEmail: $haveEmail
    hasWhatsapp: $hasWhatsapp
    includedInCampaign: $includedInCampaign
    notIncludedInCampaign: $notIncludedInCampaign
    totalMonetaryValue_Gte: $totalMonetaryValue_Gte
    totalMonetaryValue_Lte: $totalMonetaryValue_Lte
    address: $address
    purchase_Coupon_Code: $purchase_Coupon_Code
    acquisitionChannelId: $acquisitionChannelId
    acquisitionChannelUninformed: $acquisitionChannelUninformed
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        pk
        rfmClassification
        name
        email
        phone
        giftbackSet(first: 1) {
          edges {
            node {
              pk
              status
            }
          }
        }
        totalPurchasesCount
        averageTicket
        acquisitionChannel {
          pk
          name
        }
      }
    }
  }
}
    `;

/**
 * __useListCustomerQuery__
 *
 * To run a query within a React component, call `useListCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomerQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      customFields: // value for 'customFields'
 *      nameOrEmail: // value for 'nameOrEmail'
 *      taxDocument: // value for 'taxDocument'
 *      phone_Icontains: // value for 'phone_Icontains'
 *      rfmClassification_In: // value for 'rfmClassification_In'
 *      purchase_Date_Gte: // value for 'purchase_Date_Gte'
 *      purchase_Date_Lte: // value for 'purchase_Date_Lte'
 *      giftback_Status: // value for 'giftback_Status'
 *      giftback_Active: // value for 'giftback_Active'
 *      createdAt_Date_Gte: // value for 'createdAt_Date_Gte'
 *      createdAt_Date_Lte: // value for 'createdAt_Date_Lte'
 *      importedFrom_In: // value for 'importedFrom_In'
 *      importedFrom: // value for 'importedFrom'
 *      containsTag: // value for 'containsTag'
 *      doesNotContainTag: // value for 'doesNotContainTag'
 *      productsBought: // value for 'productsBought'
 *      productsNotBought: // value for 'productsNotBought'
 *      byCategory: // value for 'byCategory'
 *      byCategoryExclude: // value for 'byCategoryExclude'
 *      gender_In: // value for 'gender_In'
 *      notes_Icontains: // value for 'notes_Icontains'
 *      isActive: // value for 'isActive'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      totalPurchasesCount_Lte: // value for 'totalPurchasesCount_Lte'
 *      totalPurchasesCount_Gte: // value for 'totalPurchasesCount_Gte'
 *      birthdatesByMonthAndDate: // value for 'birthdatesByMonthAndDate'
 *      daysWithoutPurchaseMin: // value for 'daysWithoutPurchaseMin'
 *      daysWithoutPurchaseMax: // value for 'daysWithoutPurchaseMax'
 *      havePhone: // value for 'havePhone'
 *      haveEmail: // value for 'haveEmail'
 *      hasWhatsapp: // value for 'hasWhatsapp'
 *      includedInCampaign: // value for 'includedInCampaign'
 *      notIncludedInCampaign: // value for 'notIncludedInCampaign'
 *      totalMonetaryValue_Gte: // value for 'totalMonetaryValue_Gte'
 *      totalMonetaryValue_Lte: // value for 'totalMonetaryValue_Lte'
 *      address: // value for 'address'
 *      purchase_Coupon_Code: // value for 'purchase_Coupon_Code'
 *      acquisitionChannelId: // value for 'acquisitionChannelId'
 *      acquisitionChannelUninformed: // value for 'acquisitionChannelUninformed'
 *   },
 * });
 */
export function useListCustomerQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomerQuery, ListCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomerQuery, ListCustomerQueryVariables>(ListCustomerDocument, options);
      }
export function useListCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomerQuery, ListCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomerQuery, ListCustomerQueryVariables>(ListCustomerDocument, options);
        }
export function useListCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCustomerQuery, ListCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCustomerQuery, ListCustomerQueryVariables>(ListCustomerDocument, options);
        }
export type ListCustomerQueryHookResult = ReturnType<typeof useListCustomerQuery>;
export type ListCustomerLazyQueryHookResult = ReturnType<typeof useListCustomerLazyQuery>;
export type ListCustomerSuspenseQueryHookResult = ReturnType<typeof useListCustomerSuspenseQuery>;
export type ListCustomerQueryResult = Apollo.QueryResult<ListCustomerQuery, ListCustomerQueryVariables>;
export const GetAllProductsForCustomerFiltersDocument = gql`
    query GetAllProductsForCustomerFilters($name_Icontains: String) {
  allProductsRelay(name_Icontains: $name_Icontains) {
    edges {
      node {
        pk
        name
        value
        stock
      }
    }
  }
}
    `;

/**
 * __useGetAllProductsForCustomerFiltersQuery__
 *
 * To run a query within a React component, call `useGetAllProductsForCustomerFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsForCustomerFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsForCustomerFiltersQuery({
 *   variables: {
 *      name_Icontains: // value for 'name_Icontains'
 *   },
 * });
 */
export function useGetAllProductsForCustomerFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>(GetAllProductsForCustomerFiltersDocument, options);
      }
export function useGetAllProductsForCustomerFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>(GetAllProductsForCustomerFiltersDocument, options);
        }
export function useGetAllProductsForCustomerFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>(GetAllProductsForCustomerFiltersDocument, options);
        }
export type GetAllProductsForCustomerFiltersQueryHookResult = ReturnType<typeof useGetAllProductsForCustomerFiltersQuery>;
export type GetAllProductsForCustomerFiltersLazyQueryHookResult = ReturnType<typeof useGetAllProductsForCustomerFiltersLazyQuery>;
export type GetAllProductsForCustomerFiltersSuspenseQueryHookResult = ReturnType<typeof useGetAllProductsForCustomerFiltersSuspenseQuery>;
export type GetAllProductsForCustomerFiltersQueryResult = Apollo.QueryResult<GetAllProductsForCustomerFiltersQuery, GetAllProductsForCustomerFiltersQueryVariables>;
export const SalesAudienceCountDocument = gql`
    query SalesAudienceCount($abcCurveBought: String, $abcCurveNotBought: String, $abcCurveDate_Gte: Date, $abcCurveDate_Lte: Date, $abcCurveScope: String, $salesProductsBought: String, $salesProductsNotBought: String, $salesCategoriesBought: String, $salesCategoriesNotBought: String, $salesPurchaseDate_Gte: Date, $salesPurchaseDate_Lte: Date) {
  allCustomersRelay(
    first: 0
    abcCurveBought: $abcCurveBought
    abcCurveNotBought: $abcCurveNotBought
    abcCurveDate_Gte: $abcCurveDate_Gte
    abcCurveDate_Lte: $abcCurveDate_Lte
    abcCurveScope: $abcCurveScope
    salesProductsBought: $salesProductsBought
    salesProductsNotBought: $salesProductsNotBought
    salesCategoriesBought: $salesCategoriesBought
    salesCategoriesNotBought: $salesCategoriesNotBought
    salesPurchaseDate_Gte: $salesPurchaseDate_Gte
    salesPurchaseDate_Lte: $salesPurchaseDate_Lte
  ) {
    totalCount
  }
}
    `;

/**
 * __useSalesAudienceCountQuery__
 *
 * To run a query within a React component, call `useSalesAudienceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesAudienceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesAudienceCountQuery({
 *   variables: {
 *      abcCurveBought: // value for 'abcCurveBought'
 *      abcCurveNotBought: // value for 'abcCurveNotBought'
 *      abcCurveDate_Gte: // value for 'abcCurveDate_Gte'
 *      abcCurveDate_Lte: // value for 'abcCurveDate_Lte'
 *      abcCurveScope: // value for 'abcCurveScope'
 *      salesProductsBought: // value for 'salesProductsBought'
 *      salesProductsNotBought: // value for 'salesProductsNotBought'
 *      salesCategoriesBought: // value for 'salesCategoriesBought'
 *      salesCategoriesNotBought: // value for 'salesCategoriesNotBought'
 *      salesPurchaseDate_Gte: // value for 'salesPurchaseDate_Gte'
 *      salesPurchaseDate_Lte: // value for 'salesPurchaseDate_Lte'
 *   },
 * });
 */
export function useSalesAudienceCountQuery(baseOptions?: Apollo.QueryHookOptions<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>(SalesAudienceCountDocument, options);
      }
export function useSalesAudienceCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>(SalesAudienceCountDocument, options);
        }
export function useSalesAudienceCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>(SalesAudienceCountDocument, options);
        }
export type SalesAudienceCountQueryHookResult = ReturnType<typeof useSalesAudienceCountQuery>;
export type SalesAudienceCountLazyQueryHookResult = ReturnType<typeof useSalesAudienceCountLazyQuery>;
export type SalesAudienceCountSuspenseQueryHookResult = ReturnType<typeof useSalesAudienceCountSuspenseQuery>;
export type SalesAudienceCountQueryResult = Apollo.QueryResult<SalesAudienceCountQuery, SalesAudienceCountQueryVariables>;
export const SetActiveCustomerDocument = gql`
    mutation SetActiveCustomer($input: SetActiveCustomerInput!) {
  setActiveCustomer(input: $input) {
    ok
  }
}
    `;
export type SetActiveCustomerMutationFn = Apollo.MutationFunction<SetActiveCustomerMutation, SetActiveCustomerMutationVariables>;

/**
 * __useSetActiveCustomerMutation__
 *
 * To run a mutation, you first call `useSetActiveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveCustomerMutation, { data, loading, error }] = useSetActiveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetActiveCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveCustomerMutation, SetActiveCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveCustomerMutation, SetActiveCustomerMutationVariables>(SetActiveCustomerDocument, options);
      }
export type SetActiveCustomerMutationHookResult = ReturnType<typeof useSetActiveCustomerMutation>;
export type SetActiveCustomerMutationResult = Apollo.MutationResult<SetActiveCustomerMutation>;
export type SetActiveCustomerMutationOptions = Apollo.BaseMutationOptions<SetActiveCustomerMutation, SetActiveCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    customer {
      id
      name
      email
      phone
      taxDocument
      gender
      state
      city
      address
      dateOfBirth
      acquisitionChannel {
        pk
        name
        isActive
      }
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CreateCustomerNewTagsDocument = gql`
    mutation CreateCustomerNewTags($tagInput: CreateCustomerTagsInput!) {
  tagsCreate(tagInput: $tagInput) {
    ok
  }
}
    `;
export type CreateCustomerNewTagsMutationFn = Apollo.MutationFunction<CreateCustomerNewTagsMutation, CreateCustomerNewTagsMutationVariables>;

/**
 * __useCreateCustomerNewTagsMutation__
 *
 * To run a mutation, you first call `useCreateCustomerNewTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerNewTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerNewTagsMutation, { data, loading, error }] = useCreateCustomerNewTagsMutation({
 *   variables: {
 *      tagInput: // value for 'tagInput'
 *   },
 * });
 */
export function useCreateCustomerNewTagsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerNewTagsMutation, CreateCustomerNewTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerNewTagsMutation, CreateCustomerNewTagsMutationVariables>(CreateCustomerNewTagsDocument, options);
      }
export type CreateCustomerNewTagsMutationHookResult = ReturnType<typeof useCreateCustomerNewTagsMutation>;
export type CreateCustomerNewTagsMutationResult = Apollo.MutationResult<CreateCustomerNewTagsMutation>;
export type CreateCustomerNewTagsMutationOptions = Apollo.BaseMutationOptions<CreateCustomerNewTagsMutation, CreateCustomerNewTagsMutationVariables>;
export const GetAllCustomerTagsDocument = gql`
    query GetAllCustomerTags($name_Icontains: String) {
  customerTagsList(name_Icontains: $name_Icontains) {
    edges {
      node {
        name
        pk
      }
    }
  }
}
    `;

/**
 * __useGetAllCustomerTagsQuery__
 *
 * To run a query within a React component, call `useGetAllCustomerTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCustomerTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCustomerTagsQuery({
 *   variables: {
 *      name_Icontains: // value for 'name_Icontains'
 *   },
 * });
 */
export function useGetAllCustomerTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>(GetAllCustomerTagsDocument, options);
      }
export function useGetAllCustomerTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>(GetAllCustomerTagsDocument, options);
        }
export function useGetAllCustomerTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>(GetAllCustomerTagsDocument, options);
        }
export type GetAllCustomerTagsQueryHookResult = ReturnType<typeof useGetAllCustomerTagsQuery>;
export type GetAllCustomerTagsLazyQueryHookResult = ReturnType<typeof useGetAllCustomerTagsLazyQuery>;
export type GetAllCustomerTagsSuspenseQueryHookResult = ReturnType<typeof useGetAllCustomerTagsSuspenseQuery>;
export type GetAllCustomerTagsQueryResult = Apollo.QueryResult<GetAllCustomerTagsQuery, GetAllCustomerTagsQueryVariables>;
export const AddTagsToRetentionAudienceDocument = gql`
    mutation AddTagsToRetentionAudience($selectionId: ID!, $tagIds: [ID]!) {
  addTagsToAudienceSelection(input: {selectionId: $selectionId, tagIds: $tagIds}) {
    updatedCount
  }
}
    `;
export type AddTagsToRetentionAudienceMutationFn = Apollo.MutationFunction<AddTagsToRetentionAudienceMutation, AddTagsToRetentionAudienceMutationVariables>;

/**
 * __useAddTagsToRetentionAudienceMutation__
 *
 * To run a mutation, you first call `useAddTagsToRetentionAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToRetentionAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToRetentionAudienceMutation, { data, loading, error }] = useAddTagsToRetentionAudienceMutation({
 *   variables: {
 *      selectionId: // value for 'selectionId'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useAddTagsToRetentionAudienceMutation(baseOptions?: Apollo.MutationHookOptions<AddTagsToRetentionAudienceMutation, AddTagsToRetentionAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagsToRetentionAudienceMutation, AddTagsToRetentionAudienceMutationVariables>(AddTagsToRetentionAudienceDocument, options);
      }
export type AddTagsToRetentionAudienceMutationHookResult = ReturnType<typeof useAddTagsToRetentionAudienceMutation>;
export type AddTagsToRetentionAudienceMutationResult = Apollo.MutationResult<AddTagsToRetentionAudienceMutation>;
export type AddTagsToRetentionAudienceMutationOptions = Apollo.BaseMutationOptions<AddTagsToRetentionAudienceMutation, AddTagsToRetentionAudienceMutationVariables>;
export const CreateRetentionAudienceSelectionDocument = gql`
    mutation CreateRetentionAudienceSelection($input: RetentionCohortInput!, $cohortStart: Date!, $offset: Int!, $first: Int!) {
  createRetentionAudienceSelection(
    input: $input
    cohortStart: $cohortStart
    offset: $offset
    first: $first
  ) {
    selectionId
    total
    totalRevenue
    expiresAt
    customers {
      id
      name
      phone
      rfmClassification
      purchaseCount
      purchaseValue
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    `;
export type CreateRetentionAudienceSelectionMutationFn = Apollo.MutationFunction<CreateRetentionAudienceSelectionMutation, CreateRetentionAudienceSelectionMutationVariables>;

/**
 * __useCreateRetentionAudienceSelectionMutation__
 *
 * To run a mutation, you first call `useCreateRetentionAudienceSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRetentionAudienceSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRetentionAudienceSelectionMutation, { data, loading, error }] = useCreateRetentionAudienceSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      cohortStart: // value for 'cohortStart'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCreateRetentionAudienceSelectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRetentionAudienceSelectionMutation, CreateRetentionAudienceSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRetentionAudienceSelectionMutation, CreateRetentionAudienceSelectionMutationVariables>(CreateRetentionAudienceSelectionDocument, options);
      }
export type CreateRetentionAudienceSelectionMutationHookResult = ReturnType<typeof useCreateRetentionAudienceSelectionMutation>;
export type CreateRetentionAudienceSelectionMutationResult = Apollo.MutationResult<CreateRetentionAudienceSelectionMutation>;
export type CreateRetentionAudienceSelectionMutationOptions = Apollo.BaseMutationOptions<CreateRetentionAudienceSelectionMutation, CreateRetentionAudienceSelectionMutationVariables>;
export const DashboardAgeRangeQueriesDocument = gql`
    query DashboardAgeRangeQueries($input: CustomerFilterSetInput) {
  dashboardAgeColumnChartValues(input: $input) {
    categories
    series {
      name
      data
    }
  }
}
    `;

/**
 * __useDashboardAgeRangeQueriesQuery__
 *
 * To run a query within a React component, call `useDashboardAgeRangeQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAgeRangeQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAgeRangeQueriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardAgeRangeQueriesQuery(baseOptions?: Apollo.QueryHookOptions<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>(DashboardAgeRangeQueriesDocument, options);
      }
export function useDashboardAgeRangeQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>(DashboardAgeRangeQueriesDocument, options);
        }
export function useDashboardAgeRangeQueriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>(DashboardAgeRangeQueriesDocument, options);
        }
export type DashboardAgeRangeQueriesQueryHookResult = ReturnType<typeof useDashboardAgeRangeQueriesQuery>;
export type DashboardAgeRangeQueriesLazyQueryHookResult = ReturnType<typeof useDashboardAgeRangeQueriesLazyQuery>;
export type DashboardAgeRangeQueriesSuspenseQueryHookResult = ReturnType<typeof useDashboardAgeRangeQueriesSuspenseQuery>;
export type DashboardAgeRangeQueriesQueryResult = Apollo.QueryResult<DashboardAgeRangeQueriesQuery, DashboardAgeRangeQueriesQueryVariables>;
export const DashboardCustomerGenderDataDocument = gql`
    query DashboardCustomerGenderData($input: CustomerFilterSetInput) {
  dashboardGenderPieChartValues(input: $input) {
    total
    labels
    series
  }
}
    `;

/**
 * __useDashboardCustomerGenderDataQuery__
 *
 * To run a query within a React component, call `useDashboardCustomerGenderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCustomerGenderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCustomerGenderDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCustomerGenderDataQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>(DashboardCustomerGenderDataDocument, options);
      }
export function useDashboardCustomerGenderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>(DashboardCustomerGenderDataDocument, options);
        }
export function useDashboardCustomerGenderDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>(DashboardCustomerGenderDataDocument, options);
        }
export type DashboardCustomerGenderDataQueryHookResult = ReturnType<typeof useDashboardCustomerGenderDataQuery>;
export type DashboardCustomerGenderDataLazyQueryHookResult = ReturnType<typeof useDashboardCustomerGenderDataLazyQuery>;
export type DashboardCustomerGenderDataSuspenseQueryHookResult = ReturnType<typeof useDashboardCustomerGenderDataSuspenseQuery>;
export type DashboardCustomerGenderDataQueryResult = Apollo.QueryResult<DashboardCustomerGenderDataQuery, DashboardCustomerGenderDataQueryVariables>;
export const DashboardCustomerQueriesDocument = gql`
    query DashboardCustomerQueries($input: CustomerFilterSetInput) {
  cardsData: dashboardCustomerCardsValues(input: $input) {
    totalCustomers
    averageValuePerCustomer
    averagePurchaseCountPerCustomer
  }
  homepageCardsValues(input: $input) {
    totalUniqueCustomers
    totalRecurrentCustomers
  }
}
    `;

/**
 * __useDashboardCustomerQueriesQuery__
 *
 * To run a query within a React component, call `useDashboardCustomerQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCustomerQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCustomerQueriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCustomerQueriesQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>(DashboardCustomerQueriesDocument, options);
      }
export function useDashboardCustomerQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>(DashboardCustomerQueriesDocument, options);
        }
export function useDashboardCustomerQueriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>(DashboardCustomerQueriesDocument, options);
        }
export type DashboardCustomerQueriesQueryHookResult = ReturnType<typeof useDashboardCustomerQueriesQuery>;
export type DashboardCustomerQueriesLazyQueryHookResult = ReturnType<typeof useDashboardCustomerQueriesLazyQuery>;
export type DashboardCustomerQueriesSuspenseQueryHookResult = ReturnType<typeof useDashboardCustomerQueriesSuspenseQuery>;
export type DashboardCustomerQueriesQueryResult = Apollo.QueryResult<DashboardCustomerQueriesQuery, DashboardCustomerQueriesQueryVariables>;
export const DashboardCustomerTagsDocument = gql`
    query DashboardCustomerTags($input: CustomerFilterSetInput) {
  dashboardCustomerTagsValues(input: $input) {
    series
    labels
  }
}
    `;

/**
 * __useDashboardCustomerTagsQuery__
 *
 * To run a query within a React component, call `useDashboardCustomerTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCustomerTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCustomerTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCustomerTagsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>(DashboardCustomerTagsDocument, options);
      }
export function useDashboardCustomerTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>(DashboardCustomerTagsDocument, options);
        }
export function useDashboardCustomerTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>(DashboardCustomerTagsDocument, options);
        }
export type DashboardCustomerTagsQueryHookResult = ReturnType<typeof useDashboardCustomerTagsQuery>;
export type DashboardCustomerTagsLazyQueryHookResult = ReturnType<typeof useDashboardCustomerTagsLazyQuery>;
export type DashboardCustomerTagsSuspenseQueryHookResult = ReturnType<typeof useDashboardCustomerTagsSuspenseQuery>;
export type DashboardCustomerTagsQueryResult = Apollo.QueryResult<DashboardCustomerTagsQuery, DashboardCustomerTagsQueryVariables>;
export const DashboardCustomersByCityChartsDocument = gql`
    query DashboardCustomersByCityCharts($input: CustomerFilterSetInput) {
  dashboardCustomersByCity(input: $input) {
    total
    categories
    series
  }
}
    `;

/**
 * __useDashboardCustomersByCityChartsQuery__
 *
 * To run a query within a React component, call `useDashboardCustomersByCityChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCustomersByCityChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCustomersByCityChartsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCustomersByCityChartsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>(DashboardCustomersByCityChartsDocument, options);
      }
export function useDashboardCustomersByCityChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>(DashboardCustomersByCityChartsDocument, options);
        }
export function useDashboardCustomersByCityChartsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>(DashboardCustomersByCityChartsDocument, options);
        }
export type DashboardCustomersByCityChartsQueryHookResult = ReturnType<typeof useDashboardCustomersByCityChartsQuery>;
export type DashboardCustomersByCityChartsLazyQueryHookResult = ReturnType<typeof useDashboardCustomersByCityChartsLazyQuery>;
export type DashboardCustomersByCityChartsSuspenseQueryHookResult = ReturnType<typeof useDashboardCustomersByCityChartsSuspenseQuery>;
export type DashboardCustomersByCityChartsQueryResult = Apollo.QueryResult<DashboardCustomersByCityChartsQuery, DashboardCustomersByCityChartsQueryVariables>;
export const DashboardCustomersByUfChartsDocument = gql`
    query DashboardCustomersByUFCharts($input: CustomerFilterSetInput) {
  dashboardUfBarChartValues(input: $input) {
    total
    categories
    series
  }
}
    `;

/**
 * __useDashboardCustomersByUfChartsQuery__
 *
 * To run a query within a React component, call `useDashboardCustomersByUfChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCustomersByUfChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCustomersByUfChartsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardCustomersByUfChartsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>(DashboardCustomersByUfChartsDocument, options);
      }
export function useDashboardCustomersByUfChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>(DashboardCustomersByUfChartsDocument, options);
        }
export function useDashboardCustomersByUfChartsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>(DashboardCustomersByUfChartsDocument, options);
        }
export type DashboardCustomersByUfChartsQueryHookResult = ReturnType<typeof useDashboardCustomersByUfChartsQuery>;
export type DashboardCustomersByUfChartsLazyQueryHookResult = ReturnType<typeof useDashboardCustomersByUfChartsLazyQuery>;
export type DashboardCustomersByUfChartsSuspenseQueryHookResult = ReturnType<typeof useDashboardCustomersByUfChartsSuspenseQuery>;
export type DashboardCustomersByUfChartsQueryResult = Apollo.QueryResult<DashboardCustomersByUfChartsQuery, DashboardCustomersByUfChartsQueryVariables>;
export const DashboardGiftbackQueriesDocument = gql`
    query DashboardGiftbackQueries($input: GiftbackFilterSetInput) {
  cardsData: dashboardGiftbackCardsValues(input: $input) {
    activeGiftbacks
    redeemedGiftbacks
    expiredGiftbacks
    giftbackGains
    cancelledGiftbacks
    overdueGiftbacks
  }
  averageTicketData: dashboardGiftbackAverageTicket(input: $input) {
    activeGiftbackAverageTicket
    redeemedGiftbackAverageTicket
    expiredGiftbackAverageTicket
    cancelledGiftbackAverageTicket
    overdueGiftbackAverageTicket
  }
  radialChartData: dashboardGiftbacksRadialBarChartValues(input: $input) {
    series
    labels
    total
  }
  areaChartData: dashboardGiftbackAreaChartValues(input: $input) {
    kindOfDate
    series {
      name
      data {
        value
        date
      }
    }
    categories
  }
}
    `;

/**
 * __useDashboardGiftbackQueriesQuery__
 *
 * To run a query within a React component, call `useDashboardGiftbackQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGiftbackQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGiftbackQueriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardGiftbackQueriesQuery(baseOptions?: Apollo.QueryHookOptions<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>(DashboardGiftbackQueriesDocument, options);
      }
export function useDashboardGiftbackQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>(DashboardGiftbackQueriesDocument, options);
        }
export function useDashboardGiftbackQueriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>(DashboardGiftbackQueriesDocument, options);
        }
export type DashboardGiftbackQueriesQueryHookResult = ReturnType<typeof useDashboardGiftbackQueriesQuery>;
export type DashboardGiftbackQueriesLazyQueryHookResult = ReturnType<typeof useDashboardGiftbackQueriesLazyQuery>;
export type DashboardGiftbackQueriesSuspenseQueryHookResult = ReturnType<typeof useDashboardGiftbackQueriesSuspenseQuery>;
export type DashboardGiftbackQueriesQueryResult = Apollo.QueryResult<DashboardGiftbackQueriesQuery, DashboardGiftbackQueriesQueryVariables>;
export const DashboardGiftbackResumeDocument = gql`
    query DashboardGiftbackResume($input: GiftbackFilterSetInput) {
  dashboardGiftbacksRadialBarChartValues(input: $input) {
    series
    labels
    total
  }
}
    `;

/**
 * __useDashboardGiftbackResumeQuery__
 *
 * To run a query within a React component, call `useDashboardGiftbackResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGiftbackResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGiftbackResumeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardGiftbackResumeQuery(baseOptions?: Apollo.QueryHookOptions<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>(DashboardGiftbackResumeDocument, options);
      }
export function useDashboardGiftbackResumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>(DashboardGiftbackResumeDocument, options);
        }
export function useDashboardGiftbackResumeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>(DashboardGiftbackResumeDocument, options);
        }
export type DashboardGiftbackResumeQueryHookResult = ReturnType<typeof useDashboardGiftbackResumeQuery>;
export type DashboardGiftbackResumeLazyQueryHookResult = ReturnType<typeof useDashboardGiftbackResumeLazyQuery>;
export type DashboardGiftbackResumeSuspenseQueryHookResult = ReturnType<typeof useDashboardGiftbackResumeSuspenseQuery>;
export type DashboardGiftbackResumeQueryResult = Apollo.QueryResult<DashboardGiftbackResumeQuery, DashboardGiftbackResumeQueryVariables>;
export const DashboardSalesAbcOverviewDocument = gql`
    query DashboardSalesAbcOverview($input: PurchaseProductFilterSetInput) {
  abcData: dashboardProductsListValues(input: $input, page: 1, pageSize: 1) {
    total
    totalProducts
    aThreshold
    bThreshold
    summary {
      title
      count
      totalValue
      percentage
    }
  }
}
    `;

/**
 * __useDashboardSalesAbcOverviewQuery__
 *
 * To run a query within a React component, call `useDashboardSalesAbcOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSalesAbcOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSalesAbcOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardSalesAbcOverviewQuery(baseOptions?: Apollo.QueryHookOptions<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>(DashboardSalesAbcOverviewDocument, options);
      }
export function useDashboardSalesAbcOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>(DashboardSalesAbcOverviewDocument, options);
        }
export function useDashboardSalesAbcOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>(DashboardSalesAbcOverviewDocument, options);
        }
export type DashboardSalesAbcOverviewQueryHookResult = ReturnType<typeof useDashboardSalesAbcOverviewQuery>;
export type DashboardSalesAbcOverviewLazyQueryHookResult = ReturnType<typeof useDashboardSalesAbcOverviewLazyQuery>;
export type DashboardSalesAbcOverviewSuspenseQueryHookResult = ReturnType<typeof useDashboardSalesAbcOverviewSuspenseQuery>;
export type DashboardSalesAbcOverviewQueryResult = Apollo.QueryResult<DashboardSalesAbcOverviewQuery, DashboardSalesAbcOverviewQueryVariables>;
export const DashboardSalesAbcProductsDocument = gql`
    query DashboardSalesAbcProducts($input: PurchaseProductFilterSetInput, $classification: String, $search: String, $page: Int, $pageSize: Int) {
  abcData: dashboardProductsListValues(
    input: $input
    classification: $classification
    search: $search
    page: $page
    pageSize: $pageSize
  ) {
    filteredProductsCount
    page
    pageSize
    productsList {
      productName
      productTotalValue
      productIndividualPercentage
      productAccumulatedPercentage
      productAbcClassification
      productPk
      productRank
    }
  }
}
    `;

/**
 * __useDashboardSalesAbcProductsQuery__
 *
 * To run a query within a React component, call `useDashboardSalesAbcProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSalesAbcProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSalesAbcProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      classification: // value for 'classification'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useDashboardSalesAbcProductsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>(DashboardSalesAbcProductsDocument, options);
      }
export function useDashboardSalesAbcProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>(DashboardSalesAbcProductsDocument, options);
        }
export function useDashboardSalesAbcProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>(DashboardSalesAbcProductsDocument, options);
        }
export type DashboardSalesAbcProductsQueryHookResult = ReturnType<typeof useDashboardSalesAbcProductsQuery>;
export type DashboardSalesAbcProductsLazyQueryHookResult = ReturnType<typeof useDashboardSalesAbcProductsLazyQuery>;
export type DashboardSalesAbcProductsSuspenseQueryHookResult = ReturnType<typeof useDashboardSalesAbcProductsSuspenseQuery>;
export type DashboardSalesAbcProductsQueryResult = Apollo.QueryResult<DashboardSalesAbcProductsQuery, DashboardSalesAbcProductsQueryVariables>;
export const DashboardSalesProductKpisDocument = gql`
    query DashboardSalesProductKpis($input: PurchaseProductFilterSetInput, $metric: SalesProductKpiMetric) {
  productKpis: dashboardSalesProductKpis(input: $input, metric: $metric) {
    topProducts {
      id
      name
      quantity
      ordersCount
      totalRevenue
      unit
    }
    firstPurchaseProducts {
      id
      name
      quantity
      ordersCount
      totalRevenue
      unit
    }
    secondPurchaseProducts {
      id
      name
      quantity
      ordersCount
      totalRevenue
      unit
    }
    topCategories {
      id
      name
      quantity
      ordersCount
      totalRevenue
      unit
    }
    firstPurchaseCategories {
      id
      name
      quantity
      ordersCount
      totalRevenue
      unit
    }
    secondPurchaseCategories {
      id
      name
      quantity
      ordersCount
      totalRevenue
      unit
    }
  }
}
    `;

/**
 * __useDashboardSalesProductKpisQuery__
 *
 * To run a query within a React component, call `useDashboardSalesProductKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSalesProductKpisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSalesProductKpisQuery({
 *   variables: {
 *      input: // value for 'input'
 *      metric: // value for 'metric'
 *   },
 * });
 */
export function useDashboardSalesProductKpisQuery(baseOptions?: Apollo.QueryHookOptions<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>(DashboardSalesProductKpisDocument, options);
      }
export function useDashboardSalesProductKpisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>(DashboardSalesProductKpisDocument, options);
        }
export function useDashboardSalesProductKpisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>(DashboardSalesProductKpisDocument, options);
        }
export type DashboardSalesProductKpisQueryHookResult = ReturnType<typeof useDashboardSalesProductKpisQuery>;
export type DashboardSalesProductKpisLazyQueryHookResult = ReturnType<typeof useDashboardSalesProductKpisLazyQuery>;
export type DashboardSalesProductKpisSuspenseQueryHookResult = ReturnType<typeof useDashboardSalesProductKpisSuspenseQuery>;
export type DashboardSalesProductKpisQueryResult = Apollo.QueryResult<DashboardSalesProductKpisQuery, DashboardSalesProductKpisQueryVariables>;
export const DashboardSalesProductTrendsDocument = gql`
    query DashboardSalesProductTrends($productId: ID!, $mode: SalesProductTrendMode, $periodStart: Date, $periodEnd: Date, $limit: Int) {
  productTrends: dashboardSalesProductTrends(
    productId: $productId
    mode: $mode
    periodStart: $periodStart
    periodEnd: $periodEnd
    limit: $limit
  ) {
    baseOrdersCount
    analyzedOrdersCount
    items {
      productId
      name
      integrationId
      ordersCount
      ordersPercentage
      totalRevenue
      lastPurchaseDate
    }
  }
}
    `;

/**
 * __useDashboardSalesProductTrendsQuery__
 *
 * To run a query within a React component, call `useDashboardSalesProductTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSalesProductTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSalesProductTrendsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      mode: // value for 'mode'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDashboardSalesProductTrendsQuery(baseOptions: Apollo.QueryHookOptions<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>(DashboardSalesProductTrendsDocument, options);
      }
export function useDashboardSalesProductTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>(DashboardSalesProductTrendsDocument, options);
        }
export function useDashboardSalesProductTrendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>(DashboardSalesProductTrendsDocument, options);
        }
export type DashboardSalesProductTrendsQueryHookResult = ReturnType<typeof useDashboardSalesProductTrendsQuery>;
export type DashboardSalesProductTrendsLazyQueryHookResult = ReturnType<typeof useDashboardSalesProductTrendsLazyQuery>;
export type DashboardSalesProductTrendsSuspenseQueryHookResult = ReturnType<typeof useDashboardSalesProductTrendsSuspenseQuery>;
export type DashboardSalesProductTrendsQueryResult = Apollo.QueryResult<DashboardSalesProductTrendsQuery, DashboardSalesProductTrendsQueryVariables>;
export const DashboardSalesQueriesDocument = gql`
    query DashboardSalesQueries($input: PurchaseFilterSetInput) {
  cardsData: dashboardSalesCardsValues(input: $input) {
    purchasesCount
    totalValue
    purchaseAverageTicket
  }
  periodData: dashboardSalesPeriodColumnChartValues(input: $input) {
    kindOfDate
    series {
      name
      type
      data
    }
    labels
  }
}
    `;

/**
 * __useDashboardSalesQueriesQuery__
 *
 * To run a query within a React component, call `useDashboardSalesQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSalesQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSalesQueriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardSalesQueriesQuery(baseOptions?: Apollo.QueryHookOptions<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>(DashboardSalesQueriesDocument, options);
      }
export function useDashboardSalesQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>(DashboardSalesQueriesDocument, options);
        }
export function useDashboardSalesQueriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>(DashboardSalesQueriesDocument, options);
        }
export type DashboardSalesQueriesQueryHookResult = ReturnType<typeof useDashboardSalesQueriesQuery>;
export type DashboardSalesQueriesLazyQueryHookResult = ReturnType<typeof useDashboardSalesQueriesLazyQuery>;
export type DashboardSalesQueriesSuspenseQueryHookResult = ReturnType<typeof useDashboardSalesQueriesSuspenseQuery>;
export type DashboardSalesQueriesQueryResult = Apollo.QueryResult<DashboardSalesQueriesQuery, DashboardSalesQueriesQueryVariables>;
export const PurchaseProgressionValuesDocument = gql`
    query PurchaseProgressionValues($input: PurchaseProgressionInput!) {
  dashboardPurchaseProgressionValues(input: $input) {
    rows {
      purchaseNumber
      customerCount
      averageTicket
      medianDaysToNextPurchase
      nextPurchaseCount
      pendingNextPurchaseCount
    }
  }
}
    `;

/**
 * __usePurchaseProgressionValuesQuery__
 *
 * To run a query within a React component, call `usePurchaseProgressionValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseProgressionValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseProgressionValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseProgressionValuesQuery(baseOptions: Apollo.QueryHookOptions<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>(PurchaseProgressionValuesDocument, options);
      }
export function usePurchaseProgressionValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>(PurchaseProgressionValuesDocument, options);
        }
export function usePurchaseProgressionValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>(PurchaseProgressionValuesDocument, options);
        }
export type PurchaseProgressionValuesQueryHookResult = ReturnType<typeof usePurchaseProgressionValuesQuery>;
export type PurchaseProgressionValuesLazyQueryHookResult = ReturnType<typeof usePurchaseProgressionValuesLazyQuery>;
export type PurchaseProgressionValuesSuspenseQueryHookResult = ReturnType<typeof usePurchaseProgressionValuesSuspenseQuery>;
export type PurchaseProgressionValuesQueryResult = Apollo.QueryResult<PurchaseProgressionValuesQuery, PurchaseProgressionValuesQueryVariables>;
export const CreatePurchaseProgressionAudienceSelectionDocument = gql`
    mutation CreatePurchaseProgressionAudienceSelection($input: PurchaseProgressionInput!, $purchaseNumber: Int!, $pendingOnly: Boolean!, $first: Int!) {
  createPurchaseProgressionAudienceSelection(
    input: $input
    purchaseNumber: $purchaseNumber
    pendingOnly: $pendingOnly
    first: $first
  ) {
    selectionId
    total
    totalRevenue
    expiresAt
    customers {
      id
      name
      phone
      rfmClassification
      purchaseCount
      purchaseValue
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    `;
export type CreatePurchaseProgressionAudienceSelectionMutationFn = Apollo.MutationFunction<CreatePurchaseProgressionAudienceSelectionMutation, CreatePurchaseProgressionAudienceSelectionMutationVariables>;

/**
 * __useCreatePurchaseProgressionAudienceSelectionMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseProgressionAudienceSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseProgressionAudienceSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseProgressionAudienceSelectionMutation, { data, loading, error }] = useCreatePurchaseProgressionAudienceSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      purchaseNumber: // value for 'purchaseNumber'
 *      pendingOnly: // value for 'pendingOnly'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCreatePurchaseProgressionAudienceSelectionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseProgressionAudienceSelectionMutation, CreatePurchaseProgressionAudienceSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseProgressionAudienceSelectionMutation, CreatePurchaseProgressionAudienceSelectionMutationVariables>(CreatePurchaseProgressionAudienceSelectionDocument, options);
      }
export type CreatePurchaseProgressionAudienceSelectionMutationHookResult = ReturnType<typeof useCreatePurchaseProgressionAudienceSelectionMutation>;
export type CreatePurchaseProgressionAudienceSelectionMutationResult = Apollo.MutationResult<CreatePurchaseProgressionAudienceSelectionMutation>;
export type CreatePurchaseProgressionAudienceSelectionMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseProgressionAudienceSelectionMutation, CreatePurchaseProgressionAudienceSelectionMutationVariables>;
export const RetentionAudienceCustomersDocument = gql`
    query RetentionAudienceCustomers($selectionId: ID!, $first: Int!, $after: String) {
  dashboardRetentionAudienceCustomers(
    selectionId: $selectionId
    first: $first
    after: $after
  ) {
    selectionId
    total
    expiresAt
    customers {
      id
      name
      email
      phone
      rfmClassification
      purchaseCount
      purchaseValue
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    `;

/**
 * __useRetentionAudienceCustomersQuery__
 *
 * To run a query within a React component, call `useRetentionAudienceCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetentionAudienceCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetentionAudienceCustomersQuery({
 *   variables: {
 *      selectionId: // value for 'selectionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRetentionAudienceCustomersQuery(baseOptions: Apollo.QueryHookOptions<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>(RetentionAudienceCustomersDocument, options);
      }
export function useRetentionAudienceCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>(RetentionAudienceCustomersDocument, options);
        }
export function useRetentionAudienceCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>(RetentionAudienceCustomersDocument, options);
        }
export type RetentionAudienceCustomersQueryHookResult = ReturnType<typeof useRetentionAudienceCustomersQuery>;
export type RetentionAudienceCustomersLazyQueryHookResult = ReturnType<typeof useRetentionAudienceCustomersLazyQuery>;
export type RetentionAudienceCustomersSuspenseQueryHookResult = ReturnType<typeof useRetentionAudienceCustomersSuspenseQuery>;
export type RetentionAudienceCustomersQueryResult = Apollo.QueryResult<RetentionAudienceCustomersQuery, RetentionAudienceCustomersQueryVariables>;
export const RetentionCohortValuesDocument = gql`
    query RetentionCohortValues($input: RetentionCohortInput!) {
  dashboardRetentionCohortValues(input: $input) {
    summary {
      averageReturnRate
      averageTimeToReturn
      retainedRevenue
      recurrentCustomers
      nonReturningCustomers
    }
    rows {
      cohortStart
      totalCustomers
      totalRevenue
      periods {
        offset
        customers
        revenue
      }
    }
  }
}
    `;

/**
 * __useRetentionCohortValuesQuery__
 *
 * To run a query within a React component, call `useRetentionCohortValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetentionCohortValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetentionCohortValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetentionCohortValuesQuery(baseOptions: Apollo.QueryHookOptions<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>(RetentionCohortValuesDocument, options);
      }
export function useRetentionCohortValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>(RetentionCohortValuesDocument, options);
        }
export function useRetentionCohortValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>(RetentionCohortValuesDocument, options);
        }
export type RetentionCohortValuesQueryHookResult = ReturnType<typeof useRetentionCohortValuesQuery>;
export type RetentionCohortValuesLazyQueryHookResult = ReturnType<typeof useRetentionCohortValuesLazyQuery>;
export type RetentionCohortValuesSuspenseQueryHookResult = ReturnType<typeof useRetentionCohortValuesSuspenseQuery>;
export type RetentionCohortValuesQueryResult = Apollo.QueryResult<RetentionCohortValuesQuery, RetentionCohortValuesQueryVariables>;
export const RetentionCohortCustomersDocument = gql`
    query RetentionCohortCustomers($input: RetentionCohortInput!, $cohortStart: Date!, $offset: Int!, $first: Int!, $after: String) {
  dashboardRetentionCohortCustomers(
    input: $input
    cohortStart: $cohortStart
    offset: $offset
    first: $first
    after: $after
  ) {
    total
    totalRevenue
    customers {
      id
      name
      phone
      rfmClassification
      purchaseCount
      purchaseValue
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    `;

/**
 * __useRetentionCohortCustomersQuery__
 *
 * To run a query within a React component, call `useRetentionCohortCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetentionCohortCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetentionCohortCustomersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      cohortStart: // value for 'cohortStart'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRetentionCohortCustomersQuery(baseOptions: Apollo.QueryHookOptions<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>(RetentionCohortCustomersDocument, options);
      }
export function useRetentionCohortCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>(RetentionCohortCustomersDocument, options);
        }
export function useRetentionCohortCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>(RetentionCohortCustomersDocument, options);
        }
export type RetentionCohortCustomersQueryHookResult = ReturnType<typeof useRetentionCohortCustomersQuery>;
export type RetentionCohortCustomersLazyQueryHookResult = ReturnType<typeof useRetentionCohortCustomersLazyQuery>;
export type RetentionCohortCustomersSuspenseQueryHookResult = ReturnType<typeof useRetentionCohortCustomersSuspenseQuery>;
export type RetentionCohortCustomersQueryResult = Apollo.QueryResult<RetentionCohortCustomersQuery, RetentionCohortCustomersQueryVariables>;
export const CalculateGiftbackValueDocument = gql`
    query CalculateGiftbackValue($purchaseValue: Decimal!) {
  calculateGiftbackValue(purchaseValue: $purchaseValue) {
    purchaseValue
    giftbackValue
    minValueToRedeem
    dueDate
  }
}
    `;

/**
 * __useCalculateGiftbackValueQuery__
 *
 * To run a query within a React component, call `useCalculateGiftbackValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateGiftbackValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateGiftbackValueQuery({
 *   variables: {
 *      purchaseValue: // value for 'purchaseValue'
 *   },
 * });
 */
export function useCalculateGiftbackValueQuery(baseOptions: Apollo.QueryHookOptions<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>(CalculateGiftbackValueDocument, options);
      }
export function useCalculateGiftbackValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>(CalculateGiftbackValueDocument, options);
        }
export function useCalculateGiftbackValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>(CalculateGiftbackValueDocument, options);
        }
export type CalculateGiftbackValueQueryHookResult = ReturnType<typeof useCalculateGiftbackValueQuery>;
export type CalculateGiftbackValueLazyQueryHookResult = ReturnType<typeof useCalculateGiftbackValueLazyQuery>;
export type CalculateGiftbackValueSuspenseQueryHookResult = ReturnType<typeof useCalculateGiftbackValueSuspenseQuery>;
export type CalculateGiftbackValueQueryResult = Apollo.QueryResult<CalculateGiftbackValueQuery, CalculateGiftbackValueQueryVariables>;
export const CancelGiftbackDocument = gql`
    mutation CancelGiftback($giftbackInput: UpdateCancelGiftbackInput!) {
  giftbackCancel(giftbackInput: $giftbackInput) {
    ok
  }
}
    `;
export type CancelGiftbackMutationFn = Apollo.MutationFunction<CancelGiftbackMutation, CancelGiftbackMutationVariables>;

/**
 * __useCancelGiftbackMutation__
 *
 * To run a mutation, you first call `useCancelGiftbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelGiftbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelGiftbackMutation, { data, loading, error }] = useCancelGiftbackMutation({
 *   variables: {
 *      giftbackInput: // value for 'giftbackInput'
 *   },
 * });
 */
export function useCancelGiftbackMutation(baseOptions?: Apollo.MutationHookOptions<CancelGiftbackMutation, CancelGiftbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelGiftbackMutation, CancelGiftbackMutationVariables>(CancelGiftbackDocument, options);
      }
export type CancelGiftbackMutationHookResult = ReturnType<typeof useCancelGiftbackMutation>;
export type CancelGiftbackMutationResult = Apollo.MutationResult<CancelGiftbackMutation>;
export type CancelGiftbackMutationOptions = Apollo.BaseMutationOptions<CancelGiftbackMutation, CancelGiftbackMutationVariables>;
export const CreateGiftbackManualDocument = gql`
    mutation CreateGiftbackManual($giftbackInput: CreateGiftbackInput!) {
  giftbackCreate(giftbackInput: $giftbackInput) {
    ok
    giftback {
      pk
    }
  }
}
    `;
export type CreateGiftbackManualMutationFn = Apollo.MutationFunction<CreateGiftbackManualMutation, CreateGiftbackManualMutationVariables>;

/**
 * __useCreateGiftbackManualMutation__
 *
 * To run a mutation, you first call `useCreateGiftbackManualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftbackManualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftbackManualMutation, { data, loading, error }] = useCreateGiftbackManualMutation({
 *   variables: {
 *      giftbackInput: // value for 'giftbackInput'
 *   },
 * });
 */
export function useCreateGiftbackManualMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftbackManualMutation, CreateGiftbackManualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftbackManualMutation, CreateGiftbackManualMutationVariables>(CreateGiftbackManualDocument, options);
      }
export type CreateGiftbackManualMutationHookResult = ReturnType<typeof useCreateGiftbackManualMutation>;
export type CreateGiftbackManualMutationResult = Apollo.MutationResult<CreateGiftbackManualMutation>;
export type CreateGiftbackManualMutationOptions = Apollo.BaseMutationOptions<CreateGiftbackManualMutation, CreateGiftbackManualMutationVariables>;
export const GiftbackExcelReportDocument = gql`
    query GiftbackExcelReport($input: GiftbackFilterSetInput) {
  giftbackExcelReport(input: $input) {
    relatorio
  }
}
    `;

/**
 * __useGiftbackExcelReportQuery__
 *
 * To run a query within a React component, call `useGiftbackExcelReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftbackExcelReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftbackExcelReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiftbackExcelReportQuery(baseOptions?: Apollo.QueryHookOptions<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>(GiftbackExcelReportDocument, options);
      }
export function useGiftbackExcelReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>(GiftbackExcelReportDocument, options);
        }
export function useGiftbackExcelReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>(GiftbackExcelReportDocument, options);
        }
export type GiftbackExcelReportQueryHookResult = ReturnType<typeof useGiftbackExcelReportQuery>;
export type GiftbackExcelReportLazyQueryHookResult = ReturnType<typeof useGiftbackExcelReportLazyQuery>;
export type GiftbackExcelReportSuspenseQueryHookResult = ReturnType<typeof useGiftbackExcelReportSuspenseQuery>;
export type GiftbackExcelReportQueryResult = Apollo.QueryResult<GiftbackExcelReportQuery, GiftbackExcelReportQueryVariables>;
export const GetGiftbackDocument = gql`
    query GetGiftback($id: ID!) {
  giftback: getGiftback(id: $id) {
    code
    value
    minValueToRedeem
    dueDate
    id
    pk
    status
    redeemedAt
    importedFrom
    justification
    createdAt
    updatedAt
    redeemedBy {
      pk
      name
      email
    }
    customer {
      pk
      name
      email
      phone
    }
    purchaseUsed {
      pk
      date
      value
    }
    purchase {
      pk
      date
      value
    }
  }
  historic: allCustomerActivitiesRelay(giftback_Id: $id) {
    edges {
      node {
        title
        description
        updatedAt
        pk
      }
    }
  }
}
    `;

/**
 * __useGetGiftbackQuery__
 *
 * To run a query within a React component, call `useGetGiftbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftbackQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGiftbackQuery(baseOptions: Apollo.QueryHookOptions<GetGiftbackQuery, GetGiftbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGiftbackQuery, GetGiftbackQueryVariables>(GetGiftbackDocument, options);
      }
export function useGetGiftbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGiftbackQuery, GetGiftbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGiftbackQuery, GetGiftbackQueryVariables>(GetGiftbackDocument, options);
        }
export function useGetGiftbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGiftbackQuery, GetGiftbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGiftbackQuery, GetGiftbackQueryVariables>(GetGiftbackDocument, options);
        }
export type GetGiftbackQueryHookResult = ReturnType<typeof useGetGiftbackQuery>;
export type GetGiftbackLazyQueryHookResult = ReturnType<typeof useGetGiftbackLazyQuery>;
export type GetGiftbackSuspenseQueryHookResult = ReturnType<typeof useGetGiftbackSuspenseQuery>;
export type GetGiftbackQueryResult = Apollo.QueryResult<GetGiftbackQuery, GetGiftbackQueryVariables>;
export const GetGiftbackPublicDataDocument = gql`
    query GetGiftbackPublicData($storeId: ID!, $contactData: String!) {
  getPublicGiftbackDataByCpfPhone(storeId: $storeId, contactData: $contactData) {
    value
    code
    minValueForRedeem
    dueDate
    errorMessage
    clientName
    publicToken
  }
}
    `;

/**
 * __useGetGiftbackPublicDataQuery__
 *
 * To run a query within a React component, call `useGetGiftbackPublicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftbackPublicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftbackPublicDataQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      contactData: // value for 'contactData'
 *   },
 * });
 */
export function useGetGiftbackPublicDataQuery(baseOptions: Apollo.QueryHookOptions<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>(GetGiftbackPublicDataDocument, options);
      }
export function useGetGiftbackPublicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>(GetGiftbackPublicDataDocument, options);
        }
export function useGetGiftbackPublicDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>(GetGiftbackPublicDataDocument, options);
        }
export type GetGiftbackPublicDataQueryHookResult = ReturnType<typeof useGetGiftbackPublicDataQuery>;
export type GetGiftbackPublicDataLazyQueryHookResult = ReturnType<typeof useGetGiftbackPublicDataLazyQuery>;
export type GetGiftbackPublicDataSuspenseQueryHookResult = ReturnType<typeof useGetGiftbackPublicDataSuspenseQuery>;
export type GetGiftbackPublicDataQueryResult = Apollo.QueryResult<GetGiftbackPublicDataQuery, GetGiftbackPublicDataQueryVariables>;
export const ListGiftbacksDocument = gql`
    query ListGiftbacks($before: String, $after: String, $first: Int = 12, $last: Int, $code: String, $value_Gte: Float, $value_Lte: Float, $dueDate_Gte: Date, $dueDate_Lte: Date, $redeemedAt: Date, $redeemedAt_Lte: Date, $redeemedAt_Gte: Date, $purchase: ID, $customer: ID, $status: String, $customer_Name_Icontains: String, $nameOrEmailCustomer: String, $importedFrom: String, $importedFrom_In: String, $createdAt_Date_Gte: Date, $createdAt_Date_Lte: Date, $createdAt_Lte: DateTime, $createdAt_Gte: DateTime) {
  giftbackAll: allGiftbacksRelay {
    totalCount
  }
  giftbackActive: allGiftbacksRelay(status: "ACTIVE") {
    totalCount
  }
  giftbackExpired: allGiftbacksRelay(status: "EXPIRED") {
    totalCount
  }
  giftbackRedeemed: allGiftbacksRelay(status: "REDEEMED") {
    totalCount
  }
  giftbackCancelled: allGiftbacksRelay(status: "CANCELLED") {
    totalCount
  }
  giftbackOverdue: allGiftbacksRelay(status: "OVERDUE") {
    totalCount
  }
  allGiftbacksRelay(
    before: $before
    after: $after
    first: $first
    last: $last
    code: $code
    value_Gte: $value_Gte
    value_Lte: $value_Lte
    createdAt_Date_Gte: $createdAt_Date_Gte
    createdAt_Date_Lte: $createdAt_Date_Lte
    createdAt_Lte: $createdAt_Lte
    createdAt_Gte: $createdAt_Gte
    dueDate_Gte: $dueDate_Gte
    dueDate_Lte: $dueDate_Lte
    redeemedAt_Lte: $redeemedAt_Lte
    redeemedAt_Gte: $redeemedAt_Gte
    redeemedAt: $redeemedAt
    purchase: $purchase
    customer: $customer
    status: $status
    customer_Name_Icontains: $customer_Name_Icontains
    nameOrEmailCustomer: $nameOrEmailCustomer
    importedFrom: $importedFrom
    importedFrom_In: $importedFrom_In
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        pk
        code
        customer {
          name
          email
        }
        status
        value
        dueDate
        minValueToRedeem
        importedFrom
        purchase {
          pk
        }
        customeractivitySet {
          edges {
            node {
              activity
              title
              description
              pk
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListGiftbacksQuery__
 *
 * To run a query within a React component, call `useListGiftbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGiftbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGiftbacksQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      code: // value for 'code'
 *      value_Gte: // value for 'value_Gte'
 *      value_Lte: // value for 'value_Lte'
 *      dueDate_Gte: // value for 'dueDate_Gte'
 *      dueDate_Lte: // value for 'dueDate_Lte'
 *      redeemedAt: // value for 'redeemedAt'
 *      redeemedAt_Lte: // value for 'redeemedAt_Lte'
 *      redeemedAt_Gte: // value for 'redeemedAt_Gte'
 *      purchase: // value for 'purchase'
 *      customer: // value for 'customer'
 *      status: // value for 'status'
 *      customer_Name_Icontains: // value for 'customer_Name_Icontains'
 *      nameOrEmailCustomer: // value for 'nameOrEmailCustomer'
 *      importedFrom: // value for 'importedFrom'
 *      importedFrom_In: // value for 'importedFrom_In'
 *      createdAt_Date_Gte: // value for 'createdAt_Date_Gte'
 *      createdAt_Date_Lte: // value for 'createdAt_Date_Lte'
 *      createdAt_Lte: // value for 'createdAt_Lte'
 *      createdAt_Gte: // value for 'createdAt_Gte'
 *   },
 * });
 */
export function useListGiftbacksQuery(baseOptions?: Apollo.QueryHookOptions<ListGiftbacksQuery, ListGiftbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGiftbacksQuery, ListGiftbacksQueryVariables>(ListGiftbacksDocument, options);
      }
export function useListGiftbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGiftbacksQuery, ListGiftbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGiftbacksQuery, ListGiftbacksQueryVariables>(ListGiftbacksDocument, options);
        }
export function useListGiftbacksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListGiftbacksQuery, ListGiftbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGiftbacksQuery, ListGiftbacksQueryVariables>(ListGiftbacksDocument, options);
        }
export type ListGiftbacksQueryHookResult = ReturnType<typeof useListGiftbacksQuery>;
export type ListGiftbacksLazyQueryHookResult = ReturnType<typeof useListGiftbacksLazyQuery>;
export type ListGiftbacksSuspenseQueryHookResult = ReturnType<typeof useListGiftbacksSuspenseQuery>;
export type ListGiftbacksQueryResult = Apollo.QueryResult<ListGiftbacksQuery, ListGiftbacksQueryVariables>;
export const RedeemGiftbackDocument = gql`
    mutation RedeemGiftback($giftbackInput: UpdateRedeemGiftbackInput!) {
  giftbackRedeem(giftbackInput: $giftbackInput) {
    ok
    giftback {
      redeemedAt
    }
  }
}
    `;
export type RedeemGiftbackMutationFn = Apollo.MutationFunction<RedeemGiftbackMutation, RedeemGiftbackMutationVariables>;

/**
 * __useRedeemGiftbackMutation__
 *
 * To run a mutation, you first call `useRedeemGiftbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemGiftbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemGiftbackMutation, { data, loading, error }] = useRedeemGiftbackMutation({
 *   variables: {
 *      giftbackInput: // value for 'giftbackInput'
 *   },
 * });
 */
export function useRedeemGiftbackMutation(baseOptions?: Apollo.MutationHookOptions<RedeemGiftbackMutation, RedeemGiftbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemGiftbackMutation, RedeemGiftbackMutationVariables>(RedeemGiftbackDocument, options);
      }
export type RedeemGiftbackMutationHookResult = ReturnType<typeof useRedeemGiftbackMutation>;
export type RedeemGiftbackMutationResult = Apollo.MutationResult<RedeemGiftbackMutation>;
export type RedeemGiftbackMutationOptions = Apollo.BaseMutationOptions<RedeemGiftbackMutation, RedeemGiftbackMutationVariables>;
export const GetHomeCardsValuesDocument = gql`
    query GetHomeCardsValues {
  homepageCardsValues {
    totalCustomers
    totalPurchase
    totalActiveGiftbacks
    totalUniqueCustomers
    totalRecurrentCustomers
    purchaseAverageTicket
    totalValuePurchase
    totalValueRedeemedGiftbacks
    totalGiftbackGains
  }
}
    `;

/**
 * __useGetHomeCardsValuesQuery__
 *
 * To run a query within a React component, call `useGetHomeCardsValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeCardsValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeCardsValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeCardsValuesQuery(baseOptions?: Apollo.QueryHookOptions<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>(GetHomeCardsValuesDocument, options);
      }
export function useGetHomeCardsValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>(GetHomeCardsValuesDocument, options);
        }
export function useGetHomeCardsValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>(GetHomeCardsValuesDocument, options);
        }
export type GetHomeCardsValuesQueryHookResult = ReturnType<typeof useGetHomeCardsValuesQuery>;
export type GetHomeCardsValuesLazyQueryHookResult = ReturnType<typeof useGetHomeCardsValuesLazyQuery>;
export type GetHomeCardsValuesSuspenseQueryHookResult = ReturnType<typeof useGetHomeCardsValuesSuspenseQuery>;
export type GetHomeCardsValuesQueryResult = Apollo.QueryResult<GetHomeCardsValuesQuery, GetHomeCardsValuesQueryVariables>;
export const HomepageTopCustomersDocument = gql`
    query HomepageTopCustomers {
  homepageTopCustomers {
    customerName
    customerGender
    purchaseTotalQuantity
    purchaseTotalValue
    customerPk
  }
}
    `;

/**
 * __useHomepageTopCustomersQuery__
 *
 * To run a query within a React component, call `useHomepageTopCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageTopCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageTopCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomepageTopCustomersQuery(baseOptions?: Apollo.QueryHookOptions<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>(HomepageTopCustomersDocument, options);
      }
export function useHomepageTopCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>(HomepageTopCustomersDocument, options);
        }
export function useHomepageTopCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>(HomepageTopCustomersDocument, options);
        }
export type HomepageTopCustomersQueryHookResult = ReturnType<typeof useHomepageTopCustomersQuery>;
export type HomepageTopCustomersLazyQueryHookResult = ReturnType<typeof useHomepageTopCustomersLazyQuery>;
export type HomepageTopCustomersSuspenseQueryHookResult = ReturnType<typeof useHomepageTopCustomersSuspenseQuery>;
export type HomepageTopCustomersQueryResult = Apollo.QueryResult<HomepageTopCustomersQuery, HomepageTopCustomersQueryVariables>;
export const HomepageTopProductsDocument = gql`
    query HomepageTopProducts {
  homepageTopProducts {
    productName
    totalValue
    totalSold
    productPk
  }
}
    `;

/**
 * __useHomepageTopProductsQuery__
 *
 * To run a query within a React component, call `useHomepageTopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageTopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageTopProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomepageTopProductsQuery(baseOptions?: Apollo.QueryHookOptions<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>(HomepageTopProductsDocument, options);
      }
export function useHomepageTopProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>(HomepageTopProductsDocument, options);
        }
export function useHomepageTopProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>(HomepageTopProductsDocument, options);
        }
export type HomepageTopProductsQueryHookResult = ReturnType<typeof useHomepageTopProductsQuery>;
export type HomepageTopProductsLazyQueryHookResult = ReturnType<typeof useHomepageTopProductsLazyQuery>;
export type HomepageTopProductsSuspenseQueryHookResult = ReturnType<typeof useHomepageTopProductsSuspenseQuery>;
export type HomepageTopProductsQueryResult = Apollo.QueryResult<HomepageTopProductsQuery, HomepageTopProductsQueryVariables>;
export const VerifyStoreZapiEvolutionIntegrationConnectedDocument = gql`
    query verifyStoreZapiEvolutionIntegrationConnected {
  verifyIfStoreHasZapiOrEvolutionApiIntegration {
    hasIntegration
    isConnected
  }
}
    `;

/**
 * __useVerifyStoreZapiEvolutionIntegrationConnectedQuery__
 *
 * To run a query within a React component, call `useVerifyStoreZapiEvolutionIntegrationConnectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyStoreZapiEvolutionIntegrationConnectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyStoreZapiEvolutionIntegrationConnectedQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifyStoreZapiEvolutionIntegrationConnectedQuery(baseOptions?: Apollo.QueryHookOptions<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>(VerifyStoreZapiEvolutionIntegrationConnectedDocument, options);
      }
export function useVerifyStoreZapiEvolutionIntegrationConnectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>(VerifyStoreZapiEvolutionIntegrationConnectedDocument, options);
        }
export function useVerifyStoreZapiEvolutionIntegrationConnectedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>(VerifyStoreZapiEvolutionIntegrationConnectedDocument, options);
        }
export type VerifyStoreZapiEvolutionIntegrationConnectedQueryHookResult = ReturnType<typeof useVerifyStoreZapiEvolutionIntegrationConnectedQuery>;
export type VerifyStoreZapiEvolutionIntegrationConnectedLazyQueryHookResult = ReturnType<typeof useVerifyStoreZapiEvolutionIntegrationConnectedLazyQuery>;
export type VerifyStoreZapiEvolutionIntegrationConnectedSuspenseQueryHookResult = ReturnType<typeof useVerifyStoreZapiEvolutionIntegrationConnectedSuspenseQuery>;
export type VerifyStoreZapiEvolutionIntegrationConnectedQueryResult = Apollo.QueryResult<VerifyStoreZapiEvolutionIntegrationConnectedQuery, VerifyStoreZapiEvolutionIntegrationConnectedQueryVariables>;
export const GetRfmChartValuesDocument = gql`
    query GetRFMChartValues($input: CustomerFilterSetInput) {
  rfmStatus: getRfmStatus {
    dailyRefreshEnabled
    lastCompletedAt
  }
  rfmData: dashboardRfmChartValues(input: $input) {
    x
    y
    monetaryValue
    totalPurchases
    averageMonetaryValue
    averageTicket
  }
}
    `;

/**
 * __useGetRfmChartValuesQuery__
 *
 * To run a query within a React component, call `useGetRfmChartValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfmChartValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfmChartValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRfmChartValuesQuery(baseOptions?: Apollo.QueryHookOptions<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>(GetRfmChartValuesDocument, options);
      }
export function useGetRfmChartValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>(GetRfmChartValuesDocument, options);
        }
export function useGetRfmChartValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>(GetRfmChartValuesDocument, options);
        }
export type GetRfmChartValuesQueryHookResult = ReturnType<typeof useGetRfmChartValuesQuery>;
export type GetRfmChartValuesLazyQueryHookResult = ReturnType<typeof useGetRfmChartValuesLazyQuery>;
export type GetRfmChartValuesSuspenseQueryHookResult = ReturnType<typeof useGetRfmChartValuesSuspenseQuery>;
export type GetRfmChartValuesQueryResult = Apollo.QueryResult<GetRfmChartValuesQuery, GetRfmChartValuesQueryVariables>;
export const CreateJourneyDocument = gql`
    mutation CreateJourney($name: String!, $description: String, $triggerType: String!) {
  createJourney(name: $name, description: $description, triggerType: $triggerType) {
    ok
    error
    errors
    journey {
      id
      name
      description
      triggerFamily
      status
      draft {
        id
        revision
        definition
      }
    }
  }
}
    `;
export type CreateJourneyMutationFn = Apollo.MutationFunction<CreateJourneyMutation, CreateJourneyMutationVariables>;

/**
 * __useCreateJourneyMutation__
 *
 * To run a mutation, you first call `useCreateJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJourneyMutation, { data, loading, error }] = useCreateJourneyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useCreateJourneyMutation(baseOptions?: Apollo.MutationHookOptions<CreateJourneyMutation, CreateJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJourneyMutation, CreateJourneyMutationVariables>(CreateJourneyDocument, options);
      }
export type CreateJourneyMutationHookResult = ReturnType<typeof useCreateJourneyMutation>;
export type CreateJourneyMutationResult = Apollo.MutationResult<CreateJourneyMutation>;
export type CreateJourneyMutationOptions = Apollo.BaseMutationOptions<CreateJourneyMutation, CreateJourneyMutationVariables>;
export const UpdateJourneyDocument = gql`
    mutation UpdateJourney($journeyId: ID!, $name: String!, $description: String) {
  updateJourney(journeyId: $journeyId, name: $name, description: $description) {
    ok
    error
    journey {
      id
      name
      description
      updatedAt
    }
  }
}
    `;
export type UpdateJourneyMutationFn = Apollo.MutationFunction<UpdateJourneyMutation, UpdateJourneyMutationVariables>;

/**
 * __useUpdateJourneyMutation__
 *
 * To run a mutation, you first call `useUpdateJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJourneyMutation, { data, loading, error }] = useUpdateJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateJourneyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJourneyMutation, UpdateJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJourneyMutation, UpdateJourneyMutationVariables>(UpdateJourneyDocument, options);
      }
export type UpdateJourneyMutationHookResult = ReturnType<typeof useUpdateJourneyMutation>;
export type UpdateJourneyMutationResult = Apollo.MutationResult<UpdateJourneyMutation>;
export type UpdateJourneyMutationOptions = Apollo.BaseMutationOptions<UpdateJourneyMutation, UpdateJourneyMutationVariables>;
export const SaveJourneyDraftDocument = gql`
    mutation SaveJourneyDraft($journeyId: ID!, $definition: GenericScalar!, $expectedRevision: Int!) {
  saveJourneyDraft(
    journeyId: $journeyId
    definition: $definition
    expectedRevision: $expectedRevision
  ) {
    ok
    error
    errors
    draft {
      id
      revision
      definition
      lastValidation
      updatedAt
    }
  }
}
    `;
export type SaveJourneyDraftMutationFn = Apollo.MutationFunction<SaveJourneyDraftMutation, SaveJourneyDraftMutationVariables>;

/**
 * __useSaveJourneyDraftMutation__
 *
 * To run a mutation, you first call `useSaveJourneyDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJourneyDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJourneyDraftMutation, { data, loading, error }] = useSaveJourneyDraftMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      definition: // value for 'definition'
 *      expectedRevision: // value for 'expectedRevision'
 *   },
 * });
 */
export function useSaveJourneyDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveJourneyDraftMutation, SaveJourneyDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveJourneyDraftMutation, SaveJourneyDraftMutationVariables>(SaveJourneyDraftDocument, options);
      }
export type SaveJourneyDraftMutationHookResult = ReturnType<typeof useSaveJourneyDraftMutation>;
export type SaveJourneyDraftMutationResult = Apollo.MutationResult<SaveJourneyDraftMutation>;
export type SaveJourneyDraftMutationOptions = Apollo.BaseMutationOptions<SaveJourneyDraftMutation, SaveJourneyDraftMutationVariables>;
export const ValidateJourneyDraftDocument = gql`
    mutation ValidateJourneyDraft($journeyId: ID!, $definition: GenericScalar) {
  validateJourneyDraft(journeyId: $journeyId, definition: $definition) {
    ok
    error
    errors
    validation
  }
}
    `;
export type ValidateJourneyDraftMutationFn = Apollo.MutationFunction<ValidateJourneyDraftMutation, ValidateJourneyDraftMutationVariables>;

/**
 * __useValidateJourneyDraftMutation__
 *
 * To run a mutation, you first call `useValidateJourneyDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateJourneyDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateJourneyDraftMutation, { data, loading, error }] = useValidateJourneyDraftMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      definition: // value for 'definition'
 *   },
 * });
 */
export function useValidateJourneyDraftMutation(baseOptions?: Apollo.MutationHookOptions<ValidateJourneyDraftMutation, ValidateJourneyDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateJourneyDraftMutation, ValidateJourneyDraftMutationVariables>(ValidateJourneyDraftDocument, options);
      }
export type ValidateJourneyDraftMutationHookResult = ReturnType<typeof useValidateJourneyDraftMutation>;
export type ValidateJourneyDraftMutationResult = Apollo.MutationResult<ValidateJourneyDraftMutation>;
export type ValidateJourneyDraftMutationOptions = Apollo.BaseMutationOptions<ValidateJourneyDraftMutation, ValidateJourneyDraftMutationVariables>;
export const PublishJourneyDocument = gql`
    mutation PublishJourney($journeyId: ID!, $expectedRevision: Int!) {
  publishJourney(journeyId: $journeyId, expectedRevision: $expectedRevision) {
    ok
    error
    errors
    validation
    journey {
      id
      status
      activeVersion {
        id
        number
        publishedAt
      }
    }
    version {
      id
      number
      checksum
      publishedAt
    }
  }
}
    `;
export type PublishJourneyMutationFn = Apollo.MutationFunction<PublishJourneyMutation, PublishJourneyMutationVariables>;

/**
 * __usePublishJourneyMutation__
 *
 * To run a mutation, you first call `usePublishJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishJourneyMutation, { data, loading, error }] = usePublishJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      expectedRevision: // value for 'expectedRevision'
 *   },
 * });
 */
export function usePublishJourneyMutation(baseOptions?: Apollo.MutationHookOptions<PublishJourneyMutation, PublishJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishJourneyMutation, PublishJourneyMutationVariables>(PublishJourneyDocument, options);
      }
export type PublishJourneyMutationHookResult = ReturnType<typeof usePublishJourneyMutation>;
export type PublishJourneyMutationResult = Apollo.MutationResult<PublishJourneyMutation>;
export type PublishJourneyMutationOptions = Apollo.BaseMutationOptions<PublishJourneyMutation, PublishJourneyMutationVariables>;
export const RestoreJourneyVersionToDraftDocument = gql`
    mutation RestoreJourneyVersionToDraft($journeyId: ID!, $versionId: ID!, $expectedRevision: Int!) {
  restoreJourneyVersionToDraft(
    journeyId: $journeyId
    versionId: $versionId
    expectedRevision: $expectedRevision
  ) {
    ok
    error
    errors
    draft {
      id
      revision
      schemaVersion
      definition
      lastValidation
      updatedAt
    }
    version {
      id
      number
      publishedAt
    }
    journey {
      id
      activeVersion {
        id
        number
        publishedAt
      }
    }
  }
}
    `;
export type RestoreJourneyVersionToDraftMutationFn = Apollo.MutationFunction<RestoreJourneyVersionToDraftMutation, RestoreJourneyVersionToDraftMutationVariables>;

/**
 * __useRestoreJourneyVersionToDraftMutation__
 *
 * To run a mutation, you first call `useRestoreJourneyVersionToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreJourneyVersionToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreJourneyVersionToDraftMutation, { data, loading, error }] = useRestoreJourneyVersionToDraftMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      versionId: // value for 'versionId'
 *      expectedRevision: // value for 'expectedRevision'
 *   },
 * });
 */
export function useRestoreJourneyVersionToDraftMutation(baseOptions?: Apollo.MutationHookOptions<RestoreJourneyVersionToDraftMutation, RestoreJourneyVersionToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreJourneyVersionToDraftMutation, RestoreJourneyVersionToDraftMutationVariables>(RestoreJourneyVersionToDraftDocument, options);
      }
export type RestoreJourneyVersionToDraftMutationHookResult = ReturnType<typeof useRestoreJourneyVersionToDraftMutation>;
export type RestoreJourneyVersionToDraftMutationResult = Apollo.MutationResult<RestoreJourneyVersionToDraftMutation>;
export type RestoreJourneyVersionToDraftMutationOptions = Apollo.BaseMutationOptions<RestoreJourneyVersionToDraftMutation, RestoreJourneyVersionToDraftMutationVariables>;
export const PauseJourneyDocument = gql`
    mutation PauseJourney($journeyId: ID!) {
  pauseJourney(journeyId: $journeyId) {
    ok
    error
    journey {
      id
      status
    }
  }
}
    `;
export type PauseJourneyMutationFn = Apollo.MutationFunction<PauseJourneyMutation, PauseJourneyMutationVariables>;

/**
 * __usePauseJourneyMutation__
 *
 * To run a mutation, you first call `usePauseJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseJourneyMutation, { data, loading, error }] = usePauseJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *   },
 * });
 */
export function usePauseJourneyMutation(baseOptions?: Apollo.MutationHookOptions<PauseJourneyMutation, PauseJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseJourneyMutation, PauseJourneyMutationVariables>(PauseJourneyDocument, options);
      }
export type PauseJourneyMutationHookResult = ReturnType<typeof usePauseJourneyMutation>;
export type PauseJourneyMutationResult = Apollo.MutationResult<PauseJourneyMutation>;
export type PauseJourneyMutationOptions = Apollo.BaseMutationOptions<PauseJourneyMutation, PauseJourneyMutationVariables>;
export const ActivateJourneyDocument = gql`
    mutation ActivateJourney($journeyId: ID!) {
  activateJourney(journeyId: $journeyId) {
    ok
    error
    journey {
      id
      status
    }
  }
}
    `;
export type ActivateJourneyMutationFn = Apollo.MutationFunction<ActivateJourneyMutation, ActivateJourneyMutationVariables>;

/**
 * __useActivateJourneyMutation__
 *
 * To run a mutation, you first call `useActivateJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateJourneyMutation, { data, loading, error }] = useActivateJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *   },
 * });
 */
export function useActivateJourneyMutation(baseOptions?: Apollo.MutationHookOptions<ActivateJourneyMutation, ActivateJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateJourneyMutation, ActivateJourneyMutationVariables>(ActivateJourneyDocument, options);
      }
export type ActivateJourneyMutationHookResult = ReturnType<typeof useActivateJourneyMutation>;
export type ActivateJourneyMutationResult = Apollo.MutationResult<ActivateJourneyMutation>;
export type ActivateJourneyMutationOptions = Apollo.BaseMutationOptions<ActivateJourneyMutation, ActivateJourneyMutationVariables>;
export const ArchiveJourneyDocument = gql`
    mutation ArchiveJourney($journeyId: ID!) {
  archiveJourney(journeyId: $journeyId) {
    ok
    error
    journey {
      id
      status
    }
  }
}
    `;
export type ArchiveJourneyMutationFn = Apollo.MutationFunction<ArchiveJourneyMutation, ArchiveJourneyMutationVariables>;

/**
 * __useArchiveJourneyMutation__
 *
 * To run a mutation, you first call `useArchiveJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJourneyMutation, { data, loading, error }] = useArchiveJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *   },
 * });
 */
export function useArchiveJourneyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveJourneyMutation, ArchiveJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveJourneyMutation, ArchiveJourneyMutationVariables>(ArchiveJourneyDocument, options);
      }
export type ArchiveJourneyMutationHookResult = ReturnType<typeof useArchiveJourneyMutation>;
export type ArchiveJourneyMutationResult = Apollo.MutationResult<ArchiveJourneyMutation>;
export type ArchiveJourneyMutationOptions = Apollo.BaseMutationOptions<ArchiveJourneyMutation, ArchiveJourneyMutationVariables>;
export const DuplicateJourneyDocument = gql`
    mutation DuplicateJourney($journeyId: ID!, $name: String) {
  duplicateJourney(journeyId: $journeyId, name: $name) {
    ok
    error
    journey {
      id
      name
      status
    }
  }
}
    `;
export type DuplicateJourneyMutationFn = Apollo.MutationFunction<DuplicateJourneyMutation, DuplicateJourneyMutationVariables>;

/**
 * __useDuplicateJourneyMutation__
 *
 * To run a mutation, you first call `useDuplicateJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateJourneyMutation, { data, loading, error }] = useDuplicateJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDuplicateJourneyMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateJourneyMutation, DuplicateJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateJourneyMutation, DuplicateJourneyMutationVariables>(DuplicateJourneyDocument, options);
      }
export type DuplicateJourneyMutationHookResult = ReturnType<typeof useDuplicateJourneyMutation>;
export type DuplicateJourneyMutationResult = Apollo.MutationResult<DuplicateJourneyMutation>;
export type DuplicateJourneyMutationOptions = Apollo.BaseMutationOptions<DuplicateJourneyMutation, DuplicateJourneyMutationVariables>;
export const SimulateJourneyDocument = gql`
    mutation SimulateJourney($journeyId: ID!, $definition: GenericScalar, $eventContext: GenericScalar!) {
  simulateJourney(
    journeyId: $journeyId
    definition: $definition
    eventContext: $eventContext
  ) {
    ok
    error
    errors
    simulation
  }
}
    `;
export type SimulateJourneyMutationFn = Apollo.MutationFunction<SimulateJourneyMutation, SimulateJourneyMutationVariables>;

/**
 * __useSimulateJourneyMutation__
 *
 * To run a mutation, you first call `useSimulateJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateJourneyMutation, { data, loading, error }] = useSimulateJourneyMutation({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      definition: // value for 'definition'
 *      eventContext: // value for 'eventContext'
 *   },
 * });
 */
export function useSimulateJourneyMutation(baseOptions?: Apollo.MutationHookOptions<SimulateJourneyMutation, SimulateJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimulateJourneyMutation, SimulateJourneyMutationVariables>(SimulateJourneyDocument, options);
      }
export type SimulateJourneyMutationHookResult = ReturnType<typeof useSimulateJourneyMutation>;
export type SimulateJourneyMutationResult = Apollo.MutationResult<SimulateJourneyMutation>;
export type SimulateJourneyMutationOptions = Apollo.BaseMutationOptions<SimulateJourneyMutation, SimulateJourneyMutationVariables>;
export const CancelJourneyExecutionDocument = gql`
    mutation CancelJourneyExecution($executionId: ID!, $reason: String) {
  cancelJourneyExecution(executionId: $executionId, reason: $reason) {
    ok
    error
    execution {
      id
      status
      outcomeReason
      completedAt
    }
  }
}
    `;
export type CancelJourneyExecutionMutationFn = Apollo.MutationFunction<CancelJourneyExecutionMutation, CancelJourneyExecutionMutationVariables>;

/**
 * __useCancelJourneyExecutionMutation__
 *
 * To run a mutation, you first call `useCancelJourneyExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelJourneyExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelJourneyExecutionMutation, { data, loading, error }] = useCancelJourneyExecutionMutation({
 *   variables: {
 *      executionId: // value for 'executionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelJourneyExecutionMutation(baseOptions?: Apollo.MutationHookOptions<CancelJourneyExecutionMutation, CancelJourneyExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelJourneyExecutionMutation, CancelJourneyExecutionMutationVariables>(CancelJourneyExecutionDocument, options);
      }
export type CancelJourneyExecutionMutationHookResult = ReturnType<typeof useCancelJourneyExecutionMutation>;
export type CancelJourneyExecutionMutationResult = Apollo.MutationResult<CancelJourneyExecutionMutation>;
export type CancelJourneyExecutionMutationOptions = Apollo.BaseMutationOptions<CancelJourneyExecutionMutation, CancelJourneyExecutionMutationVariables>;
export const RetryJourneyIntentDocument = gql`
    mutation RetryJourneyIntent($intentId: ID!) {
  retryJourneyIntent(intentId: $intentId) {
    ok
    error
    intent {
      id
      status
      nextEligibleAt
      attemptCount
    }
  }
}
    `;
export type RetryJourneyIntentMutationFn = Apollo.MutationFunction<RetryJourneyIntentMutation, RetryJourneyIntentMutationVariables>;

/**
 * __useRetryJourneyIntentMutation__
 *
 * To run a mutation, you first call `useRetryJourneyIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryJourneyIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryJourneyIntentMutation, { data, loading, error }] = useRetryJourneyIntentMutation({
 *   variables: {
 *      intentId: // value for 'intentId'
 *   },
 * });
 */
export function useRetryJourneyIntentMutation(baseOptions?: Apollo.MutationHookOptions<RetryJourneyIntentMutation, RetryJourneyIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryJourneyIntentMutation, RetryJourneyIntentMutationVariables>(RetryJourneyIntentDocument, options);
      }
export type RetryJourneyIntentMutationHookResult = ReturnType<typeof useRetryJourneyIntentMutation>;
export type RetryJourneyIntentMutationResult = Apollo.MutationResult<RetryJourneyIntentMutation>;
export type RetryJourneyIntentMutationOptions = Apollo.BaseMutationOptions<RetryJourneyIntentMutation, RetryJourneyIntentMutationVariables>;
export const ChangeJourneyTriggerOwnershipDocument = gql`
    mutation ChangeJourneyTriggerOwnership($triggerFamily: String!, $mode: String!, $rollbackPolicy: String!) {
  changeJourneyTriggerOwnership(
    triggerFamily: $triggerFamily
    mode: $mode
    rollbackPolicy: $rollbackPolicy
  ) {
    ok
    error
    errors
    ownership {
      id
      triggerFamily
      mode
      rollbackPolicy
      changedAt
    }
  }
}
    `;
export type ChangeJourneyTriggerOwnershipMutationFn = Apollo.MutationFunction<ChangeJourneyTriggerOwnershipMutation, ChangeJourneyTriggerOwnershipMutationVariables>;

/**
 * __useChangeJourneyTriggerOwnershipMutation__
 *
 * To run a mutation, you first call `useChangeJourneyTriggerOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeJourneyTriggerOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeJourneyTriggerOwnershipMutation, { data, loading, error }] = useChangeJourneyTriggerOwnershipMutation({
 *   variables: {
 *      triggerFamily: // value for 'triggerFamily'
 *      mode: // value for 'mode'
 *      rollbackPolicy: // value for 'rollbackPolicy'
 *   },
 * });
 */
export function useChangeJourneyTriggerOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<ChangeJourneyTriggerOwnershipMutation, ChangeJourneyTriggerOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeJourneyTriggerOwnershipMutation, ChangeJourneyTriggerOwnershipMutationVariables>(ChangeJourneyTriggerOwnershipDocument, options);
      }
export type ChangeJourneyTriggerOwnershipMutationHookResult = ReturnType<typeof useChangeJourneyTriggerOwnershipMutation>;
export type ChangeJourneyTriggerOwnershipMutationResult = Apollo.MutationResult<ChangeJourneyTriggerOwnershipMutation>;
export type ChangeJourneyTriggerOwnershipMutationOptions = Apollo.BaseMutationOptions<ChangeJourneyTriggerOwnershipMutation, ChangeJourneyTriggerOwnershipMutationVariables>;
export const JourneysDocument = gql`
    query Journeys($search: String, $status: String) {
  journeys(search: $search, status: $status) {
    id
    name
    description
    triggerFamily
    status
    createdAt
    updatedAt
    activeVersion {
      id
      number
      publishedAt
    }
    draft {
      id
      revision
      schemaVersion
      definition
      lastValidation
      updatedAt
    }
  }
}
    `;

/**
 * __useJourneysQuery__
 *
 * To run a query within a React component, call `useJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneysQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useJourneysQuery(baseOptions?: Apollo.QueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
      }
export function useJourneysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
        }
export function useJourneysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
        }
export type JourneysQueryHookResult = ReturnType<typeof useJourneysQuery>;
export type JourneysLazyQueryHookResult = ReturnType<typeof useJourneysLazyQuery>;
export type JourneysSuspenseQueryHookResult = ReturnType<typeof useJourneysSuspenseQuery>;
export type JourneysQueryResult = Apollo.QueryResult<JourneysQuery, JourneysQueryVariables>;
export const JourneyDocument = gql`
    query Journey($id: ID!) {
  journey(id: $id) {
    id
    name
    description
    triggerFamily
    status
    createdAt
    updatedAt
    activeVersion {
      id
      number
      definition
      compiledPlan
      checksum
      publishedAt
    }
    draft {
      id
      revision
      schemaVersion
      definition
      lastValidation
      updatedAt
    }
    versions {
      id
      number
      schemaVersion
      definition
      checksum
      publishedAt
    }
  }
}
    `;

/**
 * __useJourneyQuery__
 *
 * To run a query within a React component, call `useJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJourneyQuery(baseOptions: Apollo.QueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
      }
export function useJourneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
export function useJourneySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
export type JourneyQueryHookResult = ReturnType<typeof useJourneyQuery>;
export type JourneyLazyQueryHookResult = ReturnType<typeof useJourneyLazyQuery>;
export type JourneySuspenseQueryHookResult = ReturnType<typeof useJourneySuspenseQuery>;
export type JourneyQueryResult = Apollo.QueryResult<JourneyQuery, JourneyQueryVariables>;
export const JourneyOwnershipsDocument = gql`
    query JourneyOwnerships {
  journeyOwnerships {
    id
    triggerFamily
    mode
    rollbackPolicy
    changedAt
  }
}
    `;

/**
 * __useJourneyOwnershipsQuery__
 *
 * To run a query within a React component, call `useJourneyOwnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyOwnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyOwnershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJourneyOwnershipsQuery(baseOptions?: Apollo.QueryHookOptions<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>(JourneyOwnershipsDocument, options);
      }
export function useJourneyOwnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>(JourneyOwnershipsDocument, options);
        }
export function useJourneyOwnershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>(JourneyOwnershipsDocument, options);
        }
export type JourneyOwnershipsQueryHookResult = ReturnType<typeof useJourneyOwnershipsQuery>;
export type JourneyOwnershipsLazyQueryHookResult = ReturnType<typeof useJourneyOwnershipsLazyQuery>;
export type JourneyOwnershipsSuspenseQueryHookResult = ReturnType<typeof useJourneyOwnershipsSuspenseQuery>;
export type JourneyOwnershipsQueryResult = Apollo.QueryResult<JourneyOwnershipsQuery, JourneyOwnershipsQueryVariables>;
export const JourneyCatalogDocument = gql`
    query JourneyCatalog {
  journeyCatalog
}
    `;

/**
 * __useJourneyCatalogQuery__
 *
 * To run a query within a React component, call `useJourneyCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useJourneyCatalogQuery(baseOptions?: Apollo.QueryHookOptions<JourneyCatalogQuery, JourneyCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyCatalogQuery, JourneyCatalogQueryVariables>(JourneyCatalogDocument, options);
      }
export function useJourneyCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyCatalogQuery, JourneyCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyCatalogQuery, JourneyCatalogQueryVariables>(JourneyCatalogDocument, options);
        }
export function useJourneyCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyCatalogQuery, JourneyCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyCatalogQuery, JourneyCatalogQueryVariables>(JourneyCatalogDocument, options);
        }
export type JourneyCatalogQueryHookResult = ReturnType<typeof useJourneyCatalogQuery>;
export type JourneyCatalogLazyQueryHookResult = ReturnType<typeof useJourneyCatalogLazyQuery>;
export type JourneyCatalogSuspenseQueryHookResult = ReturnType<typeof useJourneyCatalogSuspenseQuery>;
export type JourneyCatalogQueryResult = Apollo.QueryResult<JourneyCatalogQuery, JourneyCatalogQueryVariables>;
export const JourneyWhatsappTemplatesDocument = gql`
    query JourneyWhatsappTemplates {
  allTemplatesRelay(status: "APPROVED", orderBy: "-updated_at") {
    edges {
      node {
        pk
        templateId
        name
        message
        category
        status
        provider
        components
        imageUrl
        videoUrl
      }
    }
  }
}
    `;

/**
 * __useJourneyWhatsappTemplatesQuery__
 *
 * To run a query within a React component, call `useJourneyWhatsappTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyWhatsappTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyWhatsappTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useJourneyWhatsappTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>(JourneyWhatsappTemplatesDocument, options);
      }
export function useJourneyWhatsappTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>(JourneyWhatsappTemplatesDocument, options);
        }
export function useJourneyWhatsappTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>(JourneyWhatsappTemplatesDocument, options);
        }
export type JourneyWhatsappTemplatesQueryHookResult = ReturnType<typeof useJourneyWhatsappTemplatesQuery>;
export type JourneyWhatsappTemplatesLazyQueryHookResult = ReturnType<typeof useJourneyWhatsappTemplatesLazyQuery>;
export type JourneyWhatsappTemplatesSuspenseQueryHookResult = ReturnType<typeof useJourneyWhatsappTemplatesSuspenseQuery>;
export type JourneyWhatsappTemplatesQueryResult = Apollo.QueryResult<JourneyWhatsappTemplatesQuery, JourneyWhatsappTemplatesQueryVariables>;
export const JourneyTargetsDocument = gql`
    query JourneyTargets($productSearch: String, $categorySearch: String) {
  journeyTargetProducts(search: $productSearch, limit: 50) {
    id
    name
    active
  }
  journeyTargetCategories(search: $categorySearch, limit: 100) {
    id
    name
    parentId
    active
  }
}
    `;

/**
 * __useJourneyTargetsQuery__
 *
 * To run a query within a React component, call `useJourneyTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyTargetsQuery({
 *   variables: {
 *      productSearch: // value for 'productSearch'
 *      categorySearch: // value for 'categorySearch'
 *   },
 * });
 */
export function useJourneyTargetsQuery(baseOptions?: Apollo.QueryHookOptions<JourneyTargetsQuery, JourneyTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyTargetsQuery, JourneyTargetsQueryVariables>(JourneyTargetsDocument, options);
      }
export function useJourneyTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyTargetsQuery, JourneyTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyTargetsQuery, JourneyTargetsQueryVariables>(JourneyTargetsDocument, options);
        }
export function useJourneyTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyTargetsQuery, JourneyTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyTargetsQuery, JourneyTargetsQueryVariables>(JourneyTargetsDocument, options);
        }
export type JourneyTargetsQueryHookResult = ReturnType<typeof useJourneyTargetsQuery>;
export type JourneyTargetsLazyQueryHookResult = ReturnType<typeof useJourneyTargetsLazyQuery>;
export type JourneyTargetsSuspenseQueryHookResult = ReturnType<typeof useJourneyTargetsSuspenseQuery>;
export type JourneyTargetsQueryResult = Apollo.QueryResult<JourneyTargetsQuery, JourneyTargetsQueryVariables>;
export const JourneyAnalyticsDocument = gql`
    query JourneyAnalytics($journeyId: ID!, $versionId: ID, $dateFrom: Date, $dateTo: Date) {
  journeyNodeAnalytics(
    journeyId: $journeyId
    versionId: $versionId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    versionId
    versionNumber
    dateFrom
    dateTo
    updatedAt
    definitions
    nodes {
      nodeKey
      nodeType
      scheduledMessages
      dueMessages
      sentMessages
      failedMessages
      canceledMessages
      skippedMessages
      deliveryAttempts
      reachedExecutions
      reachedCustomers
      sentCustomers
      convertedExecutions
      convertedCustomers
      conversionRate
      stoppedExecutions
      preventedMessages
      scheduledActions
      dueActions
      completedActions
      failedActions
      canceledActions
      skippedActions
      createdGiftbacks
      engagement
    }
  }
  journeyFunnel(
    journeyId: $journeyId
    versionId: $versionId
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    enrolledExecutions
    enrolledCustomers
    stages {
      nodeKey
      reachedExecutions
      reachedCustomers
      sentMessages
      canceledBefore
      convertedExecutions
      convertedCustomers
    }
  }
}
    `;

/**
 * __useJourneyAnalyticsQuery__
 *
 * To run a query within a React component, call `useJourneyAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyAnalyticsQuery({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      versionId: // value for 'versionId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useJourneyAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>(JourneyAnalyticsDocument, options);
      }
export function useJourneyAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>(JourneyAnalyticsDocument, options);
        }
export function useJourneyAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>(JourneyAnalyticsDocument, options);
        }
export type JourneyAnalyticsQueryHookResult = ReturnType<typeof useJourneyAnalyticsQuery>;
export type JourneyAnalyticsLazyQueryHookResult = ReturnType<typeof useJourneyAnalyticsLazyQuery>;
export type JourneyAnalyticsSuspenseQueryHookResult = ReturnType<typeof useJourneyAnalyticsSuspenseQuery>;
export type JourneyAnalyticsQueryResult = Apollo.QueryResult<JourneyAnalyticsQuery, JourneyAnalyticsQueryVariables>;
export const JourneyExecutionsDocument = gql`
    query JourneyExecutions($journeyId: ID, $versionId: ID, $status: String, $productId: ID, $categoryId: ID, $limit: Int, $offset: Int) {
  journeyExecutions(
    journeyId: $journeyId
    versionId: $versionId
    status: $status
    productId: $productId
    categoryId: $categoryId
    limit: $limit
    offset: $offset
  ) {
    id
    subjectType
    subjectId
    enrollmentContext
    planningTrace
    summary
    status
    outcomeReason
    isShadow
    startedAt
    completedAt
    updatedAt
    journey {
      id
      name
    }
    journeyVersion {
      id
      number
    }
    customer {
      pk
      name
    }
    notificationIntents {
      id
      journeyNodeKey
      sequence
      channel
      status
      scheduledAt
      scheduledTime
      nextEligibleAt
      attemptCount
      maxAttempts
      lastError
      cancelReason
      skipReason
      messageSnapshot
      enrollmentContext
    }
    actionIntents {
      id
      nodeKey
      sequence
      actionType
      scheduledAt
      status
    }
    goalEvents {
      id
      exitRuleKey
      attributedNodeKey
      occurredAt
      preventedIntentCount
      reversed
      reversalReason
      purchase {
        pk
        value
        status
        issueDate
      }
    }
    deliveries {
      id
      nodeKey
      channel
      provider
      status
      externalMessageId
      sanitizedError
      attempts
      acceptedAt
      sentAt
    }
  }
}
    `;

/**
 * __useJourneyExecutionsQuery__
 *
 * To run a query within a React component, call `useJourneyExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyExecutionsQuery({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *      versionId: // value for 'versionId'
 *      status: // value for 'status'
 *      productId: // value for 'productId'
 *      categoryId: // value for 'categoryId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useJourneyExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>(JourneyExecutionsDocument, options);
      }
export function useJourneyExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>(JourneyExecutionsDocument, options);
        }
export function useJourneyExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>(JourneyExecutionsDocument, options);
        }
export type JourneyExecutionsQueryHookResult = ReturnType<typeof useJourneyExecutionsQuery>;
export type JourneyExecutionsLazyQueryHookResult = ReturnType<typeof useJourneyExecutionsLazyQuery>;
export type JourneyExecutionsSuspenseQueryHookResult = ReturnType<typeof useJourneyExecutionsSuspenseQuery>;
export type JourneyExecutionsQueryResult = Apollo.QueryResult<JourneyExecutionsQuery, JourneyExecutionsQueryVariables>;
export const JourneyExecutionDocument = gql`
    query JourneyExecution($id: ID!) {
  journeyExecution(id: $id) {
    id
    subjectType
    subjectId
    enrollmentContext
    planningTrace
    summary
    status
    outcomeReason
    isShadow
    startedAt
    completedAt
    journey {
      id
      name
    }
    journeyVersion {
      id
      number
      checksum
    }
    customer {
      pk
      name
    }
    notificationIntents {
      id
      journeyNodeKey
      sequence
      channel
      status
      scheduledAt
      scheduledTime
      nextEligibleAt
      attemptCount
      maxAttempts
      lastError
      cancelReason
      skipReason
      messageSnapshot
      enrollmentContext
      requiredJourneyAction {
        id
        nodeKey
        status
      }
      giftback {
        pk
        code
        value
        dueDate
        status
      }
    }
    actionIntents {
      id
      nodeKey
      sequence
      actionType
      configSnapshot
      scheduledAt
      status
      attemptCount
      maxAttempts
      nextEligibleAt
      providerOutcome
      lastError
      cancelReason
      canceledAt
      completedAt
      createdGiftback {
        pk
        code
        value
        minValueToRedeem
        availableFrom
        dueDate
        status
        integrationId
      }
    }
    goalEvents {
      id
      exitRuleKey
      attributedNodeKey
      matchedContext
      occurredAt
      preventedIntentCount
      reversed
      reversedAt
      reversalReason
      purchase {
        pk
        value
        status
        issueDate
      }
    }
    deliveries {
      id
      nodeKey
      channel
      provider
      status
      externalMessageId
      sanitizedError
      attempts
      acceptedAt
      sentAt
    }
  }
}
    `;

/**
 * __useJourneyExecutionQuery__
 *
 * To run a query within a React component, call `useJourneyExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyExecutionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJourneyExecutionQuery(baseOptions: Apollo.QueryHookOptions<JourneyExecutionQuery, JourneyExecutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyExecutionQuery, JourneyExecutionQueryVariables>(JourneyExecutionDocument, options);
      }
export function useJourneyExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyExecutionQuery, JourneyExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyExecutionQuery, JourneyExecutionQueryVariables>(JourneyExecutionDocument, options);
        }
export function useJourneyExecutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JourneyExecutionQuery, JourneyExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JourneyExecutionQuery, JourneyExecutionQueryVariables>(JourneyExecutionDocument, options);
        }
export type JourneyExecutionQueryHookResult = ReturnType<typeof useJourneyExecutionQuery>;
export type JourneyExecutionLazyQueryHookResult = ReturnType<typeof useJourneyExecutionLazyQuery>;
export type JourneyExecutionSuspenseQueryHookResult = ReturnType<typeof useJourneyExecutionSuspenseQuery>;
export type JourneyExecutionQueryResult = Apollo.QueryResult<JourneyExecutionQuery, JourneyExecutionQueryVariables>;
export const GetLoyaltyConfigurationDocument = gql`
    query GetLoyaltyConfiguration {
  loyaltyProgram {
    id
    name
    description
    primaryColor
    isActive
    pointsExpirationDays
    redemptionExpirationHours
    store {
      slug
      url
    }
  }
  loyaltyTiers {
    id
    name
    minimumPoints
    benefits
    isActive
  }
  loyaltyRules {
    id
    name
    event
    conditions
    pointsMode
    pointsValue
    maximumPoints
    validityDays
    occurrenceLimit
    priority
    startsAt
    endsAt
    isActive
  }
  loyaltyRewards {
    id
    name
    description
    rewardType
    pointsCost
    minimumTier {
      id
      name
    }
    product {
      id
      pk
      name
    }
    discountValue
    discountType
    availableInPdv
    availableInPublicPage
    allowPickup
    allowCustomerPaidShipping
    totalLimit
    perMemberLimit
    startsAt
    endsAt
    isActive
  }
  loyaltyRedemptions {
    id
    code
    pointsCost
    channel
    fulfillmentMethod
    status
    expiresAt
    completedAt
    createdAt
    reward {
      id
      name
    }
    member {
      id
      customer {
        pk
        name
      }
    }
  }
  allProductsRelay(first: 100, isActivated: true) {
    edges {
      node {
        id
        pk
        name
      }
    }
  }
}
    `;

/**
 * __useGetLoyaltyConfigurationQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLoyaltyConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>(GetLoyaltyConfigurationDocument, options);
      }
export function useGetLoyaltyConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>(GetLoyaltyConfigurationDocument, options);
        }
export function useGetLoyaltyConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>(GetLoyaltyConfigurationDocument, options);
        }
export type GetLoyaltyConfigurationQueryHookResult = ReturnType<typeof useGetLoyaltyConfigurationQuery>;
export type GetLoyaltyConfigurationLazyQueryHookResult = ReturnType<typeof useGetLoyaltyConfigurationLazyQuery>;
export type GetLoyaltyConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyConfigurationSuspenseQuery>;
export type GetLoyaltyConfigurationQueryResult = Apollo.QueryResult<GetLoyaltyConfigurationQuery, GetLoyaltyConfigurationQueryVariables>;
export const GetPdvLoyaltyMemberDocument = gql`
    query GetPdvLoyaltyMember($customerId: ID!) {
  loyaltyMember(customerId: $customerId) {
    id
    availablePoints
    reservedPoints
    currentTier {
      id
      name
    }
    benefits {
      id
      name
      description
      startsAt
      endsAt
      isActive
    }
    redemptions {
      id
      code
      pointsCost
      status
      fulfillmentMethod
      expiresAt
      reward {
        id
        name
      }
    }
    eligiblePdvRewards {
      id
      name
      description
      rewardType
      pointsCost
      allowPickup
      allowCustomerPaidShipping
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPdvLoyaltyMemberQuery__
 *
 * To run a query within a React component, call `useGetPdvLoyaltyMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdvLoyaltyMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdvLoyaltyMemberQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPdvLoyaltyMemberQuery(baseOptions: Apollo.QueryHookOptions<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>(GetPdvLoyaltyMemberDocument, options);
      }
export function useGetPdvLoyaltyMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>(GetPdvLoyaltyMemberDocument, options);
        }
export function useGetPdvLoyaltyMemberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>(GetPdvLoyaltyMemberDocument, options);
        }
export type GetPdvLoyaltyMemberQueryHookResult = ReturnType<typeof useGetPdvLoyaltyMemberQuery>;
export type GetPdvLoyaltyMemberLazyQueryHookResult = ReturnType<typeof useGetPdvLoyaltyMemberLazyQuery>;
export type GetPdvLoyaltyMemberSuspenseQueryHookResult = ReturnType<typeof useGetPdvLoyaltyMemberSuspenseQuery>;
export type GetPdvLoyaltyMemberQueryResult = Apollo.QueryResult<GetPdvLoyaltyMemberQuery, GetPdvLoyaltyMemberQueryVariables>;
export const AdminUpdateLoyaltyProgramDocument = gql`
    mutation AdminUpdateLoyaltyProgram($input: LoyaltyProgramInput!) {
  loyaltyProgramUpdate(input: $input) {
    success
    program {
      id
      name
      description
      primaryColor
      isActive
      pointsExpirationDays
      redemptionExpirationHours
    }
  }
}
    `;
export type AdminUpdateLoyaltyProgramMutationFn = Apollo.MutationFunction<AdminUpdateLoyaltyProgramMutation, AdminUpdateLoyaltyProgramMutationVariables>;

/**
 * __useAdminUpdateLoyaltyProgramMutation__
 *
 * To run a mutation, you first call `useAdminUpdateLoyaltyProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateLoyaltyProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateLoyaltyProgramMutation, { data, loading, error }] = useAdminUpdateLoyaltyProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateLoyaltyProgramMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateLoyaltyProgramMutation, AdminUpdateLoyaltyProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateLoyaltyProgramMutation, AdminUpdateLoyaltyProgramMutationVariables>(AdminUpdateLoyaltyProgramDocument, options);
      }
export type AdminUpdateLoyaltyProgramMutationHookResult = ReturnType<typeof useAdminUpdateLoyaltyProgramMutation>;
export type AdminUpdateLoyaltyProgramMutationResult = Apollo.MutationResult<AdminUpdateLoyaltyProgramMutation>;
export type AdminUpdateLoyaltyProgramMutationOptions = Apollo.BaseMutationOptions<AdminUpdateLoyaltyProgramMutation, AdminUpdateLoyaltyProgramMutationVariables>;
export const AdminSaveLoyaltyTierDocument = gql`
    mutation AdminSaveLoyaltyTier($input: LoyaltyTierInput!) {
  loyaltyTierSave(input: $input) {
    success
    tier {
      id
      name
      minimumPoints
      benefits
      isActive
    }
  }
}
    `;
export type AdminSaveLoyaltyTierMutationFn = Apollo.MutationFunction<AdminSaveLoyaltyTierMutation, AdminSaveLoyaltyTierMutationVariables>;

/**
 * __useAdminSaveLoyaltyTierMutation__
 *
 * To run a mutation, you first call `useAdminSaveLoyaltyTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveLoyaltyTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveLoyaltyTierMutation, { data, loading, error }] = useAdminSaveLoyaltyTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSaveLoyaltyTierMutation(baseOptions?: Apollo.MutationHookOptions<AdminSaveLoyaltyTierMutation, AdminSaveLoyaltyTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSaveLoyaltyTierMutation, AdminSaveLoyaltyTierMutationVariables>(AdminSaveLoyaltyTierDocument, options);
      }
export type AdminSaveLoyaltyTierMutationHookResult = ReturnType<typeof useAdminSaveLoyaltyTierMutation>;
export type AdminSaveLoyaltyTierMutationResult = Apollo.MutationResult<AdminSaveLoyaltyTierMutation>;
export type AdminSaveLoyaltyTierMutationOptions = Apollo.BaseMutationOptions<AdminSaveLoyaltyTierMutation, AdminSaveLoyaltyTierMutationVariables>;
export const AdminSaveLoyaltyRuleDocument = gql`
    mutation AdminSaveLoyaltyRule($input: LoyaltyRuleInput!) {
  loyaltyRuleSave(input: $input) {
    success
    rule {
      id
      name
      event
      conditions
      pointsMode
      pointsValue
      maximumPoints
      validityDays
      occurrenceLimit
      priority
      startsAt
      endsAt
      isActive
    }
  }
}
    `;
export type AdminSaveLoyaltyRuleMutationFn = Apollo.MutationFunction<AdminSaveLoyaltyRuleMutation, AdminSaveLoyaltyRuleMutationVariables>;

/**
 * __useAdminSaveLoyaltyRuleMutation__
 *
 * To run a mutation, you first call `useAdminSaveLoyaltyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveLoyaltyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveLoyaltyRuleMutation, { data, loading, error }] = useAdminSaveLoyaltyRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSaveLoyaltyRuleMutation(baseOptions?: Apollo.MutationHookOptions<AdminSaveLoyaltyRuleMutation, AdminSaveLoyaltyRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSaveLoyaltyRuleMutation, AdminSaveLoyaltyRuleMutationVariables>(AdminSaveLoyaltyRuleDocument, options);
      }
export type AdminSaveLoyaltyRuleMutationHookResult = ReturnType<typeof useAdminSaveLoyaltyRuleMutation>;
export type AdminSaveLoyaltyRuleMutationResult = Apollo.MutationResult<AdminSaveLoyaltyRuleMutation>;
export type AdminSaveLoyaltyRuleMutationOptions = Apollo.BaseMutationOptions<AdminSaveLoyaltyRuleMutation, AdminSaveLoyaltyRuleMutationVariables>;
export const AdminSaveLoyaltyRewardDocument = gql`
    mutation AdminSaveLoyaltyReward($input: LoyaltyRewardInput!) {
  loyaltyRewardSave(input: $input) {
    success
    reward {
      id
      name
      description
      rewardType
      pointsCost
      minimumTier {
        id
        name
      }
      product {
        id
        pk
        name
      }
      discountValue
      discountType
      availableInPdv
      availableInPublicPage
      allowPickup
      allowCustomerPaidShipping
      totalLimit
      perMemberLimit
      startsAt
      endsAt
      isActive
    }
  }
}
    `;
export type AdminSaveLoyaltyRewardMutationFn = Apollo.MutationFunction<AdminSaveLoyaltyRewardMutation, AdminSaveLoyaltyRewardMutationVariables>;

/**
 * __useAdminSaveLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useAdminSaveLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveLoyaltyRewardMutation, { data, loading, error }] = useAdminSaveLoyaltyRewardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSaveLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<AdminSaveLoyaltyRewardMutation, AdminSaveLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSaveLoyaltyRewardMutation, AdminSaveLoyaltyRewardMutationVariables>(AdminSaveLoyaltyRewardDocument, options);
      }
export type AdminSaveLoyaltyRewardMutationHookResult = ReturnType<typeof useAdminSaveLoyaltyRewardMutation>;
export type AdminSaveLoyaltyRewardMutationResult = Apollo.MutationResult<AdminSaveLoyaltyRewardMutation>;
export type AdminSaveLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<AdminSaveLoyaltyRewardMutation, AdminSaveLoyaltyRewardMutationVariables>;
export const AdminDeleteLoyaltyConfigurationDocument = gql`
    mutation AdminDeleteLoyaltyConfiguration($kind: String!, $id: ID!) {
  loyaltyConfigurationDelete(kind: $kind, id: $id) {
    success
  }
}
    `;
export type AdminDeleteLoyaltyConfigurationMutationFn = Apollo.MutationFunction<AdminDeleteLoyaltyConfigurationMutation, AdminDeleteLoyaltyConfigurationMutationVariables>;

/**
 * __useAdminDeleteLoyaltyConfigurationMutation__
 *
 * To run a mutation, you first call `useAdminDeleteLoyaltyConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteLoyaltyConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteLoyaltyConfigurationMutation, { data, loading, error }] = useAdminDeleteLoyaltyConfigurationMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteLoyaltyConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteLoyaltyConfigurationMutation, AdminDeleteLoyaltyConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteLoyaltyConfigurationMutation, AdminDeleteLoyaltyConfigurationMutationVariables>(AdminDeleteLoyaltyConfigurationDocument, options);
      }
export type AdminDeleteLoyaltyConfigurationMutationHookResult = ReturnType<typeof useAdminDeleteLoyaltyConfigurationMutation>;
export type AdminDeleteLoyaltyConfigurationMutationResult = Apollo.MutationResult<AdminDeleteLoyaltyConfigurationMutation>;
export type AdminDeleteLoyaltyConfigurationMutationOptions = Apollo.BaseMutationOptions<AdminDeleteLoyaltyConfigurationMutation, AdminDeleteLoyaltyConfigurationMutationVariables>;
export const CreatePdvLoyaltyRedemptionDocument = gql`
    mutation CreatePdvLoyaltyRedemption($input: LoyaltyRedemptionInput!) {
  loyaltyRedemptionCreate(input: $input) {
    success
    redemption {
      id
      code
      pointsCost
      status
      fulfillmentMethod
      expiresAt
      reward {
        id
        name
      }
      coupon {
        id
        code
      }
    }
  }
}
    `;
export type CreatePdvLoyaltyRedemptionMutationFn = Apollo.MutationFunction<CreatePdvLoyaltyRedemptionMutation, CreatePdvLoyaltyRedemptionMutationVariables>;

/**
 * __useCreatePdvLoyaltyRedemptionMutation__
 *
 * To run a mutation, you first call `useCreatePdvLoyaltyRedemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdvLoyaltyRedemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPdvLoyaltyRedemptionMutation, { data, loading, error }] = useCreatePdvLoyaltyRedemptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePdvLoyaltyRedemptionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePdvLoyaltyRedemptionMutation, CreatePdvLoyaltyRedemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePdvLoyaltyRedemptionMutation, CreatePdvLoyaltyRedemptionMutationVariables>(CreatePdvLoyaltyRedemptionDocument, options);
      }
export type CreatePdvLoyaltyRedemptionMutationHookResult = ReturnType<typeof useCreatePdvLoyaltyRedemptionMutation>;
export type CreatePdvLoyaltyRedemptionMutationResult = Apollo.MutationResult<CreatePdvLoyaltyRedemptionMutation>;
export type CreatePdvLoyaltyRedemptionMutationOptions = Apollo.BaseMutationOptions<CreatePdvLoyaltyRedemptionMutation, CreatePdvLoyaltyRedemptionMutationVariables>;
export const ConfirmLoyaltyRewardDeliveryDocument = gql`
    mutation ConfirmLoyaltyRewardDelivery($code: String!) {
  loyaltyRewardDeliver(code: $code) {
    success
    redemption {
      id
      code
      status
      deliveredAt
      pointsCost
      reward {
        id
        name
      }
      member {
        id
        customer {
          pk
          name
        }
      }
    }
  }
}
    `;
export type ConfirmLoyaltyRewardDeliveryMutationFn = Apollo.MutationFunction<ConfirmLoyaltyRewardDeliveryMutation, ConfirmLoyaltyRewardDeliveryMutationVariables>;

/**
 * __useConfirmLoyaltyRewardDeliveryMutation__
 *
 * To run a mutation, you first call `useConfirmLoyaltyRewardDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmLoyaltyRewardDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmLoyaltyRewardDeliveryMutation, { data, loading, error }] = useConfirmLoyaltyRewardDeliveryMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmLoyaltyRewardDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmLoyaltyRewardDeliveryMutation, ConfirmLoyaltyRewardDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmLoyaltyRewardDeliveryMutation, ConfirmLoyaltyRewardDeliveryMutationVariables>(ConfirmLoyaltyRewardDeliveryDocument, options);
      }
export type ConfirmLoyaltyRewardDeliveryMutationHookResult = ReturnType<typeof useConfirmLoyaltyRewardDeliveryMutation>;
export type ConfirmLoyaltyRewardDeliveryMutationResult = Apollo.MutationResult<ConfirmLoyaltyRewardDeliveryMutation>;
export type ConfirmLoyaltyRewardDeliveryMutationOptions = Apollo.BaseMutationOptions<ConfirmLoyaltyRewardDeliveryMutation, ConfirmLoyaltyRewardDeliveryMutationVariables>;
export const BulkNotificationStatusCountsDocument = gql`
    query BulkNotificationStatusCounts($startRunningDate_Gte: Date, $startRunningDate_Lte: Date, $viaWhatsapp: Boolean, $viaEmail: Boolean, $viaWhatsappOfficial: Boolean, $viaZekiCrm: Boolean, $title_Icontains: String) {
  statusAll: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusPending: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "PENDING"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusProcessing: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "PROCESSING"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusFailed: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "FAILED"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusFinished: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "FINISHED"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusCanceled: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "CANCELED"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusPaused: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "PAUSED"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
  statusPausedByTimeLimit: allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: "PAUSED_BY_TIME_LIMIT,PAUSED_BY_DAILY_LIMIT"
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
  ) {
    totalCount
  }
}
    `;

/**
 * __useBulkNotificationStatusCountsQuery__
 *
 * To run a query within a React component, call `useBulkNotificationStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkNotificationStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkNotificationStatusCountsQuery({
 *   variables: {
 *      startRunningDate_Gte: // value for 'startRunningDate_Gte'
 *      startRunningDate_Lte: // value for 'startRunningDate_Lte'
 *      viaWhatsapp: // value for 'viaWhatsapp'
 *      viaEmail: // value for 'viaEmail'
 *      viaWhatsappOfficial: // value for 'viaWhatsappOfficial'
 *      viaZekiCrm: // value for 'viaZekiCrm'
 *      title_Icontains: // value for 'title_Icontains'
 *   },
 * });
 */
export function useBulkNotificationStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>(BulkNotificationStatusCountsDocument, options);
      }
export function useBulkNotificationStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>(BulkNotificationStatusCountsDocument, options);
        }
export function useBulkNotificationStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>(BulkNotificationStatusCountsDocument, options);
        }
export type BulkNotificationStatusCountsQueryHookResult = ReturnType<typeof useBulkNotificationStatusCountsQuery>;
export type BulkNotificationStatusCountsLazyQueryHookResult = ReturnType<typeof useBulkNotificationStatusCountsLazyQuery>;
export type BulkNotificationStatusCountsSuspenseQueryHookResult = ReturnType<typeof useBulkNotificationStatusCountsSuspenseQuery>;
export type BulkNotificationStatusCountsQueryResult = Apollo.QueryResult<BulkNotificationStatusCountsQuery, BulkNotificationStatusCountsQueryVariables>;
export const CancelMassCampaignDocument = gql`
    mutation CancelMassCampaign($input: BulkNotificationCancellInput!) {
  cancelBulkNotification(input: $input) {
    success
  }
}
    `;
export type CancelMassCampaignMutationFn = Apollo.MutationFunction<CancelMassCampaignMutation, CancelMassCampaignMutationVariables>;

/**
 * __useCancelMassCampaignMutation__
 *
 * To run a mutation, you first call `useCancelMassCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMassCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMassCampaignMutation, { data, loading, error }] = useCancelMassCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelMassCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CancelMassCampaignMutation, CancelMassCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMassCampaignMutation, CancelMassCampaignMutationVariables>(CancelMassCampaignDocument, options);
      }
export type CancelMassCampaignMutationHookResult = ReturnType<typeof useCancelMassCampaignMutation>;
export type CancelMassCampaignMutationResult = Apollo.MutationResult<CancelMassCampaignMutation>;
export type CancelMassCampaignMutationOptions = Apollo.BaseMutationOptions<CancelMassCampaignMutation, CancelMassCampaignMutationVariables>;
export const ContinueMassCampaignDocument = gql`
    mutation ContinueMassCampaign($input: BulkNotificationResumeInput!) {
  resumeBulkNotification(input: $input) {
    success
  }
}
    `;
export type ContinueMassCampaignMutationFn = Apollo.MutationFunction<ContinueMassCampaignMutation, ContinueMassCampaignMutationVariables>;

/**
 * __useContinueMassCampaignMutation__
 *
 * To run a mutation, you first call `useContinueMassCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueMassCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueMassCampaignMutation, { data, loading, error }] = useContinueMassCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContinueMassCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ContinueMassCampaignMutation, ContinueMassCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueMassCampaignMutation, ContinueMassCampaignMutationVariables>(ContinueMassCampaignDocument, options);
      }
export type ContinueMassCampaignMutationHookResult = ReturnType<typeof useContinueMassCampaignMutation>;
export type ContinueMassCampaignMutationResult = Apollo.MutationResult<ContinueMassCampaignMutation>;
export type ContinueMassCampaignMutationOptions = Apollo.BaseMutationOptions<ContinueMassCampaignMutation, ContinueMassCampaignMutationVariables>;
export const CreateMassCampaignDocument = gql`
    mutation CreateMassCampaign($input: BulkNotificationCreateInput!) {
  createBulkNotification(input: $input) {
    success
  }
}
    `;
export type CreateMassCampaignMutationFn = Apollo.MutationFunction<CreateMassCampaignMutation, CreateMassCampaignMutationVariables>;

/**
 * __useCreateMassCampaignMutation__
 *
 * To run a mutation, you first call `useCreateMassCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMassCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMassCampaignMutation, { data, loading, error }] = useCreateMassCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMassCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateMassCampaignMutation, CreateMassCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMassCampaignMutation, CreateMassCampaignMutationVariables>(CreateMassCampaignDocument, options);
      }
export type CreateMassCampaignMutationHookResult = ReturnType<typeof useCreateMassCampaignMutation>;
export type CreateMassCampaignMutationResult = Apollo.MutationResult<CreateMassCampaignMutation>;
export type CreateMassCampaignMutationOptions = Apollo.BaseMutationOptions<CreateMassCampaignMutation, CreateMassCampaignMutationVariables>;
export const CreateTemplateEmailDocument = gql`
    mutation CreateTemplateEmail($input: EmailTemplateCreateInput!) {
  createEmailTemplate(input: $input) {
    success
    message
  }
}
    `;
export type CreateTemplateEmailMutationFn = Apollo.MutationFunction<CreateTemplateEmailMutation, CreateTemplateEmailMutationVariables>;

/**
 * __useCreateTemplateEmailMutation__
 *
 * To run a mutation, you first call `useCreateTemplateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateEmailMutation, { data, loading, error }] = useCreateTemplateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateEmailMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateEmailMutation, CreateTemplateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateEmailMutation, CreateTemplateEmailMutationVariables>(CreateTemplateEmailDocument, options);
      }
export type CreateTemplateEmailMutationHookResult = ReturnType<typeof useCreateTemplateEmailMutation>;
export type CreateTemplateEmailMutationResult = Apollo.MutationResult<CreateTemplateEmailMutation>;
export type CreateTemplateEmailMutationOptions = Apollo.BaseMutationOptions<CreateTemplateEmailMutation, CreateTemplateEmailMutationVariables>;
export const DeleteMassCampaignDocument = gql`
    mutation DeleteMassCampaign($input: BulkNotificationDeleteInput!) {
  deleteBulkNotification(input: $input) {
    success
  }
}
    `;
export type DeleteMassCampaignMutationFn = Apollo.MutationFunction<DeleteMassCampaignMutation, DeleteMassCampaignMutationVariables>;

/**
 * __useDeleteMassCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteMassCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMassCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMassCampaignMutation, { data, loading, error }] = useDeleteMassCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMassCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMassCampaignMutation, DeleteMassCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMassCampaignMutation, DeleteMassCampaignMutationVariables>(DeleteMassCampaignDocument, options);
      }
export type DeleteMassCampaignMutationHookResult = ReturnType<typeof useDeleteMassCampaignMutation>;
export type DeleteMassCampaignMutationResult = Apollo.MutationResult<DeleteMassCampaignMutation>;
export type DeleteMassCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteMassCampaignMutation, DeleteMassCampaignMutationVariables>;
export const GetMassCampaignDocument = gql`
    query GetMassCampaign($id: ID!) {
  getBulkNotification(id: $id) {
    pk
    title
    status
    fileAttachment
    progressCount
    progressPercentage
    viaWhatsapp
    viaEmail
    viaWhatsappOfficial
    viaZekiCrm
    zekiCrmChannelId
    zekiCrmChannelNumber
    zekiCrmTemplateVariableMapping {
      templateVariable
      zekiVariable
    }
    startTime
    endTime
    startRunningDate
    purchaseQuantity
    purchaseTotalValue
    createdAt
    messageTimeInterval
    dailyMessageLimit
    customerMessageStatusCounts {
      total
      sent
      pending
      read
      clicked
      failed
      canceled
      delivered
    }
    whatsappTemplate {
      pk
      name
      message
      status
      reason
      category
      provider
      zekiCrmParameters
      imageUrl
      videoUrl
    }
    bulknotificationmessageSet {
      active
      pk
      message
      imageUrl
      videoUrl
      htmlMessage
      emailMessage
      emailTitle
      buttonLabel
      buttonUrl
      reactEmailData
      footer
      buttons
    }
    store {
      id
      name
      telephone
      email
      url
      profileImageEmail
      emailFooterPrimaryColor
      emailFooterSecondaryColor
      emailFooterTertiaryColor
      emailFooterImg
    }
  }
}
    `;

/**
 * __useGetMassCampaignQuery__
 *
 * To run a query within a React component, call `useGetMassCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMassCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMassCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMassCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetMassCampaignQuery, GetMassCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMassCampaignQuery, GetMassCampaignQueryVariables>(GetMassCampaignDocument, options);
      }
export function useGetMassCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMassCampaignQuery, GetMassCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMassCampaignQuery, GetMassCampaignQueryVariables>(GetMassCampaignDocument, options);
        }
export function useGetMassCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMassCampaignQuery, GetMassCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMassCampaignQuery, GetMassCampaignQueryVariables>(GetMassCampaignDocument, options);
        }
export type GetMassCampaignQueryHookResult = ReturnType<typeof useGetMassCampaignQuery>;
export type GetMassCampaignLazyQueryHookResult = ReturnType<typeof useGetMassCampaignLazyQuery>;
export type GetMassCampaignSuspenseQueryHookResult = ReturnType<typeof useGetMassCampaignSuspenseQuery>;
export type GetMassCampaignQueryResult = Apollo.QueryResult<GetMassCampaignQuery, GetMassCampaignQueryVariables>;
export const GetBulkNotificationCustomerIdsDocument = gql`
    query GetBulkNotificationCustomerIds($bulkNotificationId: ID!) {
  getBulkNotificationCustomerIds(bulkNotificationId: $bulkNotificationId)
}
    `;

/**
 * __useGetBulkNotificationCustomerIdsQuery__
 *
 * To run a query within a React component, call `useGetBulkNotificationCustomerIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkNotificationCustomerIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkNotificationCustomerIdsQuery({
 *   variables: {
 *      bulkNotificationId: // value for 'bulkNotificationId'
 *   },
 * });
 */
export function useGetBulkNotificationCustomerIdsQuery(baseOptions: Apollo.QueryHookOptions<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>(GetBulkNotificationCustomerIdsDocument, options);
      }
export function useGetBulkNotificationCustomerIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>(GetBulkNotificationCustomerIdsDocument, options);
        }
export function useGetBulkNotificationCustomerIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>(GetBulkNotificationCustomerIdsDocument, options);
        }
export type GetBulkNotificationCustomerIdsQueryHookResult = ReturnType<typeof useGetBulkNotificationCustomerIdsQuery>;
export type GetBulkNotificationCustomerIdsLazyQueryHookResult = ReturnType<typeof useGetBulkNotificationCustomerIdsLazyQuery>;
export type GetBulkNotificationCustomerIdsSuspenseQueryHookResult = ReturnType<typeof useGetBulkNotificationCustomerIdsSuspenseQuery>;
export type GetBulkNotificationCustomerIdsQueryResult = Apollo.QueryResult<GetBulkNotificationCustomerIdsQuery, GetBulkNotificationCustomerIdsQueryVariables>;
export const GetBulkNotificationMetricsDocument = gql`
    query GetBulkNotificationMetrics($id: ID!) {
  getBulkNotification(id: $id) {
    customerMessageStatusCounts {
      sent
      read
      failed
      clicked
      delivered
    }
  }
}
    `;

/**
 * __useGetBulkNotificationMetricsQuery__
 *
 * To run a query within a React component, call `useGetBulkNotificationMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkNotificationMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkNotificationMetricsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBulkNotificationMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>(GetBulkNotificationMetricsDocument, options);
      }
export function useGetBulkNotificationMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>(GetBulkNotificationMetricsDocument, options);
        }
export function useGetBulkNotificationMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>(GetBulkNotificationMetricsDocument, options);
        }
export type GetBulkNotificationMetricsQueryHookResult = ReturnType<typeof useGetBulkNotificationMetricsQuery>;
export type GetBulkNotificationMetricsLazyQueryHookResult = ReturnType<typeof useGetBulkNotificationMetricsLazyQuery>;
export type GetBulkNotificationMetricsSuspenseQueryHookResult = ReturnType<typeof useGetBulkNotificationMetricsSuspenseQuery>;
export type GetBulkNotificationMetricsQueryResult = Apollo.QueryResult<GetBulkNotificationMetricsQuery, GetBulkNotificationMetricsQueryVariables>;
export const GetMassCampaignTestSendsDocument = gql`
    query GetMassCampaignTestSends($draftKey: UUID!) {
  bulkNotificationTestSends(draftKey: $draftKey) {
    remainingTests
    limit
  }
}
    `;

/**
 * __useGetMassCampaignTestSendsQuery__
 *
 * To run a query within a React component, call `useGetMassCampaignTestSendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMassCampaignTestSendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMassCampaignTestSendsQuery({
 *   variables: {
 *      draftKey: // value for 'draftKey'
 *   },
 * });
 */
export function useGetMassCampaignTestSendsQuery(baseOptions: Apollo.QueryHookOptions<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>(GetMassCampaignTestSendsDocument, options);
      }
export function useGetMassCampaignTestSendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>(GetMassCampaignTestSendsDocument, options);
        }
export function useGetMassCampaignTestSendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>(GetMassCampaignTestSendsDocument, options);
        }
export type GetMassCampaignTestSendsQueryHookResult = ReturnType<typeof useGetMassCampaignTestSendsQuery>;
export type GetMassCampaignTestSendsLazyQueryHookResult = ReturnType<typeof useGetMassCampaignTestSendsLazyQuery>;
export type GetMassCampaignTestSendsSuspenseQueryHookResult = ReturnType<typeof useGetMassCampaignTestSendsSuspenseQuery>;
export type GetMassCampaignTestSendsQueryResult = Apollo.QueryResult<GetMassCampaignTestSendsQuery, GetMassCampaignTestSendsQueryVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates {
  getEmailTemplates {
    pk
    name
    json
    stores {
      name
    }
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetTemplatesSuspenseQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const ListBulkNotificationWhatsappTemplatesDocument = gql`
    query ListBulkNotificationWhatsappTemplates {
  allTemplatesRelay(origin: "BULK_NOTIFICATION") {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edgeCount
    edges {
      node {
        pk
        templateId
        name
        message
        status
        isCurrentlySending
        components
        imageUrl
        videoUrl
      }
    }
  }
}
    `;

/**
 * __useListBulkNotificationWhatsappTemplatesQuery__
 *
 * To run a query within a React component, call `useListBulkNotificationWhatsappTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBulkNotificationWhatsappTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBulkNotificationWhatsappTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBulkNotificationWhatsappTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>(ListBulkNotificationWhatsappTemplatesDocument, options);
      }
export function useListBulkNotificationWhatsappTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>(ListBulkNotificationWhatsappTemplatesDocument, options);
        }
export function useListBulkNotificationWhatsappTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>(ListBulkNotificationWhatsappTemplatesDocument, options);
        }
export type ListBulkNotificationWhatsappTemplatesQueryHookResult = ReturnType<typeof useListBulkNotificationWhatsappTemplatesQuery>;
export type ListBulkNotificationWhatsappTemplatesLazyQueryHookResult = ReturnType<typeof useListBulkNotificationWhatsappTemplatesLazyQuery>;
export type ListBulkNotificationWhatsappTemplatesSuspenseQueryHookResult = ReturnType<typeof useListBulkNotificationWhatsappTemplatesSuspenseQuery>;
export type ListBulkNotificationWhatsappTemplatesQueryResult = Apollo.QueryResult<ListBulkNotificationWhatsappTemplatesQuery, ListBulkNotificationWhatsappTemplatesQueryVariables>;
export const ListBulkNotificationsDocument = gql`
    query ListBulkNotifications($startRunningDate_Gte: Date, $startRunningDate_Lte: Date, $status_In: String, $viaWhatsapp: Boolean, $viaEmail: Boolean, $viaWhatsappOfficial: Boolean, $viaZekiCrm: Boolean, $title_Icontains: String, $before: String, $after: String, $first: Int, $last: Int) {
  allBulkNotificationsRelay(
    startRunningDate_Gte: $startRunningDate_Gte
    startRunningDate_Lte: $startRunningDate_Lte
    status_In: $status_In
    viaWhatsapp: $viaWhatsapp
    viaEmail: $viaEmail
    viaWhatsappOfficial: $viaWhatsappOfficial
    viaZekiCrm: $viaZekiCrm
    title_Icontains: $title_Icontains
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        pk
        title
        status
        viaWhatsapp
        viaEmail
        viaWhatsappOfficial
        viaZekiCrm
        startTime
        startRunningDate
        createdAt
        progressPercentage
        purchaseQuantity
        purchaseTotalValue
        whatsappTemplate {
          category
          status
        }
        bulknotificationcustomerSet {
          totalCount
        }
      }
    }
  }
}
    `;

/**
 * __useListBulkNotificationsQuery__
 *
 * To run a query within a React component, call `useListBulkNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBulkNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBulkNotificationsQuery({
 *   variables: {
 *      startRunningDate_Gte: // value for 'startRunningDate_Gte'
 *      startRunningDate_Lte: // value for 'startRunningDate_Lte'
 *      status_In: // value for 'status_In'
 *      viaWhatsapp: // value for 'viaWhatsapp'
 *      viaEmail: // value for 'viaEmail'
 *      viaWhatsappOfficial: // value for 'viaWhatsappOfficial'
 *      viaZekiCrm: // value for 'viaZekiCrm'
 *      title_Icontains: // value for 'title_Icontains'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListBulkNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>(ListBulkNotificationsDocument, options);
      }
export function useListBulkNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>(ListBulkNotificationsDocument, options);
        }
export function useListBulkNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>(ListBulkNotificationsDocument, options);
        }
export type ListBulkNotificationsQueryHookResult = ReturnType<typeof useListBulkNotificationsQuery>;
export type ListBulkNotificationsLazyQueryHookResult = ReturnType<typeof useListBulkNotificationsLazyQuery>;
export type ListBulkNotificationsSuspenseQueryHookResult = ReturnType<typeof useListBulkNotificationsSuspenseQuery>;
export type ListBulkNotificationsQueryResult = Apollo.QueryResult<ListBulkNotificationsQuery, ListBulkNotificationsQueryVariables>;
export const GetMassCampaignCustomersDocument = gql`
    query GetMassCampaignCustomers($bulkNotificationId: ID!, $before: String, $after: String, $first: Int = 12, $last: Int, $nameOrEmailOrPhone: String, $status_In: String, $messageStatus: String, $hasPurchase: String) {
  allBulkNotificationCustomersRelay(
    bulkNotificationId: $bulkNotificationId
    before: $before
    after: $after
    first: $first
    last: $last
    nameOrEmailOrPhone: $nameOrEmailOrPhone
    status_In: $status_In
    messageStatus: $messageStatus
    hasPurchase: $hasPurchase
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        pk
        customer {
          pk
        }
        name
        email
        phone
        messageStatus
        status
        bulknotificationcustomersalesSet {
          value
          purchase {
            pk
            date
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMassCampaignCustomersQuery__
 *
 * To run a query within a React component, call `useGetMassCampaignCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMassCampaignCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMassCampaignCustomersQuery({
 *   variables: {
 *      bulkNotificationId: // value for 'bulkNotificationId'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameOrEmailOrPhone: // value for 'nameOrEmailOrPhone'
 *      status_In: // value for 'status_In'
 *      messageStatus: // value for 'messageStatus'
 *      hasPurchase: // value for 'hasPurchase'
 *   },
 * });
 */
export function useGetMassCampaignCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>(GetMassCampaignCustomersDocument, options);
      }
export function useGetMassCampaignCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>(GetMassCampaignCustomersDocument, options);
        }
export function useGetMassCampaignCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>(GetMassCampaignCustomersDocument, options);
        }
export type GetMassCampaignCustomersQueryHookResult = ReturnType<typeof useGetMassCampaignCustomersQuery>;
export type GetMassCampaignCustomersLazyQueryHookResult = ReturnType<typeof useGetMassCampaignCustomersLazyQuery>;
export type GetMassCampaignCustomersSuspenseQueryHookResult = ReturnType<typeof useGetMassCampaignCustomersSuspenseQuery>;
export type GetMassCampaignCustomersQueryResult = Apollo.QueryResult<GetMassCampaignCustomersQuery, GetMassCampaignCustomersQueryVariables>;
export const PauseMassCampaignDocument = gql`
    mutation PauseMassCampaign($input: BulkNotificationPauseInput!) {
  pauseBulkNotification(input: $input) {
    success
  }
}
    `;
export type PauseMassCampaignMutationFn = Apollo.MutationFunction<PauseMassCampaignMutation, PauseMassCampaignMutationVariables>;

/**
 * __usePauseMassCampaignMutation__
 *
 * To run a mutation, you first call `usePauseMassCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseMassCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseMassCampaignMutation, { data, loading, error }] = usePauseMassCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseMassCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PauseMassCampaignMutation, PauseMassCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseMassCampaignMutation, PauseMassCampaignMutationVariables>(PauseMassCampaignDocument, options);
      }
export type PauseMassCampaignMutationHookResult = ReturnType<typeof usePauseMassCampaignMutation>;
export type PauseMassCampaignMutationResult = Apollo.MutationResult<PauseMassCampaignMutation>;
export type PauseMassCampaignMutationOptions = Apollo.BaseMutationOptions<PauseMassCampaignMutation, PauseMassCampaignMutationVariables>;
export const RescheduleCampaignDocument = gql`
    mutation RescheduleCampaign($input: BulkNotificationRescheduleCampaignInput!) {
  rescheduleBulkNotificationCampaign(input: $input) {
    success
    bulkNotification {
      pk
    }
  }
}
    `;
export type RescheduleCampaignMutationFn = Apollo.MutationFunction<RescheduleCampaignMutation, RescheduleCampaignMutationVariables>;

/**
 * __useRescheduleCampaignMutation__
 *
 * To run a mutation, you first call `useRescheduleCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleCampaignMutation, { data, loading, error }] = useRescheduleCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleCampaignMutation, RescheduleCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleCampaignMutation, RescheduleCampaignMutationVariables>(RescheduleCampaignDocument, options);
      }
export type RescheduleCampaignMutationHookResult = ReturnType<typeof useRescheduleCampaignMutation>;
export type RescheduleCampaignMutationResult = Apollo.MutationResult<RescheduleCampaignMutation>;
export type RescheduleCampaignMutationOptions = Apollo.BaseMutationOptions<RescheduleCampaignMutation, RescheduleCampaignMutationVariables>;
export const SendCampaignDocument = gql`
    mutation SendCampaign($input: BulkNotificationSendCampaignInput!) {
  sendBulkNotificationCampaign(input: $input) {
    success
  }
}
    `;
export type SendCampaignMutationFn = Apollo.MutationFunction<SendCampaignMutation, SendCampaignMutationVariables>;

/**
 * __useSendCampaignMutation__
 *
 * To run a mutation, you first call `useSendCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCampaignMutation, { data, loading, error }] = useSendCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SendCampaignMutation, SendCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCampaignMutation, SendCampaignMutationVariables>(SendCampaignDocument, options);
      }
export type SendCampaignMutationHookResult = ReturnType<typeof useSendCampaignMutation>;
export type SendCampaignMutationResult = Apollo.MutationResult<SendCampaignMutation>;
export type SendCampaignMutationOptions = Apollo.BaseMutationOptions<SendCampaignMutation, SendCampaignMutationVariables>;
export const SendMassCampaignTestDocument = gql`
    mutation SendMassCampaignTest($input: BulkNotificationTestSendInput!) {
  sendBulkNotificationTest(input: $input) {
    success
    message
    remainingTests
  }
}
    `;
export type SendMassCampaignTestMutationFn = Apollo.MutationFunction<SendMassCampaignTestMutation, SendMassCampaignTestMutationVariables>;

/**
 * __useSendMassCampaignTestMutation__
 *
 * To run a mutation, you first call `useSendMassCampaignTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMassCampaignTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMassCampaignTestMutation, { data, loading, error }] = useSendMassCampaignTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMassCampaignTestMutation(baseOptions?: Apollo.MutationHookOptions<SendMassCampaignTestMutation, SendMassCampaignTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMassCampaignTestMutation, SendMassCampaignTestMutationVariables>(SendMassCampaignTestDocument, options);
      }
export type SendMassCampaignTestMutationHookResult = ReturnType<typeof useSendMassCampaignTestMutation>;
export type SendMassCampaignTestMutationResult = Apollo.MutationResult<SendMassCampaignTestMutation>;
export type SendMassCampaignTestMutationOptions = Apollo.BaseMutationOptions<SendMassCampaignTestMutation, SendMassCampaignTestMutationVariables>;
export const UpdateMassCampaignDocument = gql`
    mutation UpdateMassCampaign($input: BulkNotificationUpdateInput!) {
  updateBulkNotification(input: $input) {
    success
  }
}
    `;
export type UpdateMassCampaignMutationFn = Apollo.MutationFunction<UpdateMassCampaignMutation, UpdateMassCampaignMutationVariables>;

/**
 * __useUpdateMassCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateMassCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMassCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMassCampaignMutation, { data, loading, error }] = useUpdateMassCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMassCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMassCampaignMutation, UpdateMassCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMassCampaignMutation, UpdateMassCampaignMutationVariables>(UpdateMassCampaignDocument, options);
      }
export type UpdateMassCampaignMutationHookResult = ReturnType<typeof useUpdateMassCampaignMutation>;
export type UpdateMassCampaignMutationResult = Apollo.MutationResult<UpdateMassCampaignMutation>;
export type UpdateMassCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateMassCampaignMutation, UpdateMassCampaignMutationVariables>;
export const UpdateBulkNotificationCustomerDataDocument = gql`
    mutation UpdateBulkNotificationCustomerData($input: BulkNotificationUpdateCustomerDataInput!) {
  updateBulkNotificationCustomerData(input: $input) {
    success
    message
  }
}
    `;
export type UpdateBulkNotificationCustomerDataMutationFn = Apollo.MutationFunction<UpdateBulkNotificationCustomerDataMutation, UpdateBulkNotificationCustomerDataMutationVariables>;

/**
 * __useUpdateBulkNotificationCustomerDataMutation__
 *
 * To run a mutation, you first call `useUpdateBulkNotificationCustomerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkNotificationCustomerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkNotificationCustomerDataMutation, { data, loading, error }] = useUpdateBulkNotificationCustomerDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkNotificationCustomerDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkNotificationCustomerDataMutation, UpdateBulkNotificationCustomerDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkNotificationCustomerDataMutation, UpdateBulkNotificationCustomerDataMutationVariables>(UpdateBulkNotificationCustomerDataDocument, options);
      }
export type UpdateBulkNotificationCustomerDataMutationHookResult = ReturnType<typeof useUpdateBulkNotificationCustomerDataMutation>;
export type UpdateBulkNotificationCustomerDataMutationResult = Apollo.MutationResult<UpdateBulkNotificationCustomerDataMutation>;
export type UpdateBulkNotificationCustomerDataMutationOptions = Apollo.BaseMutationOptions<UpdateBulkNotificationCustomerDataMutation, UpdateBulkNotificationCustomerDataMutationVariables>;
export const CashRegisterCashAvailableDocument = gql`
    query CashRegisterCashAvailable($businessDate: Date!) {
  cashRegisterCashAvailable(businessDate: $businessDate)
}
    `;

/**
 * __useCashRegisterCashAvailableQuery__
 *
 * To run a query within a React component, call `useCashRegisterCashAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterCashAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegisterCashAvailableQuery({
 *   variables: {
 *      businessDate: // value for 'businessDate'
 *   },
 * });
 */
export function useCashRegisterCashAvailableQuery(baseOptions: Apollo.QueryHookOptions<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>(CashRegisterCashAvailableDocument, options);
      }
export function useCashRegisterCashAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>(CashRegisterCashAvailableDocument, options);
        }
export function useCashRegisterCashAvailableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>(CashRegisterCashAvailableDocument, options);
        }
export type CashRegisterCashAvailableQueryHookResult = ReturnType<typeof useCashRegisterCashAvailableQuery>;
export type CashRegisterCashAvailableLazyQueryHookResult = ReturnType<typeof useCashRegisterCashAvailableLazyQuery>;
export type CashRegisterCashAvailableSuspenseQueryHookResult = ReturnType<typeof useCashRegisterCashAvailableSuspenseQuery>;
export type CashRegisterCashAvailableQueryResult = Apollo.QueryResult<CashRegisterCashAvailableQuery, CashRegisterCashAvailableQueryVariables>;
export const CashRegisterSangriasDocument = gql`
    query CashRegisterSangrias($businessDate: Date!) {
  cashRegisterSangrias(businessDate: $businessDate) {
    pk
    amount
    businessDate
    notes
    createdAt
    operatorName
  }
}
    `;

/**
 * __useCashRegisterSangriasQuery__
 *
 * To run a query within a React component, call `useCashRegisterSangriasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterSangriasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegisterSangriasQuery({
 *   variables: {
 *      businessDate: // value for 'businessDate'
 *   },
 * });
 */
export function useCashRegisterSangriasQuery(baseOptions: Apollo.QueryHookOptions<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>(CashRegisterSangriasDocument, options);
      }
export function useCashRegisterSangriasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>(CashRegisterSangriasDocument, options);
        }
export function useCashRegisterSangriasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>(CashRegisterSangriasDocument, options);
        }
export type CashRegisterSangriasQueryHookResult = ReturnType<typeof useCashRegisterSangriasQuery>;
export type CashRegisterSangriasLazyQueryHookResult = ReturnType<typeof useCashRegisterSangriasLazyQuery>;
export type CashRegisterSangriasSuspenseQueryHookResult = ReturnType<typeof useCashRegisterSangriasSuspenseQuery>;
export type CashRegisterSangriasQueryResult = Apollo.QueryResult<CashRegisterSangriasQuery, CashRegisterSangriasQueryVariables>;
export const CreateCashRegisterSangriaDocument = gql`
    mutation CreateCashRegisterSangria($input: CreateCashRegisterSangriaInput!) {
  cashRegisterSangriaCreate(input: $input) {
    success
    error
    cashAvailable
    cashRegisterMovement {
      pk
      amount
      businessDate
      notes
      createdAt
      operatorName
    }
  }
}
    `;
export type CreateCashRegisterSangriaMutationFn = Apollo.MutationFunction<CreateCashRegisterSangriaMutation, CreateCashRegisterSangriaMutationVariables>;

/**
 * __useCreateCashRegisterSangriaMutation__
 *
 * To run a mutation, you first call `useCreateCashRegisterSangriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashRegisterSangriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashRegisterSangriaMutation, { data, loading, error }] = useCreateCashRegisterSangriaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashRegisterSangriaMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashRegisterSangriaMutation, CreateCashRegisterSangriaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashRegisterSangriaMutation, CreateCashRegisterSangriaMutationVariables>(CreateCashRegisterSangriaDocument, options);
      }
export type CreateCashRegisterSangriaMutationHookResult = ReturnType<typeof useCreateCashRegisterSangriaMutation>;
export type CreateCashRegisterSangriaMutationResult = Apollo.MutationResult<CreateCashRegisterSangriaMutation>;
export type CreateCashRegisterSangriaMutationOptions = Apollo.BaseMutationOptions<CreateCashRegisterSangriaMutation, CreateCashRegisterSangriaMutationVariables>;
export const CreatePurchasePdvDocument = gql`
    mutation CreatePurchasePDV($purchaseInput: CreatePurchaseInput!) {
  purchaseCreate(purchaseInput: $purchaseInput) {
    success
    error
    purchase {
      pk
    }
  }
}
    `;
export type CreatePurchasePdvMutationFn = Apollo.MutationFunction<CreatePurchasePdvMutation, CreatePurchasePdvMutationVariables>;

/**
 * __useCreatePurchasePdvMutation__
 *
 * To run a mutation, you first call `useCreatePurchasePdvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchasePdvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchasePdvMutation, { data, loading, error }] = useCreatePurchasePdvMutation({
 *   variables: {
 *      purchaseInput: // value for 'purchaseInput'
 *   },
 * });
 */
export function useCreatePurchasePdvMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchasePdvMutation, CreatePurchasePdvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchasePdvMutation, CreatePurchasePdvMutationVariables>(CreatePurchasePdvDocument, options);
      }
export type CreatePurchasePdvMutationHookResult = ReturnType<typeof useCreatePurchasePdvMutation>;
export type CreatePurchasePdvMutationResult = Apollo.MutationResult<CreatePurchasePdvMutation>;
export type CreatePurchasePdvMutationOptions = Apollo.BaseMutationOptions<CreatePurchasePdvMutation, CreatePurchasePdvMutationVariables>;
export const GetCustomerStepDocument = gql`
    query GetCustomerStep($phone: String, $phoneOrTaxDocument: String, $taxDocument: String, $id: Float) {
  allCustomersRelay(
    phone: $phone
    phoneOrTaxDocument: $phoneOrTaxDocument
    taxDocument: $taxDocument
    id: $id
  ) {
    edges {
      node {
        pk
        name
        email
        phone
        taxDocument
        gender
        state
        city
        id
        dateOfBirth
        isActive
        store {
          giftbackconfig {
            multiplegiftbackconfigSet {
              id
              minPurchaseValueForRedeem
              minimumValueType
              maximumDiscountPercentage
            }
          }
        }
        tags {
          edges {
            node {
              pk
              name
            }
          }
        }
        giftbackSet(status: "ACTIVE") {
          edges {
            node {
              value
              code
              dueDate
              minValueToRedeem
              status
              importedFrom
              purchase {
                value
                id
              }
              store {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerStepQuery__
 *
 * To run a query within a React component, call `useGetCustomerStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerStepQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      phoneOrTaxDocument: // value for 'phoneOrTaxDocument'
 *      taxDocument: // value for 'taxDocument'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerStepQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerStepQuery, GetCustomerStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerStepQuery, GetCustomerStepQueryVariables>(GetCustomerStepDocument, options);
      }
export function useGetCustomerStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerStepQuery, GetCustomerStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerStepQuery, GetCustomerStepQueryVariables>(GetCustomerStepDocument, options);
        }
export function useGetCustomerStepSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerStepQuery, GetCustomerStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerStepQuery, GetCustomerStepQueryVariables>(GetCustomerStepDocument, options);
        }
export type GetCustomerStepQueryHookResult = ReturnType<typeof useGetCustomerStepQuery>;
export type GetCustomerStepLazyQueryHookResult = ReturnType<typeof useGetCustomerStepLazyQuery>;
export type GetCustomerStepSuspenseQueryHookResult = ReturnType<typeof useGetCustomerStepSuspenseQuery>;
export type GetCustomerStepQueryResult = Apollo.QueryResult<GetCustomerStepQuery, GetCustomerStepQueryVariables>;
export const PlanningEventsDocument = gql`
    query PlanningEvents($startsAt: DateTime!, $endsAt: DateTime!, $sources: [PlanningEventSource!], $statuses: [PlanningEventStatus!], $communityId: ID, $first: Int, $after: String, $timeZone: String) {
  planningEvents(
    startsAt: $startsAt
    endsAt: $endsAt
    sources: $sources
    statuses: $statuses
    communityId: $communityId
    first: $first
    after: $after
    timeZone: $timeZone
  ) {
    items {
      ...PlanningEventFields
    }
    total
    hasNextPage
    endCursor
    availableSources
    undatedCampaignCount
    campaignTimeZone
  }
}
    ${PlanningEventFieldsFragmentDoc}`;

/**
 * __usePlanningEventsQuery__
 *
 * To run a query within a React component, call `usePlanningEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningEventsQuery({
 *   variables: {
 *      startsAt: // value for 'startsAt'
 *      endsAt: // value for 'endsAt'
 *      sources: // value for 'sources'
 *      statuses: // value for 'statuses'
 *      communityId: // value for 'communityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function usePlanningEventsQuery(baseOptions: Apollo.QueryHookOptions<PlanningEventsQuery, PlanningEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningEventsQuery, PlanningEventsQueryVariables>(PlanningEventsDocument, options);
      }
export function usePlanningEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningEventsQuery, PlanningEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningEventsQuery, PlanningEventsQueryVariables>(PlanningEventsDocument, options);
        }
export function usePlanningEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlanningEventsQuery, PlanningEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanningEventsQuery, PlanningEventsQueryVariables>(PlanningEventsDocument, options);
        }
export type PlanningEventsQueryHookResult = ReturnType<typeof usePlanningEventsQuery>;
export type PlanningEventsLazyQueryHookResult = ReturnType<typeof usePlanningEventsLazyQuery>;
export type PlanningEventsSuspenseQueryHookResult = ReturnType<typeof usePlanningEventsSuspenseQuery>;
export type PlanningEventsQueryResult = Apollo.QueryResult<PlanningEventsQuery, PlanningEventsQueryVariables>;
export const GetStoreModulePermissionsDocument = gql`
    query GetStoreModulePermissions {
  getStoreModulePermissions {
    hasReports
    hasRfm
    hasMessageTemplates
    hasDashboards
    hasProducts
    hasPdv
    hasServices
    hasAppointments
    hasBulkNotification
    hasJourneys
    hasCoupons
    hasLoyalty
    hasOrderDeliveryDataPermission
    hasCommunicationIntegrations
    hasErpIntegrations
    hasEcommerceIntegrations
  }
}
    `;

/**
 * __useGetStoreModulePermissionsQuery__
 *
 * To run a query within a React component, call `useGetStoreModulePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreModulePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreModulePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoreModulePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>(GetStoreModulePermissionsDocument, options);
      }
export function useGetStoreModulePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>(GetStoreModulePermissionsDocument, options);
        }
export function useGetStoreModulePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>(GetStoreModulePermissionsDocument, options);
        }
export type GetStoreModulePermissionsQueryHookResult = ReturnType<typeof useGetStoreModulePermissionsQuery>;
export type GetStoreModulePermissionsLazyQueryHookResult = ReturnType<typeof useGetStoreModulePermissionsLazyQuery>;
export type GetStoreModulePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetStoreModulePermissionsSuspenseQuery>;
export type GetStoreModulePermissionsQueryResult = Apollo.QueryResult<GetStoreModulePermissionsQuery, GetStoreModulePermissionsQueryVariables>;
export const ProductCreateDocument = gql`
    mutation ProductCreate($productsInput: [CreateProductBulkInput]) {
  productBulkCreate(productsInput: $productsInput) {
    ok
    error
    product {
      id
      name
      value
      costValue
      wholesaleValue
    }
  }
}
    `;
export type ProductCreateMutationFn = Apollo.MutationFunction<ProductCreateMutation, ProductCreateMutationVariables>;

/**
 * __useProductCreateMutation__
 *
 * To run a mutation, you first call `useProductCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCreateMutation, { data, loading, error }] = useProductCreateMutation({
 *   variables: {
 *      productsInput: // value for 'productsInput'
 *   },
 * });
 */
export function useProductCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductCreateMutation, ProductCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCreateMutation, ProductCreateMutationVariables>(ProductCreateDocument, options);
      }
export type ProductCreateMutationHookResult = ReturnType<typeof useProductCreateMutation>;
export type ProductCreateMutationResult = Apollo.MutationResult<ProductCreateMutation>;
export type ProductCreateMutationOptions = Apollo.BaseMutationOptions<ProductCreateMutation, ProductCreateMutationVariables>;
export const CategoryListDocument = gql`
    query CategoryList($name_Icontains: String, $first: Int, $after: String, $importedFrom: String) {
  categoryList(
    name_Icontains: $name_Icontains
    first: $first
    after: $after
    importedFrom: $importedFrom
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        pk
        name
        integrationId
      }
    }
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *      name_Icontains: // value for 'name_Icontains'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      importedFrom: // value for 'importedFrom'
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export function useCategoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListSuspenseQueryHookResult = ReturnType<typeof useCategoryListSuspenseQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export const GetAllProductsDocument = gql`
    query GetAllProducts($first: Int = 20, $name_Icontains: String) {
  allProductsRelay(first: $first, name_Icontains: $name_Icontains) {
    edges {
      node {
        pk
        name
        value
        wholesaleValue
        costValue
        stock
      }
    }
  }
}
    `;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      name_Icontains: // value for 'name_Icontains'
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
      }
export function useGetAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductsSuspenseQuery>;
export type GetAllProductsQueryResult = Apollo.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($id: ID!) {
  getProduct(id: $id) {
    id
    name
    value
    costValue
    wholesaleValue
    stock
    integrationId
    importedFrom
    categories {
      edges {
        node {
          id
          pk
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetReportProductDocument = gql`
    query GetReportProduct($input: ProductFilterSetInput!) {
  productExcelReport(input: $input) {
    relatorio
    background
  }
}
    `;

/**
 * __useGetReportProductQuery__
 *
 * To run a query within a React component, call `useGetReportProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReportProductQuery(baseOptions: Apollo.QueryHookOptions<GetReportProductQuery, GetReportProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportProductQuery, GetReportProductQueryVariables>(GetReportProductDocument, options);
      }
export function useGetReportProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportProductQuery, GetReportProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportProductQuery, GetReportProductQueryVariables>(GetReportProductDocument, options);
        }
export function useGetReportProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportProductQuery, GetReportProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportProductQuery, GetReportProductQueryVariables>(GetReportProductDocument, options);
        }
export type GetReportProductQueryHookResult = ReturnType<typeof useGetReportProductQuery>;
export type GetReportProductLazyQueryHookResult = ReturnType<typeof useGetReportProductLazyQuery>;
export type GetReportProductSuspenseQueryHookResult = ReturnType<typeof useGetReportProductSuspenseQuery>;
export type GetReportProductQueryResult = Apollo.QueryResult<GetReportProductQuery, GetReportProductQueryVariables>;
export const ListAllProductsDocument = gql`
    query ListAllProducts($before: String, $after: String, $first: Int, $last: Int, $id: Float, $name_Icontains: String, $categoriesNames: String, $importedFrom: String, $importedFrom_In: String, $isActivated: Boolean) {
  allProductsRelay(
    before: $before
    after: $after
    first: $first
    last: $last
    id: $id
    name_Icontains: $name_Icontains
    categoriesNames: $categoriesNames
    importedFrom: $importedFrom
    importedFrom_In: $importedFrom_In
    isActivated: $isActivated
  ) {
    edgeCount
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        pk
        name
        integrationId
        isActivated
        value
        costValue
        wholesaleValue
        categories {
          edges {
            node {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListAllProductsQuery__
 *
 * To run a query within a React component, call `useListAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllProductsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      id: // value for 'id'
 *      name_Icontains: // value for 'name_Icontains'
 *      categoriesNames: // value for 'categoriesNames'
 *      importedFrom: // value for 'importedFrom'
 *      importedFrom_In: // value for 'importedFrom_In'
 *      isActivated: // value for 'isActivated'
 *   },
 * });
 */
export function useListAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllProductsQuery, ListAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllProductsQuery, ListAllProductsQueryVariables>(ListAllProductsDocument, options);
      }
export function useListAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllProductsQuery, ListAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllProductsQuery, ListAllProductsQueryVariables>(ListAllProductsDocument, options);
        }
export function useListAllProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAllProductsQuery, ListAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllProductsQuery, ListAllProductsQueryVariables>(ListAllProductsDocument, options);
        }
export type ListAllProductsQueryHookResult = ReturnType<typeof useListAllProductsQuery>;
export type ListAllProductsLazyQueryHookResult = ReturnType<typeof useListAllProductsLazyQuery>;
export type ListAllProductsSuspenseQueryHookResult = ReturnType<typeof useListAllProductsSuspenseQuery>;
export type ListAllProductsQueryResult = Apollo.QueryResult<ListAllProductsQuery, ListAllProductsQueryVariables>;
export const ProductUpdateDocument = gql`
    mutation ProductUpdate($productInput: UpdateProductInput!) {
  productUpdate(productInput: $productInput) {
    ok
    product {
      id
      value
      costValue
      wholesaleValue
    }
  }
}
    `;
export type ProductUpdateMutationFn = Apollo.MutationFunction<ProductUpdateMutation, ProductUpdateMutationVariables>;

/**
 * __useProductUpdateMutation__
 *
 * To run a mutation, you first call `useProductUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productUpdateMutation, { data, loading, error }] = useProductUpdateMutation({
 *   variables: {
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useProductUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductUpdateMutation, ProductUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductUpdateMutation, ProductUpdateMutationVariables>(ProductUpdateDocument, options);
      }
export type ProductUpdateMutationHookResult = ReturnType<typeof useProductUpdateMutation>;
export type ProductUpdateMutationResult = Apollo.MutationResult<ProductUpdateMutation>;
export type ProductUpdateMutationOptions = Apollo.BaseMutationOptions<ProductUpdateMutation, ProductUpdateMutationVariables>;
export const AcceptTermsMutationDocument = gql`
    mutation AcceptTermsMutation($termsId: [ID]) {
  acceptTerms(termsId: $termsId) {
    ok
  }
}
    `;
export type AcceptTermsMutationMutationFn = Apollo.MutationFunction<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>;

/**
 * __useAcceptTermsMutationMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutationMutation, { data, loading, error }] = useAcceptTermsMutationMutation({
 *   variables: {
 *      termsId: // value for 'termsId'
 *   },
 * });
 */
export function useAcceptTermsMutationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>(AcceptTermsMutationDocument, options);
      }
export type AcceptTermsMutationMutationHookResult = ReturnType<typeof useAcceptTermsMutationMutation>;
export type AcceptTermsMutationMutationResult = Apollo.MutationResult<AcceptTermsMutationMutation>;
export type AcceptTermsMutationMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>;
export const GetConnectedStoreChartsConfigDocument = gql`
    query GetConnectedStoreChartsConfig {
  me {
    connectedStore {
      customerSet {
        edgeCount
      }
      chartsconfig {
        tags
        gender
        yearRange
        city
        state
      }
    }
  }
}
    `;

/**
 * __useGetConnectedStoreChartsConfigQuery__
 *
 * To run a query within a React component, call `useGetConnectedStoreChartsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedStoreChartsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedStoreChartsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectedStoreChartsConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>(GetConnectedStoreChartsConfigDocument, options);
      }
export function useGetConnectedStoreChartsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>(GetConnectedStoreChartsConfigDocument, options);
        }
export function useGetConnectedStoreChartsConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>(GetConnectedStoreChartsConfigDocument, options);
        }
export type GetConnectedStoreChartsConfigQueryHookResult = ReturnType<typeof useGetConnectedStoreChartsConfigQuery>;
export type GetConnectedStoreChartsConfigLazyQueryHookResult = ReturnType<typeof useGetConnectedStoreChartsConfigLazyQuery>;
export type GetConnectedStoreChartsConfigSuspenseQueryHookResult = ReturnType<typeof useGetConnectedStoreChartsConfigSuspenseQuery>;
export type GetConnectedStoreChartsConfigQueryResult = Apollo.QueryResult<GetConnectedStoreChartsConfigQuery, GetConnectedStoreChartsConfigQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile {
  me {
    email
    firstName
    lastName
    pk
    name
    gender
    connectedStore {
      id
      name
      plan
      isActive
      currencyType
      profileImage
      hasCompletePdv
      hasBulkNotificationPermission
      totalNotificationCredits
      usedNotificationCredits
      extraNotificationCredits
      availableNotificationCredits
    }
    permissions {
      id
      store {
        name
        id
        plan
        isActive
        profileImage
      }
      userType
    }
    acceptedTerm
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export function useGetProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileSuspenseQueryHookResult = ReturnType<typeof useGetProfileSuspenseQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const NotAcceptedTermsDocument = gql`
    query NotAcceptedTerms {
  allTerms {
    pk
    termType
    content
  }
}
    `;

/**
 * __useNotAcceptedTermsQuery__
 *
 * To run a query within a React component, call `useNotAcceptedTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotAcceptedTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotAcceptedTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotAcceptedTermsQuery(baseOptions?: Apollo.QueryHookOptions<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>(NotAcceptedTermsDocument, options);
      }
export function useNotAcceptedTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>(NotAcceptedTermsDocument, options);
        }
export function useNotAcceptedTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>(NotAcceptedTermsDocument, options);
        }
export type NotAcceptedTermsQueryHookResult = ReturnType<typeof useNotAcceptedTermsQuery>;
export type NotAcceptedTermsLazyQueryHookResult = ReturnType<typeof useNotAcceptedTermsLazyQuery>;
export type NotAcceptedTermsSuspenseQueryHookResult = ReturnType<typeof useNotAcceptedTermsSuspenseQuery>;
export type NotAcceptedTermsQueryResult = Apollo.QueryResult<NotAcceptedTermsQuery, NotAcceptedTermsQueryVariables>;
export const UpdateMyConnectedStoreDocument = gql`
    mutation UpdateMyConnectedStore($storeId: ID!) {
  updateUserConnectedStore(storeId: $storeId) {
    ok
  }
}
    `;
export type UpdateMyConnectedStoreMutationFn = Apollo.MutationFunction<UpdateMyConnectedStoreMutation, UpdateMyConnectedStoreMutationVariables>;

/**
 * __useUpdateMyConnectedStoreMutation__
 *
 * To run a mutation, you first call `useUpdateMyConnectedStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyConnectedStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyConnectedStoreMutation, { data, loading, error }] = useUpdateMyConnectedStoreMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useUpdateMyConnectedStoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyConnectedStoreMutation, UpdateMyConnectedStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyConnectedStoreMutation, UpdateMyConnectedStoreMutationVariables>(UpdateMyConnectedStoreDocument, options);
      }
export type UpdateMyConnectedStoreMutationHookResult = ReturnType<typeof useUpdateMyConnectedStoreMutation>;
export type UpdateMyConnectedStoreMutationResult = Apollo.MutationResult<UpdateMyConnectedStoreMutation>;
export type UpdateMyConnectedStoreMutationOptions = Apollo.BaseMutationOptions<UpdateMyConnectedStoreMutation, UpdateMyConnectedStoreMutationVariables>;
export const CancelPurchaseActionDocument = gql`
    mutation CancelPurchaseAction($purchaseInput: CancelPurchaseInput!) {
  cancelPurchase(purchaseInput: $purchaseInput) {
    purchase {
      id
      value
      canceledBy
    }
  }
}
    `;
export type CancelPurchaseActionMutationFn = Apollo.MutationFunction<CancelPurchaseActionMutation, CancelPurchaseActionMutationVariables>;

/**
 * __useCancelPurchaseActionMutation__
 *
 * To run a mutation, you first call `useCancelPurchaseActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPurchaseActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPurchaseActionMutation, { data, loading, error }] = useCancelPurchaseActionMutation({
 *   variables: {
 *      purchaseInput: // value for 'purchaseInput'
 *   },
 * });
 */
export function useCancelPurchaseActionMutation(baseOptions?: Apollo.MutationHookOptions<CancelPurchaseActionMutation, CancelPurchaseActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPurchaseActionMutation, CancelPurchaseActionMutationVariables>(CancelPurchaseActionDocument, options);
      }
export type CancelPurchaseActionMutationHookResult = ReturnType<typeof useCancelPurchaseActionMutation>;
export type CancelPurchaseActionMutationResult = Apollo.MutationResult<CancelPurchaseActionMutation>;
export type CancelPurchaseActionMutationOptions = Apollo.BaseMutationOptions<CancelPurchaseActionMutation, CancelPurchaseActionMutationVariables>;
export const CashRegisterClosingPreviewDocument = gql`
    query CashRegisterClosingPreview($businessDate: Date!) {
  cashRegisterClosingPreview(businessDate: $businessDate) {
    ...CashRegisterClosingFields
  }
}
    ${CashRegisterClosingFieldsFragmentDoc}`;

/**
 * __useCashRegisterClosingPreviewQuery__
 *
 * To run a query within a React component, call `useCashRegisterClosingPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterClosingPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegisterClosingPreviewQuery({
 *   variables: {
 *      businessDate: // value for 'businessDate'
 *   },
 * });
 */
export function useCashRegisterClosingPreviewQuery(baseOptions: Apollo.QueryHookOptions<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>(CashRegisterClosingPreviewDocument, options);
      }
export function useCashRegisterClosingPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>(CashRegisterClosingPreviewDocument, options);
        }
export function useCashRegisterClosingPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>(CashRegisterClosingPreviewDocument, options);
        }
export type CashRegisterClosingPreviewQueryHookResult = ReturnType<typeof useCashRegisterClosingPreviewQuery>;
export type CashRegisterClosingPreviewLazyQueryHookResult = ReturnType<typeof useCashRegisterClosingPreviewLazyQuery>;
export type CashRegisterClosingPreviewSuspenseQueryHookResult = ReturnType<typeof useCashRegisterClosingPreviewSuspenseQuery>;
export type CashRegisterClosingPreviewQueryResult = Apollo.QueryResult<CashRegisterClosingPreviewQuery, CashRegisterClosingPreviewQueryVariables>;
export const CashRegisterClosingDocument = gql`
    query CashRegisterClosing($businessDate: Date!) {
  cashRegisterClosing(businessDate: $businessDate) {
    ...CashRegisterClosingFields
  }
}
    ${CashRegisterClosingFieldsFragmentDoc}`;

/**
 * __useCashRegisterClosingQuery__
 *
 * To run a query within a React component, call `useCashRegisterClosingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterClosingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegisterClosingQuery({
 *   variables: {
 *      businessDate: // value for 'businessDate'
 *   },
 * });
 */
export function useCashRegisterClosingQuery(baseOptions: Apollo.QueryHookOptions<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>(CashRegisterClosingDocument, options);
      }
export function useCashRegisterClosingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>(CashRegisterClosingDocument, options);
        }
export function useCashRegisterClosingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>(CashRegisterClosingDocument, options);
        }
export type CashRegisterClosingQueryHookResult = ReturnType<typeof useCashRegisterClosingQuery>;
export type CashRegisterClosingLazyQueryHookResult = ReturnType<typeof useCashRegisterClosingLazyQuery>;
export type CashRegisterClosingSuspenseQueryHookResult = ReturnType<typeof useCashRegisterClosingSuspenseQuery>;
export type CashRegisterClosingQueryResult = Apollo.QueryResult<CashRegisterClosingQuery, CashRegisterClosingQueryVariables>;
export const CashRegisterClosingsDocument = gql`
    query CashRegisterClosings($businessDate: Date!) {
  cashRegisterClosings(businessDate: $businessDate) {
    ...CashRegisterClosingFields
  }
}
    ${CashRegisterClosingFieldsFragmentDoc}`;

/**
 * __useCashRegisterClosingsQuery__
 *
 * To run a query within a React component, call `useCashRegisterClosingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashRegisterClosingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashRegisterClosingsQuery({
 *   variables: {
 *      businessDate: // value for 'businessDate'
 *   },
 * });
 */
export function useCashRegisterClosingsQuery(baseOptions: Apollo.QueryHookOptions<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>(CashRegisterClosingsDocument, options);
      }
export function useCashRegisterClosingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>(CashRegisterClosingsDocument, options);
        }
export function useCashRegisterClosingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>(CashRegisterClosingsDocument, options);
        }
export type CashRegisterClosingsQueryHookResult = ReturnType<typeof useCashRegisterClosingsQuery>;
export type CashRegisterClosingsLazyQueryHookResult = ReturnType<typeof useCashRegisterClosingsLazyQuery>;
export type CashRegisterClosingsSuspenseQueryHookResult = ReturnType<typeof useCashRegisterClosingsSuspenseQuery>;
export type CashRegisterClosingsQueryResult = Apollo.QueryResult<CashRegisterClosingsQuery, CashRegisterClosingsQueryVariables>;
export const SaveCashRegisterClosingDocument = gql`
    mutation SaveCashRegisterClosing($input: SaveCashRegisterClosingInput!) {
  cashRegisterClosingSave(input: $input) {
    success
    error
    cashRegisterClosing {
      ...CashRegisterClosingFields
    }
  }
}
    ${CashRegisterClosingFieldsFragmentDoc}`;
export type SaveCashRegisterClosingMutationFn = Apollo.MutationFunction<SaveCashRegisterClosingMutation, SaveCashRegisterClosingMutationVariables>;

/**
 * __useSaveCashRegisterClosingMutation__
 *
 * To run a mutation, you first call `useSaveCashRegisterClosingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCashRegisterClosingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCashRegisterClosingMutation, { data, loading, error }] = useSaveCashRegisterClosingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCashRegisterClosingMutation(baseOptions?: Apollo.MutationHookOptions<SaveCashRegisterClosingMutation, SaveCashRegisterClosingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCashRegisterClosingMutation, SaveCashRegisterClosingMutationVariables>(SaveCashRegisterClosingDocument, options);
      }
export type SaveCashRegisterClosingMutationHookResult = ReturnType<typeof useSaveCashRegisterClosingMutation>;
export type SaveCashRegisterClosingMutationResult = Apollo.MutationResult<SaveCashRegisterClosingMutation>;
export type SaveCashRegisterClosingMutationOptions = Apollo.BaseMutationOptions<SaveCashRegisterClosingMutation, SaveCashRegisterClosingMutationVariables>;
export const GetPurchaseInvoiceDetailDocument = gql`
    query GetPurchaseInvoiceDetail($id: ID!) {
  getPurchase(id: $id) {
    pk
    paymentMethod
    purchasepaymentmethodSet {
      pk
      name
      value
      installments
    }
    issueDate
    status
    importedFrom
    shipmentValue
    discountType
    discountValue
    value
    notes
    giftbackRedeemedValue
    store {
      name
      telephone
      email
      address
      profileImage
      profileImageEmail
    }
    customer {
      pk
      name
      phone
      state
      city
      address
    }
    user {
      gender
    }
    purchaseproductSet {
      edges {
        node {
          pk
          quantity
          value
          subtotal
          product {
            name
            unit
          }
        }
      }
    }
    serviceItems {
      pk
      serviceName
      quantity
      value
      subtotal
      service {
        pk
        name
      }
      appointment {
        pk
      }
    }
    storeProfileImageBase64
  }
}
    `;

/**
 * __useGetPurchaseInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useGetPurchaseInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseInvoiceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPurchaseInvoiceDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>(GetPurchaseInvoiceDetailDocument, options);
      }
export function useGetPurchaseInvoiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>(GetPurchaseInvoiceDetailDocument, options);
        }
export function useGetPurchaseInvoiceDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>(GetPurchaseInvoiceDetailDocument, options);
        }
export type GetPurchaseInvoiceDetailQueryHookResult = ReturnType<typeof useGetPurchaseInvoiceDetailQuery>;
export type GetPurchaseInvoiceDetailLazyQueryHookResult = ReturnType<typeof useGetPurchaseInvoiceDetailLazyQuery>;
export type GetPurchaseInvoiceDetailSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseInvoiceDetailSuspenseQuery>;
export type GetPurchaseInvoiceDetailQueryResult = Apollo.QueryResult<GetPurchaseInvoiceDetailQuery, GetPurchaseInvoiceDetailQueryVariables>;
export const GetDetailPurchaseDocument = gql`
    query GetDetailPurchase($id: ID!) {
  getPurchase(id: $id) {
    integrationId
    erpIntegrationId
    canceledBy
    canceledAt
    date
    value
    paymentMethod
    purchasepaymentmethodSet {
      pk
      name
      value
      installments
    }
    importedFrom
    discountType
    discountValue
    coupon {
      code
      value
      valueType
    }
    sellerName
    justification
    store {
      name
    }
    user {
      name
    }
    pk
    customer {
      pk
      name
      email
      phone
      taxDocument
      state
      city
    }
    purchaseproductSet {
      edges {
        node {
          quantity
          subtotal
          value
          product {
            pk
            name
            unit
          }
        }
      }
    }
    serviceItems {
      pk
      serviceName
      quantity
      subtotal
      value
      service {
        pk
        name
      }
      appointment {
        pk
      }
    }
    giftback {
      pk
      status
      value
      dueDate
      code
    }
    giftbackRedeemed {
      pk
      code
      id
    }
    giftbackRedeemedValue
    credithousepurchase {
      installments
      tax
      pk
    }
    extraData
    nfeKey
    trackingCode
    trackingCodeUrl
    estimatedDeliveryDate
    deliveryAddress
    nfeLink
    volumesQuantity
    shipmentWeight
    transportCompany
  }
}
    `;

/**
 * __useGetDetailPurchaseQuery__
 *
 * To run a query within a React component, call `useGetDetailPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailPurchaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDetailPurchaseQuery(baseOptions: Apollo.QueryHookOptions<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>(GetDetailPurchaseDocument, options);
      }
export function useGetDetailPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>(GetDetailPurchaseDocument, options);
        }
export function useGetDetailPurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>(GetDetailPurchaseDocument, options);
        }
export type GetDetailPurchaseQueryHookResult = ReturnType<typeof useGetDetailPurchaseQuery>;
export type GetDetailPurchaseLazyQueryHookResult = ReturnType<typeof useGetDetailPurchaseLazyQuery>;
export type GetDetailPurchaseSuspenseQueryHookResult = ReturnType<typeof useGetDetailPurchaseSuspenseQuery>;
export type GetDetailPurchaseQueryResult = Apollo.QueryResult<GetDetailPurchaseQuery, GetDetailPurchaseQueryVariables>;
export const RelatorioFechamentoDeCaixaDocument = gql`
    query RelatorioFechamentoDeCaixa($periodStartedAt: DateTime!, $closedAt: DateTime!) {
  allPurchasesRelay(createdAt_Gte: $periodStartedAt, createdAt_Lt: $closedAt) {
    totalCount
    edges {
      node {
        value
        pk
        importedFrom
        paymentMethod
        canceledAt
        discountValue
        purchasepaymentmethodSet {
          pk
          name
          value
          installments
        }
        purchaseproductSet {
          edges {
            node {
              product {
                pk
                name
                unit
              }
              quantity
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRelatorioFechamentoDeCaixaQuery__
 *
 * To run a query within a React component, call `useRelatorioFechamentoDeCaixaQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatorioFechamentoDeCaixaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatorioFechamentoDeCaixaQuery({
 *   variables: {
 *      periodStartedAt: // value for 'periodStartedAt'
 *      closedAt: // value for 'closedAt'
 *   },
 * });
 */
export function useRelatorioFechamentoDeCaixaQuery(baseOptions: Apollo.QueryHookOptions<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>(RelatorioFechamentoDeCaixaDocument, options);
      }
export function useRelatorioFechamentoDeCaixaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>(RelatorioFechamentoDeCaixaDocument, options);
        }
export function useRelatorioFechamentoDeCaixaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>(RelatorioFechamentoDeCaixaDocument, options);
        }
export type RelatorioFechamentoDeCaixaQueryHookResult = ReturnType<typeof useRelatorioFechamentoDeCaixaQuery>;
export type RelatorioFechamentoDeCaixaLazyQueryHookResult = ReturnType<typeof useRelatorioFechamentoDeCaixaLazyQuery>;
export type RelatorioFechamentoDeCaixaSuspenseQueryHookResult = ReturnType<typeof useRelatorioFechamentoDeCaixaSuspenseQuery>;
export type RelatorioFechamentoDeCaixaQueryResult = Apollo.QueryResult<RelatorioFechamentoDeCaixaQuery, RelatorioFechamentoDeCaixaQueryVariables>;
export const ListPurchasesPageDocument = gql`
    query ListPurchasesPage($before: String, $after: String, $first: Int = 12, $last: Int, $customer_Phone_Icontains: String, $id: Float, $integrationId_In: String, $usernameOrEmailUser: String, $nameOrEmailCustomer: String, $value_Gte: Float, $value_Lte: Float, $date_Gte: Date, $date_Lte: Date, $importedFrom_In: String, $approvedOrCanceledSales: String, $sellerName_Icontains: String, $createdRedeemedGiftback: String, $productIds: String, $createdAt_Date_Gte: Date, $createdAt_Date_Lte: Date, $coupon_Code_Icontains: String) {
  purchaseAll: allPurchasesRelay {
    totalCount
  }
  purchaseApproved: allPurchasesRelay(approvedOrCanceledSales: "approved") {
    totalCount
  }
  purchaseCanceled: allPurchasesRelay(approvedOrCanceledSales: "canceled") {
    totalCount
  }
  allPurchasesRelay(
    before: $before
    after: $after
    first: $first
    last: $last
    customer_Phone_Icontains: $customer_Phone_Icontains
    id: $id
    integrationId_In: $integrationId_In
    usernameOrEmailUser: $usernameOrEmailUser
    nameOrEmailCustomer: $nameOrEmailCustomer
    value_Gte: $value_Gte
    value_Lte: $value_Lte
    date_Gte: $date_Gte
    date_Lte: $date_Lte
    importedFrom_In: $importedFrom_In
    approvedOrCanceledSales: $approvedOrCanceledSales
    sellerName_Icontains: $sellerName_Icontains
    createdRedeemedGiftback: $createdRedeemedGiftback
    productIds: $productIds
    createdAt_Date_Gte: $createdAt_Date_Gte
    createdAt_Date_Lte: $createdAt_Date_Lte
    coupon_Code_Icontains: $coupon_Code_Icontains
  ) {
    edgeCount
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        pk
        value
        date
        importedFrom
        canceledBy
        canceledAt
        customer {
          pk
          name
          email
        }
        purchaseproductSet {
          edges {
            node {
              quantity
              product {
                pk
                unit
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListPurchasesPageQuery__
 *
 * To run a query within a React component, call `useListPurchasesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPurchasesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPurchasesPageQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      customer_Phone_Icontains: // value for 'customer_Phone_Icontains'
 *      id: // value for 'id'
 *      integrationId_In: // value for 'integrationId_In'
 *      usernameOrEmailUser: // value for 'usernameOrEmailUser'
 *      nameOrEmailCustomer: // value for 'nameOrEmailCustomer'
 *      value_Gte: // value for 'value_Gte'
 *      value_Lte: // value for 'value_Lte'
 *      date_Gte: // value for 'date_Gte'
 *      date_Lte: // value for 'date_Lte'
 *      importedFrom_In: // value for 'importedFrom_In'
 *      approvedOrCanceledSales: // value for 'approvedOrCanceledSales'
 *      sellerName_Icontains: // value for 'sellerName_Icontains'
 *      createdRedeemedGiftback: // value for 'createdRedeemedGiftback'
 *      productIds: // value for 'productIds'
 *      createdAt_Date_Gte: // value for 'createdAt_Date_Gte'
 *      createdAt_Date_Lte: // value for 'createdAt_Date_Lte'
 *      coupon_Code_Icontains: // value for 'coupon_Code_Icontains'
 *   },
 * });
 */
export function useListPurchasesPageQuery(baseOptions?: Apollo.QueryHookOptions<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>(ListPurchasesPageDocument, options);
      }
export function useListPurchasesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>(ListPurchasesPageDocument, options);
        }
export function useListPurchasesPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>(ListPurchasesPageDocument, options);
        }
export type ListPurchasesPageQueryHookResult = ReturnType<typeof useListPurchasesPageQuery>;
export type ListPurchasesPageLazyQueryHookResult = ReturnType<typeof useListPurchasesPageLazyQuery>;
export type ListPurchasesPageSuspenseQueryHookResult = ReturnType<typeof useListPurchasesPageSuspenseQuery>;
export type ListPurchasesPageQueryResult = Apollo.QueryResult<ListPurchasesPageQuery, ListPurchasesPageQueryVariables>;
export const ListAllPurchasesDocument = gql`
    query ListAllPurchases($customer_Id: ID) {
  allPurchasesRelay(customer_Id: $customer_Id) {
    edges {
      node {
        pk
        value
        date
        importedFrom
        canceledBy
        canceledAt
        store {
          name
        }
        customeractivitySet {
          edges {
            node {
              activity
              title
              description
              pk
            }
          }
        }
        purchaseproductSet {
          edges {
            node {
              product {
                name
              }
            }
          }
        }
        serviceItems {
          serviceName
        }
      }
    }
  }
}
    `;

/**
 * __useListAllPurchasesQuery__
 *
 * To run a query within a React component, call `useListAllPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllPurchasesQuery({
 *   variables: {
 *      customer_Id: // value for 'customer_Id'
 *   },
 * });
 */
export function useListAllPurchasesQuery(baseOptions?: Apollo.QueryHookOptions<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>(ListAllPurchasesDocument, options);
      }
export function useListAllPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>(ListAllPurchasesDocument, options);
        }
export function useListAllPurchasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>(ListAllPurchasesDocument, options);
        }
export type ListAllPurchasesQueryHookResult = ReturnType<typeof useListAllPurchasesQuery>;
export type ListAllPurchasesLazyQueryHookResult = ReturnType<typeof useListAllPurchasesLazyQuery>;
export type ListAllPurchasesSuspenseQueryHookResult = ReturnType<typeof useListAllPurchasesSuspenseQuery>;
export type ListAllPurchasesQueryResult = Apollo.QueryResult<ListAllPurchasesQuery, ListAllPurchasesQueryVariables>;
export const PurchaseExcelReportDocument = gql`
    query PurchaseExcelReport($input: PurchaseFilterSetInput) {
  purchaseExcelReport(input: $input) {
    relatorio
    background
  }
}
    `;

/**
 * __usePurchaseExcelReportQuery__
 *
 * To run a query within a React component, call `usePurchaseExcelReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseExcelReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseExcelReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseExcelReportQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>(PurchaseExcelReportDocument, options);
      }
export function usePurchaseExcelReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>(PurchaseExcelReportDocument, options);
        }
export function usePurchaseExcelReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>(PurchaseExcelReportDocument, options);
        }
export type PurchaseExcelReportQueryHookResult = ReturnType<typeof usePurchaseExcelReportQuery>;
export type PurchaseExcelReportLazyQueryHookResult = ReturnType<typeof usePurchaseExcelReportLazyQuery>;
export type PurchaseExcelReportSuspenseQueryHookResult = ReturnType<typeof usePurchaseExcelReportSuspenseQuery>;
export type PurchaseExcelReportQueryResult = Apollo.QueryResult<PurchaseExcelReportQuery, PurchaseExcelReportQueryVariables>;
export const UpdatePurchaseNotesActionDocument = gql`
    mutation UpdatePurchaseNotesAction($purchaseInput: UpdatePurchaseNotesInput!) {
  purchaseNotesUpdate(purchaseInput: $purchaseInput) {
    purchase {
      notes
    }
  }
}
    `;
export type UpdatePurchaseNotesActionMutationFn = Apollo.MutationFunction<UpdatePurchaseNotesActionMutation, UpdatePurchaseNotesActionMutationVariables>;

/**
 * __useUpdatePurchaseNotesActionMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseNotesActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseNotesActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseNotesActionMutation, { data, loading, error }] = useUpdatePurchaseNotesActionMutation({
 *   variables: {
 *      purchaseInput: // value for 'purchaseInput'
 *   },
 * });
 */
export function useUpdatePurchaseNotesActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseNotesActionMutation, UpdatePurchaseNotesActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchaseNotesActionMutation, UpdatePurchaseNotesActionMutationVariables>(UpdatePurchaseNotesActionDocument, options);
      }
export type UpdatePurchaseNotesActionMutationHookResult = ReturnType<typeof useUpdatePurchaseNotesActionMutation>;
export type UpdatePurchaseNotesActionMutationResult = Apollo.MutationResult<UpdatePurchaseNotesActionMutation>;
export type UpdatePurchaseNotesActionMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseNotesActionMutation, UpdatePurchaseNotesActionMutationVariables>;
export const ServicesDocument = gql`
    query Services($first: Int = 200, $nameIcontains: String) {
  allServicesRelay(first: $first, nameIcontains: $nameIcontains) {
    edges {
      node {
        id
        pk
        name
        description
        value
        costValue
        promotionalValue
        durationMinutes
        bufferBeforeMinutes
        bufferAfterMinutes
        recommendedReturnDays
        isActive
        availableInPdv
        availableForBooking
        isPublic
        category {
          id
          pk
          name
        }
      }
    }
  }
  serviceCategories(active: true) {
    id
    pk
    name
    isActive
  }
}
    `;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      nameIcontains: // value for 'nameIcontains'
 *   },
 * });
 */
export function useServicesQuery(baseOptions?: Apollo.QueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export function useServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesSuspenseQueryHookResult = ReturnType<typeof useServicesSuspenseQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const ServiceDashboardDocument = gql`
    query ServiceDashboard($start: Date, $end: Date) {
  serviceDashboard(start: $start, end: $end) {
    activeServices
    pdvServices
    bookingServices
    servicesSold
    serviceRevenue
    averageServiceTicket
  }
}
    `;

/**
 * __useServiceDashboardQuery__
 *
 * To run a query within a React component, call `useServiceDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDashboardQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useServiceDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ServiceDashboardQuery, ServiceDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDashboardQuery, ServiceDashboardQueryVariables>(ServiceDashboardDocument, options);
      }
export function useServiceDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDashboardQuery, ServiceDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDashboardQuery, ServiceDashboardQueryVariables>(ServiceDashboardDocument, options);
        }
export function useServiceDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceDashboardQuery, ServiceDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceDashboardQuery, ServiceDashboardQueryVariables>(ServiceDashboardDocument, options);
        }
export type ServiceDashboardQueryHookResult = ReturnType<typeof useServiceDashboardQuery>;
export type ServiceDashboardLazyQueryHookResult = ReturnType<typeof useServiceDashboardLazyQuery>;
export type ServiceDashboardSuspenseQueryHookResult = ReturnType<typeof useServiceDashboardSuspenseQuery>;
export type ServiceDashboardQueryResult = Apollo.QueryResult<ServiceDashboardQuery, ServiceDashboardQueryVariables>;
export const SaveServiceCategoryFrontendDocument = gql`
    mutation SaveServiceCategoryFrontend($input: SaveServiceCategoryInput!) {
  saveServiceCategory(input: $input) {
    category {
      id
      pk
      name
      isActive
    }
  }
}
    `;
export type SaveServiceCategoryFrontendMutationFn = Apollo.MutationFunction<SaveServiceCategoryFrontendMutation, SaveServiceCategoryFrontendMutationVariables>;

/**
 * __useSaveServiceCategoryFrontendMutation__
 *
 * To run a mutation, you first call `useSaveServiceCategoryFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveServiceCategoryFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveServiceCategoryFrontendMutation, { data, loading, error }] = useSaveServiceCategoryFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveServiceCategoryFrontendMutation(baseOptions?: Apollo.MutationHookOptions<SaveServiceCategoryFrontendMutation, SaveServiceCategoryFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveServiceCategoryFrontendMutation, SaveServiceCategoryFrontendMutationVariables>(SaveServiceCategoryFrontendDocument, options);
      }
export type SaveServiceCategoryFrontendMutationHookResult = ReturnType<typeof useSaveServiceCategoryFrontendMutation>;
export type SaveServiceCategoryFrontendMutationResult = Apollo.MutationResult<SaveServiceCategoryFrontendMutation>;
export type SaveServiceCategoryFrontendMutationOptions = Apollo.BaseMutationOptions<SaveServiceCategoryFrontendMutation, SaveServiceCategoryFrontendMutationVariables>;
export const SaveServiceFrontendDocument = gql`
    mutation SaveServiceFrontend($input: SaveServiceInput!) {
  saveService(input: $input) {
    service {
      id
      pk
      name
      description
      value
      costValue
      promotionalValue
      durationMinutes
      bufferBeforeMinutes
      bufferAfterMinutes
      recommendedReturnDays
      isActive
      availableInPdv
      availableForBooking
      isPublic
      category {
        id
        pk
        name
      }
    }
  }
}
    `;
export type SaveServiceFrontendMutationFn = Apollo.MutationFunction<SaveServiceFrontendMutation, SaveServiceFrontendMutationVariables>;

/**
 * __useSaveServiceFrontendMutation__
 *
 * To run a mutation, you first call `useSaveServiceFrontendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveServiceFrontendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveServiceFrontendMutation, { data, loading, error }] = useSaveServiceFrontendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveServiceFrontendMutation(baseOptions?: Apollo.MutationHookOptions<SaveServiceFrontendMutation, SaveServiceFrontendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveServiceFrontendMutation, SaveServiceFrontendMutationVariables>(SaveServiceFrontendDocument, options);
      }
export type SaveServiceFrontendMutationHookResult = ReturnType<typeof useSaveServiceFrontendMutation>;
export type SaveServiceFrontendMutationResult = Apollo.MutationResult<SaveServiceFrontendMutation>;
export type SaveServiceFrontendMutationOptions = Apollo.BaseMutationOptions<SaveServiceFrontendMutation, SaveServiceFrontendMutationVariables>;
export const GetPublicStoreDataDocument = gql`
    query GetPublicStoreData($slug: String!) {
  getStoreBySlug(slug: $slug) {
    pk
    url
    profileImage
  }
}
    `;

/**
 * __useGetPublicStoreDataQuery__
 *
 * To run a query within a React component, call `useGetPublicStoreDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicStoreDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicStoreDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPublicStoreDataQuery(baseOptions: Apollo.QueryHookOptions<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>(GetPublicStoreDataDocument, options);
      }
export function useGetPublicStoreDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>(GetPublicStoreDataDocument, options);
        }
export function useGetPublicStoreDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>(GetPublicStoreDataDocument, options);
        }
export type GetPublicStoreDataQueryHookResult = ReturnType<typeof useGetPublicStoreDataQuery>;
export type GetPublicStoreDataLazyQueryHookResult = ReturnType<typeof useGetPublicStoreDataLazyQuery>;
export type GetPublicStoreDataSuspenseQueryHookResult = ReturnType<typeof useGetPublicStoreDataSuspenseQuery>;
export type GetPublicStoreDataQueryResult = Apollo.QueryResult<GetPublicStoreDataQuery, GetPublicStoreDataQueryVariables>;
export const GetStoreDocument = gql`
    query GetStore {
  getStore {
    id
    name
    telephone
    email
    cnpj
    plan
    isActive
    url
    profileImage
    currencyType
    hasBulkNotificationPermission
    totalNotificationCredits
    usedNotificationCredits
    extraNotificationCredits
    availableBulkNotificationChannels
    zekiMessage
    whatsappconfig {
      connected
      activated
    }
    emailproviderstoreintegration {
      isActive
    }
    evolutionapiintegration {
      connected
    }
    zapiintegration {
      connected
    }
    helenastoreintegration {
      connected
      activated
    }
    profileImageEmail
    emailFooterPrimaryColor
    emailFooterSecondaryColor
    emailFooterTertiaryColor
    emailFooterImg
    connectedIntegration {
      integration
      isConnected
    }
  }
}
    `;

/**
 * __useGetStoreQuery__
 *
 * To run a query within a React component, call `useGetStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoreQuery(baseOptions?: Apollo.QueryHookOptions<GetStoreQuery, GetStoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreQuery, GetStoreQueryVariables>(GetStoreDocument, options);
      }
export function useGetStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreQuery, GetStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreQuery, GetStoreQueryVariables>(GetStoreDocument, options);
        }
export function useGetStoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStoreQuery, GetStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoreQuery, GetStoreQueryVariables>(GetStoreDocument, options);
        }
export type GetStoreQueryHookResult = ReturnType<typeof useGetStoreQuery>;
export type GetStoreLazyQueryHookResult = ReturnType<typeof useGetStoreLazyQuery>;
export type GetStoreSuspenseQueryHookResult = ReturnType<typeof useGetStoreSuspenseQuery>;
export type GetStoreQueryResult = Apollo.QueryResult<GetStoreQuery, GetStoreQueryVariables>;
export const GetWatsappConfigDocument = gql`
    query GetWatsappConfig {
  getStore {
    whatsappconfig {
      connected
      activated
    }
  }
}
    `;

/**
 * __useGetWatsappConfigQuery__
 *
 * To run a query within a React component, call `useGetWatsappConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatsappConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatsappConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWatsappConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>(GetWatsappConfigDocument, options);
      }
export function useGetWatsappConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>(GetWatsappConfigDocument, options);
        }
export function useGetWatsappConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>(GetWatsappConfigDocument, options);
        }
export type GetWatsappConfigQueryHookResult = ReturnType<typeof useGetWatsappConfigQuery>;
export type GetWatsappConfigLazyQueryHookResult = ReturnType<typeof useGetWatsappConfigLazyQuery>;
export type GetWatsappConfigSuspenseQueryHookResult = ReturnType<typeof useGetWatsappConfigSuspenseQuery>;
export type GetWatsappConfigQueryResult = Apollo.QueryResult<GetWatsappConfigQuery, GetWatsappConfigQueryVariables>;
export const StoreUpdateDocument = gql`
    mutation StoreUpdate($input: UpdateStoreInput) {
  storeUpdate(input: $input) {
    ok
    store {
      id
      name
      telephone
      email
      cnpj
      plan
      isActive
    }
  }
}
    `;
export type StoreUpdateMutationFn = Apollo.MutationFunction<StoreUpdateMutation, StoreUpdateMutationVariables>;

/**
 * __useStoreUpdateMutation__
 *
 * To run a mutation, you first call `useStoreUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeUpdateMutation, { data, loading, error }] = useStoreUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StoreUpdateMutation, StoreUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreUpdateMutation, StoreUpdateMutationVariables>(StoreUpdateDocument, options);
      }
export type StoreUpdateMutationHookResult = ReturnType<typeof useStoreUpdateMutation>;
export type StoreUpdateMutationResult = Apollo.MutationResult<StoreUpdateMutation>;
export type StoreUpdateMutationOptions = Apollo.BaseMutationOptions<StoreUpdateMutation, StoreUpdateMutationVariables>;
export const CreatePurchaseViaTotemDocument = gql`
    mutation CreatePurchaseViaTotem($purchaseInput: CreatePurchaseTotemInput!) {
  purchaseTotemCreate(purchaseInput: $purchaseInput) {
    success
    error
  }
}
    `;
export type CreatePurchaseViaTotemMutationFn = Apollo.MutationFunction<CreatePurchaseViaTotemMutation, CreatePurchaseViaTotemMutationVariables>;

/**
 * __useCreatePurchaseViaTotemMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseViaTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseViaTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseViaTotemMutation, { data, loading, error }] = useCreatePurchaseViaTotemMutation({
 *   variables: {
 *      purchaseInput: // value for 'purchaseInput'
 *   },
 * });
 */
export function useCreatePurchaseViaTotemMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseViaTotemMutation, CreatePurchaseViaTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePurchaseViaTotemMutation, CreatePurchaseViaTotemMutationVariables>(CreatePurchaseViaTotemDocument, options);
      }
export type CreatePurchaseViaTotemMutationHookResult = ReturnType<typeof useCreatePurchaseViaTotemMutation>;
export type CreatePurchaseViaTotemMutationResult = Apollo.MutationResult<CreatePurchaseViaTotemMutation>;
export type CreatePurchaseViaTotemMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseViaTotemMutation, CreatePurchaseViaTotemMutationVariables>;
export const GetCreditHouseGiftbackConfigDocument = gql`
    query GetCreditHouseGiftbackConfig {
  getStore {
    credithouseconfig {
      credithousegiftbackconfigSet {
        id
        pk
        loanMinValue
        loanMaxValue
        taxMinValue
        taxMaxValue
        giftbackTypeValue
        giftbackValue
      }
    }
  }
}
    `;

/**
 * __useGetCreditHouseGiftbackConfigQuery__
 *
 * To run a query within a React component, call `useGetCreditHouseGiftbackConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditHouseGiftbackConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditHouseGiftbackConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditHouseGiftbackConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>(GetCreditHouseGiftbackConfigDocument, options);
      }
export function useGetCreditHouseGiftbackConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>(GetCreditHouseGiftbackConfigDocument, options);
        }
export function useGetCreditHouseGiftbackConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>(GetCreditHouseGiftbackConfigDocument, options);
        }
export type GetCreditHouseGiftbackConfigQueryHookResult = ReturnType<typeof useGetCreditHouseGiftbackConfigQuery>;
export type GetCreditHouseGiftbackConfigLazyQueryHookResult = ReturnType<typeof useGetCreditHouseGiftbackConfigLazyQuery>;
export type GetCreditHouseGiftbackConfigSuspenseQueryHookResult = ReturnType<typeof useGetCreditHouseGiftbackConfigSuspenseQuery>;
export type GetCreditHouseGiftbackConfigQueryResult = Apollo.QueryResult<GetCreditHouseGiftbackConfigQuery, GetCreditHouseGiftbackConfigQueryVariables>;
export const GetDetailGiftbackDocument = gql`
    query GetDetailGiftback($input: String!) {
  getGiftbackByCodeCpfEmailPhone(input: $input) {
    pk
    code
    status
    dueDate
    value
    importedFrom
    purchase {
      value
    }
    customer {
      id
      pk
    }
    minValueToRedeem
    store {
      giftbackconfig {
        multiplegiftbackconfigSet {
          id
          minPurchaseValueForRedeem
          minimumValueType
          maximumDiscountPercentage
        }
      }
    }
  }
}
    `;

/**
 * __useGetDetailGiftbackQuery__
 *
 * To run a query within a React component, call `useGetDetailGiftbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailGiftbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailGiftbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDetailGiftbackQuery(baseOptions: Apollo.QueryHookOptions<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>(GetDetailGiftbackDocument, options);
      }
export function useGetDetailGiftbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>(GetDetailGiftbackDocument, options);
        }
export function useGetDetailGiftbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>(GetDetailGiftbackDocument, options);
        }
export type GetDetailGiftbackQueryHookResult = ReturnType<typeof useGetDetailGiftbackQuery>;
export type GetDetailGiftbackLazyQueryHookResult = ReturnType<typeof useGetDetailGiftbackLazyQuery>;
export type GetDetailGiftbackSuspenseQueryHookResult = ReturnType<typeof useGetDetailGiftbackSuspenseQuery>;
export type GetDetailGiftbackQueryResult = Apollo.QueryResult<GetDetailGiftbackQuery, GetDetailGiftbackQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($userInput: CreateUserInput!) {
  createUserCustom(userInput: $userInput) {
    ok
    customUser {
      id
      name
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserCustomDocument = gql`
    mutation UpdateUserCustom($input: UpdateUserInput) {
  updateUserCustom(input: $input) {
    ok
  }
}
    `;
export type UpdateUserCustomMutationFn = Apollo.MutationFunction<UpdateUserCustomMutation, UpdateUserCustomMutationVariables>;

/**
 * __useUpdateUserCustomMutation__
 *
 * To run a mutation, you first call `useUpdateUserCustomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCustomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCustomMutation, { data, loading, error }] = useUpdateUserCustomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCustomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCustomMutation, UpdateUserCustomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCustomMutation, UpdateUserCustomMutationVariables>(UpdateUserCustomDocument, options);
      }
export type UpdateUserCustomMutationHookResult = ReturnType<typeof useUpdateUserCustomMutation>;
export type UpdateUserCustomMutationResult = Apollo.MutationResult<UpdateUserCustomMutation>;
export type UpdateUserCustomMutationOptions = Apollo.BaseMutationOptions<UpdateUserCustomMutation, UpdateUserCustomMutationVariables>;
export const ForgotEmailDocument = gql`
    mutation ForgotEmail($input: SendPasswordResetEmailInput!) {
  sendPasswordResetEmail(input: $input) {
    success
    errors
  }
}
    `;
export type ForgotEmailMutationFn = Apollo.MutationFunction<ForgotEmailMutation, ForgotEmailMutationVariables>;

/**
 * __useForgotEmailMutation__
 *
 * To run a mutation, you first call `useForgotEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotEmailMutation, { data, loading, error }] = useForgotEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotEmailMutation(baseOptions?: Apollo.MutationHookOptions<ForgotEmailMutation, ForgotEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotEmailMutation, ForgotEmailMutationVariables>(ForgotEmailDocument, options);
      }
export type ForgotEmailMutationHookResult = ReturnType<typeof useForgotEmailMutation>;
export type ForgotEmailMutationResult = Apollo.MutationResult<ForgotEmailMutation>;
export type ForgotEmailMutationOptions = Apollo.BaseMutationOptions<ForgotEmailMutation, ForgotEmailMutationVariables>;
export const ListUserDocument = gql`
    query ListUser($before: String, $after: String, $first: Int = 12, $last: Int, $nameOrEmail: String, $isActive: Boolean, $cpf_Icontains: String, $phone_Icontains: String, $permissions_UserType_In: String) {
  usersAll: allUsersRelay(isStaff: false) {
    totalCount
  }
  userActive: allUsersRelay(isActive: true, isStaff: false) {
    totalCount
  }
  userInactive: allUsersRelay(isActive: false, isStaff: false) {
    totalCount
  }
  allUsersRelay(
    before: $before
    after: $after
    first: $first
    last: $last
    nameOrEmail: $nameOrEmail
    isActive: $isActive
    cpf_Icontains: $cpf_Icontains
    phone_Icontains: $phone_Icontains
    permissions_UserType_In: $permissions_UserType_In
    isStaff: false
  ) {
    totalCount
    edgeCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        pk
        cpf
        name
        email
        phone
        isActive
        permissionInStore {
          userType
        }
        permissions {
          userType
          store {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListUserQuery__
 *
 * To run a query within a React component, call `useListUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameOrEmail: // value for 'nameOrEmail'
 *      isActive: // value for 'isActive'
 *      cpf_Icontains: // value for 'cpf_Icontains'
 *      phone_Icontains: // value for 'phone_Icontains'
 *      permissions_UserType_In: // value for 'permissions_UserType_In'
 *   },
 * });
 */
export function useListUserQuery(baseOptions?: Apollo.QueryHookOptions<ListUserQuery, ListUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserQuery, ListUserQueryVariables>(ListUserDocument, options);
      }
export function useListUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserQuery, ListUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserQuery, ListUserQueryVariables>(ListUserDocument, options);
        }
export function useListUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUserQuery, ListUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserQuery, ListUserQueryVariables>(ListUserDocument, options);
        }
export type ListUserQueryHookResult = ReturnType<typeof useListUserQuery>;
export type ListUserLazyQueryHookResult = ReturnType<typeof useListUserLazyQuery>;
export type ListUserSuspenseQueryHookResult = ReturnType<typeof useListUserSuspenseQuery>;
export type ListUserQueryResult = Apollo.QueryResult<ListUserQuery, ListUserQueryVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($input: PasswordResetInput!) {
  passwordReset(input: $input) {
    success
    errors
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($input: RedefinePasswordInput!) {
  redefinePassword(input: $input) {
    ok
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const GetUserDetailsDocument = gql`
    query GetUserDetails($id: ID!) {
  getUser(id: $id) {
    id
    pk
    username
    email
    name
    cpf
    gender
    phone
    birthdate
    isActive
    isStaff
    connectedStore {
      id
    }
    permissions {
      userType
      store {
        id
      }
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUserDetailsSuspenseQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const LoginDocument = gql`
    mutation Login($input: ObtainJSONWebTokenInput!) {
  tokenAuth(input: $input) {
    success
    errors
    unarchiving
    token
    unarchiving
    user {
      id
      username
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;